/* eslint-disable semi */
/* eslint-disable quotes */
// // *** 火车票城市控件数据 ***
export const trainCity = [
  {
    "name": "北京北",
    "spell": "beijingbei",
    "spellShort": "bjb",
    "code": "VAP"
  },
  {
    "name": "北京东",
    "spell": "beijingdong",
    "spellShort": "bjd",
    "code": "BOP"
  },
  {
    "name": "北京",
    "spell": "beijing",
    "spellShort": "bji",
    "code": "BJP",
    "isHot": true
  },
  {
    "name": "北京南",
    "spell": "beijingnan",
    "spellShort": "bjn",
    "code": "VNP"
  },
  {
    "name": "北京大兴",
    "spell": "beijingdaxing",
    "spellShort": "bjx",
    "code": "IPP"
  },
  {
    "name": "北京西",
    "spell": "beijingxi",
    "spellShort": "bjx",
    "code": "BXP"
  },
  {
    "name": "北京朝阳",
    "spell": "beijingchaoyang",
    "spellShort": "bjy",
    "code": "IFP"
  },
  {
    "name": "重庆北",
    "spell": "chongqingbei",
    "spellShort": "cqb",
    "code": "CUW"
  },
  {
    "name": "重庆",
    "spell": "chongqing",
    "spellShort": "cqi",
    "code": "CQW",
    "isHot": true
  },
  {
    "name": "重庆南",
    "spell": "chongqingnan",
    "spellShort": "cqn",
    "code": "CRW"
  },
  {
    "name": "重庆西",
    "spell": "chongqingxi",
    "spellShort": "cqx",
    "code": "CXW"
  },
  {
    "name": "上海",
    "spell": "shanghai",
    "spellShort": "sha",
    "code": "SHH",
    "isHot": true
  },
  {
    "name": "上海南",
    "spell": "shanghainan",
    "spellShort": "shn",
    "code": "SNH"
  },
  {
    "name": "上海虹桥",
    "spell": "shanghaihongqiao",
    "spellShort": "shq",
    "code": "AOH"
  },
  {
    "name": "上海西",
    "spell": "shanghaixi",
    "spellShort": "shx",
    "code": "SXH"
  },
  {
    "name": "天津北",
    "spell": "tianjinbei",
    "spellShort": "tjb",
    "code": "TBP"
  },
  {
    "name": "天津",
    "spell": "tianjin",
    "spellShort": "tji",
    "code": "TJP",
    "isHot": true
  },
  {
    "name": "天津南",
    "spell": "tianjinnan",
    "spellShort": "tjn",
    "code": "TIP"
  },
  {
    "name": "天津西",
    "spell": "tianjinxi",
    "spellShort": "tjx",
    "code": "TXP"
  },
  {
    "name": "万象",
    "spell": "wanxiang",
    "spellShort": "wxi",
    "code": "YTM"
  },
  {
    "name": "滨江",
    "spell": "binjiang",
    "spellShort": "bji",
    "code": "BJB"
  },
  {
    "name": "百浪",
    "spell": "bailang",
    "spellShort": "bla",
    "code": "BRZ"
  },
  {
    "name": "班猫箐",
    "spell": "banmaoqing",
    "spellShort": "bmq",
    "code": "BNM"
  },
  {
    "name": "北营",
    "spell": "beiying",
    "spellShort": "byi",
    "code": "BIV"
  },
  {
    "name": "长春",
    "spell": "changchun",
    "spellShort": "cch",
    "code": "CCT",
    "isHot": true
  },
  {
    "name": "长春南",
    "spell": "changchunnan",
    "spellShort": "ccn",
    "code": "CET"
  },
  {
    "name": "长春西",
    "spell": "changchunxi",
    "spellShort": "ccx",
    "code": "CRT"
  },
  {
    "name": "成都东",
    "spell": "chengdudong",
    "spellShort": "cdd",
    "code": "ICW"
  },
  {
    "name": "成都南",
    "spell": "chengdunan",
    "spellShort": "cdn",
    "code": "CNW"
  },
  {
    "name": "成都",
    "spell": "chengdu",
    "spellShort": "cdu",
    "code": "CDW",
    "isHot": true
  },
  {
    "name": "成都西",
    "spell": "chengduxi",
    "spellShort": "cdx",
    "code": "CMW"
  },
  {
    "name": "陈官营",
    "spell": "chenguanying",
    "spellShort": "cgy",
    "code": "CAJ"
  },
  {
    "name": "长清",
    "spell": "changqing",
    "spellShort": "cqi",
    "code": "CNK"
  },
  {
    "name": "长沙",
    "spell": "changsha",
    "spellShort": "csh",
    "code": "CSQ",
    "isHot": true
  },
  {
    "name": "长沙南",
    "spell": "changshanan",
    "spellShort": "csn",
    "code": "CWQ"
  },
  {
    "name": "长沙西",
    "spell": "changshaxi",
    "spellShort": "csx",
    "code": "RXQ"
  },
  {
    "name": "常庄",
    "spell": "changzhuang",
    "spellShort": "czh",
    "code": "CVK"
  },
  {
    "name": "大成",
    "spell": "dacheng",
    "spellShort": "dch",
    "code": "DCT"
  },
  {
    "name": "大拟",
    "spell": "dani",
    "spellShort": "dni",
    "code": "DNZ"
  },
  {
    "name": "读书铺",
    "spell": "dushupu",
    "spellShort": "dsp",
    "code": "DPM"
  },
  {
    "name": "大王滩",
    "spell": "dawangtan",
    "spellShort": "dwt",
    "code": "DZZ"
  },
  {
    "name": "大元",
    "spell": "dayuan",
    "spellShort": "dyu",
    "code": "DYZ"
  },
  {
    "name": "丰水村",
    "spell": "fengshuicun",
    "spellShort": "fsc",
    "code": "FSJ"
  },
  {
    "name": "福州",
    "spell": "fuzhou",
    "spellShort": "fzh",
    "code": "FZS",
    "isHot": true
  },
  {
    "name": "福州南",
    "spell": "fuzhounan",
    "spellShort": "fzn",
    "code": "FYS"
  },
  {
    "name": "甘草店",
    "spell": "gancaodian",
    "spellShort": "gcd",
    "code": "GDJ"
  },
  {
    "name": "钢城",
    "spell": "gangcheng",
    "spellShort": "gch",
    "code": "GAK"
  },
  {
    "name": "孤家子",
    "spell": "gujiazi",
    "spellShort": "gjz",
    "code": "GKT"
  },
  {
    "name": "广南卫",
    "spell": "guangnanwei",
    "spellShort": "gnw",
    "code": "GNM"
  },
  {
    "name": "贵阳",
    "spell": "guiyang",
    "spellShort": "gya",
    "code": "GIW",
    "isHot": true
  },
  {
    "name": "贵阳北",
    "spell": "guiyangbei",
    "spellShort": "gyb",
    "code": "KQW"
  },
  {
    "name": "贵阳东",
    "spell": "guiyangdong",
    "spellShort": "gyd",
    "code": "KEW"
  },
  {
    "name": "广州北",
    "spell": "guangzhoubei",
    "spellShort": "gzb",
    "code": "GBQ"
  },
  {
    "name": "广州东",
    "spell": "guangzhoudong",
    "spellShort": "gzd",
    "code": "GGQ"
  },
  {
    "name": "广州",
    "spell": "guangzhou",
    "spellShort": "gzh",
    "code": "GZQ",
    "isHot": true
  },
  {
    "name": "广州南",
    "spell": "guangzhounan",
    "spellShort": "gzn",
    "code": "IZQ"
  },
  {
    "name": "广州西",
    "spell": "guangzhouxi",
    "spellShort": "gzx",
    "code": "GXQ"
  },
  {
    "name": "广州白云",
    "spell": "guangzhoubaiyun",
    "spellShort": "gzy",
    "code": "GBA"
  },
  {
    "name": "哈尔滨北",
    "spell": "haerbinbei",
    "spellShort": "heb",
    "code": "HTB"
  },
  {
    "name": "哈尔滨",
    "spell": "haerbin",
    "spellShort": "heb",
    "code": "HBB",
    "isHot": true
  },
  {
    "name": "哈尔滨东",
    "spell": "haerbindong",
    "spellShort": "hed",
    "code": "VBB"
  },
  {
    "name": "哈尔滨西",
    "spell": "haerbinxi",
    "spellShort": "hex",
    "code": "VAB"
  },
  {
    "name": "合肥北城",
    "spell": "hefeibeicheng",
    "spellShort": "hfc",
    "code": "COH"
  },
  {
    "name": "合肥",
    "spell": "hefei",
    "spellShort": "hfe",
    "code": "HFH",
    "isHot": true
  },
  {
    "name": "合肥南",
    "spell": "hefeinan",
    "spellShort": "hfn",
    "code": "ENH"
  },
  {
    "name": "皇姑屯",
    "spell": "huanggutun",
    "spellShort": "hgt",
    "code": "HTT"
  },
  {
    "name": "呼和浩特东",
    "spell": "huhehaotedong",
    "spellShort": "hhd",
    "code": "NDC"
  },
  {
    "name": "呼和浩特",
    "spell": "huhehaote",
    "spellShort": "hht",
    "code": "HHC",
    "isHot": true
  },
  {
    "name": "海口东",
    "spell": "haikoudong",
    "spellShort": "hkd",
    "code": "HMQ"
  },
  {
    "name": "海口",
    "spell": "haikou",
    "spellShort": "hko",
    "code": "VUQ",
    "isHot": true
  },
  {
    "name": "杭州东",
    "spell": "hangzhoudong",
    "spellShort": "hzd",
    "code": "HGH"
  },
  {
    "name": "杭州",
    "spell": "hangzhou",
    "spellShort": "hzh",
    "code": "HZH",
    "isHot": true
  },
  {
    "name": "杭州南",
    "spell": "hangzhounan",
    "spellShort": "hzn",
    "code": "XHH"
  },
  {
    "name": "金马村",
    "spell": "jinmacun",
    "spellShort": "jmc",
    "code": "JMM"
  },
  {
    "name": "济南",
    "spell": "jinan",
    "spellShort": "jna",
    "code": "JNK",
    "isHot": true
  },
  {
    "name": "济南东",
    "spell": "jinandong",
    "spellShort": "jnd",
    "code": "MDK"
  },
  {
    "name": "济南西",
    "spell": "jinanxi",
    "spellShort": "jnx",
    "code": "JGK"
  },
  {
    "name": "昆明",
    "spell": "kunming",
    "spellShort": "kmi",
    "code": "KMM",
    "isHot": true
  },
  {
    "name": "昆明南",
    "spell": "kunmingnan",
    "spellShort": "kmn",
    "code": "KOM"
  },
  {
    "name": "历城",
    "spell": "licheng",
    "spellShort": "lch",
    "code": "VHK"
  },
  {
    "name": "蔺家楼",
    "spell": "linjialou",
    "spellShort": "ljl",
    "code": "ULK"
  },
  {
    "name": "龙泉寺",
    "spell": "longquansi",
    "spellShort": "lqs",
    "code": "UQJ"
  },
  {
    "name": "拉萨",
    "spell": "lasa",
    "spellShort": "lsa",
    "code": "LSO",
    "isHot": true
  },
  {
    "name": "乐善村",
    "spell": "leshancun",
    "spellShort": "lsc",
    "code": "LUM"
  },
  {
    "name": "林盛堡",
    "spell": "linshengpu",
    "spellShort": "lsp",
    "code": "LBT"
  },
  {
    "name": "骆驼巷",
    "spell": "luotuoxiang",
    "spellShort": "ltx",
    "code": "LTJ"
  },
  {
    "name": "莱芜北",
    "spell": "laiwubei",
    "spellShort": "lwb",
    "code": "VIK"
  },
  {
    "name": "兰州东",
    "spell": "lanzhoudong",
    "spellShort": "lzd",
    "code": "LVJ"
  },
  {
    "name": "兰州",
    "spell": "lanzhou",
    "spellShort": "lzh",
    "code": "LZJ",
    "isHot": true
  },
  {
    "name": "兰州新区",
    "spell": "lanzhouxinqu",
    "spellShort": "lzq",
    "code": "LQJ"
  },
  {
    "name": "兰州西",
    "spell": "lanzhouxi",
    "spellShort": "lzx",
    "code": "LAJ"
  },
  {
    "name": "茂舍祖",
    "spell": "maoshezu",
    "spellShort": "msz",
    "code": "MOM"
  },
  {
    "name": "南昌东",
    "spell": "nanchangdong",
    "spellShort": "ncd",
    "code": "NUG"
  },
  {
    "name": "南昌",
    "spell": "nanchang",
    "spellShort": "nch",
    "code": "NCG",
    "isHot": true
  },
  {
    "name": "南昌南",
    "spell": "nanchangnan",
    "spellShort": "ncn",
    "code": "HOG"
  },
  {
    "name": "宁村",
    "spell": "ningcun",
    "spellShort": "ncu",
    "code": "NCZ"
  },
  {
    "name": "南昌西",
    "spell": "nanchangxi",
    "spellShort": "ncx",
    "code": "NXG"
  },
  {
    "name": "南京",
    "spell": "nanjing",
    "spellShort": "nji",
    "code": "NJH",
    "isHot": true
  },
  {
    "name": "南京南",
    "spell": "nanjingnan",
    "spellShort": "njn",
    "code": "NKH"
  },
  {
    "name": "那罗",
    "spell": "naluo",
    "spellShort": "nlu",
    "code": "ULZ"
  },
  {
    "name": "南宁北",
    "spell": "nanningbei",
    "spellShort": "nnb",
    "code": "NRZ"
  },
  {
    "name": "南宁东",
    "spell": "nanningdong",
    "spellShort": "nnd",
    "code": "NFZ"
  },
  {
    "name": "南宁",
    "spell": "nanning",
    "spellShort": "nni",
    "code": "NNZ",
    "isHot": true
  },
  {
    "name": "南宁西",
    "spell": "nanningxi",
    "spellShort": "nnx",
    "code": "NXZ"
  },
  {
    "name": "那铺",
    "spell": "napu",
    "spellShort": "npu",
    "code": "NPZ"
  },
  {
    "name": "暖泉",
    "spell": "nuanquan",
    "spellShort": "nqu",
    "code": "NQJ"
  },
  {
    "name": "坡底下",
    "spell": "podixia",
    "spellShort": "pdx",
    "code": "PXJ"
  },
  {
    "name": "七甸",
    "spell": "qidian",
    "spellShort": "qdi",
    "code": "QDM"
  },
  {
    "name": "世博园",
    "spell": "shiboyuan",
    "spellShort": "sby",
    "code": "ZWT"
  },
  {
    "name": "石家庄北",
    "spell": "shijiazhuangbei",
    "spellShort": "sjb",
    "code": "VVP"
  },
  {
    "name": "石家庄东",
    "spell": "shijiazhuangdong",
    "spellShort": "sjd",
    "code": "SXP"
  },
  {
    "name": "邵家堂",
    "spell": "shaojiatang",
    "spellShort": "sjt",
    "code": "SJJ"
  },
  {
    "name": "石家庄",
    "spell": "shijiazhuang",
    "spellShort": "sjz",
    "code": "SJP",
    "isHot": true
  },
  {
    "name": "施家嘴",
    "spell": "shijiazui",
    "spellShort": "sjz",
    "code": "SHM"
  },
  {
    "name": "沈阳",
    "spell": "shenyang",
    "spellShort": "sya",
    "code": "SYT",
    "isHot": true
  },
  {
    "name": "沈阳北",
    "spell": "shenyangbei",
    "spellShort": "syb",
    "code": "SBT"
  },
  {
    "name": "沈阳东",
    "spell": "shenyangdong",
    "spellShort": "syd",
    "code": "SDT"
  },
  {
    "name": "沈阳南",
    "spell": "shenyangnan",
    "spellShort": "syn",
    "code": "SOT"
  },
  {
    "name": "水源",
    "spell": "shuiyuan",
    "spellShort": "syu",
    "code": "OYJ"
  },
  {
    "name": "沈阳西",
    "spell": "shenyangxi",
    "spellShort": "syx",
    "code": "OOT"
  },
  {
    "name": "桑园子",
    "spell": "sangyuanzi",
    "spellShort": "syz",
    "code": "SAJ"
  },
  {
    "name": "太原北",
    "spell": "taiyuanbei",
    "spellShort": "tyb",
    "code": "TBV"
  },
  {
    "name": "太原东",
    "spell": "taiyuandong",
    "spellShort": "tyd",
    "code": "TDV"
  },
  {
    "name": "太原南",
    "spell": "taiyuannan",
    "spellShort": "tyn",
    "code": "TNV"
  },
  {
    "name": "太原",
    "spell": "taiyuan",
    "spellShort": "tyu",
    "code": "TYV",
    "isHot": true
  },
  {
    "name": "武汉",
    "spell": "wuhan",
    "spellShort": "wha",
    "code": "WHN",
    "isHot": true
  },
  {
    "name": "武汉东",
    "spell": "wuhandong",
    "spellShort": "whd",
    "code": "LFN"
  },
  {
    "name": "王家湾",
    "spell": "wangjiawan",
    "spellShort": "wjw",
    "code": "WJJ"
  },
  {
    "name": "乌鲁木齐南",
    "spell": "wulumuqinan",
    "spellShort": "wln",
    "code": "WMR",
    "isHot": true
  },
  {
    "name": "乌鲁木齐",
    "spell": "wulumuqi",
    "spellShort": "wlq",
    "code": "WAR"
  },
  {
    "name": "吴圩机场",
    "spell": "wuxujichang",
    "spellShort": "wxc",
    "code": "WJZ"
  },
  {
    "name": "王兆屯",
    "spell": "wangzhaotun",
    "spellShort": "wzt",
    "code": "WZB"
  },
  {
    "name": "西安北",
    "spell": "xianbei",
    "spellShort": "xab",
    "code": "EAY"
  },
  {
    "name": "西安",
    "spell": "xian",
    "spellShort": "xan",
    "code": "XAY",
    "isHot": true
  },
  {
    "name": "西固城",
    "spell": "xigucheng",
    "spellShort": "xgc",
    "code": "XUJ"
  },
  {
    "name": "西街口",
    "spell": "xijiekou",
    "spellShort": "xjk",
    "code": "EKM"
  },
  {
    "name": "许家台",
    "spell": "xujiatai",
    "spellShort": "xjt",
    "code": "XTJ"
  },
  {
    "name": "西宁",
    "spell": "xining",
    "spellShort": "xni",
    "code": "XNO",
    "isHot": true
  },
  {
    "name": "小哨",
    "spell": "xiaoshao",
    "spellShort": "xsh",
    "code": "XAM"
  },
  {
    "name": "新塘",
    "spell": "xintang",
    "spellShort": "xta",
    "code": "XWQ"
  },
  {
    "name": "雪野",
    "spell": "xueye",
    "spellShort": "xye",
    "code": "XYK"
  },
  {
    "name": "银川",
    "spell": "yinchuan",
    "spellShort": "ych",
    "code": "YIJ",
    "isHot": true
  },
  {
    "name": "永丰营",
    "spell": "yongfengying",
    "spellShort": "yfy",
    "code": "YYM"
  },
  {
    "name": "一间堡",
    "spell": "yijianpu",
    "spellShort": "yjp",
    "code": "YJT"
  },
  {
    "name": "宜耐",
    "spell": "yinai",
    "spellShort": "yna",
    "code": "YVM"
  },
  {
    "name": "羊堡",
    "spell": "yangpu",
    "spellShort": "ypu",
    "code": "ABM"
  },
  {
    "name": "榆树台",
    "spell": "yushutai",
    "spellShort": "yst",
    "code": "YUT"
  },
  {
    "name": "引镇",
    "spell": "yinzhen",
    "spellShort": "yzh",
    "code": "CAY"
  },
  {
    "name": "朱家窑",
    "spell": "zhujiayao",
    "spellShort": "zjy",
    "code": "ZUJ"
  },
  {
    "name": "章丘南",
    "spell": "zhangqiunan",
    "spellShort": "zqn",
    "code": "VQK"
  },
  {
    "name": "郑州东",
    "spell": "zhengzhoudong",
    "spellShort": "zzd",
    "code": "ZAF"
  },
  {
    "name": "郑州航空港",
    "spell": "zhengzhouhangkonggang",
    "spellShort": "zzg",
    "code": "ZIF"
  },
  {
    "name": "郑州",
    "spell": "zhengzhou",
    "spellShort": "zzh",
    "code": "ZZF",
    "isHot": true
  },
  {
    "name": "郑州西",
    "spell": "zhengzhouxi",
    "spellShort": "zzx",
    "code": "XPF"
  },
  {
    "name": "昂昂溪",
    "spell": "angangxi",
    "spellShort": "aax",
    "code": "AAX"
  },
  {
    "name": "阿城北",
    "spell": "achengbei",
    "spellShort": "acb",
    "code": "ABB"
  },
  {
    "name": "阿城",
    "spell": "acheng",
    "spellShort": "ach",
    "code": "ACB"
  },
  {
    "name": "安次",
    "spell": "anci",
    "spellShort": "aci",
    "code": "ACI"
  },
  {
    "name": "安达",
    "spell": "anda",
    "spellShort": "ada",
    "code": "ADX"
  },
  {
    "name": "安德",
    "spell": "ande",
    "spellShort": "ade",
    "code": "ARW"
  },
  {
    "name": "阿尔山北",
    "spell": "aershanbei",
    "spellShort": "aeb",
    "code": "ARX"
  },
  {
    "name": "阿尔山",
    "spell": "aershan",
    "spellShort": "aes",
    "code": "ART"
  },
  {
    "name": "安吉",
    "spell": "anji",
    "spellShort": "aji",
    "code": "AJU"
  },
  {
    "name": "安靖",
    "spell": "anjing",
    "spellShort": "aji",
    "code": "PYW"
  },
  {
    "name": "安家",
    "spell": "anjia",
    "spellShort": "aji",
    "code": "AJB"
  },
  {
    "name": "安康",
    "spell": "ankang",
    "spellShort": "aka",
    "code": "AKY"
  },
  {
    "name": "阿克苏",
    "spell": "akesu",
    "spellShort": "aks",
    "code": "ASR"
  },
  {
    "name": "阿克陶",
    "spell": "aketao",
    "spellShort": "akt",
    "code": "AER"
  },
  {
    "name": "阿拉尔",
    "spell": "alaer",
    "spellShort": "ale",
    "code": "AOR"
  },
  {
    "name": "阿里河",
    "spell": "alihe",
    "spellShort": "alh",
    "code": "AHX"
  },
  {
    "name": "阿拉山口",
    "spell": "alashankou",
    "spellShort": "alk",
    "code": "AKR"
  },
  {
    "name": "阿勒泰",
    "spell": "aletai",
    "spellShort": "alt",
    "code": "AUR"
  },
  {
    "name": "安陆",
    "spell": "anlu",
    "spellShort": "alu",
    "code": "ALN"
  },
  {
    "name": "安陆西",
    "spell": "anluxi",
    "spellShort": "alx",
    "code": "AXN"
  },
  {
    "name": "安平",
    "spell": "anping",
    "spellShort": "api",
    "code": "APT"
  },
  {
    "name": "安庆",
    "spell": "anqing",
    "spellShort": "aqi",
    "code": "AQH"
  },
  {
    "name": "安庆西",
    "spell": "anqingxi",
    "spellShort": "aqx",
    "code": "AIU"
  },
  {
    "name": "安顺",
    "spell": "anshun",
    "spellShort": "ash",
    "code": "ASW"
  },
  {
    "name": "鞍山",
    "spell": "anshan",
    "spellShort": "ash",
    "code": "AST"
  },
  {
    "name": "安顺西",
    "spell": "anshunxi",
    "spellShort": "asx",
    "code": "ASE"
  },
  {
    "name": "鞍山西",
    "spell": "anshanxi",
    "spellShort": "asx",
    "code": "AXT"
  },
  {
    "name": "安亭北",
    "spell": "antingbei",
    "spellShort": "atb",
    "code": "ASH"
  },
  {
    "name": "安亭西",
    "spell": "antingxi",
    "spellShort": "atx",
    "code": "AXU"
  },
  {
    "name": "安阳",
    "spell": "anyang",
    "spellShort": "aya",
    "code": "AYF"
  },
  {
    "name": "安阳东",
    "spell": "anyangdong",
    "spellShort": "ayd",
    "code": "ADF"
  },
  {
    "name": "北安",
    "spell": "beian",
    "spellShort": "ban",
    "code": "BAB"
  },
  {
    "name": "博白",
    "spell": "bobai",
    "spellShort": "bba",
    "code": "BBZ"
  },
  {
    "name": "蚌埠南",
    "spell": "bengbunan",
    "spellShort": "bbn",
    "code": "BMH"
  },
  {
    "name": "蚌埠",
    "spell": "bengbu",
    "spellShort": "bbu",
    "code": "BBH"
  },
  {
    "name": "巴楚",
    "spell": "bachu",
    "spellShort": "bch",
    "code": "BCR"
  },
  {
    "name": "白城",
    "spell": "baicheng",
    "spellShort": "bch",
    "code": "BCT"
  },
  {
    "name": "北辰",
    "spell": "beichen",
    "spellShort": "bch",
    "code": "BII"
  },
  {
    "name": "宝坻北",
    "spell": "baodibei",
    "spellShort": "bdb",
    "code": "BPP"
  },
  {
    "name": "八达岭长城",
    "spell": "badalingchangcheng",
    "spellShort": "bdc",
    "code": "VLP"
  },
  {
    "name": "保定东",
    "spell": "baodingdong",
    "spellShort": "bdd",
    "code": "BMP"
  },
  {
    "name": "北戴河",
    "spell": "beidaihe",
    "spellShort": "bdh",
    "code": "BEP"
  },
  {
    "name": "保定",
    "spell": "baoding",
    "spellShort": "bdi",
    "code": "BDP"
  },
  {
    "name": "八达岭",
    "spell": "badaling",
    "spellShort": "bdl",
    "code": "ILP"
  },
  {
    "name": "巴东",
    "spell": "badong",
    "spellShort": "bdo",
    "code": "BBN"
  },
  {
    "name": "八方山",
    "spell": "bafangshan",
    "spellShort": "bfs",
    "code": "FGQ"
  },
  {
    "name": "柏果",
    "spell": "baiguo",
    "spellShort": "bgu",
    "code": "BGM"
  },
  {
    "name": "北海",
    "spell": "beihai",
    "spellShort": "bha",
    "code": "BHZ"
  },
  {
    "name": "布海",
    "spell": "buhai",
    "spellShort": "bha",
    "code": "BUT"
  },
  {
    "name": "滨海",
    "spell": "binhai",
    "spellShort": "bha",
    "code": "YKP"
  },
  {
    "name": "滨海北",
    "spell": "binhaibei",
    "spellShort": "bhb",
    "code": "FCP"
  },
  {
    "name": "白河",
    "spell": "baihe",
    "spellShort": "bhe",
    "code": "BEL"
  },
  {
    "name": "滨海西",
    "spell": "binhaixi",
    "spellShort": "bhx",
    "code": "FHP"
  },
  {
    "name": "毕节",
    "spell": "bijie",
    "spellShort": "bji",
    "code": "BOE"
  },
  {
    "name": "宝鸡",
    "spell": "baoji",
    "spellShort": "bji",
    "code": "BJY"
  },
  {
    "name": "白涧",
    "spell": "baijian",
    "spellShort": "bji",
    "code": "BAP"
  },
  {
    "name": "宝鸡南",
    "spell": "baojinan",
    "spellShort": "bjn",
    "code": "BBY"
  },
  {
    "name": "北京丰台",
    "spell": "beijingfengtai",
    "spellShort": "bjt",
    "code": "FTP"
  },
  {
    "name": "白奎堡",
    "spell": "baikuipu",
    "spellShort": "bkp",
    "code": "BKB"
  },
  {
    "name": "博克图",
    "spell": "boketu",
    "spellShort": "bkt",
    "code": "BKX"
  },
  {
    "name": "博乐",
    "spell": "bole",
    "spellShort": "ble",
    "code": "BER"
  },
  {
    "name": "巴林",
    "spell": "balin",
    "spellShort": "bli",
    "code": "BLX"
  },
  {
    "name": "勃利",
    "spell": "boli",
    "spellShort": "bli",
    "code": "BLB"
  },
  {
    "name": "白马井",
    "spell": "baimajing",
    "spellShort": "bmj",
    "code": "BFQ"
  },
  {
    "name": "八面通",
    "spell": "bamiantong",
    "spellShort": "bmt",
    "code": "BMB"
  },
  {
    "name": "北票",
    "spell": "beipiao",
    "spellShort": "bpi",
    "code": "BPT"
  },
  {
    "name": "宝清",
    "spell": "baoqing",
    "spellShort": "bqi",
    "code": "BUB"
  },
  {
    "name": "宝泉岭",
    "spell": "baoquanling",
    "spellShort": "bql",
    "code": "BQB"
  },
  {
    "name": "百色",
    "spell": "baise",
    "spellShort": "bse",
    "code": "BIZ"
  },
  {
    "name": "白山市",
    "spell": "baishanshi",
    "spellShort": "bss",
    "code": "HJL"
  },
  {
    "name": "包头东",
    "spell": "baotoudong",
    "spellShort": "btd",
    "code": "BDC"
  },
  {
    "name": "包头",
    "spell": "baotou",
    "spellShort": "bto",
    "code": "BTC"
  },
  {
    "name": "北屯市",
    "spell": "beitunshi",
    "spellShort": "bts",
    "code": "BXR"
  },
  {
    "name": "宾西北",
    "spell": "binxibei",
    "spellShort": "bxb",
    "code": "BBB"
  },
  {
    "name": "本溪",
    "spell": "benxi",
    "spellShort": "bxi",
    "code": "BXT"
  },
  {
    "name": "步行街",
    "spell": "buxingjie",
    "spellShort": "bxj",
    "code": "BWW"
  },
  {
    "name": "宾阳",
    "spell": "binyang",
    "spellShort": "bya",
    "code": "UKZ"
  },
  {
    "name": "白云鄂博",
    "spell": "baiyunebo",
    "spellShort": "byb",
    "code": "BEC"
  },
  {
    "name": "白云北",
    "spell": "baiyunbei",
    "spellShort": "byb",
    "code": "BVE"
  },
  {
    "name": "白云机场北",
    "spell": "baiyunjichangbei",
    "spellShort": "byb",
    "code": "BBA"
  },
  {
    "name": "白洋淀",
    "spell": "baiyangdian",
    "spellShort": "byd",
    "code": "FWP"
  },
  {
    "name": "背荫河",
    "spell": "beiyinhe",
    "spellShort": "byh",
    "code": "BYB"
  },
  {
    "name": "百宜",
    "spell": "baiyi",
    "spellShort": "byi",
    "code": "FHW"
  },
  {
    "name": "巴彦高勒",
    "spell": "bayangaole",
    "spellShort": "byl",
    "code": "BAC"
  },
  {
    "name": "鲅鱼圈",
    "spell": "bayuquan",
    "spellShort": "byq",
    "code": "BYT"
  },
  {
    "name": "白银西",
    "spell": "baiyinxi",
    "spellShort": "byx",
    "code": "BXJ"
  },
  {
    "name": "白云西",
    "spell": "baiyunxi",
    "spellShort": "byx",
    "code": "BXE"
  },
  {
    "name": "巴中东",
    "spell": "bazhongdong",
    "spellShort": "bzd",
    "code": "BDE"
  },
  {
    "name": "彬州东",
    "spell": "binzhoudong",
    "spellShort": "bzd",
    "code": "BFY"
  },
  {
    "name": "巴中",
    "spell": "bazhong",
    "spellShort": "bzh",
    "code": "IEW"
  },
  {
    "name": "滨州",
    "spell": "binzhou",
    "spellShort": "bzh",
    "code": "BIK"
  },
  {
    "name": "亳州",
    "spell": "bozhou",
    "spellShort": "bzh",
    "code": "BZH"
  },
  {
    "name": "宾州",
    "spell": "binzhou",
    "spellShort": "bzh",
    "code": "BZB"
  },
  {
    "name": "亳州南",
    "spell": "bozhounan",
    "spellShort": "bzn",
    "code": "BNU"
  },
  {
    "name": "查布嘎",
    "spell": "chabuga",
    "spellShort": "cbg",
    "code": "CBC"
  },
  {
    "name": "赤壁",
    "spell": "chibi",
    "spellShort": "cbi",
    "code": "CBN"
  },
  {
    "name": "长白山",
    "spell": "changbaishan",
    "spellShort": "cbs",
    "code": "CUL"
  },
  {
    "name": "常德",
    "spell": "changde",
    "spellShort": "cde",
    "code": "VGQ"
  },
  {
    "name": "承德",
    "spell": "chengde",
    "spellShort": "cde",
    "code": "CDP"
  },
  {
    "name": "承德南",
    "spell": "chengdenan",
    "spellShort": "cdn",
    "code": "IVP"
  },
  {
    "name": "曹妃甸东",
    "spell": "caofeidiandong",
    "spellShort": "cfd",
    "code": "POP"
  },
  {
    "name": "赤峰",
    "spell": "chifeng",
    "spellShort": "cfe",
    "code": "CID"
  },
  {
    "name": "曹妃甸港",
    "spell": "caofeidiangang",
    "spellShort": "cfg",
    "code": "PGP"
  },
  {
    "name": "赤峰南",
    "spell": "chifengnan",
    "spellShort": "cfn",
    "code": "CFD"
  },
  {
    "name": "嵯岗",
    "spell": "cuogang",
    "spellShort": "cga",
    "code": "CAX"
  },
  {
    "name": "柴岗",
    "spell": "chaigang",
    "spellShort": "cga",
    "code": "CGT"
  },
  {
    "name": "柴沟堡",
    "spell": "chaigoubu",
    "spellShort": "cgb",
    "code": "CGV"
  },
  {
    "name": "长葛北",
    "spell": "changgebei",
    "spellShort": "cgb",
    "code": "CGF"
  },
  {
    "name": "城固",
    "spell": "chenggu",
    "spellShort": "cgu",
    "code": "CGY"
  },
  {
    "name": "成高子",
    "spell": "chenggaozi",
    "spellShort": "cgz",
    "code": "CZB"
  },
  {
    "name": "草海",
    "spell": "caohai",
    "spellShort": "cha",
    "code": "WBW"
  },
  {
    "name": "巢湖东",
    "spell": "chaohudong",
    "spellShort": "chd",
    "code": "GUH"
  },
  {
    "name": "柴河",
    "spell": "chaihe",
    "spellShort": "che",
    "code": "CHB"
  },
  {
    "name": "巢湖",
    "spell": "chaohu",
    "spellShort": "chu",
    "code": "CIH"
  },
  {
    "name": "从江",
    "spell": "congjiang",
    "spellShort": "cji",
    "code": "KNW"
  },
  {
    "name": "蔡家崖",
    "spell": "caijiaya",
    "spellShort": "cjy",
    "code": "EBV"
  },
  {
    "name": "长乐东",
    "spell": "changledong",
    "spellShort": "cld",
    "code": "CIS"
  },
  {
    "name": "长乐",
    "spell": "changle",
    "spellShort": "cle",
    "code": "CAS"
  },
  {
    "name": "长临河",
    "spell": "changlinhe",
    "spellShort": "clh",
    "code": "FVH"
  },
  {
    "name": "慈利",
    "spell": "cili",
    "spellShort": "cli",
    "code": "CUQ"
  },
  {
    "name": "茶陵",
    "spell": "chaling",
    "spellShort": "cli",
    "code": "CDG"
  },
  {
    "name": "崇礼",
    "spell": "chongli",
    "spellShort": "cli",
    "code": "KOP"
  },
  {
    "name": "昌黎",
    "spell": "changli",
    "spellShort": "cli",
    "code": "CLP"
  },
  {
    "name": "长流",
    "spell": "changliu",
    "spellShort": "cli",
    "code": "CLA"
  },
  {
    "name": "长乐南",
    "spell": "changlenan",
    "spellShort": "cln",
    "code": "CVS"
  },
  {
    "name": "晨明",
    "spell": "chenming",
    "spellShort": "cmi",
    "code": "CMB"
  },
  {
    "name": "苍南",
    "spell": "cangnan",
    "spellShort": "cna",
    "code": "CEH"
  },
  {
    "name": "昌平北",
    "spell": "changpingbei",
    "spellShort": "cpb",
    "code": "VBP"
  },
  {
    "name": "常平东",
    "spell": "changpingdong",
    "spellShort": "cpd",
    "code": "FQQ"
  },
  {
    "name": "翠屏",
    "spell": "cuiping",
    "spellShort": "cpi",
    "code": "YBW"
  },
  {
    "name": "昌平",
    "spell": "changping",
    "spellShort": "cpi",
    "code": "CPP"
  },
  {
    "name": "长庆桥",
    "spell": "changqingqiao",
    "spellShort": "cqq",
    "code": "CQJ"
  },
  {
    "name": "崇仁",
    "spell": "chongren",
    "spellShort": "cre",
    "code": "CRG"
  },
  {
    "name": "长寿北",
    "spell": "changshoubei",
    "spellShort": "csb",
    "code": "COW"
  },
  {
    "name": "潮汕",
    "spell": "chaoshan",
    "spellShort": "csh",
    "code": "CBQ"
  },
  {
    "name": "察素齐",
    "spell": "chasuqi",
    "spellShort": "csq",
    "code": "CSC"
  },
  {
    "name": "朝天",
    "spell": "chaotian",
    "spellShort": "cti",
    "code": "CTE"
  },
  {
    "name": "长汀南",
    "spell": "changtingnan",
    "spellShort": "ctn",
    "code": "CNS"
  },
  {
    "name": "朝天南",
    "spell": "chaotiannan",
    "spellShort": "ctn",
    "code": "CTY"
  },
  {
    "name": "昌图",
    "spell": "changtu",
    "spellShort": "ctu",
    "code": "CTT"
  },
  {
    "name": "昌图西",
    "spell": "changtuxi",
    "spellShort": "ctx",
    "code": "CPT"
  },
  {
    "name": "长汀镇",
    "spell": "changtingzhen",
    "spellShort": "ctz",
    "code": "CDB"
  },
  {
    "name": "长武",
    "spell": "changwu",
    "spellShort": "cwu",
    "code": "CWY"
  },
  {
    "name": "苍溪",
    "spell": "cangxi",
    "spellShort": "cxi",
    "code": "CXE"
  },
  {
    "name": "辰溪",
    "spell": "chenxi",
    "spellShort": "cxi",
    "code": "CXQ"
  },
  {
    "name": "磁县",
    "spell": "cixian",
    "spellShort": "cxi",
    "code": "CIP"
  },
  {
    "name": "楚雄",
    "spell": "chuxiong",
    "spellShort": "cxi",
    "code": "CUM"
  },
  {
    "name": "曹县",
    "spell": "caoxian",
    "spellShort": "cxi",
    "code": "CXK"
  },
  {
    "name": "城西",
    "spell": "chengxi",
    "spellShort": "cxi",
    "code": "CIA"
  },
  {
    "name": "长兴南",
    "spell": "changxingnan",
    "spellShort": "cxn",
    "code": "CFH"
  },
  {
    "name": "陈相屯",
    "spell": "chenxiangtun",
    "spellShort": "cxt",
    "code": "CXT"
  },
  {
    "name": "春阳",
    "spell": "chunyang",
    "spellShort": "cya",
    "code": "CAL"
  },
  {
    "name": "潮阳",
    "spell": "chaoyang",
    "spellShort": "cya",
    "code": "CNQ"
  },
  {
    "name": "朝阳川",
    "spell": "chaoyangchuan",
    "spellShort": "cyc",
    "code": "CYL"
  },
  {
    "name": "朝阳湖",
    "spell": "chaoyanghu",
    "spellShort": "cyh",
    "code": "CYE"
  },
  {
    "name": "滁州北",
    "spell": "chuzhoubei",
    "spellShort": "czb",
    "code": "CUH"
  },
  {
    "name": "常州北",
    "spell": "changzhoubei",
    "spellShort": "czb",
    "code": "ESH"
  },
  {
    "name": "长治北",
    "spell": "changzhibei",
    "spellShort": "czb",
    "code": "CBF"
  },
  {
    "name": "长治东",
    "spell": "changzhidong",
    "spellShort": "czd",
    "code": "CUF"
  },
  {
    "name": "长征",
    "spell": "changzheng",
    "spellShort": "czh",
    "code": "CZJ"
  },
  {
    "name": "池州",
    "spell": "chizhou",
    "spellShort": "czh",
    "code": "IYH"
  },
  {
    "name": "滁州",
    "spell": "chuzhou",
    "spellShort": "czh",
    "code": "CXH"
  },
  {
    "name": "郴州",
    "spell": "chenzhou",
    "spellShort": "czh",
    "code": "CZQ"
  },
  {
    "name": "沧州",
    "spell": "cangzhou",
    "spellShort": "czh",
    "code": "COP"
  },
  {
    "name": "常州",
    "spell": "changzhou",
    "spellShort": "czh",
    "code": "CZH"
  },
  {
    "name": "长治",
    "spell": "changzhi",
    "spellShort": "czh",
    "code": "CZF"
  },
  {
    "name": "崇州",
    "spell": "chongzhou",
    "spellShort": "czh",
    "code": "CZE"
  },
  {
    "name": "崇左南",
    "spell": "chongzuonan",
    "spellShort": "czn",
    "code": "COZ"
  },
  {
    "name": "崇左",
    "spell": "chongzuo",
    "spellShort": "czu",
    "code": "CZZ"
  },
  {
    "name": "郴州西",
    "spell": "chenzhouxi",
    "spellShort": "czx",
    "code": "ICQ"
  },
  {
    "name": "沧州西",
    "spell": "cangzhouxi",
    "spellShort": "czx",
    "code": "CBP"
  },
  {
    "name": "大安北",
    "spell": "daanbei",
    "spellShort": "dab",
    "code": "RNT"
  },
  {
    "name": "东安东",
    "spell": "dongandong",
    "spellShort": "dad",
    "code": "DCZ"
  },
  {
    "name": "达坂城",
    "spell": "dabancheng",
    "spellShort": "dbc",
    "code": "DCR"
  },
  {
    "name": "定边",
    "spell": "dingbian",
    "spellShort": "dbi",
    "code": "DYJ"
  },
  {
    "name": "东岔",
    "spell": "dongcha",
    "spellShort": "dch",
    "code": "DCJ"
  },
  {
    "name": "丹东",
    "spell": "dandong",
    "spellShort": "ddo",
    "code": "DUT"
  },
  {
    "name": "东方",
    "spell": "dongfang",
    "spellShort": "dfa",
    "code": "UFQ"
  },
  {
    "name": "丹凤",
    "spell": "danfeng",
    "spellShort": "dfe",
    "code": "DGY"
  },
  {
    "name": "大丰",
    "spell": "dafeng",
    "spellShort": "dfe",
    "code": "KRQ"
  },
  {
    "name": "东方红",
    "spell": "dongfanghong",
    "spellShort": "dfh",
    "code": "DFB"
  },
  {
    "name": "大方南",
    "spell": "dafangnan",
    "spellShort": "dfn",
    "code": "DNE"
  },
  {
    "name": "东风南",
    "spell": "dongfengnan",
    "spellShort": "dfn",
    "code": "DPJ"
  },
  {
    "name": "东港北",
    "spell": "donggangbei",
    "spellShort": "dgb",
    "code": "RGT"
  },
  {
    "name": "东莞东",
    "spell": "dongguandong",
    "spellShort": "dgd",
    "code": "DMQ"
  },
  {
    "name": "东莞南",
    "spell": "dongguannan",
    "spellShort": "dgn",
    "code": "DNA"
  },
  {
    "name": "大孤山",
    "spell": "dagushan",
    "spellShort": "dgs",
    "code": "RMT"
  },
  {
    "name": "东莞",
    "spell": "dongguan",
    "spellShort": "dgu",
    "code": "RTQ"
  },
  {
    "name": "东莞西",
    "spell": "dongguanxi",
    "spellShort": "dgx",
    "code": "WGQ"
  },
  {
    "name": "大红旗",
    "spell": "dahongqi",
    "spellShort": "dhq",
    "code": "DQD"
  },
  {
    "name": "大虎山",
    "spell": "dahushan",
    "spellShort": "dhs",
    "code": "DHD"
  },
  {
    "name": "敦化",
    "spell": "dunhua",
    "spellShort": "dhu",
    "code": "DHL"
  },
  {
    "name": "敦煌",
    "spell": "dunhuang",
    "spellShort": "dhu",
    "code": "DHJ"
  },
  {
    "name": "德惠",
    "spell": "dehui",
    "spellShort": "dhu",
    "code": "DHT"
  },
  {
    "name": "德惠西",
    "spell": "dehuixi",
    "spellShort": "dhx",
    "code": "DXT"
  },
  {
    "name": "东京城",
    "spell": "dongjingcheng",
    "spellShort": "djc",
    "code": "DJB"
  },
  {
    "name": "达家沟",
    "spell": "dajiagou",
    "spellShort": "djg",
    "code": "DJT"
  },
  {
    "name": "垫江",
    "spell": "dianjiang",
    "spellShort": "dji",
    "code": "DJE"
  },
  {
    "name": "道滘",
    "spell": "daojiao",
    "spellShort": "dji",
    "code": "RRQ"
  },
  {
    "name": "大涧",
    "spell": "dajian",
    "spellShort": "dji",
    "code": "DFP"
  },
  {
    "name": "洞井",
    "spell": "dongjing",
    "spellShort": "dji",
    "code": "FWQ"
  },
  {
    "name": "都江堰",
    "spell": "dujiangyan",
    "spellShort": "djy",
    "code": "DDW"
  },
  {
    "name": "洞口",
    "spell": "dongkou",
    "spellShort": "dko",
    "code": "DKA"
  },
  {
    "name": "大连北",
    "spell": "dalianbei",
    "spellShort": "dlb",
    "code": "DFT"
  },
  {
    "name": "德令哈",
    "spell": "delingha",
    "spellShort": "dlh",
    "code": "DHO"
  },
  {
    "name": "达连河",
    "spell": "dalianhe",
    "spellShort": "dlh",
    "code": "DCB"
  },
  {
    "name": "大荔",
    "spell": "dali",
    "spellShort": "dli",
    "code": "DNY"
  },
  {
    "name": "大理",
    "spell": "dali",
    "spellShort": "dli",
    "code": "DKM"
  },
  {
    "name": "大连",
    "spell": "dalian",
    "spellShort": "dli",
    "code": "DLT"
  },
  {
    "name": "大明湖",
    "spell": "daminghu",
    "spellShort": "dmh",
    "code": "JAK"
  },
  {
    "name": "得莫利",
    "spell": "demoli",
    "spellShort": "dml",
    "code": "DTB"
  },
  {
    "name": "东明县",
    "spell": "dongmingxian",
    "spellShort": "dmx",
    "code": "DNF"
  },
  {
    "name": "定南",
    "spell": "dingnan",
    "spellShort": "dna",
    "code": "DNG"
  },
  {
    "name": "定南南",
    "spell": "dingnannan",
    "spellShort": "dnn",
    "code": "DIG"
  },
  {
    "name": "大埔",
    "spell": "dapu",
    "spellShort": "dpu",
    "code": "DPI"
  },
  {
    "name": "大庆东",
    "spell": "daqingdong",
    "spellShort": "dqd",
    "code": "LFX"
  },
  {
    "name": "大庆",
    "spell": "daqing",
    "spellShort": "dqi",
    "code": "DZX"
  },
  {
    "name": "对青山",
    "spell": "duiqingshan",
    "spellShort": "dqs",
    "code": "DQB"
  },
  {
    "name": "大庆西",
    "spell": "daqingxi",
    "spellShort": "dqx",
    "code": "RHX"
  },
  {
    "name": "东胜",
    "spell": "dongsheng",
    "spellShort": "dsh",
    "code": "DOC"
  },
  {
    "name": "独山",
    "spell": "dushan",
    "spellShort": "dsh",
    "code": "RWW"
  },
  {
    "name": "砀山南",
    "spell": "dangshannan",
    "spellShort": "dsn",
    "code": "PRH"
  },
  {
    "name": "大石桥",
    "spell": "dashiqiao",
    "spellShort": "dsq",
    "code": "DQT"
  },
  {
    "name": "东胜西",
    "spell": "dongshengxi",
    "spellShort": "dsx",
    "code": "DYC"
  },
  {
    "name": "大同南",
    "spell": "datongnan",
    "spellShort": "dtn",
    "code": "DMV"
  },
  {
    "name": "大同",
    "spell": "datong",
    "spellShort": "dto",
    "code": "DTV"
  },
  {
    "name": "大屯",
    "spell": "datun",
    "spellShort": "dtu",
    "code": "DNT"
  },
  {
    "name": "大通西",
    "spell": "datongxi",
    "spellShort": "dtx",
    "code": "DTO"
  },
  {
    "name": "大武口",
    "spell": "dawukou",
    "spellShort": "dwk",
    "code": "DFJ"
  },
  {
    "name": "党武",
    "spell": "dangwu",
    "spellShort": "dwu",
    "code": "DWE"
  },
  {
    "name": "定西北",
    "spell": "dingxibei",
    "spellShort": "dxb",
    "code": "DNJ"
  },
  {
    "name": "大兴机场",
    "spell": "daxingjichang",
    "spellShort": "dxc",
    "code": "IWP"
  },
  {
    "name": "定西",
    "spell": "dingxi",
    "spellShort": "dxi",
    "code": "DSJ"
  },
  {
    "name": "东乡",
    "spell": "dongxiang",
    "spellShort": "dxi",
    "code": "DXG"
  },
  {
    "name": "大兴",
    "spell": "daxing",
    "spellShort": "dxi",
    "code": "DXX"
  },
  {
    "name": "东兴市",
    "spell": "dongxingshi",
    "spellShort": "dxs",
    "code": "RIZ"
  },
  {
    "name": "德阳",
    "spell": "deyang",
    "spellShort": "dya",
    "code": "DYW"
  },
  {
    "name": "当阳",
    "spell": "dangyang",
    "spellShort": "dya",
    "code": "DYN"
  },
  {
    "name": "丹阳",
    "spell": "danyang",
    "spellShort": "dya",
    "code": "DYH"
  },
  {
    "name": "大冶北",
    "spell": "dayebei",
    "spellShort": "dyb",
    "code": "DBN"
  },
  {
    "name": "大英东",
    "spell": "dayingdong",
    "spellShort": "dyd",
    "code": "IAW"
  },
  {
    "name": "都匀东",
    "spell": "duyundong",
    "spellShort": "dyd",
    "code": "KJW"
  },
  {
    "name": "东营",
    "spell": "dongying",
    "spellShort": "dyi",
    "code": "DPK"
  },
  {
    "name": "大邑",
    "spell": "dayi",
    "spellShort": "dyi",
    "code": "DEE"
  },
  {
    "name": "东营南",
    "spell": "dongyingnan",
    "spellShort": "dyn",
    "code": "DOK"
  },
  {
    "name": "大杨树",
    "spell": "dayangshu",
    "spellShort": "dys",
    "code": "DUX"
  },
  {
    "name": "都匀",
    "spell": "duyun",
    "spellShort": "dyu",
    "code": "RYW"
  },
  {
    "name": "德州东",
    "spell": "dezhoudong",
    "spellShort": "dzd",
    "code": "DIP"
  },
  {
    "name": "定州东",
    "spell": "dingzhoudong",
    "spellShort": "dzd",
    "code": "DOP"
  },
  {
    "name": "邓州东",
    "spell": "dengzhoudong",
    "spellShort": "dzd",
    "code": "DDF"
  },
  {
    "name": "东至",
    "spell": "dongzhi",
    "spellShort": "dzh",
    "code": "DCH"
  },
  {
    "name": "达州",
    "spell": "dazhou",
    "spellShort": "dzh",
    "code": "RXW"
  },
  {
    "name": "德州",
    "spell": "dezhou",
    "spellShort": "dzh",
    "code": "DZP"
  },
  {
    "name": "定州",
    "spell": "dingzhou",
    "spellShort": "dzh",
    "code": "DXP"
  },
  {
    "name": "邓州",
    "spell": "dengzhou",
    "spellShort": "dzh",
    "code": "DOF"
  },
  {
    "name": "峨边",
    "spell": "ebian",
    "spellShort": "ebi",
    "code": "EBW"
  },
  {
    "name": "鄂尔多斯",
    "spell": "eerduosi",
    "spellShort": "ees",
    "code": "EEC"
  },
  {
    "name": "额济纳",
    "spell": "ejina",
    "spellShort": "ejn",
    "code": "EJC"
  },
  {
    "name": "二连",
    "spell": "erlian",
    "spellShort": "eli",
    "code": "RLC"
  },
  {
    "name": "峨眉",
    "spell": "emei",
    "spellShort": "eme",
    "code": "EMW"
  },
  {
    "name": "峨眉山",
    "spell": "emeishan",
    "spellShort": "ems",
    "code": "IXW"
  },
  {
    "name": "恩施",
    "spell": "enshi",
    "spellShort": "esh",
    "code": "ESN"
  },
  {
    "name": "鄂州",
    "spell": "ezhou",
    "spellShort": "ezh",
    "code": "ECN"
  },
  {
    "name": "防城港北",
    "spell": "fangchenggangbei",
    "spellShort": "fcb",
    "code": "FBZ"
  },
  {
    "name": "福鼎",
    "spell": "fuding",
    "spellShort": "fdi",
    "code": "FES"
  },
  {
    "name": "肥东",
    "spell": "feidong",
    "spellShort": "fdo",
    "code": "FIH"
  },
  {
    "name": "丰都",
    "spell": "fengdu",
    "spellShort": "fdu",
    "code": "FUW"
  },
  {
    "name": "发耳",
    "spell": "faer",
    "spellShort": "fer",
    "code": "FEM"
  },
  {
    "name": "福海",
    "spell": "fuhai",
    "spellShort": "fha",
    "code": "FHR"
  },
  {
    "name": "凤凰机场",
    "spell": "fenghuangjichang",
    "spellShort": "fhc",
    "code": "FJQ"
  },
  {
    "name": "凤凰城",
    "spell": "fenghuangcheng",
    "spellShort": "fhc",
    "code": "FHT"
  },
  {
    "name": "汾河",
    "spell": "fenhe",
    "spellShort": "fhe",
    "code": "FEV"
  },
  {
    "name": "奉化",
    "spell": "fenghua",
    "spellShort": "fhu",
    "code": "FHH"
  },
  {
    "name": "富锦",
    "spell": "fujin",
    "spellShort": "fji",
    "code": "FIB"
  },
  {
    "name": "范家屯",
    "spell": "fanjiatun",
    "spellShort": "fjt",
    "code": "FTT"
  },
  {
    "name": "涪陵北",
    "spell": "fulingbei",
    "spellShort": "flb",
    "code": "FEW"
  },
  {
    "name": "风陵渡",
    "spell": "fenglingdu",
    "spellShort": "fld",
    "code": "FLV"
  },
  {
    "name": "浮梁东",
    "spell": "fuliangdong",
    "spellShort": "fld",
    "code": "FVG"
  },
  {
    "name": "涪陵",
    "spell": "fuling",
    "spellShort": "fli",
    "code": "FLW"
  },
  {
    "name": "富拉尔基",
    "spell": "fulaerji",
    "spellShort": "flj",
    "code": "FRX"
  },
  {
    "name": "福利区",
    "spell": "fuliqu",
    "spellShort": "flq",
    "code": "FLJ"
  },
  {
    "name": "阜宁东",
    "spell": "funingdong",
    "spellShort": "fnd",
    "code": "FDU"
  },
  {
    "name": "富宁",
    "spell": "funing",
    "spellShort": "fni",
    "code": "FNM"
  },
  {
    "name": "福清",
    "spell": "fuqing",
    "spellShort": "fqi",
    "code": "FQS"
  },
  {
    "name": "福泉",
    "spell": "fuquan",
    "spellShort": "fqu",
    "code": "VMW"
  },
  {
    "name": "芙蓉南",
    "spell": "furongnan",
    "spellShort": "frn",
    "code": "KCQ"
  },
  {
    "name": "抚顺北",
    "spell": "fushunbei",
    "spellShort": "fsb",
    "code": "FET"
  },
  {
    "name": "富顺",
    "spell": "fushun",
    "spellShort": "fsh",
    "code": "FSE"
  },
  {
    "name": "佛山",
    "spell": "foshan",
    "spellShort": "fsh",
    "code": "FSQ"
  },
  {
    "name": "扶绥",
    "spell": "fusui",
    "spellShort": "fsu",
    "code": "FSZ"
  },
  {
    "name": "佛山西",
    "spell": "foshanxi",
    "spellShort": "fsx",
    "code": "FOQ"
  },
  {
    "name": "福田",
    "spell": "futian",
    "spellShort": "fti",
    "code": "NZQ"
  },
  {
    "name": "凤县",
    "spell": "fengxian",
    "spellShort": "fxi",
    "code": "FXY"
  },
  {
    "name": "阜新",
    "spell": "fuxin",
    "spellShort": "fxi",
    "code": "FOT"
  },
  {
    "name": "肥西",
    "spell": "feixi",
    "spellShort": "fxi",
    "code": "FAH"
  },
  {
    "name": "阜新南",
    "spell": "fuxinnan",
    "spellShort": "fxn",
    "code": "FXD"
  },
  {
    "name": "阜阳",
    "spell": "fuyang",
    "spellShort": "fya",
    "code": "FYH"
  },
  {
    "name": "富阳",
    "spell": "fuyang",
    "spellShort": "fya",
    "code": "FYU"
  },
  {
    "name": "扶余北",
    "spell": "fuyubei",
    "spellShort": "fyb",
    "code": "FBT"
  },
  {
    "name": "分宜",
    "spell": "fenyi",
    "spellShort": "fyi",
    "code": "FYG"
  },
  {
    "name": "富蕴",
    "spell": "fuyun",
    "spellShort": "fyu",
    "code": "FYR"
  },
  {
    "name": "富源",
    "spell": "fuyuan",
    "spellShort": "fyu",
    "code": "FYM"
  },
  {
    "name": "抚远",
    "spell": "fuyuan",
    "spellShort": "fyu",
    "code": "FYB"
  },
  {
    "name": "富裕",
    "spell": "fuyu",
    "spellShort": "fyu",
    "code": "FYX"
  },
  {
    "name": "阜阳西",
    "spell": "fuyangxi",
    "spellShort": "fyx",
    "code": "FXU"
  },
  {
    "name": "丰镇",
    "spell": "fengzhen",
    "spellShort": "fzh",
    "code": "FZC"
  },
  {
    "name": "凤州",
    "spell": "fengzhou",
    "spellShort": "fzh",
    "code": "FZY"
  },
  {
    "name": "抚州",
    "spell": "fuzhou",
    "spellShort": "fzh",
    "code": "FZG"
  },
  {
    "name": "方正",
    "spell": "fangzheng",
    "spellShort": "fzh",
    "code": "FNB"
  },
  {
    "name": "广安南",
    "spell": "guangannan",
    "spellShort": "gan",
    "code": "VUW"
  },
  {
    "name": "广安",
    "spell": "guangan",
    "spellShort": "gan",
    "code": "VJW"
  },
  {
    "name": "高安",
    "spell": "gaoan",
    "spellShort": "gan",
    "code": "GCG"
  },
  {
    "name": "贵安",
    "spell": "guian",
    "spellShort": "gan",
    "code": "GAE"
  },
  {
    "name": "古北口",
    "spell": "gubeikou",
    "spellShort": "gbk",
    "code": "GKP"
  },
  {
    "name": "藁城",
    "spell": "gaocheng",
    "spellShort": "gch",
    "code": "GEP"
  },
  {
    "name": "藁城南",
    "spell": "gaochengnan",
    "spellShort": "gcn",
    "code": "GUP"
  },
  {
    "name": "高村",
    "spell": "gaocun",
    "spellShort": "gcu",
    "code": "GCV"
  },
  {
    "name": "古东",
    "spell": "gudong",
    "spellShort": "gdo",
    "code": "GDV"
  },
  {
    "name": "格尔木",
    "spell": "geermu",
    "spellShort": "gem",
    "code": "GRO"
  },
  {
    "name": "贵港",
    "spell": "guigang",
    "spellShort": "gga",
    "code": "GGZ"
  },
  {
    "name": "甘谷",
    "spell": "gangu",
    "spellShort": "ggu",
    "code": "GGJ"
  },
  {
    "name": "根河",
    "spell": "genhe",
    "spellShort": "ghe",
    "code": "GEX"
  },
  {
    "name": "高花",
    "spell": "gaohua",
    "spellShort": "ghu",
    "code": "HGD"
  },
  {
    "name": "古交",
    "spell": "gujiao",
    "spellShort": "gji",
    "code": "GJV"
  },
  {
    "name": "皋兰",
    "spell": "gaolan",
    "spellShort": "gla",
    "code": "GEJ"
  },
  {
    "name": "桂林北",
    "spell": "guilinbei",
    "spellShort": "glb",
    "code": "GBZ"
  },
  {
    "name": "高楞",
    "spell": "gaoleng",
    "spellShort": "gle",
    "code": "GLB"
  },
  {
    "name": "桂林",
    "spell": "guilin",
    "spellShort": "gli",
    "code": "GLZ"
  },
  {
    "name": "古莲",
    "spell": "gulian",
    "spellShort": "gli",
    "code": "GRX"
  },
  {
    "name": "甘洛",
    "spell": "ganluo",
    "spellShort": "glu",
    "code": "VOW"
  },
  {
    "name": "公庙子",
    "spell": "gongmiaozi",
    "spellShort": "gmz",
    "code": "GMC"
  },
  {
    "name": "广南县",
    "spell": "guangnanxian",
    "spellShort": "gnx",
    "code": "GXM"
  },
  {
    "name": "桂平",
    "spell": "guiping",
    "spellShort": "gpi",
    "code": "GAZ"
  },
  {
    "name": "共青城",
    "spell": "gongqingcheng",
    "spellShort": "gqc",
    "code": "GAG"
  },
  {
    "name": "固始",
    "spell": "gushi",
    "spellShort": "gsh",
    "code": "GXN"
  },
  {
    "name": "广水",
    "spell": "guangshui",
    "spellShort": "gsh",
    "code": "GSN"
  },
  {
    "name": "谷山",
    "spell": "gushan",
    "spellShort": "gsh",
    "code": "FFQ"
  },
  {
    "name": "观沙岭",
    "spell": "guanshaling",
    "spellShort": "gsl",
    "code": "FKQ"
  },
  {
    "name": "干塘",
    "spell": "gantang",
    "spellShort": "gta",
    "code": "GNJ"
  },
  {
    "name": "广通北",
    "spell": "guangtongbei",
    "spellShort": "gtb",
    "code": "GPM"
  },
  {
    "name": "古田会址",
    "spell": "gutianhuizhi",
    "spellShort": "gtz",
    "code": "STS"
  },
  {
    "name": "高兴",
    "spell": "gaoxing",
    "spellShort": "gxi",
    "code": "VWW"
  },
  {
    "name": "冠县",
    "spell": "guanxian",
    "spellShort": "gxi",
    "code": "GHP"
  },
  {
    "name": "广阳",
    "spell": "guangyang",
    "spellShort": "gya",
    "code": "LFP"
  },
  {
    "name": "高邑",
    "spell": "gaoyi",
    "spellShort": "gyi",
    "code": "GIP"
  },
  {
    "name": "巩义",
    "spell": "gongyi",
    "spellShort": "gyi",
    "code": "GXF"
  },
  {
    "name": "巩义南",
    "spell": "gongyinan",
    "spellShort": "gyn",
    "code": "GYF"
  },
  {
    "name": "固原",
    "spell": "guyuan",
    "spellShort": "gyu",
    "code": "GUJ"
  },
  {
    "name": "广元",
    "spell": "guangyuan",
    "spellShort": "gyu",
    "code": "GYW"
  },
  {
    "name": "赣榆",
    "spell": "ganyu",
    "spellShort": "gyu",
    "code": "GYU"
  },
  {
    "name": "高邑西",
    "spell": "gaoyixi",
    "spellShort": "gyx",
    "code": "GNP"
  },
  {
    "name": "高州",
    "spell": "gaozhou",
    "spellShort": "gzh",
    "code": "GSQ"
  },
  {
    "name": "赣州",
    "spell": "ganzhou",
    "spellShort": "gzh",
    "code": "GZG"
  },
  {
    "name": "公主岭",
    "spell": "gongzhuling",
    "spellShort": "gzl",
    "code": "GLT"
  },
  {
    "name": "公主岭南",
    "spell": "gongzhulingnan",
    "spellShort": "gzn",
    "code": "GBT"
  },
  {
    "name": "冠豸山",
    "spell": "guanzhaishan",
    "spellShort": "gzs",
    "code": "GPS"
  },
  {
    "name": "盖州西",
    "spell": "gaizhouxi",
    "spellShort": "gzx",
    "code": "GAT"
  },
  {
    "name": "赣州西",
    "spell": "ganzhouxi",
    "spellShort": "gzx",
    "code": "GOG"
  },
  {
    "name": "淮安东",
    "spell": "huaiandong",
    "spellShort": "had",
    "code": "HAU"
  },
  {
    "name": "淮安",
    "spell": "huaian",
    "spellShort": "han",
    "code": "AUH"
  },
  {
    "name": "红安西",
    "spell": "honganxi",
    "spellShort": "hax",
    "code": "VXN"
  },
  {
    "name": "淮北",
    "spell": "huaibei",
    "spellShort": "hbe",
    "code": "HRH"
  },
  {
    "name": "鹤北",
    "spell": "hebei",
    "spellShort": "hbe",
    "code": "HMB"
  },
  {
    "name": "淮滨",
    "spell": "huaibin",
    "spellShort": "hbi",
    "code": "HVN"
  },
  {
    "name": "河边",
    "spell": "hebian",
    "spellShort": "hbi",
    "code": "HBV"
  },
  {
    "name": "湖潮东",
    "spell": "huchaodong",
    "spellShort": "hcd",
    "code": "HCE"
  },
  {
    "name": "韩城",
    "spell": "hancheng",
    "spellShort": "hch",
    "code": "HCY"
  },
  {
    "name": "合川",
    "spell": "hechuan",
    "spellShort": "hch",
    "code": "WKW"
  },
  {
    "name": "珲春",
    "spell": "hunchun",
    "spellShort": "hch",
    "code": "HUL"
  },
  {
    "name": "潢川",
    "spell": "huangchuan",
    "spellShort": "hch",
    "code": "KCN"
  },
  {
    "name": "海城",
    "spell": "haicheng",
    "spellShort": "hch",
    "code": "HCT"
  },
  {
    "name": "花城街",
    "spell": "huachengjie",
    "spellShort": "hcj",
    "code": "HCA"
  },
  {
    "name": "黄村",
    "spell": "huangcun",
    "spellShort": "hcu",
    "code": "HCP"
  },
  {
    "name": "河池西",
    "spell": "hechixi",
    "spellShort": "hcx",
    "code": "HIZ"
  },
  {
    "name": "海城西",
    "spell": "haichengxi",
    "spellShort": "hcx",
    "code": "HXT"
  },
  {
    "name": "邯郸",
    "spell": "handan",
    "spellShort": "hda",
    "code": "HDP"
  },
  {
    "name": "河东机场",
    "spell": "hedongjichang",
    "spellShort": "hdc",
    "code": "HFJ"
  },
  {
    "name": "邯郸东",
    "spell": "handandong",
    "spellShort": "hdd",
    "code": "HPP"
  },
  {
    "name": "惠东南",
    "spell": "huidongnan",
    "spellShort": "hdn",
    "code": "KDQ"
  },
  {
    "name": "哈达铺",
    "spell": "hadapu",
    "spellShort": "hdp",
    "code": "HDJ"
  },
  {
    "name": "花都",
    "spell": "huadu",
    "spellShort": "hdu",
    "code": "HAA"
  },
  {
    "name": "洪洞西",
    "spell": "hongtongxi",
    "spellShort": "hdx",
    "code": "HTV"
  },
  {
    "name": "横道河子",
    "spell": "hengdaohezi",
    "spellShort": "hdz",
    "code": "HDB"
  },
  {
    "name": "霍尔果斯",
    "spell": "huoerguosi",
    "spellShort": "hes",
    "code": "HFR"
  },
  {
    "name": "鹤岗",
    "spell": "hegang",
    "spellShort": "hga",
    "code": "HGB"
  },
  {
    "name": "黄冈东",
    "spell": "huanggangdong",
    "spellShort": "hgd",
    "code": "KAN"
  },
  {
    "name": "红果",
    "spell": "hongguo",
    "spellShort": "hgu",
    "code": "HEM"
  },
  {
    "name": "汉沽",
    "spell": "hangu",
    "spellShort": "hgu",
    "code": "HGP"
  },
  {
    "name": "红光镇",
    "spell": "hongguangzhen",
    "spellShort": "hgz",
    "code": "IGW"
  },
  {
    "name": "红河",
    "spell": "honghe",
    "spellShort": "hhe",
    "code": "HHM"
  },
  {
    "name": "黑河",
    "spell": "heihe",
    "spellShort": "hhe",
    "code": "HJB"
  },
  {
    "name": "怀化南",
    "spell": "huaihuanan",
    "spellShort": "hhn",
    "code": "KAQ"
  },
  {
    "name": "黄河景区",
    "spell": "huanghejingqu",
    "spellShort": "hhq",
    "code": "HCF"
  },
  {
    "name": "怀化",
    "spell": "huaihua",
    "spellShort": "hhu",
    "code": "HHQ"
  },
  {
    "name": "后湖",
    "spell": "houhu",
    "spellShort": "hhu",
    "code": "IHN"
  },
  {
    "name": "环江",
    "spell": "huanjiang",
    "spellShort": "hji",
    "code": "HFZ"
  },
  {
    "name": "和静",
    "spell": "hejing",
    "spellShort": "hji",
    "code": "HJR"
  },
  {
    "name": "河津",
    "spell": "hejin",
    "spellShort": "hji",
    "code": "HJV"
  },
  {
    "name": "怀集",
    "spell": "huaiji",
    "spellShort": "hji",
    "code": "FAQ"
  },
  {
    "name": "华家",
    "spell": "huajia",
    "spellShort": "hji",
    "code": "HJT"
  },
  {
    "name": "河口北",
    "spell": "hekoubei",
    "spellShort": "hkb",
    "code": "HBM"
  },
  {
    "name": "宏克力",
    "spell": "hongkeli",
    "spellShort": "hkl",
    "code": "OKB"
  },
  {
    "name": "河口南",
    "spell": "hekounan",
    "spellShort": "hkn",
    "code": "HKJ"
  },
  {
    "name": "汉口",
    "spell": "hankou",
    "spellShort": "hko",
    "code": "HKN"
  },
  {
    "name": "呼兰",
    "spell": "hulan",
    "spellShort": "hla",
    "code": "HUB"
  },
  {
    "name": "葫芦岛北",
    "spell": "huludaobei",
    "spellShort": "hlb",
    "code": "HPD"
  },
  {
    "name": "葫芦岛",
    "spell": "huludao",
    "spellShort": "hld",
    "code": "HLD"
  },
  {
    "name": "海拉尔",
    "spell": "hailaer",
    "spellShort": "hle",
    "code": "HRX"
  },
  {
    "name": "哈拉海",
    "spell": "halahai",
    "spellShort": "hlh",
    "code": "HIT"
  },
  {
    "name": "寒岭",
    "spell": "hanling",
    "spellShort": "hli",
    "code": "HAT"
  },
  {
    "name": "海林",
    "spell": "hailin",
    "spellShort": "hli",
    "code": "HRB"
  },
  {
    "name": "虎林",
    "spell": "hulin",
    "spellShort": "hli",
    "code": "VLB"
  },
  {
    "name": "霍林郭勒",
    "spell": "huolinguole",
    "spellShort": "hll",
    "code": "HWD"
  },
  {
    "name": "黄陵南",
    "spell": "huanglingnan",
    "spellShort": "hln",
    "code": "VLY"
  },
  {
    "name": "海伦",
    "spell": "hailun",
    "spellShort": "hlu",
    "code": "HLB"
  },
  {
    "name": "侯马",
    "spell": "houma",
    "spellShort": "hma",
    "code": "HMV"
  },
  {
    "name": "黄梅东",
    "spell": "huangmeidong",
    "spellShort": "hmd",
    "code": "HDU"
  },
  {
    "name": "鲘门",
    "spell": "houmen",
    "spellShort": "hme",
    "code": "KMQ"
  },
  {
    "name": "海门",
    "spell": "haimen",
    "spellShort": "hme",
    "code": "HMU"
  },
  {
    "name": "哈密",
    "spell": "hami",
    "spellShort": "hmi",
    "code": "HMR"
  },
  {
    "name": "侯马西",
    "spell": "houmaxi",
    "spellShort": "hmx",
    "code": "HPV"
  },
  {
    "name": "淮南",
    "spell": "huainan",
    "spellShort": "hna",
    "code": "HAH"
  },
  {
    "name": "桦南",
    "spell": "huanan",
    "spellShort": "hna",
    "code": "HNB"
  },
  {
    "name": "淮南东",
    "spell": "huainandong",
    "spellShort": "hnd",
    "code": "HOH"
  },
  {
    "name": "淮南南",
    "spell": "huainannan",
    "spellShort": "hnn",
    "code": "HNU"
  },
  {
    "name": "海宁西",
    "spell": "hainingxi",
    "spellShort": "hnx",
    "code": "EUH"
  },
  {
    "name": "鹤庆",
    "spell": "heqing",
    "spellShort": "hqi",
    "code": "HQM"
  },
  {
    "name": "怀柔北",
    "spell": "huairoubei",
    "spellShort": "hrb",
    "code": "HBP"
  },
  {
    "name": "怀仁东",
    "spell": "huairendong",
    "spellShort": "hrd",
    "code": "HFV"
  },
  {
    "name": "怀柔南",
    "spell": "huairounan",
    "spellShort": "hrn",
    "code": "IMP"
  },
  {
    "name": "怀柔",
    "spell": "huairou",
    "spellShort": "hro",
    "code": "HRP"
  },
  {
    "name": "华山北",
    "spell": "huashanbei",
    "spellShort": "hsb",
    "code": "HDY"
  },
  {
    "name": "衡水北",
    "spell": "hengshuibei",
    "spellShort": "hsb",
    "code": "IHP"
  },
  {
    "name": "黄山北",
    "spell": "huangshanbei",
    "spellShort": "hsb",
    "code": "NYH"
  },
  {
    "name": "黄石东",
    "spell": "huangshidong",
    "spellShort": "hsd",
    "code": "OSN"
  },
  {
    "name": "和什托洛盖",
    "spell": "heshituoluogai",
    "spellShort": "hsg",
    "code": "VSR"
  },
  {
    "name": "华山",
    "spell": "huashan",
    "spellShort": "hsh",
    "code": "HGY"
  },
  {
    "name": "和硕",
    "spell": "heshuo",
    "spellShort": "hsh",
    "code": "VUR"
  },
  {
    "name": "黑水",
    "spell": "heishui",
    "spellShort": "hsh",
    "code": "HOT"
  },
  {
    "name": "衡水",
    "spell": "hengshui",
    "spellShort": "hsh",
    "code": "HSP"
  },
  {
    "name": "黄石",
    "spell": "huangshi",
    "spellShort": "hsh",
    "code": "HSN"
  },
  {
    "name": "黄山",
    "spell": "huangshan",
    "spellShort": "hsh",
    "code": "HKH"
  },
  {
    "name": "花山南",
    "spell": "huashannan",
    "spellShort": "hsn",
    "code": "KNN"
  },
  {
    "name": "黑山寺",
    "spell": "heishansi",
    "spellShort": "hss",
    "code": "HVP"
  },
  {
    "name": "海石湾",
    "spell": "haishiwan",
    "spellShort": "hsw",
    "code": "HSO"
  },
  {
    "name": "黄山西",
    "spell": "huangshanxi",
    "spellShort": "hsx",
    "code": "HWU"
  },
  {
    "name": "花山镇",
    "spell": "huashanzhen",
    "spellShort": "hsz",
    "code": "HZA"
  },
  {
    "name": "黄土店",
    "spell": "huangtudian",
    "spellShort": "htd",
    "code": "HKP"
  },
  {
    "name": "花土沟",
    "spell": "huatugou",
    "spellShort": "htg",
    "code": "HTO"
  },
  {
    "name": "和田",
    "spell": "hetian",
    "spellShort": "hti",
    "code": "VTR"
  },
  {
    "name": "会同",
    "spell": "huitong",
    "spellShort": "hto",
    "code": "VTQ"
  },
  {
    "name": "海湾",
    "spell": "haiwan",
    "spellShort": "hwa",
    "code": "RWH"
  },
  {
    "name": "花溪大学城",
    "spell": "huaxidaxuecheng",
    "spellShort": "hxc",
    "code": "HDE"
  },
  {
    "name": "环县",
    "spell": "huanxian",
    "spellShort": "hxi",
    "code": "KXJ"
  },
  {
    "name": "花溪南",
    "spell": "huaxinan",
    "spellShort": "hxn",
    "code": "HNE"
  },
  {
    "name": "花溪西",
    "spell": "huaxixi",
    "spellShort": "hxx",
    "code": "HUE"
  },
  {
    "name": "惠阳",
    "spell": "huiyang",
    "spellShort": "hya",
    "code": "KNQ"
  },
  {
    "name": "衡阳",
    "spell": "hengyang",
    "spellShort": "hya",
    "code": "HYQ"
  },
  {
    "name": "海阳",
    "spell": "haiyang",
    "spellShort": "hya",
    "code": "KYK"
  },
  {
    "name": "河源东",
    "spell": "heyuandong",
    "spellShort": "hyd",
    "code": "HEA"
  },
  {
    "name": "衡阳东",
    "spell": "hengyangdong",
    "spellShort": "hyd",
    "code": "HVQ"
  },
  {
    "name": "华蓥",
    "spell": "huaying",
    "spellShort": "hyi",
    "code": "HUW"
  },
  {
    "name": "鄠邑",
    "spell": "huyi",
    "spellShort": "hyi",
    "code": "KXY"
  },
  {
    "name": "汉源",
    "spell": "hanyuan",
    "spellShort": "hyu",
    "code": "WHW"
  },
  {
    "name": "河源",
    "spell": "heyuan",
    "spellShort": "hyu",
    "code": "VIQ"
  },
  {
    "name": "湟源",
    "spell": "huangyuan",
    "spellShort": "hyu",
    "code": "HNO"
  },
  {
    "name": "惠州北",
    "spell": "huizhoubei",
    "spellShort": "hzb",
    "code": "HUA"
  },
  {
    "name": "菏泽东",
    "spell": "hezedong",
    "spellShort": "hzd",
    "code": "KDK"
  },
  {
    "name": "菏泽",
    "spell": "heze",
    "spellShort": "hze",
    "code": "HIK"
  },
  {
    "name": "贺州",
    "spell": "hezhou",
    "spellShort": "hzh",
    "code": "HXZ"
  },
  {
    "name": "华州",
    "spell": "huazhou",
    "spellShort": "hzh",
    "code": "HXY"
  },
  {
    "name": "湖州",
    "spell": "huzhou",
    "spellShort": "hzh",
    "code": "VZH"
  },
  {
    "name": "汉中",
    "spell": "hanzhong",
    "spellShort": "hzh",
    "code": "HOY"
  },
  {
    "name": "惠州",
    "spell": "huizhou",
    "spellShort": "hzh",
    "code": "HCQ"
  },
  {
    "name": "吉安",
    "spell": "jian",
    "spellShort": "jan",
    "code": "VAG"
  },
  {
    "name": "集安",
    "spell": "jian",
    "spellShort": "jan",
    "code": "JAL"
  },
  {
    "name": "建安",
    "spell": "jianan",
    "spellShort": "jan",
    "code": "JUL"
  },
  {
    "name": "吉安西",
    "spell": "jianxi",
    "spellShort": "jax",
    "code": "JIG"
  },
  {
    "name": "江边村",
    "spell": "jiangbiancun",
    "spellShort": "jbc",
    "code": "JBG"
  },
  {
    "name": "晋城东",
    "spell": "jinchengdong",
    "spellShort": "jcd",
    "code": "JGF"
  },
  {
    "name": "金昌",
    "spell": "jinchang",
    "spellShort": "jch",
    "code": "JCJ"
  },
  {
    "name": "晋城",
    "spell": "jincheng",
    "spellShort": "jch",
    "code": "JCF"
  },
  {
    "name": "金城江",
    "spell": "jinchengjiang",
    "spellShort": "jcj",
    "code": "JJZ"
  },
  {
    "name": "景德镇北",
    "spell": "jingdezhenbei",
    "spellShort": "jdb",
    "code": "JDG"
  },
  {
    "name": "建德",
    "spell": "jiande",
    "spellShort": "jde",
    "code": "JDU"
  },
  {
    "name": "鸡东",
    "spell": "jidong",
    "spellShort": "jdo",
    "code": "JOB"
  },
  {
    "name": "景德镇",
    "spell": "jingdezhen",
    "spellShort": "jdz",
    "code": "JCG"
  },
  {
    "name": "嘉峰",
    "spell": "jiafeng",
    "spellShort": "jfe",
    "code": "JFF"
  },
  {
    "name": "加格达奇",
    "spell": "jiagedaqi",
    "spellShort": "jgq",
    "code": "JGX"
  },
  {
    "name": "井冈山",
    "spell": "jinggangshan",
    "spellShort": "jgs",
    "code": "JGG"
  },
  {
    "name": "近海",
    "spell": "jinhai",
    "spellShort": "jha",
    "code": "JHD"
  },
  {
    "name": "静海",
    "spell": "jinghai",
    "spellShort": "jha",
    "code": "JHP"
  },
  {
    "name": "蛟河",
    "spell": "jiaohe",
    "spellShort": "jhe",
    "code": "JHL"
  },
  {
    "name": "精河南",
    "spell": "jinghenan",
    "spellShort": "jhn",
    "code": "JIR"
  },
  {
    "name": "金华南",
    "spell": "jinhuanan",
    "spellShort": "jhn",
    "code": "RNH"
  },
  {
    "name": "金华",
    "spell": "jinhua",
    "spellShort": "jhu",
    "code": "JBH"
  },
  {
    "name": "蛟河西",
    "spell": "jiaohexi",
    "spellShort": "jhx",
    "code": "JOL"
  },
  {
    "name": "金华镇",
    "spell": "jinhuazhen",
    "spellShort": "jhz",
    "code": "JZE"
  },
  {
    "name": "晋江",
    "spell": "jinjiang",
    "spellShort": "jji",
    "code": "JJS"
  },
  {
    "name": "九江",
    "spell": "jiujiang",
    "spellShort": "jji",
    "code": "JJG"
  },
  {
    "name": "军粮城北",
    "spell": "junliangchengbei",
    "spellShort": "jlb",
    "code": "JMP"
  },
  {
    "name": "贾鲁河",
    "spell": "jialuhe",
    "spellShort": "jlh",
    "code": "JLF"
  },
  {
    "name": "吉林",
    "spell": "jilin",
    "spellShort": "jli",
    "code": "JLL"
  },
  {
    "name": "即墨北",
    "spell": "jimobei",
    "spellShort": "jmb",
    "code": "JVK"
  },
  {
    "name": "江门",
    "spell": "jiangmen",
    "spellShort": "jme",
    "code": "JOQ"
  },
  {
    "name": "荆门",
    "spell": "jingmen",
    "spellShort": "jme",
    "code": "JMN"
  },
  {
    "name": "剑门关",
    "spell": "jianmenguan",
    "spellShort": "jmg",
    "code": "JME"
  },
  {
    "name": "佳木斯",
    "spell": "jiamusi",
    "spellShort": "jms",
    "code": "JMB"
  },
  {
    "name": "井南",
    "spell": "jingnan",
    "spellShort": "jna",
    "code": "JNP"
  },
  {
    "name": "建宁县北",
    "spell": "jianningxianbei",
    "spellShort": "jnb",
    "code": "JCS"
  },
  {
    "name": "济宁",
    "spell": "jining",
    "spellShort": "jni",
    "code": "JIK"
  },
  {
    "name": "江宁",
    "spell": "jiangning",
    "spellShort": "jni",
    "code": "JJH"
  },
  {
    "name": "集宁南",
    "spell": "jiningnan",
    "spellShort": "jnn",
    "code": "JAC"
  },
  {
    "name": "江宁西",
    "spell": "jiangningxi",
    "spellShort": "jnx",
    "code": "OKH"
  },
  {
    "name": "经棚",
    "spell": "jingpeng",
    "spellShort": "jpe",
    "code": "JPC"
  },
  {
    "name": "建平",
    "spell": "jianping",
    "spellShort": "jpi",
    "code": "JAD"
  },
  {
    "name": "酒泉南",
    "spell": "jiuquannan",
    "spellShort": "jqn",
    "code": "JNJ"
  },
  {
    "name": "酒泉",
    "spell": "jiuquan",
    "spellShort": "jqu",
    "code": "JQJ"
  },
  {
    "name": "金山北",
    "spell": "jinshanbei",
    "spellShort": "jsb",
    "code": "EGH"
  },
  {
    "name": "吉首东",
    "spell": "jishoudong",
    "spellShort": "jsd",
    "code": "JDA"
  },
  {
    "name": "吉首",
    "spell": "jishou",
    "spellShort": "jsh",
    "code": "JIQ"
  },
  {
    "name": "江山",
    "spell": "jiangshan",
    "spellShort": "jsh",
    "code": "JUH"
  },
  {
    "name": "尖山",
    "spell": "jianshan",
    "spellShort": "jsh",
    "code": "JPQ"
  },
  {
    "name": "建三江",
    "spell": "jiansanjiang",
    "spellShort": "jsj",
    "code": "JIB"
  },
  {
    "name": "界首南",
    "spell": "jieshounan",
    "spellShort": "jsn",
    "code": "JKU"
  },
  {
    "name": "九台",
    "spell": "jiutai",
    "spellShort": "jta",
    "code": "JTL"
  },
  {
    "name": "九台南",
    "spell": "jiutainan",
    "spellShort": "jtn",
    "code": "JNL"
  },
  {
    "name": "镜铁山",
    "spell": "jingtieshan",
    "spellShort": "jts",
    "code": "JVJ"
  },
  {
    "name": "绩溪北",
    "spell": "jixibei",
    "spellShort": "jxb",
    "code": "NRH"
  },
  {
    "name": "介休东",
    "spell": "jiexiudong",
    "spellShort": "jxd",
    "code": "JDV"
  },
  {
    "name": "介休",
    "spell": "jiexiu",
    "spellShort": "jxi",
    "code": "JXV"
  },
  {
    "name": "靖西",
    "spell": "jingxi",
    "spellShort": "jxi",
    "code": "JMZ"
  },
  {
    "name": "嘉兴",
    "spell": "jiaxing",
    "spellShort": "jxi",
    "code": "JXH"
  },
  {
    "name": "鸡西",
    "spell": "jixi",
    "spellShort": "jxi",
    "code": "JXB"
  },
  {
    "name": "井陉",
    "spell": "jingxing",
    "spellShort": "jxi",
    "code": "JJP"
  },
  {
    "name": "进贤",
    "spell": "jinxian",
    "spellShort": "jxi",
    "code": "JUG"
  },
  {
    "name": "嘉兴南",
    "spell": "jiaxingnan",
    "spellShort": "jxn",
    "code": "EPH"
  },
  {
    "name": "进贤南",
    "spell": "jinxiannan",
    "spellShort": "jxn",
    "code": "JXG"
  },
  {
    "name": "绩溪县",
    "spell": "jixixian",
    "spellShort": "jxx",
    "code": "JRH"
  },
  {
    "name": "鸡西西",
    "spell": "jixixi",
    "spellShort": "jxx",
    "code": "JAB"
  },
  {
    "name": "金阳",
    "spell": "jinyang",
    "spellShort": "jya",
    "code": "JYE"
  },
  {
    "name": "巨野",
    "spell": "juye",
    "spellShort": "jye",
    "code": "JYK"
  },
  {
    "name": "嘉峪关",
    "spell": "jiayuguan",
    "spellShort": "jyg",
    "code": "JGJ"
  },
  {
    "name": "嘉峪关南",
    "spell": "jiayuguannan",
    "spellShort": "jyn",
    "code": "JBJ"
  },
  {
    "name": "金阳南",
    "spell": "jinyangnan",
    "spellShort": "jyn",
    "code": "JNE"
  },
  {
    "name": "简阳南",
    "spell": "jianyangnan",
    "spellShort": "jyn",
    "code": "JOW"
  },
  {
    "name": "江油",
    "spell": "jiangyou",
    "spellShort": "jyo",
    "code": "JFW"
  },
  {
    "name": "金银潭",
    "spell": "jinyintan",
    "spellShort": "jyt",
    "code": "JTN"
  },
  {
    "name": "靖宇",
    "spell": "jingyu",
    "spellShort": "jyu",
    "code": "JYL"
  },
  {
    "name": "锦州北",
    "spell": "jinzhoubei",
    "spellShort": "jzb",
    "code": "JFT"
  },
  {
    "name": "蓟州北",
    "spell": "jizhoubei",
    "spellShort": "jzb",
    "code": "JKP"
  },
  {
    "name": "荆州",
    "spell": "jingzhou",
    "spellShort": "jzh",
    "code": "JBN"
  },
  {
    "name": "金寨",
    "spell": "jinzhai",
    "spellShort": "jzh",
    "code": "JZH"
  },
  {
    "name": "锦州",
    "spell": "jinzhou",
    "spellShort": "jzh",
    "code": "JZD"
  },
  {
    "name": "金州",
    "spell": "jinzhou",
    "spellShort": "jzh",
    "code": "JZT"
  },
  {
    "name": "晋州",
    "spell": "jinzhou",
    "spellShort": "jzh",
    "code": "JXP"
  },
  {
    "name": "蓟州",
    "spell": "jizhou",
    "spellShort": "jzh",
    "code": "JIP"
  },
  {
    "name": "锦州南",
    "spell": "jinzhounan",
    "spellShort": "jzn",
    "code": "JOD"
  },
  {
    "name": "焦作",
    "spell": "jiaozuo",
    "spellShort": "jzu",
    "code": "JOF"
  },
  {
    "name": "焦作西",
    "spell": "jiaozuoxi",
    "spellShort": "jzx",
    "code": "JIF"
  },
  {
    "name": "开安",
    "spell": "kaian",
    "spellShort": "kan",
    "code": "KAT"
  },
  {
    "name": "库车",
    "spell": "kuche",
    "spellShort": "kch",
    "code": "KCR"
  },
  {
    "name": "库都尔",
    "spell": "kuduer",
    "spellShort": "kde",
    "code": "KDX"
  },
  {
    "name": "库尔勒",
    "spell": "kuerle",
    "spellShort": "kel",
    "code": "KLR"
  },
  {
    "name": "开封北",
    "spell": "kaifengbei",
    "spellShort": "kfb",
    "code": "KBF"
  },
  {
    "name": "开封",
    "spell": "kaifeng",
    "spellShort": "kfe",
    "code": "KFF"
  },
  {
    "name": "开福寺",
    "spell": "kaifusi",
    "spellShort": "kfs",
    "code": "FLQ"
  },
  {
    "name": "开化",
    "spell": "kaihua",
    "spellShort": "khu",
    "code": "KHU"
  },
  {
    "name": "康金井",
    "spell": "kangjinjing",
    "spellShort": "kjj",
    "code": "KJB"
  },
  {
    "name": "岢岚",
    "spell": "kelan",
    "spellShort": "kla",
    "code": "KLV"
  },
  {
    "name": "凯里",
    "spell": "kaili",
    "spellShort": "kli",
    "code": "KLW"
  },
  {
    "name": "凯里南",
    "spell": "kailinan",
    "spellShort": "kln",
    "code": "QKW"
  },
  {
    "name": "库伦",
    "spell": "kulun",
    "spellShort": "klu",
    "code": "KLD"
  },
  {
    "name": "开鲁",
    "spell": "kailu",
    "spellShort": "klu",
    "code": "KLC"
  },
  {
    "name": "克拉玛依",
    "spell": "kelamayi",
    "spellShort": "kly",
    "code": "KHR"
  },
  {
    "name": "喀什",
    "spell": "kashi",
    "spellShort": "ksh",
    "code": "KSR"
  },
  {
    "name": "昆山",
    "spell": "kunshan",
    "spellShort": "ksh",
    "code": "KSH"
  },
  {
    "name": "克山",
    "spell": "keshan",
    "spellShort": "ksh",
    "code": "KSB"
  },
  {
    "name": "昆山南",
    "spell": "kunshannan",
    "spellShort": "ksn",
    "code": "KNH"
  },
  {
    "name": "奎屯",
    "spell": "kuitun",
    "spellShort": "ktu",
    "code": "KTR"
  },
  {
    "name": "开阳",
    "spell": "kaiyang",
    "spellShort": "kya",
    "code": "KVW"
  },
  {
    "name": "昆阳",
    "spell": "kunyang",
    "spellShort": "kya",
    "code": "KAM"
  },
  {
    "name": "开原",
    "spell": "kaiyuan",
    "spellShort": "kyu",
    "code": "KYT"
  },
  {
    "name": "开原西",
    "spell": "kaiyuanxi",
    "spellShort": "kyx",
    "code": "KXT"
  },
  {
    "name": "康庄",
    "spell": "kangzhuang",
    "spellShort": "kzh",
    "code": "KZP"
  },
  {
    "name": "喀左",
    "spell": "kazuo",
    "spellShort": "kzu",
    "code": "KZT"
  },
  {
    "name": "隆安东",
    "spell": "longandong",
    "spellShort": "lad",
    "code": "IDZ"
  },
  {
    "name": "六安",
    "spell": "luan",
    "spellShort": "lan",
    "code": "UAH"
  },
  {
    "name": "灵宝",
    "spell": "lingbao",
    "spellShort": "lba",
    "code": "LBF"
  },
  {
    "name": "来宾北",
    "spell": "laibinbei",
    "spellShort": "lbb",
    "code": "UCZ"
  },
  {
    "name": "灵宝西",
    "spell": "lingbaoxi",
    "spellShort": "lbx",
    "code": "LPF"
  },
  {
    "name": "绿博园",
    "spell": "lvboyuan",
    "spellShort": "lby",
    "code": "LCF"
  },
  {
    "name": "临沧",
    "spell": "lincang",
    "spellShort": "lca",
    "code": "LXM"
  },
  {
    "name": "隆昌北",
    "spell": "longchangbei",
    "spellShort": "lcb",
    "code": "NWW"
  },
  {
    "name": "乐昌东",
    "spell": "lechangdong",
    "spellShort": "lcd",
    "code": "ILQ"
  },
  {
    "name": "芦潮港",
    "spell": "luchaogang",
    "spellShort": "lcg",
    "code": "UCH"
  },
  {
    "name": "陆川",
    "spell": "luchuan",
    "spellShort": "lch",
    "code": "LKZ"
  },
  {
    "name": "龙川",
    "spell": "longchuan",
    "spellShort": "lch",
    "code": "LUQ"
  },
  {
    "name": "利川",
    "spell": "lichuan",
    "spellShort": "lch",
    "code": "LCN"
  },
  {
    "name": "临川",
    "spell": "linchuan",
    "spellShort": "lch",
    "code": "LCG"
  },
  {
    "name": "隆昌",
    "spell": "longchang",
    "spellShort": "lch",
    "code": "LCW"
  },
  {
    "name": "潞城",
    "spell": "lucheng",
    "spellShort": "lch",
    "code": "UTP"
  },
  {
    "name": "聊城",
    "spell": "liaocheng",
    "spellShort": "lch",
    "code": "UCK"
  },
  {
    "name": "陵城",
    "spell": "lingcheng",
    "spellShort": "lch",
    "code": "LGK"
  },
  {
    "name": "龙川西",
    "spell": "longchuanxi",
    "spellShort": "lcx",
    "code": "LCA"
  },
  {
    "name": "聊城西",
    "spell": "liaochengxi",
    "spellShort": "lcx",
    "code": "VXK"
  },
  {
    "name": "老城镇",
    "spell": "laochengzhen",
    "spellShort": "lcz",
    "code": "ACQ"
  },
  {
    "name": "两当",
    "spell": "liangdang",
    "spellShort": "lda",
    "code": "LDY"
  },
  {
    "name": "鹿道",
    "spell": "ludao",
    "spellShort": "lda",
    "code": "LDL"
  },
  {
    "name": "龙洞堡",
    "spell": "longdongbao",
    "spellShort": "ldb",
    "code": "FVW"
  },
  {
    "name": "娄底",
    "spell": "loudi",
    "spellShort": "ldi",
    "code": "LDQ"
  },
  {
    "name": "娄底南",
    "spell": "loudinan",
    "spellShort": "ldn",
    "code": "UOQ"
  },
  {
    "name": "离堆公园",
    "spell": "liduigongyuan",
    "spellShort": "ldy",
    "code": "INW"
  },
  {
    "name": "廊坊",
    "spell": "langfang",
    "spellShort": "lfa",
    "code": "LJP"
  },
  {
    "name": "娄烦",
    "spell": "loufan",
    "spellShort": "lfa",
    "code": "USV"
  },
  {
    "name": "陆丰",
    "spell": "lufeng",
    "spellShort": "lfe",
    "code": "LLQ"
  },
  {
    "name": "临汾",
    "spell": "linfen",
    "spellShort": "lfe",
    "code": "LFV"
  },
  {
    "name": "临汾西",
    "spell": "linfenxi",
    "spellShort": "lfx",
    "code": "LXV"
  },
  {
    "name": "拉古",
    "spell": "lagu",
    "spellShort": "lgu",
    "code": "LGB"
  },
  {
    "name": "芦官",
    "spell": "luguan",
    "spellShort": "lgu",
    "code": "LAE"
  },
  {
    "name": "麓谷",
    "spell": "lugu",
    "spellShort": "lgu",
    "code": "BNQ"
  },
  {
    "name": "良各庄",
    "spell": "lianggezhuang",
    "spellShort": "lgz",
    "code": "LGP"
  },
  {
    "name": "临河",
    "spell": "linhe",
    "spellShort": "lhe",
    "code": "LHC"
  },
  {
    "name": "柳河",
    "spell": "liuhe",
    "spellShort": "lhe",
    "code": "LNL"
  },
  {
    "name": "漯河",
    "spell": "luohe",
    "spellShort": "lhe",
    "code": "LON"
  },
  {
    "name": "六合",
    "spell": "liuhe",
    "spellShort": "lhe",
    "code": "KLH"
  },
  {
    "name": "珞璜南",
    "spell": "luohuangnan",
    "spellShort": "lhn",
    "code": "LNE"
  },
  {
    "name": "隆回",
    "spell": "longhui",
    "spellShort": "lhu",
    "code": "LHA"
  },
  {
    "name": "隆化",
    "spell": "longhua",
    "spellShort": "lhu",
    "code": "UHP"
  },
  {
    "name": "绿化",
    "spell": "lvhua",
    "spellShort": "lhu",
    "code": "LWJ"
  },
  {
    "name": "漯河西",
    "spell": "luohexi",
    "spellShort": "lhx",
    "code": "LBN"
  },
  {
    "name": "刘家店",
    "spell": "liujiadian",
    "spellShort": "ljd",
    "code": "UDT"
  },
  {
    "name": "龙井",
    "spell": "longjing",
    "spellShort": "lji",
    "code": "LJL"
  },
  {
    "name": "临江",
    "spell": "linjiang",
    "spellShort": "lji",
    "code": "LQL"
  },
  {
    "name": "丽江",
    "spell": "lijiang",
    "spellShort": "lji",
    "code": "LHM"
  },
  {
    "name": "龙嘉",
    "spell": "longjia",
    "spellShort": "lji",
    "code": "UJL"
  },
  {
    "name": "庐江",
    "spell": "lujiang",
    "spellShort": "lji",
    "code": "UJH"
  },
  {
    "name": "连江",
    "spell": "lianjiang",
    "spellShort": "lji",
    "code": "LKS"
  },
  {
    "name": "庐江西",
    "spell": "lujiangxi",
    "spellShort": "ljx",
    "code": "LUU"
  },
  {
    "name": "兰考",
    "spell": "lankao",
    "spellShort": "lka",
    "code": "LKF"
  },
  {
    "name": "兰考南",
    "spell": "lankaonan",
    "spellShort": "lkn",
    "code": "LUF"
  },
  {
    "name": "林口",
    "spell": "linkou",
    "spellShort": "lko",
    "code": "LKB"
  },
  {
    "name": "龙口市",
    "spell": "longkoushi",
    "spellShort": "lks",
    "code": "UKK"
  },
  {
    "name": "吕梁",
    "spell": "lvliang",
    "spellShort": "lli",
    "code": "LHV"
  },
  {
    "name": "醴陵",
    "spell": "liling",
    "spellShort": "lli",
    "code": "LLG"
  },
  {
    "name": "兰棱",
    "spell": "lanling",
    "spellShort": "lli",
    "code": "LLB"
  },
  {
    "name": "拉林",
    "spell": "lalin",
    "spellShort": "lli",
    "code": "LAB"
  },
  {
    "name": "柳林南",
    "spell": "liulinnan",
    "spellShort": "lln",
    "code": "LKV"
  },
  {
    "name": "陇南",
    "spell": "longnan",
    "spellShort": "lna",
    "code": "INJ"
  },
  {
    "name": "辽宁朝阳",
    "spell": "liaoningchaoyang",
    "spellShort": "lny",
    "code": "VET"
  },
  {
    "name": "梁平",
    "spell": "liangping",
    "spellShort": "lpi",
    "code": "UQW"
  },
  {
    "name": "滦平",
    "spell": "luanping",
    "spellShort": "lpi",
    "code": "UPP"
  },
  {
    "name": "罗平",
    "spell": "luoping",
    "spellShort": "lpi",
    "code": "LPM"
  },
  {
    "name": "梁平南",
    "spell": "liangpingnan",
    "spellShort": "lpn",
    "code": "LPE"
  },
  {
    "name": "临平南",
    "spell": "linpingnan",
    "spellShort": "lpn",
    "code": "EVH"
  },
  {
    "name": "六盘水",
    "spell": "liupanshui",
    "spellShort": "lps",
    "code": "UMW"
  },
  {
    "name": "灵丘",
    "spell": "lingqiu",
    "spellShort": "lqi",
    "code": "LVV"
  },
  {
    "name": "龙桥",
    "spell": "longqiao",
    "spellShort": "lqi",
    "code": "LQU"
  },
  {
    "name": "龙山北",
    "spell": "longshanbei",
    "spellShort": "lsb",
    "code": "LBA"
  },
  {
    "name": "灵石东",
    "spell": "lingshidong",
    "spellShort": "lsd",
    "code": "UDV"
  },
  {
    "name": "乐山",
    "spell": "leshan",
    "spellShort": "lsh",
    "code": "IVW"
  },
  {
    "name": "陵水",
    "spell": "lingshui",
    "spellShort": "lsh",
    "code": "LIQ"
  },
  {
    "name": "丽水",
    "spell": "lishui",
    "spellShort": "lsh",
    "code": "USH"
  },
  {
    "name": "旅顺",
    "spell": "lvshun",
    "spellShort": "lsh",
    "code": "LST"
  },
  {
    "name": "庐山",
    "spell": "lushan",
    "spellShort": "lsh",
    "code": "LSG"
  },
  {
    "name": "溧水",
    "spell": "lishui",
    "spellShort": "lsh",
    "code": "LDH"
  },
  {
    "name": "岚山西",
    "spell": "lanshanxi",
    "spellShort": "lsx",
    "code": "UWK"
  },
  {
    "name": "黎塘",
    "spell": "litang",
    "spellShort": "lta",
    "code": "LTZ"
  },
  {
    "name": "芦台",
    "spell": "lutai",
    "spellShort": "lta",
    "code": "LTP"
  },
  {
    "name": "临潼",
    "spell": "lintong",
    "spellShort": "lto",
    "code": "LIY"
  },
  {
    "name": "乐同",
    "spell": "letong",
    "spellShort": "lto",
    "code": "LEA"
  },
  {
    "name": "灵武北",
    "spell": "lingwubei",
    "spellShort": "lwb",
    "code": "UWJ"
  },
  {
    "name": "莱芜东",
    "spell": "laiwudong",
    "spellShort": "lwd",
    "code": "LWK"
  },
  {
    "name": "洛湾三江",
    "spell": "luowansanjiang",
    "spellShort": "lwj",
    "code": "KRW"
  },
  {
    "name": "泸县",
    "spell": "luxian",
    "spellShort": "lxi",
    "code": "LXE"
  },
  {
    "name": "澧县",
    "spell": "lixian",
    "spellShort": "lxi",
    "code": "LEQ"
  },
  {
    "name": "陇西",
    "spell": "longxi",
    "spellShort": "lxi",
    "code": "LXJ"
  },
  {
    "name": "陇县",
    "spell": "longxian",
    "spellShort": "lxi",
    "code": "LXY"
  },
  {
    "name": "临西",
    "spell": "linxi",
    "spellShort": "lxi",
    "code": "UEP"
  },
  {
    "name": "莱西",
    "spell": "laixi",
    "spellShort": "lxi",
    "code": "LBK"
  },
  {
    "name": "兰溪",
    "spell": "lanxi",
    "spellShort": "lxi",
    "code": "LWH"
  },
  {
    "name": "良乡",
    "spell": "liangxiang",
    "spellShort": "lxi",
    "code": "LAP"
  },
  {
    "name": "略阳",
    "spell": "lueyang",
    "spellShort": "lya",
    "code": "LYY"
  },
  {
    "name": "辽阳",
    "spell": "liaoyang",
    "spellShort": "lya",
    "code": "LYT"
  },
  {
    "name": "耒阳",
    "spell": "leiyang",
    "spellShort": "lya",
    "code": "LYQ"
  },
  {
    "name": "溧阳",
    "spell": "liyang",
    "spellShort": "lya",
    "code": "LEH"
  },
  {
    "name": "龙岩",
    "spell": "longyan",
    "spellShort": "lya",
    "code": "LYS"
  },
  {
    "name": "洛阳",
    "spell": "luoyang",
    "spellShort": "lya",
    "code": "LYF"
  },
  {
    "name": "临沂北",
    "spell": "linyibei",
    "spellShort": "lyb",
    "code": "UMK"
  },
  {
    "name": "连云港东",
    "spell": "lianyungangdong",
    "spellShort": "lyd",
    "code": "UKH"
  },
  {
    "name": "洛阳东",
    "spell": "luoyangdong",
    "spellShort": "lyd",
    "code": "LDF"
  },
  {
    "name": "连云港",
    "spell": "lianyungang",
    "spellShort": "lyg",
    "code": "UIH"
  },
  {
    "name": "临沂",
    "spell": "linyi",
    "spellShort": "lyi",
    "code": "LVK"
  },
  {
    "name": "洛阳龙门",
    "spell": "luoyanglongmen",
    "spellShort": "lym",
    "code": "LLF"
  },
  {
    "name": "柳园南",
    "spell": "liuyuannan",
    "spellShort": "lyn",
    "code": "LNR"
  },
  {
    "name": "凌源",
    "spell": "lingyuan",
    "spellShort": "lyu",
    "code": "LYD"
  },
  {
    "name": "辽源",
    "spell": "liaoyuan",
    "spellShort": "lyu",
    "code": "LYL"
  },
  {
    "name": "柳园",
    "spell": "liuyuan",
    "spellShort": "lyu",
    "code": "DHR"
  },
  {
    "name": "涟源",
    "spell": "lianyuan",
    "spellShort": "lyu",
    "code": "LAQ"
  },
  {
    "name": "涞源",
    "spell": "laiyuan",
    "spellShort": "lyu",
    "code": "LYP"
  },
  {
    "name": "罗源",
    "spell": "luoyuan",
    "spellShort": "lyu",
    "code": "LVS"
  },
  {
    "name": "耒阳西",
    "spell": "leiyangxi",
    "spellShort": "lyx",
    "code": "LPQ"
  },
  {
    "name": "泸州",
    "spell": "luzhou",
    "spellShort": "lzh",
    "code": "LUE"
  },
  {
    "name": "林芝",
    "spell": "linzhi",
    "spellShort": "lzh",
    "code": "LZO"
  },
  {
    "name": "柳州",
    "spell": "liuzhou",
    "spellShort": "lzh",
    "code": "LZZ"
  },
  {
    "name": "六枝",
    "spell": "liuzhi",
    "spellShort": "lzh",
    "code": "LIW"
  },
  {
    "name": "阆中",
    "spell": "langzhong",
    "spellShort": "lzh",
    "code": "LZE"
  },
  {
    "name": "龙镇",
    "spell": "longzhen",
    "spellShort": "lzh",
    "code": "LZA"
  },
  {
    "name": "立志",
    "spell": "lizhi",
    "spellShort": "lzh",
    "code": "LZX"
  },
  {
    "name": "辽中",
    "spell": "liaozhong",
    "spellShort": "lzh",
    "code": "LZD"
  },
  {
    "name": "马鞍山东",
    "spell": "maanshandong",
    "spellShort": "mad",
    "code": "OMH"
  },
  {
    "name": "麻城北",
    "spell": "machengbei",
    "spellShort": "mcb",
    "code": "MBN"
  },
  {
    "name": "麻城",
    "spell": "macheng",
    "spellShort": "mch",
    "code": "MCN"
  },
  {
    "name": "渑池南",
    "spell": "mianchinan",
    "spellShort": "mcn",
    "code": "MNF"
  },
  {
    "name": "免渡河",
    "spell": "mianduhe",
    "spellShort": "mdh",
    "code": "MDX"
  },
  {
    "name": "磨丁",
    "spell": "moding",
    "spellShort": "mdi",
    "code": "VBM"
  },
  {
    "name": "牡丹江",
    "spell": "mudanjiang",
    "spellShort": "mdj",
    "code": "MDB"
  },
  {
    "name": "莫尔道嘎",
    "spell": "moerdaoga",
    "spellShort": "meg",
    "code": "MRX"
  },
  {
    "name": "帽儿山",
    "spell": "maoershan",
    "spellShort": "mes",
    "code": "MRB"
  },
  {
    "name": "帽儿山西",
    "spell": "mershanxi",
    "spellShort": "mex",
    "code": "MUB"
  },
  {
    "name": "明光",
    "spell": "mingguang",
    "spellShort": "mgu",
    "code": "MGH"
  },
  {
    "name": "满归",
    "spell": "mangui",
    "spellShort": "mgu",
    "code": "MHX"
  },
  {
    "name": "孟关",
    "spell": "mengguan",
    "spellShort": "mgu",
    "code": "MGE"
  },
  {
    "name": "磨憨",
    "spell": "mohan",
    "spellShort": "mha",
    "code": "MHM"
  },
  {
    "name": "漠河",
    "spell": "mohe",
    "spellShort": "mhe",
    "code": "MVX"
  },
  {
    "name": "梅河口",
    "spell": "meihekou",
    "spellShort": "mhk",
    "code": "MHL"
  },
  {
    "name": "民和南",
    "spell": "minhenan",
    "spellShort": "mhn",
    "code": "MNO"
  },
  {
    "name": "孟家岗",
    "spell": "mengjiagang",
    "spellShort": "mjg",
    "code": "MGB"
  },
  {
    "name": "米兰",
    "spell": "milan",
    "spellShort": "mla",
    "code": "MIR"
  },
  {
    "name": "勐腊",
    "spell": "mengla",
    "spellShort": "mla",
    "code": "MWM"
  },
  {
    "name": "美兰",
    "spell": "meilan",
    "spellShort": "mla",
    "code": "MHQ"
  },
  {
    "name": "弥勒",
    "spell": "mile",
    "spellShort": "mle",
    "code": "MLM"
  },
  {
    "name": "穆棱",
    "spell": "muling",
    "spellShort": "mli",
    "code": "MLB"
  },
  {
    "name": "茂名",
    "spell": "maoming",
    "spellShort": "mmi",
    "code": "MDQ"
  },
  {
    "name": "茂名西",
    "spell": "maomingxi",
    "spellShort": "mmx",
    "code": "MMZ"
  },
  {
    "name": "冕宁",
    "spell": "mianning",
    "spellShort": "mni",
    "code": "UGW"
  },
  {
    "name": "玛纳斯",
    "spell": "manasi",
    "spellShort": "mns",
    "code": "MSR"
  },
  {
    "name": "闽清北",
    "spell": "minqingbei",
    "spellShort": "mqb",
    "code": "MBS"
  },
  {
    "name": "民权",
    "spell": "minquan",
    "spellShort": "mqu",
    "code": "MQF"
  },
  {
    "name": "眉山东",
    "spell": "meishandong",
    "spellShort": "msd",
    "code": "IUW"
  },
  {
    "name": "名山",
    "spell": "mingshan",
    "spellShort": "msh",
    "code": "MSE"
  },
  {
    "name": "密山",
    "spell": "mishan",
    "spellShort": "msh",
    "code": "MSB"
  },
  {
    "name": "庙山",
    "spell": "miaoshan",
    "spellShort": "msh",
    "code": "MSN"
  },
  {
    "name": "马三家",
    "spell": "masanjia",
    "spellShort": "msj",
    "code": "MJT"
  },
  {
    "name": "米沙子",
    "spell": "mishazi",
    "spellShort": "msz",
    "code": "MST"
  },
  {
    "name": "麻尾",
    "spell": "mawei",
    "spellShort": "mwe",
    "code": "VAW"
  },
  {
    "name": "岷县",
    "spell": "minxian",
    "spellShort": "mxi",
    "code": "MXJ"
  },
  {
    "name": "勉县",
    "spell": "mianxian",
    "spellShort": "mxi",
    "code": "MVY"
  },
  {
    "name": "绵阳",
    "spell": "mianyang",
    "spellShort": "mya",
    "code": "MYW"
  },
  {
    "name": "密云北",
    "spell": "miyunbei",
    "spellShort": "myb",
    "code": "MUP"
  },
  {
    "name": "孟塬",
    "spell": "mengyuan",
    "spellShort": "myu",
    "code": "HSY"
  },
  {
    "name": "墨玉",
    "spell": "moyu",
    "spellShort": "myu",
    "code": "MUR"
  },
  {
    "name": "门源",
    "spell": "menyuan",
    "spellShort": "myu",
    "code": "MYO"
  },
  {
    "name": "暮云",
    "spell": "muyun",
    "spellShort": "myu",
    "code": "KIQ"
  },
  {
    "name": "密云",
    "spell": "miyun",
    "spellShort": "myu",
    "code": "MYP"
  },
  {
    "name": "梅州",
    "spell": "meizhou",
    "spellShort": "mzh",
    "code": "MOQ"
  },
  {
    "name": "孟庄",
    "spell": "mengzhuang",
    "spellShort": "mzh",
    "code": "MZF"
  },
  {
    "name": "蒙自",
    "spell": "mengzi",
    "spellShort": "mzi",
    "code": "MZM"
  },
  {
    "name": "满洲里",
    "spell": "manzhouli",
    "spellShort": "mzl",
    "code": "MLX"
  },
  {
    "name": "梅州西",
    "spell": "meizhouxi",
    "spellShort": "mzx",
    "code": "MXA"
  },
  {
    "name": "宁安",
    "spell": "ningan",
    "spellShort": "nan",
    "code": "NAB"
  },
  {
    "name": "农安",
    "spell": "nongan",
    "spellShort": "nan",
    "code": "NAT"
  },
  {
    "name": "宁波东",
    "spell": "ningbodong",
    "spellShort": "nbd",
    "code": "NVH"
  },
  {
    "name": "宁波",
    "spell": "ningbo",
    "spellShort": "nbo",
    "code": "NGH"
  },
  {
    "name": "南部",
    "spell": "nanbu",
    "spellShort": "nbu",
    "code": "NBE"
  },
  {
    "name": "南曹",
    "spell": "nancao",
    "spellShort": "nca",
    "code": "NEF"
  },
  {
    "name": "南充北",
    "spell": "nanchongbei",
    "spellShort": "ncb",
    "code": "NCE"
  },
  {
    "name": "南充",
    "spell": "nanchong",
    "spellShort": "nch",
    "code": "NCW"
  },
  {
    "name": "南城",
    "spell": "nancheng",
    "spellShort": "nch",
    "code": "NDG"
  },
  {
    "name": "南岔",
    "spell": "nancha",
    "spellShort": "nch",
    "code": "NCB"
  },
  {
    "name": "南丹",
    "spell": "nandan",
    "spellShort": "nda",
    "code": "NDZ"
  },
  {
    "name": "宁德",
    "spell": "ningde",
    "spellShort": "nde",
    "code": "NES"
  },
  {
    "name": "南大庙",
    "spell": "nandamiao",
    "spellShort": "ndm",
    "code": "NMP"
  },
  {
    "name": "宁东南",
    "spell": "ningdongnan",
    "spellShort": "ndn",
    "code": "NDJ"
  },
  {
    "name": "宁东",
    "spell": "ningdong",
    "spellShort": "ndo",
    "code": "NOJ"
  },
  {
    "name": "南芬",
    "spell": "nanfen",
    "spellShort": "nfe",
    "code": "NFT"
  },
  {
    "name": "南丰",
    "spell": "nanfeng",
    "spellShort": "nfe",
    "code": "NFG"
  },
  {
    "name": "宁海",
    "spell": "ninghai",
    "spellShort": "nha",
    "code": "NHH"
  },
  {
    "name": "南湖东",
    "spell": "nanhudong",
    "spellShort": "nhd",
    "code": "NDN"
  },
  {
    "name": "讷河",
    "spell": "nehe",
    "spellShort": "nhe",
    "code": "NHX"
  },
  {
    "name": "牛河梁",
    "spell": "niuheliang",
    "spellShort": "nhl",
    "code": "LKT"
  },
  {
    "name": "内江北",
    "spell": "neijiangbei",
    "spellShort": "njb",
    "code": "NKW"
  },
  {
    "name": "内江",
    "spell": "neijiang",
    "spellShort": "nji",
    "code": "NJW"
  },
  {
    "name": "嫩江",
    "spell": "nenjiang",
    "spellShort": "nji",
    "code": "NGX"
  },
  {
    "name": "南江",
    "spell": "nanjiang",
    "spellShort": "nji",
    "code": "FIW"
  },
  {
    "name": "牛家",
    "spell": "niujia",
    "spellShort": "nji",
    "code": "NJB"
  },
  {
    "name": "南口",
    "spell": "nankou",
    "spellShort": "nko",
    "code": "NKP"
  },
  {
    "name": "牛栏山",
    "spell": "niulanshan",
    "spellShort": "nls",
    "code": "NLP"
  },
  {
    "name": "宁陵县",
    "spell": "ninglingxian",
    "spellShort": "nlx",
    "code": "NLF"
  },
  {
    "name": "奈曼",
    "spell": "naiman",
    "spellShort": "nma",
    "code": "NMD"
  },
  {
    "name": "尼木",
    "spell": "nimu",
    "spellShort": "nmu",
    "code": "NMO"
  },
  {
    "name": "南平市",
    "spell": "nanpingshi",
    "spellShort": "nps",
    "code": "NOS"
  },
  {
    "name": "宁强南",
    "spell": "ningqiangnan",
    "spellShort": "nqn",
    "code": "NOY"
  },
  {
    "name": "那曲",
    "spell": "naqu",
    "spellShort": "nqu",
    "code": "NQO"
  },
  {
    "name": "南通",
    "spell": "nantong",
    "spellShort": "nto",
    "code": "NUH"
  },
  {
    "name": "南通西",
    "spell": "nantongxi",
    "spellShort": "ntx",
    "code": "NXU"
  },
  {
    "name": "宁武",
    "spell": "ningwu",
    "spellShort": "nwu",
    "code": "NWV"
  },
  {
    "name": "南翔北",
    "spell": "nanxiangbei",
    "spellShort": "nxb",
    "code": "NEH"
  },
  {
    "name": "南雄",
    "spell": "nanxiong",
    "spellShort": "nxi",
    "code": "NCQ"
  },
  {
    "name": "宁乡",
    "spell": "ningxiang",
    "spellShort": "nxi",
    "code": "NXQ"
  },
  {
    "name": "南阳",
    "spell": "nanyang",
    "spellShort": "nya",
    "code": "NFF"
  },
  {
    "name": "南阳东",
    "spell": "nanyangdong",
    "spellShort": "nyd",
    "code": "NOF"
  },
  {
    "name": "纳雍",
    "spell": "nayong",
    "spellShort": "nyo",
    "code": "NYE"
  },
  {
    "name": "南峪",
    "spell": "nanyu",
    "spellShort": "nyu",
    "code": "NUP"
  },
  {
    "name": "南阳寨",
    "spell": "nanyangzhai",
    "spellShort": "nyz",
    "code": "NYF"
  },
  {
    "name": "碾子山",
    "spell": "nianzishan",
    "spellShort": "nzs",
    "code": "NZX"
  },
  {
    "name": "普安",
    "spell": "puan",
    "spellShort": "pan",
    "code": "PAN"
  },
  {
    "name": "蒲城东",
    "spell": "puchengdong",
    "spellShort": "pcd",
    "code": "PEY"
  },
  {
    "name": "平昌",
    "spell": "pingchang",
    "spellShort": "pch",
    "code": "PCE"
  },
  {
    "name": "平顶山",
    "spell": "pingdingshan",
    "spellShort": "pds",
    "code": "PEN"
  },
  {
    "name": "平度",
    "spell": "pingdu",
    "spellShort": "pdu",
    "code": "PNK"
  },
  {
    "name": "平度西",
    "spell": "pingduxi",
    "spellShort": "pdx",
    "code": "PAK"
  },
  {
    "name": "平顶山西",
    "spell": "pingdingshanxi",
    "spellShort": "pdx",
    "code": "PDF"
  },
  {
    "name": "普洱",
    "spell": "puer",
    "spellShort": "per",
    "code": "PEM"
  },
  {
    "name": "平房",
    "spell": "pingfang",
    "spellShort": "pfa",
    "code": "PFB"
  },
  {
    "name": "盘锦北",
    "spell": "panjinbei",
    "spellShort": "pjb",
    "code": "PBD"
  },
  {
    "name": "盘锦",
    "spell": "panjin",
    "spellShort": "pji",
    "code": "PVD"
  },
  {
    "name": "蒲江",
    "spell": "pujiang",
    "spellShort": "pji",
    "code": "PJE"
  },
  {
    "name": "盘龙城",
    "spell": "panlongcheng",
    "spellShort": "plc",
    "code": "PNN"
  },
  {
    "name": "普兰店",
    "spell": "pulandian",
    "spellShort": "pld",
    "code": "PLT"
  },
  {
    "name": "平凉",
    "spell": "pingliang",
    "spellShort": "pli",
    "code": "PIJ"
  },
  {
    "name": "平凉南",
    "spell": "pingliangnan",
    "spellShort": "pln",
    "code": "POJ"
  },
  {
    "name": "蓬莱市",
    "spell": "penglaishi",
    "spellShort": "pls",
    "code": "POK"
  },
  {
    "name": "普宁",
    "spell": "puning",
    "spellShort": "pni",
    "code": "PEQ"
  },
  {
    "name": "平泉北",
    "spell": "pingquanbei",
    "spellShort": "pqb",
    "code": "PBP"
  },
  {
    "name": "平泉",
    "spell": "pingquan",
    "spellShort": "pqu",
    "code": "PQP"
  },
  {
    "name": "皮山",
    "spell": "pishan",
    "spellShort": "psh",
    "code": "PSR"
  },
  {
    "name": "磐石",
    "spell": "panshi",
    "spellShort": "psh",
    "code": "PSL"
  },
  {
    "name": "坪石",
    "spell": "pingshi",
    "spellShort": "psh",
    "code": "PSQ"
  },
  {
    "name": "平山",
    "spell": "pingshan",
    "spellShort": "psh",
    "code": "PSB"
  },
  {
    "name": "平潭",
    "spell": "pingtan",
    "spellShort": "pta",
    "code": "PIS"
  },
  {
    "name": "莆田",
    "spell": "putian",
    "spellShort": "pti",
    "code": "PTS"
  },
  {
    "name": "萍乡北",
    "spell": "pingxiangbei",
    "spellShort": "pxb",
    "code": "PBG"
  },
  {
    "name": "凭祥",
    "spell": "pingxiang",
    "spellShort": "pxi",
    "code": "PXZ"
  },
  {
    "name": "萍乡",
    "spell": "pingxiang",
    "spellShort": "pxi",
    "code": "PXG"
  },
  {
    "name": "普雄",
    "spell": "puxiong",
    "spellShort": "pxi",
    "code": "POW"
  },
  {
    "name": "郫县",
    "spell": "pixian",
    "spellShort": "pxi",
    "code": "PWW"
  },
  {
    "name": "郫县西",
    "spell": "pixianxi",
    "spellShort": "pxx",
    "code": "PCW"
  },
  {
    "name": "濮阳",
    "spell": "puyang",
    "spellShort": "pya",
    "code": "PYF"
  },
  {
    "name": "平阳",
    "spell": "pingyang",
    "spellShort": "pya",
    "code": "ARH"
  },
  {
    "name": "平遥古城",
    "spell": "pingyaogucheng",
    "spellShort": "pyc",
    "code": "PDV"
  },
  {
    "name": "濮阳东",
    "spell": "puyangdong",
    "spellShort": "pyd",
    "code": "PUF"
  },
  {
    "name": "平原东",
    "spell": "pingyuandong",
    "spellShort": "pyd",
    "code": "PUK"
  },
  {
    "name": "彭泽",
    "spell": "pengze",
    "spellShort": "pze",
    "code": "PZG"
  },
  {
    "name": "普者黑",
    "spell": "puzhehei",
    "spellShort": "pzh",
    "code": "PZM"
  },
  {
    "name": "盘州",
    "spell": "panzhou",
    "spellShort": "pzh",
    "code": "PAE"
  },
  {
    "name": "攀枝花",
    "spell": "panzhihua",
    "spellShort": "pzh",
    "code": "PRW"
  },
  {
    "name": "彭州",
    "spell": "pengzhou",
    "spellShort": "pzh",
    "code": "PMW"
  },
  {
    "name": "攀枝花南",
    "spell": "panzhihuanan",
    "spellShort": "pzn",
    "code": "PNE"
  },
  {
    "name": "彭州南",
    "spell": "pengzhounan",
    "spellShort": "pzn",
    "code": "PKW"
  },
  {
    "name": "庆安",
    "spell": "qingan",
    "spellShort": "qan",
    "code": "QAB"
  },
  {
    "name": "青白江东",
    "spell": "qingbaijiangdong",
    "spellShort": "qbd",
    "code": "QFW"
  },
  {
    "name": "清城",
    "spell": "qingcheng",
    "spellShort": "qch",
    "code": "QCA"
  },
  {
    "name": "蕲春",
    "spell": "qichun",
    "spellShort": "qch",
    "code": "QRN"
  },
  {
    "name": "青川",
    "spell": "qingchuan",
    "spellShort": "qch",
    "code": "QCE"
  },
  {
    "name": "青城山",
    "spell": "qingchengshan",
    "spellShort": "qcs",
    "code": "QSW"
  },
  {
    "name": "青岛",
    "spell": "qingdao",
    "spellShort": "qda",
    "code": "QDK"
  },
  {
    "name": "青岛北",
    "spell": "qingdaobei",
    "spellShort": "qdb",
    "code": "QHK"
  },
  {
    "name": "千岛湖",
    "spell": "qiandaohu",
    "spellShort": "qdh",
    "code": "QDU"
  },
  {
    "name": "启东",
    "spell": "qidong",
    "spellShort": "qdo",
    "code": "QOU"
  },
  {
    "name": "青岛西",
    "spell": "qingdaoxi",
    "spellShort": "qdx",
    "code": "QUK"
  },
  {
    "name": "曲阜东",
    "spell": "qufudong",
    "spellShort": "qfd",
    "code": "QAK"
  },
  {
    "name": "前锋",
    "spell": "qianfeng",
    "spellShort": "qfe",
    "code": "QFB"
  },
  {
    "name": "曲阜",
    "spell": "qufu",
    "spellShort": "qfu",
    "code": "QFK"
  },
  {
    "name": "琼海",
    "spell": "qionghai",
    "spellShort": "qha",
    "code": "QYQ"
  },
  {
    "name": "清河城",
    "spell": "qinghecheng",
    "spellShort": "qhc",
    "code": "QYP"
  },
  {
    "name": "秦皇岛",
    "spell": "qinhuangdao",
    "spellShort": "qhd",
    "code": "QTP"
  },
  {
    "name": "清河",
    "spell": "qinghe",
    "spellShort": "qhe",
    "code": "QIP"
  },
  {
    "name": "清华园",
    "spell": "qinghuayuan",
    "spellShort": "qhy",
    "code": "QHP"
  },
  {
    "name": "曲靖北",
    "spell": "qujingbei",
    "spellShort": "qjb",
    "code": "QBM"
  },
  {
    "name": "綦江东",
    "spell": "qijiangdong",
    "spellShort": "qjd",
    "code": "QDE"
  },
  {
    "name": "黔江",
    "spell": "qianjiang",
    "spellShort": "qji",
    "code": "QNW"
  },
  {
    "name": "曲靖",
    "spell": "qujing",
    "spellShort": "qji",
    "code": "QJM"
  },
  {
    "name": "前进镇",
    "spell": "qianjinzhen",
    "spellShort": "qjz",
    "code": "QEB"
  },
  {
    "name": "邛崃",
    "spell": "qionglai",
    "spellShort": "qla",
    "code": "QLE"
  },
  {
    "name": "清流",
    "spell": "qingliu",
    "spellShort": "qli",
    "code": "QLS"
  },
  {
    "name": "齐齐哈尔",
    "spell": "qiqihaer",
    "spellShort": "qqe",
    "code": "QHX"
  },
  {
    "name": "齐齐哈尔南",
    "spell": "qiqihaernan",
    "spellShort": "qqn",
    "code": "QNB"
  },
  {
    "name": "潜山",
    "spell": "qianshan",
    "spellShort": "qsh",
    "code": "QSU"
  },
  {
    "name": "庆盛",
    "spell": "qingsheng",
    "spellShort": "qsh",
    "code": "QSQ"
  },
  {
    "name": "曲水县",
    "spell": "qushuixian",
    "spellShort": "qsx",
    "code": "QSO"
  },
  {
    "name": "七台河",
    "spell": "qitaihe",
    "spellShort": "qth",
    "code": "QTB"
  },
  {
    "name": "青铜峡",
    "spell": "qingtongxia",
    "spellShort": "qtx",
    "code": "QTJ"
  },
  {
    "name": "七台河西",
    "spell": "qitaihexi",
    "spellShort": "qtx",
    "code": "QXB"
  },
  {
    "name": "渠县",
    "spell": "quxian",
    "spellShort": "qxi",
    "code": "QRW"
  },
  {
    "name": "沁县",
    "spell": "qinxian",
    "spellShort": "qxi",
    "code": "QVV"
  },
  {
    "name": "清徐",
    "spell": "qingxu",
    "spellShort": "qxu",
    "code": "QUV"
  },
  {
    "name": "庆阳",
    "spell": "qingyang",
    "spellShort": "qya",
    "code": "QOJ"
  },
  {
    "name": "清远",
    "spell": "qingyuan",
    "spellShort": "qyu",
    "code": "QBQ"
  },
  {
    "name": "庆元",
    "spell": "qingyuan",
    "spellShort": "qyu",
    "code": "QYU"
  },
  {
    "name": "钦州东",
    "spell": "qinzhoudong",
    "spellShort": "qzd",
    "code": "QDZ"
  },
  {
    "name": "乔庄东",
    "spell": "qiaozhuangdong",
    "spellShort": "qzd",
    "code": "QEP"
  },
  {
    "name": "衢州",
    "spell": "quzhou",
    "spellShort": "qzh",
    "code": "QEH"
  },
  {
    "name": "泉州",
    "spell": "quanzhou",
    "spellShort": "qzh",
    "code": "QYS"
  },
  {
    "name": "全州南",
    "spell": "quanzhounan",
    "spellShort": "qzn",
    "code": "QNZ"
  },
  {
    "name": "清镇西",
    "spell": "qingzhenxi",
    "spellShort": "qzx",
    "code": "QUE"
  },
  {
    "name": "融安",
    "spell": "rongan",
    "spellShort": "ran",
    "code": "RAZ"
  },
  {
    "name": "瑞安",
    "spell": "ruian",
    "spellShort": "ran",
    "code": "RAH"
  },
  {
    "name": "荣昌北",
    "spell": "rongchangbei",
    "spellShort": "rcb",
    "code": "RQW"
  },
  {
    "name": "荣成",
    "spell": "rongcheng",
    "spellShort": "rch",
    "code": "RCK"
  },
  {
    "name": "如东",
    "spell": "rudong",
    "spellShort": "rdo",
    "code": "RIH"
  },
  {
    "name": "汝箕沟",
    "spell": "rujigou",
    "spellShort": "rjg",
    "code": "RQJ"
  },
  {
    "name": "瑞金",
    "spell": "ruijin",
    "spellShort": "rji",
    "code": "RJG"
  },
  {
    "name": "日喀则",
    "spell": "rikaze",
    "spellShort": "rkz",
    "code": "RKO"
  },
  {
    "name": "饶平",
    "spell": "raoping",
    "spellShort": "rpi",
    "code": "RVQ"
  },
  {
    "name": "若羌",
    "spell": "ruoqiang",
    "spellShort": "rqi",
    "code": "RQR"
  },
  {
    "name": "乳山南",
    "spell": "rushannan",
    "spellShort": "rsn",
    "code": "REK"
  },
  {
    "name": "日照",
    "spell": "rizhao",
    "spellShort": "rzh",
    "code": "RZK"
  },
  {
    "name": "日照西",
    "spell": "rizhaoxi",
    "spellShort": "rzx",
    "code": "KZK"
  },
  {
    "name": "肃北",
    "spell": "subei",
    "spellShort": "sbe",
    "code": "SBJ"
  },
  {
    "name": "双城北",
    "spell": "shuangchengbei",
    "spellShort": "scb",
    "code": "SBB"
  },
  {
    "name": "舒城东",
    "spell": "shuchengdong",
    "spellShort": "scd",
    "code": "SDU"
  },
  {
    "name": "莎车",
    "spell": "shache",
    "spellShort": "sch",
    "code": "SCR"
  },
  {
    "name": "沙城",
    "spell": "shacheng",
    "spellShort": "sch",
    "code": "SCP"
  },
  {
    "name": "宋城路",
    "spell": "songchenglu",
    "spellShort": "scl",
    "code": "SFF"
  },
  {
    "name": "双城堡",
    "spell": "shuangchengpu",
    "spellShort": "scp",
    "code": "SCB"
  },
  {
    "name": "邵东",
    "spell": "shaodong",
    "spellShort": "sdo",
    "code": "FIQ"
  },
  {
    "name": "十渡",
    "spell": "shidu",
    "spellShort": "sdu",
    "code": "SEP"
  },
  {
    "name": "双峰北",
    "spell": "shuangfengbei",
    "spellShort": "sfb",
    "code": "NFQ"
  },
  {
    "name": "双丰",
    "spell": "shuangfeng",
    "spellShort": "sfe",
    "code": "OFB"
  },
  {
    "name": "绥芬河",
    "spell": "suifenhe",
    "spellShort": "sfh",
    "code": "SFB"
  },
  {
    "name": "韶关东",
    "spell": "shaoguandong",
    "spellShort": "sgd",
    "code": "SGQ"
  },
  {
    "name": "韶关",
    "spell": "shaoguan",
    "spellShort": "sgu",
    "code": "SNQ"
  },
  {
    "name": "沙河",
    "spell": "shahe",
    "spellShort": "she",
    "code": "SHP"
  },
  {
    "name": "商河",
    "spell": "shanghe",
    "spellShort": "she",
    "code": "SOK"
  },
  {
    "name": "山海关",
    "spell": "shanhaiguan",
    "spellShort": "shg",
    "code": "SHD"
  },
  {
    "name": "沙河市",
    "spell": "shaheshi",
    "spellShort": "shs",
    "code": "VOP"
  },
  {
    "name": "山河屯",
    "spell": "shanhetun",
    "spellShort": "sht",
    "code": "SHL"
  },
  {
    "name": "绥化",
    "spell": "suihua",
    "spellShort": "shu",
    "code": "SHB"
  },
  {
    "name": "石河子",
    "spell": "shihezi",
    "spellShort": "shz",
    "code": "SZR"
  },
  {
    "name": "三家店",
    "spell": "sanjiadian",
    "spellShort": "sjd",
    "code": "ODP"
  },
  {
    "name": "三间房",
    "spell": "sanjianfang",
    "spellShort": "sjf",
    "code": "SFX"
  },
  {
    "name": "松江河",
    "spell": "songjianghe",
    "spellShort": "sjh",
    "code": "SJL"
  },
  {
    "name": "水家湖",
    "spell": "shuijiahu",
    "spellShort": "sjh",
    "code": "SQH"
  },
  {
    "name": "松江",
    "spell": "songjiang",
    "spellShort": "sji",
    "code": "SAH"
  },
  {
    "name": "孙家",
    "spell": "sunjia",
    "spellShort": "sji",
    "code": "SUB"
  },
  {
    "name": "沈家",
    "spell": "shenjia",
    "spellShort": "sji",
    "code": "OJB"
  },
  {
    "name": "三江南",
    "spell": "sanjiangnan",
    "spellShort": "sjn",
    "code": "SWZ"
  },
  {
    "name": "石景山南",
    "spell": "shijingshannan",
    "spellShort": "sjn",
    "code": "SRP"
  },
  {
    "name": "松江南",
    "spell": "songjiangnan",
    "spellShort": "sjn",
    "code": "IMH"
  },
  {
    "name": "苏家屯",
    "spell": "sujiatun",
    "spellShort": "sjt",
    "code": "SXT"
  },
  {
    "name": "三江县",
    "spell": "sanjiangxian",
    "spellShort": "sjx",
    "code": "SOZ"
  },
  {
    "name": "深井子",
    "spell": "shenjingzi",
    "spellShort": "sjz",
    "code": "SWT"
  },
  {
    "name": "四棵树",
    "spell": "sikeshu",
    "spellShort": "sks",
    "code": "SIR"
  },
  {
    "name": "舒兰",
    "spell": "shulan",
    "spellShort": "sla",
    "code": "SLL"
  },
  {
    "name": "双流机场",
    "spell": "shuangliujichang",
    "spellShort": "slc",
    "code": "IPW"
  },
  {
    "name": "双龙湖",
    "spell": "shuanglonghu",
    "spellShort": "slh",
    "code": "OHB"
  },
  {
    "name": "绥棱",
    "spell": "suiling",
    "spellShort": "sli",
    "code": "SIB"
  },
  {
    "name": "狮岭",
    "spell": "shiling",
    "spellShort": "sli",
    "code": "SLA"
  },
  {
    "name": "石林",
    "spell": "shilin",
    "spellShort": "sli",
    "code": "SLM"
  },
  {
    "name": "双龙南",
    "spell": "shuanglongnan",
    "spellShort": "sln",
    "code": "SNE"
  },
  {
    "name": "商洛",
    "spell": "shangluo",
    "spellShort": "slu",
    "code": "OLY"
  },
  {
    "name": "双流西",
    "spell": "shuangliuxi",
    "spellShort": "slx",
    "code": "IQW"
  },
  {
    "name": "石林西",
    "spell": "shilinxi",
    "spellShort": "slx",
    "code": "SYM"
  },
  {
    "name": "胜利镇",
    "spell": "shenglizhen",
    "spellShort": "slz",
    "code": "OLB"
  },
  {
    "name": "石门县北",
    "spell": "shimenxianbei",
    "spellShort": "smb",
    "code": "VFQ"
  },
  {
    "name": "三明北",
    "spell": "sanmingbei",
    "spellShort": "smb",
    "code": "SHS"
  },
  {
    "name": "三明",
    "spell": "sanming",
    "spellShort": "smi",
    "code": "SVS"
  },
  {
    "name": "嵩明",
    "spell": "songming",
    "spellShort": "smi",
    "code": "SVM"
  },
  {
    "name": "树木岭",
    "spell": "shumuling",
    "spellShort": "sml",
    "code": "FMQ"
  },
  {
    "name": "神木南",
    "spell": "shenmunan",
    "spellShort": "smn",
    "code": "OMY"
  },
  {
    "name": "三门峡南",
    "spell": "sanmenxianan",
    "spellShort": "smn",
    "code": "SCF"
  },
  {
    "name": "神木",
    "spell": "shenmu",
    "spellShort": "smu",
    "code": "HMY"
  },
  {
    "name": "三门县",
    "spell": "sanmenxian",
    "spellShort": "smx",
    "code": "OQH"
  },
  {
    "name": "三门峡西",
    "spell": "sanmenxiaxi",
    "spellShort": "smx",
    "code": "SXF"
  },
  {
    "name": "三门峡",
    "spell": "sanmenxia",
    "spellShort": "smx",
    "code": "SMF"
  },
  {
    "name": "商南",
    "spell": "shangnan",
    "spellShort": "sna",
    "code": "ONY"
  },
  {
    "name": "遂宁",
    "spell": "suining",
    "spellShort": "sni",
    "code": "NIW"
  },
  {
    "name": "睢宁",
    "spell": "suining",
    "spellShort": "sni",
    "code": "SNU"
  },
  {
    "name": "宋",
    "spell": "song",
    "spellShort": "son",
    "code": "SOB"
  },
  {
    "name": "石牌",
    "spell": "shipai",
    "spellShort": "spa",
    "code": "SPQ"
  },
  {
    "name": "沙坪坝",
    "spell": "shapingba",
    "spellShort": "spb",
    "code": "CYW"
  },
  {
    "name": "四平东",
    "spell": "sipingdong",
    "spellShort": "spd",
    "code": "PPT"
  },
  {
    "name": "山坡东",
    "spell": "shanpodong",
    "spellShort": "spd",
    "code": "SBN"
  },
  {
    "name": "四平",
    "spell": "siping",
    "spellShort": "spi",
    "code": "SPT"
  },
  {
    "name": "沈丘北",
    "spell": "shenqiubei",
    "spellShort": "sqb",
    "code": "SKF"
  },
  {
    "name": "宿迁",
    "spell": "suqian",
    "spellShort": "sqi",
    "code": "SQU"
  },
  {
    "name": "商丘",
    "spell": "shangqiu",
    "spellShort": "sqi",
    "code": "SQF"
  },
  {
    "name": "石泉县",
    "spell": "shiquanxian",
    "spellShort": "sqx",
    "code": "SXY"
  },
  {
    "name": "石桥子",
    "spell": "shiqiaozi",
    "spellShort": "sqz",
    "code": "SQT"
  },
  {
    "name": "上饶",
    "spell": "shangrao",
    "spellShort": "sra",
    "code": "SRG"
  },
  {
    "name": "石人城",
    "spell": "shirencheng",
    "spellShort": "src",
    "code": "SRB"
  },
  {
    "name": "鄯善北",
    "spell": "shanshanbei",
    "spellShort": "ssb",
    "code": "SMR"
  },
  {
    "name": "宿松东",
    "spell": "susongdong",
    "spellShort": "ssd",
    "code": "SSU"
  },
  {
    "name": "蜀山东",
    "spell": "shushandong",
    "spellShort": "ssd",
    "code": "HTH"
  },
  {
    "name": "韶山",
    "spell": "shaoshan",
    "spellShort": "ssh",
    "code": "SSQ"
  },
  {
    "name": "神树",
    "spell": "shenshu",
    "spellShort": "ssh",
    "code": "SWB"
  },
  {
    "name": "韶山南",
    "spell": "shaoshannan",
    "spellShort": "ssn",
    "code": "INQ"
  },
  {
    "name": "宿松",
    "spell": "susong",
    "spellShort": "sso",
    "code": "OAH"
  },
  {
    "name": "三穗",
    "spell": "sansui",
    "spellShort": "ssu",
    "code": "QHW"
  },
  {
    "name": "松桃",
    "spell": "songtao",
    "spellShort": "sta",
    "code": "MZQ"
  },
  {
    "name": "汕头南",
    "spell": "shantounan",
    "spellShort": "stn",
    "code": "SNA"
  },
  {
    "name": "汕头",
    "spell": "shantou",
    "spellShort": "sto",
    "code": "OTQ"
  },
  {
    "name": "汕尾",
    "spell": "shanwei",
    "spellShort": "swe",
    "code": "OGQ"
  },
  {
    "name": "邵武",
    "spell": "shaowu",
    "spellShort": "swu",
    "code": "SWS"
  },
  {
    "name": "绍兴北",
    "spell": "shaoxingbei",
    "spellShort": "sxb",
    "code": "SLH"
  },
  {
    "name": "绍兴东",
    "spell": "shaoxingdong",
    "spellShort": "sxd",
    "code": "SSH"
  },
  {
    "name": "松溪",
    "spell": "songxi",
    "spellShort": "sxi",
    "code": "SIS"
  },
  {
    "name": "涉县",
    "spell": "shexian",
    "spellShort": "sxi",
    "code": "OEP"
  },
  {
    "name": "莘县",
    "spell": "shenxian",
    "spellShort": "sxi",
    "code": "SNK"
  },
  {
    "name": "绍兴",
    "spell": "shaoxing",
    "spellShort": "sxi",
    "code": "SOH"
  },
  {
    "name": "三亚",
    "spell": "sanya",
    "spellShort": "sya",
    "code": "SEQ"
  },
  {
    "name": "邵阳",
    "spell": "shaoyang",
    "spellShort": "sya",
    "code": "SYQ"
  },
  {
    "name": "十堰",
    "spell": "shiyan",
    "spellShort": "sya",
    "code": "SNN"
  },
  {
    "name": "双阳",
    "spell": "shuangyang",
    "spellShort": "sya",
    "code": "OYT"
  },
  {
    "name": "十堰东",
    "spell": "shiyandong",
    "spellShort": "syd",
    "code": "OUN"
  },
  {
    "name": "顺义",
    "spell": "shunyi",
    "spellShort": "syi",
    "code": "SOP"
  },
  {
    "name": "三元区",
    "spell": "sanyuanqu",
    "spellShort": "syq",
    "code": "SMS"
  },
  {
    "name": "双鸭山",
    "spell": "shuangyashan",
    "spellShort": "sys",
    "code": "SSB"
  },
  {
    "name": "松原",
    "spell": "songyuan",
    "spellShort": "syu",
    "code": "VYT"
  },
  {
    "name": "双鸭山西",
    "spell": "shuangyashanxi",
    "spellShort": "syx",
    "code": "OXB"
  },
  {
    "name": "顺义西",
    "spell": "shunyixi",
    "spellShort": "syx",
    "code": "IKP"
  },
  {
    "name": "深圳北",
    "spell": "shenzhenbei",
    "spellShort": "szb",
    "code": "IOQ"
  },
  {
    "name": "苏州北",
    "spell": "suzhoubei",
    "spellShort": "szb",
    "code": "OHH"
  },
  {
    "name": "深圳机场",
    "spell": "shenzhenjichang",
    "spellShort": "szc",
    "code": "SCA"
  },
  {
    "name": "嵊州新昌",
    "spell": "shengzhouxinchang",
    "spellShort": "szc",
    "code": "SKU"
  },
  {
    "name": "深圳东",
    "spell": "shenzhendong",
    "spellShort": "szd",
    "code": "BJQ"
  },
  {
    "name": "宿州东",
    "spell": "suzhoudong",
    "spellShort": "szd",
    "code": "SRH"
  },
  {
    "name": "绥中",
    "spell": "suizhong",
    "spellShort": "szh",
    "code": "SZD"
  },
  {
    "name": "朔州",
    "spell": "shuozhou",
    "spellShort": "szh",
    "code": "SUV"
  },
  {
    "name": "深圳",
    "spell": "shenzhen",
    "spellShort": "szh",
    "code": "SZQ",
    "isHot": true
  },
  {
    "name": "随州",
    "spell": "suizhou",
    "spellShort": "szh",
    "code": "SZN"
  },
  {
    "name": "宿州",
    "spell": "suzhou",
    "spellShort": "szh",
    "code": "OXH"
  },
  {
    "name": "苏州",
    "spell": "suzhou",
    "spellShort": "szh",
    "code": "SZH"
  },
  {
    "name": "尚志",
    "spell": "shangzhi",
    "spellShort": "szh",
    "code": "SZB"
  },
  {
    "name": "随州南",
    "spell": "suizhounan",
    "spellShort": "szn",
    "code": "ONN"
  },
  {
    "name": "尚志南",
    "spell": "shangzhinan",
    "spellShort": "szn",
    "code": "OZB"
  },
  {
    "name": "深圳坪山",
    "spell": "shenzhenpingshan",
    "spellShort": "szs",
    "code": "IFQ"
  },
  {
    "name": "石嘴山",
    "spell": "shizuishan",
    "spellShort": "szs",
    "code": "QQJ"
  },
  {
    "name": "石柱县",
    "spell": "shizhuxian",
    "spellShort": "szx",
    "code": "OSW"
  },
  {
    "name": "深圳西",
    "spell": "shenzhenxi",
    "spellShort": "szx",
    "code": "OSQ"
  },
  {
    "name": "泰安",
    "spell": "taian",
    "spellShort": "tan",
    "code": "TMK"
  },
  {
    "name": "通北",
    "spell": "tongbei",
    "spellShort": "tbe",
    "code": "TBB"
  },
  {
    "name": "铜川东",
    "spell": "tongchuandong",
    "spellShort": "tcd",
    "code": "TCY"
  },
  {
    "name": "塔城",
    "spell": "tacheng",
    "spellShort": "tch",
    "code": "TZR"
  },
  {
    "name": "汤池",
    "spell": "tangchi",
    "spellShort": "tch",
    "code": "TCX"
  },
  {
    "name": "通道",
    "spell": "tongdao",
    "spellShort": "tda",
    "code": "TRQ"
  },
  {
    "name": "土地堂东",
    "spell": "tuditangdong",
    "spellShort": "tdd",
    "code": "TTN"
  },
  {
    "name": "塔尔气",
    "spell": "taerqi",
    "spellShort": "teq",
    "code": "TVX"
  },
  {
    "name": "潼关",
    "spell": "tongguan",
    "spellShort": "tgu",
    "code": "TGY"
  },
  {
    "name": "太谷",
    "spell": "taigu",
    "spellShort": "tgu",
    "code": "TGV"
  },
  {
    "name": "塘沽",
    "spell": "tanggu",
    "spellShort": "tgu",
    "code": "TGP"
  },
  {
    "name": "吐哈",
    "spell": "tuha",
    "spellShort": "tha",
    "code": "THR"
  },
  {
    "name": "通海",
    "spell": "tonghai",
    "spellShort": "tha",
    "code": "TAM"
  },
  {
    "name": "塔哈",
    "spell": "taha",
    "spellShort": "tha",
    "code": "THX"
  },
  {
    "name": "天河机场",
    "spell": "tianhejichang",
    "spellShort": "thc",
    "code": "TJN"
  },
  {
    "name": "泰和",
    "spell": "taihe",
    "spellShort": "the",
    "code": "THG"
  },
  {
    "name": "塔河",
    "spell": "tahe",
    "spellShort": "the",
    "code": "TXX"
  },
  {
    "name": "天河街",
    "spell": "tianhejie",
    "spellShort": "thj",
    "code": "TEN"
  },
  {
    "name": "太湖南",
    "spell": "taihunan",
    "spellShort": "thn",
    "code": "TAU"
  },
  {
    "name": "天河潭",
    "spell": "tianhetan",
    "spellShort": "tht",
    "code": "TTE"
  },
  {
    "name": "通化",
    "spell": "tonghua",
    "spellShort": "thu",
    "code": "THL"
  },
  {
    "name": "太湖",
    "spell": "taihu",
    "spellShort": "thu",
    "code": "TKH"
  },
  {
    "name": "同江",
    "spell": "tongjiang",
    "spellShort": "tji",
    "code": "TJB"
  },
  {
    "name": "陶家屯",
    "spell": "taojiatun",
    "spellShort": "tjt",
    "code": "TOT"
  },
  {
    "name": "托克托东",
    "spell": "tuoketuodong",
    "spellShort": "tkd",
    "code": "TVC"
  },
  {
    "name": "泰来",
    "spell": "tailai",
    "spellShort": "tla",
    "code": "TLX"
  },
  {
    "name": "吐鲁番北",
    "spell": "tulufanbei",
    "spellShort": "tlb",
    "code": "TAR"
  },
  {
    "name": "吐鲁番",
    "spell": "tulufan",
    "spellShort": "tlf",
    "code": "TFR"
  },
  {
    "name": "通辽",
    "spell": "tongliao",
    "spellShort": "tli",
    "code": "TLD"
  },
  {
    "name": "铜陵",
    "spell": "tongling",
    "spellShort": "tli",
    "code": "TJH"
  },
  {
    "name": "铁岭",
    "spell": "tieling",
    "spellShort": "tli",
    "code": "TLT"
  },
  {
    "name": "铁力",
    "spell": "tieli",
    "spellShort": "tli",
    "code": "TLB"
  },
  {
    "name": "桐庐",
    "spell": "tonglu",
    "spellShort": "tlu",
    "code": "TLU"
  },
  {
    "name": "铁岭西",
    "spell": "tielingxi",
    "spellShort": "tlx",
    "code": "PXT"
  },
  {
    "name": "陶赖昭",
    "spell": "taolaizhao",
    "spellShort": "tlz",
    "code": "TPT"
  },
  {
    "name": "图们北",
    "spell": "tumenbei",
    "spellShort": "tmb",
    "code": "QSL"
  },
  {
    "name": "图们",
    "spell": "tumen",
    "spellShort": "tme",
    "code": "TML"
  },
  {
    "name": "头门港",
    "spell": "toumengang",
    "spellShort": "tmg",
    "code": "TMU"
  },
  {
    "name": "图木舒克",
    "spell": "tumushuke",
    "spellShort": "tmk",
    "code": "TMR"
  },
  {
    "name": "天门南",
    "spell": "tianmennan",
    "spellShort": "tmn",
    "code": "TNN"
  },
  {
    "name": "潼南",
    "spell": "tongnan",
    "spellShort": "tna",
    "code": "TVW"
  },
  {
    "name": "泰宁",
    "spell": "taining",
    "spellShort": "tni",
    "code": "TNS"
  },
  {
    "name": "铜仁",
    "spell": "tongren",
    "spellShort": "tre",
    "code": "RDQ"
  },
  {
    "name": "铜仁南",
    "spell": "tongrennan",
    "spellShort": "trn",
    "code": "TNW"
  },
  {
    "name": "唐山北",
    "spell": "tangshanbei",
    "spellShort": "tsb",
    "code": "FUP"
  },
  {
    "name": "田师府",
    "spell": "tianshifu",
    "spellShort": "tsf",
    "code": "TFT"
  },
  {
    "name": "泰山",
    "spell": "taishan",
    "spellShort": "tsh",
    "code": "TAK"
  },
  {
    "name": "唐山",
    "spell": "tangshan",
    "spellShort": "tsh",
    "code": "TSP"
  },
  {
    "name": "天水",
    "spell": "tianshui",
    "spellShort": "tsh",
    "code": "TSJ"
  },
  {
    "name": "天水南",
    "spell": "tianshuinan",
    "spellShort": "tsn",
    "code": "TIJ"
  },
  {
    "name": "汤旺河",
    "spell": "tangwanghe",
    "spellShort": "twh",
    "code": "THB"
  },
  {
    "name": "汤逊湖",
    "spell": "tangxunhu",
    "spellShort": "txh",
    "code": "THN"
  },
  {
    "name": "土溪",
    "spell": "tuxi",
    "spellShort": "txi",
    "code": "TSW"
  },
  {
    "name": "通远堡",
    "spell": "tongyuanpu",
    "spellShort": "typ",
    "code": "TYT"
  },
  {
    "name": "太阳升",
    "spell": "taiyangsheng",
    "spellShort": "tys",
    "code": "TQT"
  },
  {
    "name": "通榆",
    "spell": "tongyu",
    "spellShort": "tyu",
    "code": "KTT"
  },
  {
    "name": "桐梓北",
    "spell": "tongzibei",
    "spellShort": "tzb",
    "code": "TBE"
  },
  {
    "name": "太子城",
    "spell": "taizicheng",
    "spellShort": "tzc",
    "code": "IZP"
  },
  {
    "name": "滕州东",
    "spell": "tengzhoudong",
    "spellShort": "tzd",
    "code": "TEK"
  },
  {
    "name": "桐梓东",
    "spell": "tongzidong",
    "spellShort": "tzd",
    "code": "TDE"
  },
  {
    "name": "台州",
    "spell": "taizhou",
    "spellShort": "tzh",
    "code": "TEU"
  },
  {
    "name": "泰州",
    "spell": "taizhou",
    "spellShort": "tzh",
    "code": "UTH"
  },
  {
    "name": "通州",
    "spell": "tongzhou",
    "spellShort": "tzh",
    "code": "TOP"
  },
  {
    "name": "台州西",
    "spell": "taizhouxi",
    "spellShort": "tzx",
    "code": "TZH"
  },
  {
    "name": "通州西",
    "spell": "tongzhouxi",
    "spellShort": "tzx",
    "code": "TAP"
  },
  {
    "name": "文昌",
    "spell": "wenchang",
    "spellShort": "wch",
    "code": "WEQ"
  },
  {
    "name": "武昌",
    "spell": "wuchang",
    "spellShort": "wch",
    "code": "WCN"
  },
  {
    "name": "五常",
    "spell": "wuchang",
    "spellShort": "wch",
    "code": "WCB"
  },
  {
    "name": "武当山",
    "spell": "wudangshan",
    "spellShort": "wds",
    "code": "WRN"
  },
  {
    "name": "潍坊",
    "spell": "weifang",
    "spellShort": "wfa",
    "code": "WFK"
  },
  {
    "name": "瓦房店",
    "spell": "wafangdian",
    "spellShort": "wfd",
    "code": "WDT"
  },
  {
    "name": "万发屯",
    "spell": "wanfatun",
    "spellShort": "wft",
    "code": "WFB"
  },
  {
    "name": "瓦房店西",
    "spell": "wafangdianxi",
    "spellShort": "wfx",
    "code": "WXT"
  },
  {
    "name": "王岗",
    "spell": "wanggang",
    "spellShort": "wga",
    "code": "WGB"
  },
  {
    "name": "武功",
    "spell": "wugong",
    "spellShort": "wgo",
    "code": "WGY"
  },
  {
    "name": "威海",
    "spell": "weihai",
    "spellShort": "wha",
    "code": "WKK"
  },
  {
    "name": "乌海",
    "spell": "wuhai",
    "spellShort": "wha",
    "code": "WVC"
  },
  {
    "name": "苇河",
    "spell": "weihe",
    "spellShort": "whe",
    "code": "WHB"
  },
  {
    "name": "芜湖",
    "spell": "wuhu",
    "spellShort": "whu",
    "code": "WHH"
  },
  {
    "name": "乌海西",
    "spell": "wuhaixi",
    "spellShort": "whx",
    "code": "WXC"
  },
  {
    "name": "苇河西",
    "spell": "weihexi",
    "spellShort": "whx",
    "code": "WIB"
  },
  {
    "name": "温江",
    "spell": "wenjiang",
    "spellShort": "wji",
    "code": "WJE"
  },
  {
    "name": "五家",
    "spell": "wujia",
    "spellShort": "wji",
    "code": "WUB"
  },
  {
    "name": "五棵树",
    "spell": "wukeshu",
    "spellShort": "wks",
    "code": "WKT"
  },
  {
    "name": "乌兰察布",
    "spell": "wulanchabu",
    "spellShort": "wlb",
    "code": "WPC"
  },
  {
    "name": "万乐",
    "spell": "wanle",
    "spellShort": "wle",
    "code": "WEB"
  },
  {
    "name": "温岭",
    "spell": "wenling",
    "spellShort": "wli",
    "code": "VHH"
  },
  {
    "name": "乌龙泉南",
    "spell": "wulongquannan",
    "spellShort": "wln",
    "code": "WFN"
  },
  {
    "name": "武隆",
    "spell": "wulong",
    "spellShort": "wlo",
    "code": "WLW"
  },
  {
    "name": "乌拉特前旗",
    "spell": "wulateqianqi",
    "spellShort": "wlq",
    "code": "WQC"
  },
  {
    "name": "乌兰浩特",
    "spell": "wulanhaote",
    "spellShort": "wlt",
    "code": "WWT"
  },
  {
    "name": "渭南",
    "spell": "weinan",
    "spellShort": "wna",
    "code": "WNY"
  },
  {
    "name": "渭南北",
    "spell": "weinanbei",
    "spellShort": "wnb",
    "code": "WBY"
  },
  {
    "name": "五女山",
    "spell": "wunvshan",
    "spellShort": "wns",
    "code": "WET"
  },
  {
    "name": "渭南西",
    "spell": "weinanxi",
    "spellShort": "wnx",
    "code": "WXY"
  },
  {
    "name": "沃皮",
    "spell": "wopi",
    "spellShort": "wpi",
    "code": "WPT"
  },
  {
    "name": "汪清",
    "spell": "wangqing",
    "spellShort": "wqi",
    "code": "WQL"
  },
  {
    "name": "武清",
    "spell": "wuqing",
    "spellShort": "wqi",
    "code": "WWP"
  },
  {
    "name": "武胜",
    "spell": "wusheng",
    "spellShort": "wsh",
    "code": "WSE"
  },
  {
    "name": "威舍",
    "spell": "weishe",
    "spellShort": "wsh",
    "code": "WSM"
  },
  {
    "name": "乌审旗",
    "spell": "wushenqi",
    "spellShort": "wsq",
    "code": "WGC"
  },
  {
    "name": "乌苏",
    "spell": "wusu",
    "spellShort": "wsu",
    "code": "WSR"
  },
  {
    "name": "武威",
    "spell": "wuwei",
    "spellShort": "wwe",
    "code": "WUJ"
  },
  {
    "name": "武威南",
    "spell": "wuweinan",
    "spellShort": "wwn",
    "code": "WWJ"
  },
  {
    "name": "无为南",
    "spell": "wuweinan",
    "spellShort": "wwn",
    "code": "WWU"
  },
  {
    "name": "武穴北",
    "spell": "wuxuebei",
    "spellShort": "wxb",
    "code": "WJN"
  },
  {
    "name": "无锡东",
    "spell": "wuxidong",
    "spellShort": "wxd",
    "code": "WGH"
  },
  {
    "name": "无锡",
    "spell": "wuxi",
    "spellShort": "wxi",
    "code": "WXH"
  },
  {
    "name": "乌西",
    "spell": "wuxi",
    "spellShort": "wxi",
    "code": "WXR"
  },
  {
    "name": "武穴",
    "spell": "wuxue",
    "spellShort": "wxu",
    "code": "WXN"
  },
  {
    "name": "吴圩",
    "spell": "wuxu",
    "spellShort": "wxu",
    "code": "WYZ"
  },
  {
    "name": "闻喜西",
    "spell": "wenxixi",
    "spellShort": "wxx",
    "code": "WOV"
  },
  {
    "name": "武夷山北",
    "spell": "wuyishanbei",
    "spellShort": "wyb",
    "code": "WBS"
  },
  {
    "name": "五营",
    "spell": "wuying",
    "spellShort": "wyi",
    "code": "WWB"
  },
  {
    "name": "乌伊岭",
    "spell": "wuyiling",
    "spellShort": "wyl",
    "code": "WPB"
  },
  {
    "name": "武夷山",
    "spell": "wuyishan",
    "spellShort": "wys",
    "code": "WAS"
  },
  {
    "name": "渭源",
    "spell": "weiyuan",
    "spellShort": "wyu",
    "code": "WEJ"
  },
  {
    "name": "婺源",
    "spell": "wuyuan",
    "spellShort": "wyu",
    "code": "WYG"
  },
  {
    "name": "万源",
    "spell": "wanyuan",
    "spellShort": "wyu",
    "code": "WYY"
  },
  {
    "name": "万州北",
    "spell": "wanzhoubei",
    "spellShort": "wzb",
    "code": "WZE"
  },
  {
    "name": "梧州",
    "spell": "wuzhou",
    "spellShort": "wzh",
    "code": "WZZ"
  },
  {
    "name": "万州",
    "spell": "wanzhou",
    "spellShort": "wzh",
    "code": "WYW"
  },
  {
    "name": "吴忠",
    "spell": "wuzhong",
    "spellShort": "wzh",
    "code": "WVJ"
  },
  {
    "name": "温州",
    "spell": "wenzhou",
    "spellShort": "wzh",
    "code": "RZH"
  },
  {
    "name": "梧州南",
    "spell": "wuzhounan",
    "spellShort": "wzn",
    "code": "WBZ"
  },
  {
    "name": "温州南",
    "spell": "wenzhounan",
    "spellShort": "wzn",
    "code": "VRH"
  },
  {
    "name": "兴安北",
    "spell": "xinganbei",
    "spellShort": "xab",
    "code": "XDZ"
  },
  {
    "name": "雄安",
    "spell": "xiongan",
    "spellShort": "xan",
    "code": "IQP"
  },
  {
    "name": "西安西",
    "spell": "xianxi",
    "spellShort": "xax",
    "code": "EGY"
  },
  {
    "name": "许昌东",
    "spell": "xuchangdong",
    "spellShort": "xcd",
    "code": "XVF"
  },
  {
    "name": "兴城",
    "spell": "xingcheng",
    "spellShort": "xch",
    "code": "XCD"
  },
  {
    "name": "宣城",
    "spell": "xuancheng",
    "spellShort": "xch",
    "code": "ECH"
  },
  {
    "name": "西昌",
    "spell": "xichang",
    "spellShort": "xch",
    "code": "ECW"
  },
  {
    "name": "许昌",
    "spell": "xuchang",
    "spellShort": "xch",
    "code": "XCF"
  },
  {
    "name": "西昌西",
    "spell": "xichangxi",
    "spellShort": "xcx",
    "code": "XCE"
  },
  {
    "name": "新都东",
    "spell": "xindudong",
    "spellShort": "xdd",
    "code": "EWW"
  },
  {
    "name": "香坊",
    "spell": "xiangfang",
    "spellShort": "xfa",
    "code": "XFB"
  },
  {
    "name": "咸丰",
    "spell": "xianfeng",
    "spellShort": "xfe",
    "code": "XFA"
  },
  {
    "name": "西丰",
    "spell": "xifeng",
    "spellShort": "xfe",
    "code": "XFT"
  },
  {
    "name": "息烽",
    "spell": "xifeng",
    "spellShort": "xfe",
    "code": "XFW"
  },
  {
    "name": "先锋",
    "spell": "xianfeng",
    "spellShort": "xfe",
    "code": "NQQ"
  },
  {
    "name": "湘府路",
    "spell": "xiangfulu",
    "spellShort": "xfl",
    "code": "FVQ"
  },
  {
    "name": "轩岗",
    "spell": "xuangang",
    "spellShort": "xga",
    "code": "XGV"
  },
  {
    "name": "孝感北",
    "spell": "xiaoganbei",
    "spellShort": "xgb",
    "code": "XJN"
  },
  {
    "name": "孝感东",
    "spell": "xiaogandong",
    "spellShort": "xgd",
    "code": "GDN"
  },
  {
    "name": "香港西九龙",
    "spell": "hkwestkowloon",
    "spellShort": "xgl",
    "code": "XJA"
  },
  {
    "name": "兴国",
    "spell": "xingguo",
    "spellShort": "xgu",
    "code": "EUG"
  },
  {
    "name": "西固",
    "spell": "xigu",
    "spellShort": "xgu",
    "code": "XIJ"
  },
  {
    "name": "夏官营",
    "spell": "xiaguanying",
    "spellShort": "xgy",
    "code": "XGJ"
  },
  {
    "name": "宣汉",
    "spell": "xuanhan",
    "spellShort": "xha",
    "code": "XHY"
  },
  {
    "name": "兴和北",
    "spell": "xinghebei",
    "spellShort": "xhb",
    "code": "EBC"
  },
  {
    "name": "下花园北",
    "spell": "xiahuayuanbei",
    "spellShort": "xhb",
    "code": "OKP"
  },
  {
    "name": "新化南",
    "spell": "xinhuanan",
    "spellShort": "xhn",
    "code": "EJQ"
  },
  {
    "name": "新会",
    "spell": "xinhui",
    "spellShort": "xhu",
    "code": "EFQ"
  },
  {
    "name": "新晃",
    "spell": "xinhuang",
    "spellShort": "xhu",
    "code": "XLQ"
  },
  {
    "name": "兴和西",
    "spell": "xinghexi",
    "spellShort": "xhx",
    "code": "XEC"
  },
  {
    "name": "新晃西",
    "spell": "xinhuangxi",
    "spellShort": "xhx",
    "code": "EWQ"
  },
  {
    "name": "新津",
    "spell": "xinjin",
    "spellShort": "xji",
    "code": "IRW"
  },
  {
    "name": "辛集",
    "spell": "xinji",
    "spellShort": "xji",
    "code": "ENP"
  },
  {
    "name": "徐家",
    "spell": "xujia",
    "spellShort": "xji",
    "code": "XJB"
  },
  {
    "name": "小金口",
    "spell": "xiaojinkou",
    "spellShort": "xjk",
    "code": "NKQ"
  },
  {
    "name": "新津南",
    "spell": "xinjinnan",
    "spellShort": "xjn",
    "code": "ITW"
  },
  {
    "name": "辛集南",
    "spell": "xinjinan",
    "spellShort": "xjn",
    "code": "IJP"
  },
  {
    "name": "谢家镇",
    "spell": "xiejiazhen",
    "spellShort": "xjz",
    "code": "XMT"
  },
  {
    "name": "西来",
    "spell": "xilai",
    "spellShort": "xla",
    "code": "XLE"
  },
  {
    "name": "兴隆店",
    "spell": "xinglongdian",
    "spellShort": "xld",
    "code": "XDD"
  },
  {
    "name": "新乐",
    "spell": "xinle",
    "spellShort": "xle",
    "code": "ELP"
  },
  {
    "name": "仙林",
    "spell": "xianlin",
    "spellShort": "xli",
    "code": "XPH"
  },
  {
    "name": "小岭",
    "spell": "xiaoling",
    "spellShort": "xli",
    "code": "XLB"
  },
  {
    "name": "锡林浩特",
    "spell": "xilinhaote",
    "spellShort": "xlt",
    "code": "XTC"
  },
  {
    "name": "兴隆县",
    "spell": "xinglongxian",
    "spellShort": "xlx",
    "code": "EXP"
  },
  {
    "name": "新立镇",
    "spell": "xinlizhen",
    "spellShort": "xlz",
    "code": "XGT"
  },
  {
    "name": "兴隆镇",
    "spell": "xinglongzhen",
    "spellShort": "xlz",
    "code": "XZB"
  },
  {
    "name": "厦门北",
    "spell": "xiamenbei",
    "spellShort": "xmb",
    "code": "XKS"
  },
  {
    "name": "新民北",
    "spell": "xinminbei",
    "spellShort": "xmb",
    "code": "XOT"
  },
  {
    "name": "厦门",
    "spell": "xiamen",
    "spellShort": "xme",
    "code": "XMS",
    "isHot": true
  },
  {
    "name": "新民",
    "spell": "xinmin",
    "spellShort": "xmi",
    "code": "XMD"
  },
  {
    "name": "厦门高崎",
    "spell": "xiamengaoqi",
    "spellShort": "xmq",
    "code": "XBS"
  },
  {
    "name": "咸宁南",
    "spell": "xianningnan",
    "spellShort": "xnn",
    "code": "UNN"
  },
  {
    "name": "犀浦东",
    "spell": "xipudong",
    "spellShort": "xpd",
    "code": "XAW"
  },
  {
    "name": "溆浦南",
    "spell": "xupunan",
    "spellShort": "xpn",
    "code": "EMQ"
  },
  {
    "name": "霞浦",
    "spell": "xiapu",
    "spellShort": "xpu",
    "code": "XOS"
  },
  {
    "name": "溆浦",
    "spell": "xupu",
    "spellShort": "xpu",
    "code": "EPQ"
  },
  {
    "name": "犀浦",
    "spell": "xipu",
    "spellShort": "xpu",
    "code": "XIW"
  },
  {
    "name": "秀山",
    "spell": "xiushan",
    "spellShort": "xsh",
    "code": "ETW"
  },
  {
    "name": "小市",
    "spell": "xiaoshi",
    "spellShort": "xsh",
    "code": "XST"
  },
  {
    "name": "兴山",
    "spell": "xingshan",
    "spellShort": "xsh",
    "code": "EMN"
  },
  {
    "name": "西双版纳",
    "spell": "xishuangbanna",
    "spellShort": "xsn",
    "code": "ENM"
  },
  {
    "name": "新松浦",
    "spell": "xinsongpu",
    "spellShort": "xsp",
    "code": "XOB"
  },
  {
    "name": "仙桃",
    "spell": "xiantao",
    "spellShort": "xta",
    "code": "VTN"
  },
  {
    "name": "湘潭",
    "spell": "xiangtan",
    "spellShort": "xta",
    "code": "XTQ"
  },
  {
    "name": "向塘",
    "spell": "xiangtang",
    "spellShort": "xta",
    "code": "XTG"
  },
  {
    "name": "邢台东",
    "spell": "xingtaidong",
    "spellShort": "xtd",
    "code": "EDP"
  },
  {
    "name": "新塘南",
    "spell": "xintangnan",
    "spellShort": "xtn",
    "code": "NUQ"
  },
  {
    "name": "兴文",
    "spell": "xingwen",
    "spellShort": "xwe",
    "code": "XNE"
  },
  {
    "name": "宣威",
    "spell": "xuanwei",
    "spellShort": "xwe",
    "code": "XWM"
  },
  {
    "name": "修文县",
    "spell": "xiuwenxian",
    "spellShort": "xwx",
    "code": "XWE"
  },
  {
    "name": "萧县北",
    "spell": "xiaoxianbei",
    "spellShort": "xxb",
    "code": "QSH"
  },
  {
    "name": "新香坊北",
    "spell": "xinxiangfangbei",
    "spellShort": "xxb",
    "code": "RHB"
  },
  {
    "name": "新乡东",
    "spell": "xinxiangdong",
    "spellShort": "xxd",
    "code": "EGF"
  },
  {
    "name": "孝西",
    "spell": "xiaoxi",
    "spellShort": "xxi",
    "code": "XOV"
  },
  {
    "name": "西乡",
    "spell": "xixiang",
    "spellShort": "xxi",
    "code": "XQY"
  },
  {
    "name": "西峡",
    "spell": "xixia",
    "spellShort": "xxi",
    "code": "XIF"
  },
  {
    "name": "新乡",
    "spell": "xinxiang",
    "spellShort": "xxi",
    "code": "XXF"
  },
  {
    "name": "小新街",
    "spell": "xiaoxinjie",
    "spellShort": "xxj",
    "code": "XXM"
  },
  {
    "name": "信阳",
    "spell": "xinyang",
    "spellShort": "xya",
    "code": "XUN"
  },
  {
    "name": "旬阳",
    "spell": "xunyang",
    "spellShort": "xya",
    "code": "XUY"
  },
  {
    "name": "咸阳",
    "spell": "xianyang",
    "spellShort": "xya",
    "code": "XYY"
  },
  {
    "name": "岫岩",
    "spell": "xiuyan",
    "spellShort": "xya",
    "code": "XXT"
  },
  {
    "name": "襄阳",
    "spell": "xiangyang",
    "spellShort": "xya",
    "code": "XFN"
  },
  {
    "name": "叙永北",
    "spell": "xuyongbei",
    "spellShort": "xyb",
    "code": "XEE"
  },
  {
    "name": "新余北",
    "spell": "xinyubei",
    "spellShort": "xyb",
    "code": "XBG"
  },
  {
    "name": "熊岳城",
    "spell": "xiongyuecheng",
    "spellShort": "xyc",
    "code": "XYT"
  },
  {
    "name": "信阳东",
    "spell": "xinyangdong",
    "spellShort": "xyd",
    "code": "OYN"
  },
  {
    "name": "襄阳东",
    "spell": "xiangyangdong",
    "spellShort": "xyd",
    "code": "EKN"
  },
  {
    "name": "兴义",
    "spell": "xingyi",
    "spellShort": "xyi",
    "code": "XRZ"
  },
  {
    "name": "信宜",
    "spell": "xinyi",
    "spellShort": "xyi",
    "code": "EEQ"
  },
  {
    "name": "秀英",
    "spell": "xiuying",
    "spellShort": "xyi",
    "code": "XYA"
  },
  {
    "name": "祥云",
    "spell": "xiangyun",
    "spellShort": "xyu",
    "code": "XQM"
  },
  {
    "name": "新余",
    "spell": "xinyu",
    "spellShort": "xyu",
    "code": "XUG"
  },
  {
    "name": "咸阳西",
    "spell": "xianyangxi",
    "spellShort": "xyx",
    "code": "XOY"
  },
  {
    "name": "新郑机场",
    "spell": "xinzhengjichang",
    "spellShort": "xzc",
    "code": "EZF"
  },
  {
    "name": "徐州东",
    "spell": "xuzhoudong",
    "spellShort": "xzd",
    "code": "UUH"
  },
  {
    "name": "忻州",
    "spell": "xinzhou",
    "spellShort": "xzh",
    "code": "XXV"
  },
  {
    "name": "新肇",
    "spell": "xinzhao",
    "spellShort": "xzh",
    "code": "XZT"
  },
  {
    "name": "襄州",
    "spell": "xiangzhou",
    "spellShort": "xzh",
    "code": "XWN"
  },
  {
    "name": "徐州",
    "spell": "xuzhou",
    "spellShort": "xzh",
    "code": "XCH"
  },
  {
    "name": "香樟路",
    "spell": "xiangzhanglu",
    "spellShort": "xzl",
    "code": "FNQ"
  },
  {
    "name": "忻州西",
    "spell": "xinzhouxi",
    "spellShort": "xzx",
    "code": "IXV"
  },
  {
    "name": "雅安",
    "spell": "yaan",
    "spellShort": "yan",
    "code": "YAE"
  },
  {
    "name": "延安",
    "spell": "yanan",
    "spellShort": "yan",
    "code": "YWY"
  },
  {
    "name": "永安南",
    "spell": "yongannan",
    "spellShort": "yan",
    "code": "YQS"
  },
  {
    "name": "依安",
    "spell": "yian",
    "spellShort": "yan",
    "code": "YAX"
  },
  {
    "name": "迎宾路",
    "spell": "yingbinlu",
    "spellShort": "ybl",
    "code": "YFW"
  },
  {
    "name": "亚布力",
    "spell": "yabuli",
    "spellShort": "ybl",
    "code": "YBB"
  },
  {
    "name": "亚布力南",
    "spell": "yabulinan",
    "spellShort": "ybn",
    "code": "YWB"
  },
  {
    "name": "叶柏寿",
    "spell": "yebaishou",
    "spellShort": "ybs",
    "code": "YBD"
  },
  {
    "name": "宜宾西",
    "spell": "yibinxi",
    "spellShort": "ybx",
    "code": "YXE"
  },
  {
    "name": "亚布力西",
    "spell": "yabulixi",
    "spellShort": "ybx",
    "code": "YSB"
  },
  {
    "name": "运城北",
    "spell": "yunchengbei",
    "spellShort": "ycb",
    "code": "ABV"
  },
  {
    "name": "盐城北",
    "spell": "yanchengbei",
    "spellShort": "ycb",
    "code": "AEH"
  },
  {
    "name": "永川东",
    "spell": "yongchuandong",
    "spellShort": "ycd",
    "code": "WMW"
  },
  {
    "name": "宜昌东",
    "spell": "yichangdong",
    "spellShort": "ycd",
    "code": "HAN"
  },
  {
    "name": "岳池",
    "spell": "yuechi",
    "spellShort": "ych",
    "code": "AWW"
  },
  {
    "name": "叶城",
    "spell": "yecheng",
    "spellShort": "ych",
    "code": "YER"
  },
  {
    "name": "阳春",
    "spell": "yangchun",
    "spellShort": "ych",
    "code": "YQQ"
  },
  {
    "name": "宜春",
    "spell": "yichun",
    "spellShort": "ych",
    "code": "YEG"
  },
  {
    "name": "运城",
    "spell": "yuncheng",
    "spellShort": "ych",
    "code": "YNV"
  },
  {
    "name": "宜昌",
    "spell": "yichang",
    "spellShort": "ych",
    "code": "YCN"
  },
  {
    "name": "盐城",
    "spell": "yancheng",
    "spellShort": "ych",
    "code": "AFH"
  },
  {
    "name": "伊春",
    "spell": "yichun",
    "spellShort": "ych",
    "code": "YCB"
  },
  {
    "name": "榆次",
    "spell": "yuci",
    "spellShort": "yci",
    "code": "YCV"
  },
  {
    "name": "杨村",
    "spell": "yangcun",
    "spellShort": "ycu",
    "code": "YBP"
  },
  {
    "name": "永登",
    "spell": "yongdeng",
    "spellShort": "yde",
    "code": "YDJ"
  },
  {
    "name": "雁荡山",
    "spell": "yandangshan",
    "spellShort": "yds",
    "code": "YGH"
  },
  {
    "name": "于都",
    "spell": "yudu",
    "spellShort": "ydu",
    "code": "YDG"
  },
  {
    "name": "姚渡",
    "spell": "yaodu",
    "spellShort": "ydu",
    "code": "AOJ"
  },
  {
    "name": "英德西",
    "spell": "yingdexi",
    "spellShort": "ydx",
    "code": "IIQ"
  },
  {
    "name": "云浮东",
    "spell": "yunfudong",
    "spellShort": "yfd",
    "code": "IXQ"
  },
  {
    "name": "燕岗",
    "spell": "yangang",
    "spellShort": "yga",
    "code": "YGW"
  },
  {
    "name": "永济北",
    "spell": "yongjibei",
    "spellShort": "yjb",
    "code": "AJV"
  },
  {
    "name": "延吉",
    "spell": "yanji",
    "spellShort": "yji",
    "code": "YJL"
  },
  {
    "name": "阳江",
    "spell": "yangjiang",
    "spellShort": "yji",
    "code": "WRQ"
  },
  {
    "name": "永济",
    "spell": "yongji",
    "spellShort": "yji",
    "code": "YIV"
  },
  {
    "name": "燕郊",
    "spell": "yanjiao",
    "spellShort": "yji",
    "code": "AJP"
  },
  {
    "name": "姚家",
    "spell": "yaojia",
    "spellShort": "yji",
    "code": "YAT"
  },
  {
    "name": "英吉沙",
    "spell": "yingjisha",
    "spellShort": "yjs",
    "code": "YIR"
  },
  {
    "name": "延吉西",
    "spell": "yanjixi",
    "spellShort": "yjx",
    "code": "YXL"
  },
  {
    "name": "营口东",
    "spell": "yingkoudong",
    "spellShort": "ykd",
    "code": "YGT"
  },
  {
    "name": "永康南",
    "spell": "yongkangnan",
    "spellShort": "ykn",
    "code": "QUH"
  },
  {
    "name": "营口",
    "spell": "yingkou",
    "spellShort": "yko",
    "code": "YKT"
  },
  {
    "name": "牙克石",
    "spell": "yakeshi",
    "spellShort": "yks",
    "code": "YKX"
  },
  {
    "name": "依兰",
    "spell": "yilan",
    "spellShort": "yla",
    "code": "YEB"
  },
  {
    "name": "宜良北",
    "spell": "yiliangbei",
    "spellShort": "ylb",
    "code": "YSM"
  },
  {
    "name": "永乐店",
    "spell": "yongledian",
    "spellShort": "yld",
    "code": "YDY"
  },
  {
    "name": "玉林",
    "spell": "yulin",
    "spellShort": "yli",
    "code": "YLZ"
  },
  {
    "name": "榆林",
    "spell": "yulin",
    "spellShort": "yli",
    "code": "ALY"
  },
  {
    "name": "杨陵",
    "spell": "yangling",
    "spellShort": "yli",
    "code": "YSY"
  },
  {
    "name": "炎陵",
    "spell": "yanling",
    "spellShort": "yli",
    "code": "YAG"
  },
  {
    "name": "阎良",
    "spell": "yanliang",
    "spellShort": "yli",
    "code": "YNY"
  },
  {
    "name": "杨林",
    "spell": "yanglin",
    "spellShort": "yli",
    "code": "YLM"
  },
  {
    "name": "杨陵南",
    "spell": "yanglingnan",
    "spellShort": "yln",
    "code": "YEY"
  },
  {
    "name": "余粮堡",
    "spell": "yuliangpu",
    "spellShort": "ylp",
    "code": "YLD"
  },
  {
    "name": "杨柳青",
    "spell": "yangliuqing",
    "spellShort": "ylq",
    "code": "YQP"
  },
  {
    "name": "亚龙湾",
    "spell": "yalongwan",
    "spellShort": "ylw",
    "code": "TWQ"
  },
  {
    "name": "羊马",
    "spell": "yangma",
    "spellShort": "yma",
    "code": "YME"
  },
  {
    "name": "一面坡北",
    "spell": "yimianpobei",
    "spellShort": "ymb",
    "code": "YXB"
  },
  {
    "name": "云梦东",
    "spell": "yunmengdong",
    "spellShort": "ymd",
    "code": "YRN"
  },
  {
    "name": "玉门",
    "spell": "yumen",
    "spellShort": "yme",
    "code": "YXJ"
  },
  {
    "name": "一面坡",
    "spell": "yimianpo",
    "spellShort": "ymp",
    "code": "YPB"
  },
  {
    "name": "元谋西",
    "spell": "yuanmouxi",
    "spellShort": "ymx",
    "code": "AMM"
  },
  {
    "name": "郁南",
    "spell": "yunan",
    "spellShort": "yna",
    "code": "YKQ"
  },
  {
    "name": "伊宁东",
    "spell": "yiningdong",
    "spellShort": "ynd",
    "code": "YNR"
  },
  {
    "name": "伊宁",
    "spell": "yining",
    "spellShort": "yni",
    "code": "YMR"
  },
  {
    "name": "延平东",
    "spell": "yanpingdong",
    "spellShort": "ypd",
    "code": "ADS"
  },
  {
    "name": "阳平关",
    "spell": "yangpingguan",
    "spellShort": "ypg",
    "code": "YAY"
  },
  {
    "name": "玉屏",
    "spell": "yuping",
    "spellShort": "ypi",
    "code": "YZW"
  },
  {
    "name": "延平",
    "spell": "yanping",
    "spellShort": "ypi",
    "code": "YPS"
  },
  {
    "name": "原平",
    "spell": "yuanping",
    "spellShort": "ypi",
    "code": "YPV"
  },
  {
    "name": "延平西",
    "spell": "yanpingxi",
    "spellShort": "ypx",
    "code": "YWS"
  },
  {
    "name": "原平西",
    "spell": "yuanpingxi",
    "spellShort": "ypx",
    "code": "IPV"
  },
  {
    "name": "阳泉北",
    "spell": "yangquanbei",
    "spellShort": "yqb",
    "code": "YPP"
  },
  {
    "name": "阳泉东",
    "spell": "yangquandong",
    "spellShort": "yqd",
    "code": "AYP"
  },
  {
    "name": "永清东",
    "spell": "yongqingdong",
    "spellShort": "yqd",
    "code": "YDI"
  },
  {
    "name": "雁栖湖",
    "spell": "yanqihu",
    "spellShort": "yqh",
    "code": "FGP"
  },
  {
    "name": "焉耆",
    "spell": "yanqi",
    "spellShort": "yqi",
    "code": "YSR"
  },
  {
    "name": "乐清",
    "spell": "yueqing",
    "spellShort": "yqi",
    "code": "UPH"
  },
  {
    "name": "延庆",
    "spell": "yanqing",
    "spellShort": "yqi",
    "code": "YNP"
  },
  {
    "name": "阳泉曲",
    "spell": "yangquanqu",
    "spellShort": "yqq",
    "code": "YYV"
  },
  {
    "name": "姚千户屯",
    "spell": "yaoqianhutun",
    "spellShort": "yqt",
    "code": "YQT"
  },
  {
    "name": "阳泉",
    "spell": "yangquan",
    "spellShort": "yqu",
    "code": "AQP"
  },
  {
    "name": "阳曲",
    "spell": "yangqu",
    "spellShort": "yqu",
    "code": "YQV"
  },
  {
    "name": "玉泉",
    "spell": "yuquan",
    "spellShort": "yqu",
    "code": "YQB"
  },
  {
    "name": "阳曲西",
    "spell": "yangquxi",
    "spellShort": "yqx",
    "code": "IQV"
  },
  {
    "name": "榆社",
    "spell": "yushe",
    "spellShort": "ysh",
    "code": "YSV"
  },
  {
    "name": "玉山",
    "spell": "yushan",
    "spellShort": "ysh",
    "code": "YNG"
  },
  {
    "name": "营山",
    "spell": "yingshan",
    "spellShort": "ysh",
    "code": "NUW"
  },
  {
    "name": "榆树",
    "spell": "yushu",
    "spellShort": "ysh",
    "code": "YRT"
  },
  {
    "name": "元氏",
    "spell": "yuanshi",
    "spellShort": "ysh",
    "code": "YSP"
  },
  {
    "name": "燕山",
    "spell": "yanshan",
    "spellShort": "ysh",
    "code": "AOP"
  },
  {
    "name": "玉山南",
    "spell": "yushannan",
    "spellShort": "ysn",
    "code": "YGG"
  },
  {
    "name": "榆树屯",
    "spell": "yushutun",
    "spellShort": "yst",
    "code": "YSX"
  },
  {
    "name": "银滩",
    "spell": "yintan",
    "spellShort": "yta",
    "code": "CTQ"
  },
  {
    "name": "烟台",
    "spell": "yantai",
    "spellShort": "yta",
    "code": "YAK"
  },
  {
    "name": "鹰潭",
    "spell": "yingtan",
    "spellShort": "yta",
    "code": "YTG"
  },
  {
    "name": "永泰",
    "spell": "yongtai",
    "spellShort": "yta",
    "code": "YTS"
  },
  {
    "name": "鹰潭北",
    "spell": "yingtanbei",
    "spellShort": "ytb",
    "code": "YKG"
  },
  {
    "name": "伊图里河",
    "spell": "yitulihe",
    "spellShort": "yth",
    "code": "YEX"
  },
  {
    "name": "依吞布拉克",
    "spell": "yitunbulake",
    "spellShort": "ytk",
    "code": "YVR"
  },
  {
    "name": "烟台南",
    "spell": "yantainan",
    "spellShort": "ytn",
    "code": "YLK"
  },
  {
    "name": "烟筒山",
    "spell": "yantongshan",
    "spellShort": "yts",
    "code": "YSL"
  },
  {
    "name": "玉田县",
    "spell": "yutianxian",
    "spellShort": "ytx",
    "code": "ATP"
  },
  {
    "name": "义乌",
    "spell": "yiwu",
    "spellShort": "ywu",
    "code": "YWH"
  },
  {
    "name": "玉溪",
    "spell": "yuxi",
    "spellShort": "yxi",
    "code": "AXM"
  },
  {
    "name": "云霄",
    "spell": "yunxiao",
    "spellShort": "yxi",
    "code": "YBS"
  },
  {
    "name": "义县",
    "spell": "yixian",
    "spellShort": "yxi",
    "code": "YXD"
  },
  {
    "name": "阳新",
    "spell": "yangxin",
    "spellShort": "yxi",
    "code": "YON"
  },
  {
    "name": "宜兴",
    "spell": "yixing",
    "spellShort": "yxi",
    "code": "YUH"
  },
  {
    "name": "尤溪",
    "spell": "youxi",
    "spellShort": "yxi",
    "code": "YXS"
  },
  {
    "name": "益阳",
    "spell": "yiyang",
    "spellShort": "yya",
    "code": "AEQ"
  },
  {
    "name": "岳阳",
    "spell": "yueyang",
    "spellShort": "yya",
    "code": "YYQ"
  },
  {
    "name": "岳阳东",
    "spell": "yueyangdong",
    "spellShort": "yyd",
    "code": "YIQ"
  },
  {
    "name": "益阳南",
    "spell": "yiyangnan",
    "spellShort": "yyn",
    "code": "YAA"
  },
  {
    "name": "扬州东",
    "spell": "yangzhoudong",
    "spellShort": "yzd",
    "code": "YDU"
  },
  {
    "name": "崖州",
    "spell": "yazhou",
    "spellShort": "yzh",
    "code": "YUQ"
  },
  {
    "name": "永州",
    "spell": "yongzhou",
    "spellShort": "yzh",
    "code": "AOQ"
  },
  {
    "name": "兖州",
    "spell": "yanzhou",
    "spellShort": "yzh",
    "code": "YZK"
  },
  {
    "name": "扬州",
    "spell": "yangzhou",
    "spellShort": "yzh",
    "code": "YLH"
  },
  {
    "name": "榆中",
    "spell": "yuzhong",
    "spellShort": "yzh",
    "code": "IZJ"
  },
  {
    "name": "诏安",
    "spell": "zhaoan",
    "spellShort": "zan",
    "code": "ZDS"
  },
  {
    "name": "淄博北",
    "spell": "zibobei",
    "spellShort": "zbb",
    "code": "ZRK"
  },
  {
    "name": "淄博",
    "spell": "zibo",
    "spellShort": "zbo",
    "code": "ZBK"
  },
  {
    "name": "中川机场",
    "spell": "zhongchuanjichang",
    "spellShort": "zcc",
    "code": "ZJJ"
  },
  {
    "name": "镇城底",
    "spell": "zhenchengdi",
    "spellShort": "zcd",
    "code": "ZDV"
  },
  {
    "name": "正定机场",
    "spell": "zhengdingjichang",
    "spellShort": "zdc",
    "code": "ZHP"
  },
  {
    "name": "正定",
    "spell": "zhengding",
    "spellShort": "zdi",
    "code": "ZDP"
  },
  {
    "name": "准东",
    "spell": "zhundong",
    "spellShort": "zdo",
    "code": "ZER"
  },
  {
    "name": "纸坊东",
    "spell": "zhifangdong",
    "spellShort": "zfd",
    "code": "ZMN"
  },
  {
    "name": "柘皋",
    "spell": "zhegao",
    "spellShort": "zga",
    "code": "ZGU"
  },
  {
    "name": "自贡北",
    "spell": "zigongbei",
    "spellShort": "zgb",
    "code": "ZGW"
  },
  {
    "name": "自贡",
    "spell": "zigong",
    "spellShort": "zgo",
    "code": "ZGE"
  },
  {
    "name": "珠海",
    "spell": "zhuhai",
    "spellShort": "zha",
    "code": "ZHQ"
  },
  {
    "name": "庄河北",
    "spell": "zhuanghebei",
    "spellShort": "zhb",
    "code": "ZUT"
  },
  {
    "name": "珠海北",
    "spell": "zhuhaibei",
    "spellShort": "zhb",
    "code": "ZIQ"
  },
  {
    "name": "珠海机场",
    "spell": "zhuhaijichang",
    "spellShort": "zhc",
    "code": "ZJA"
  },
  {
    "name": "珠海长隆",
    "spell": "zhuhaichanglong",
    "spellShort": "zhl",
    "code": "ZLA"
  },
  {
    "name": "中华门",
    "spell": "zhonghuamen",
    "spellShort": "zhm",
    "code": "VNH"
  },
  {
    "name": "张家川",
    "spell": "zhangjiachuan",
    "spellShort": "zjc",
    "code": "ZIJ"
  },
  {
    "name": "张家港",
    "spell": "zhangjiagang",
    "spellShort": "zjg",
    "code": "ZAU"
  },
  {
    "name": "湛江",
    "spell": "zhanjiang",
    "spellShort": "zji",
    "code": "ZJZ"
  },
  {
    "name": "织金",
    "spell": "zhijin",
    "spellShort": "zji",
    "code": "IZW"
  },
  {
    "name": "治江",
    "spell": "zhijiang",
    "spellShort": "zji",
    "code": "ZIY"
  },
  {
    "name": "芷江",
    "spell": "zhijiang",
    "spellShort": "zji",
    "code": "ZPQ"
  },
  {
    "name": "诸暨",
    "spell": "zhuji",
    "spellShort": "zji",
    "code": "ZDH"
  },
  {
    "name": "镇江",
    "spell": "zhenjiang",
    "spellShort": "zji",
    "code": "ZJH"
  },
  {
    "name": "周家",
    "spell": "zhoujia",
    "spellShort": "zji",
    "code": "ZOB"
  },
  {
    "name": "张家界",
    "spell": "zhangjiajie",
    "spellShort": "zjj",
    "code": "DIQ"
  },
  {
    "name": "张家口",
    "spell": "zhangjiakou",
    "spellShort": "zjk",
    "code": "ZMP"
  },
  {
    "name": "张家口南",
    "spell": "zhangjiakounan",
    "spellShort": "zjn",
    "code": "IXP"
  },
  {
    "name": "镇江南",
    "spell": "zhenjiangnan",
    "spellShort": "zjn",
    "code": "ZEH"
  },
  {
    "name": "湛江西",
    "spell": "zhanjiangxi",
    "spellShort": "zjx",
    "code": "ZWQ"
  },
  {
    "name": "张家界西",
    "spell": "zhangjiajiexi",
    "spellShort": "zjx",
    "code": "JXA"
  },
  {
    "name": "周口东",
    "spell": "zhoukoudong",
    "spellShort": "zkd",
    "code": "ZKF"
  },
  {
    "name": "周口",
    "spell": "zhoukou",
    "spellShort": "zko",
    "code": "ZKN"
  },
  {
    "name": "镇赉",
    "spell": "zhenlai",
    "spellShort": "zla",
    "code": "ZLT"
  },
  {
    "name": "庄里",
    "spell": "zhuangli",
    "spellShort": "zli",
    "code": "ZLY"
  },
  {
    "name": "左岭",
    "spell": "zuoling",
    "spellShort": "zli",
    "code": "ZSN"
  },
  {
    "name": "扎兰屯",
    "spell": "zhalantun",
    "spellShort": "zlt",
    "code": "ZTX"
  },
  {
    "name": "扎赉诺尔西",
    "spell": "zhalainuoerxi",
    "spellShort": "zlx",
    "code": "ZXX"
  },
  {
    "name": "驻马店",
    "spell": "zhumadian",
    "spellShort": "zmd",
    "code": "ZDN"
  },
  {
    "name": "中牟",
    "spell": "zhongmu",
    "spellShort": "zmu",
    "code": "ZGF"
  },
  {
    "name": "驻马店西",
    "spell": "zhumadianxi",
    "spellShort": "zmx",
    "code": "ZLN"
  },
  {
    "name": "漳平",
    "spell": "zhangping",
    "spellShort": "zpi",
    "code": "ZPS"
  },
  {
    "name": "泽普",
    "spell": "zepu",
    "spellShort": "zpu",
    "code": "ZPR"
  },
  {
    "name": "漳平西",
    "spell": "zhangpingxi",
    "spellShort": "zpx",
    "code": "ZXG"
  },
  {
    "name": "章丘北",
    "spell": "zhangqiubei",
    "spellShort": "zqb",
    "code": "ZVK"
  },
  {
    "name": "肇庆东",
    "spell": "zhaoqingdong",
    "spellShort": "zqd",
    "code": "FCQ"
  },
  {
    "name": "肇庆",
    "spell": "zhaoqing",
    "spellShort": "zqi",
    "code": "ZVQ"
  },
  {
    "name": "章丘",
    "spell": "zhangqiu",
    "spellShort": "zqi",
    "code": "ZTK"
  },
  {
    "name": "柞水",
    "spell": "zhashui",
    "spellShort": "zsh",
    "code": "ZSY"
  },
  {
    "name": "珠斯花",
    "spell": "zhusihua",
    "spellShort": "zsh",
    "code": "ZHD"
  },
  {
    "name": "中山",
    "spell": "zhongshan",
    "spellShort": "zsh",
    "code": "ZSQ"
  },
  {
    "name": "樟树",
    "spell": "zhangshu",
    "spellShort": "zsh",
    "code": "ZSG"
  },
  {
    "name": "朱砂古镇",
    "spell": "zhushaguzhen",
    "spellShort": "zsz",
    "code": "ZSE"
  },
  {
    "name": "周水子",
    "spell": "zhoushuizi",
    "spellShort": "zsz",
    "code": "ZIT"
  },
  {
    "name": "中堂",
    "spell": "zhongtang",
    "spellShort": "zta",
    "code": "ZTA"
  },
  {
    "name": "昭通",
    "spell": "zhaotong",
    "spellShort": "zto",
    "code": "ZDW"
  },
  {
    "name": "中卫",
    "spell": "zhongwei",
    "spellShort": "zwe",
    "code": "ZWJ"
  },
  {
    "name": "中卫南",
    "spell": "zhongweinan",
    "spellShort": "zwn",
    "code": "ZTJ"
  },
  {
    "name": "镇雄",
    "spell": "zhenxiong",
    "spellShort": "zxi",
    "code": "ZXE"
  },
  {
    "name": "紫阳",
    "spell": "ziyang",
    "spellShort": "zya",
    "code": "ZVY"
  },
  {
    "name": "枣阳",
    "spell": "zaoyang",
    "spellShort": "zya",
    "code": "ZYN"
  },
  {
    "name": "资阳北",
    "spell": "ziyangbei",
    "spellShort": "zyb",
    "code": "FYW"
  },
  {
    "name": "张掖",
    "spell": "zhangye",
    "spellShort": "zye",
    "code": "ZYJ"
  },
  {
    "name": "遵义",
    "spell": "zunyi",
    "spellShort": "zyi",
    "code": "ZYE"
  },
  {
    "name": "镇远",
    "spell": "zhenyuan",
    "spellShort": "zyu",
    "code": "ZUW"
  },
  {
    "name": "遵义西",
    "spell": "zunyixi",
    "spellShort": "zyx",
    "code": "ZIW"
  },
  {
    "name": "张掖西",
    "spell": "zhangyexi",
    "spellShort": "zyx",
    "code": "ZEJ"
  },
  {
    "name": "资中北",
    "spell": "zizhongbei",
    "spellShort": "zzb",
    "code": "WZW"
  },
  {
    "name": "漳州东",
    "spell": "zhangzhoudong",
    "spellShort": "zzd",
    "code": "GOS"
  },
  {
    "name": "涿州东",
    "spell": "zhuozhoudong",
    "spellShort": "zzd",
    "code": "ZAP"
  },
  {
    "name": "枣庄",
    "spell": "zaozhuang",
    "spellShort": "zzh",
    "code": "ZEK"
  },
  {
    "name": "漳州",
    "spell": "zhangzhou",
    "spellShort": "zzh",
    "code": "ZUS"
  },
  {
    "name": "株洲",
    "spell": "zhuzhou",
    "spellShort": "zzh",
    "code": "ZZQ"
  },
  {
    "name": "庄寨",
    "spell": "zhuangzhai",
    "spellShort": "zzh",
    "code": "VOK"
  },
  {
    "name": "株洲南",
    "spell": "zhuzhounan",
    "spellShort": "zzn",
    "code": "KVQ"
  },
  {
    "name": "枣庄西",
    "spell": "zaozhuangxi",
    "spellShort": "zzx",
    "code": "ZFK"
  },
  {
    "name": "株洲西",
    "spell": "zhuzhouxi",
    "spellShort": "zzx",
    "code": "ZAQ"
  },
  {
    "name": "阿巴嘎旗",
    "spell": "abagaqi",
    "spellShort": "abq",
    "code": "AQC"
  },
  {
    "name": "安定",
    "spell": "anding",
    "spellShort": "adi",
    "code": "ADP"
  },
  {
    "name": "安多",
    "spell": "anduo",
    "spellShort": "adu",
    "code": "ADO"
  },
  {
    "name": "安广",
    "spell": "anguang",
    "spellShort": "agu",
    "code": "AGT"
  },
  {
    "name": "敖汉",
    "spell": "aohan",
    "spellShort": "aha",
    "code": "YED"
  },
  {
    "name": "艾河",
    "spell": "aihe",
    "spellShort": "ahe",
    "code": "AHP"
  },
  {
    "name": "安化",
    "spell": "anhua",
    "spellShort": "ahu",
    "code": "PKQ"
  },
  {
    "name": "艾家村",
    "spell": "aijiacun",
    "spellShort": "ajc",
    "code": "AJJ"
  },
  {
    "name": "安江东",
    "spell": "anjiangdong",
    "spellShort": "ajd",
    "code": "ADA"
  },
  {
    "name": "阿金",
    "spell": "ajin",
    "spellShort": "aji",
    "code": "AJD"
  },
  {
    "name": "安匠",
    "spell": "anjiang",
    "spellShort": "aji",
    "code": "MJP"
  },
  {
    "name": "阿克塞",
    "spell": "akesai",
    "spellShort": "aks",
    "code": "AKJ"
  },
  {
    "name": "安口窑",
    "spell": "ankouyao",
    "spellShort": "aky",
    "code": "AYY"
  },
  {
    "name": "敖力布告",
    "spell": "aolibugao",
    "spellShort": "alg",
    "code": "ALD"
  },
  {
    "name": "安龙",
    "spell": "anlong",
    "spellShort": "alo",
    "code": "AUZ"
  },
  {
    "name": "阿龙山",
    "spell": "alongshan",
    "spellShort": "als",
    "code": "ASX"
  },
  {
    "name": "阿木尔",
    "spell": "amuer",
    "spellShort": "ame",
    "code": "JTX"
  },
  {
    "name": "阿南庄",
    "spell": "ananzhuang",
    "spellShort": "anz",
    "code": "AZM"
  },
  {
    "name": "安仁",
    "spell": "anren",
    "spellShort": "are",
    "code": "ARG"
  },
  {
    "name": "安塘",
    "spell": "antang",
    "spellShort": "ata",
    "code": "ATV"
  },
  {
    "name": "阿图什",
    "spell": "atushi",
    "spellShort": "ats",
    "code": "ATR"
  },
  {
    "name": "安图",
    "spell": "antu",
    "spellShort": "atu",
    "code": "ATL"
  },
  {
    "name": "安图西",
    "spell": "antuxi",
    "spellShort": "atx",
    "code": "AXL"
  },
  {
    "name": "阿瓦提",
    "spell": "awati",
    "spellShort": "awt",
    "code": "AWR"
  },
  {
    "name": "安溪",
    "spell": "anxi",
    "spellShort": "axi",
    "code": "AXS"
  },
  {
    "name": "博鳌",
    "spell": "boao",
    "spellShort": "bao",
    "code": "BWQ"
  },
  {
    "name": "白壁关",
    "spell": "baibiguan",
    "spellShort": "bbg",
    "code": "BGV"
  },
  {
    "name": "八步",
    "spell": "babu",
    "spellShort": "bbu",
    "code": "BBE"
  },
  {
    "name": "栟茶",
    "spell": "bencha",
    "spellShort": "bch",
    "code": "FWH"
  },
  {
    "name": "板城",
    "spell": "bancheng",
    "spellShort": "bch",
    "code": "BUP"
  },
  {
    "name": "宝坻",
    "spell": "baodi",
    "spellShort": "bdi",
    "code": "BZI"
  },
  {
    "name": "宝坻南",
    "spell": "baodinan",
    "spellShort": "bdn",
    "code": "BOI"
  },
  {
    "name": "宝丰",
    "spell": "baofeng",
    "spellShort": "bfe",
    "code": "BFF"
  },
  {
    "name": "白沟",
    "spell": "baigou",
    "spellShort": "bgo",
    "code": "FEP"
  },
  {
    "name": "白河东",
    "spell": "baihedong",
    "spellShort": "bhd",
    "code": "BIY"
  },
  {
    "name": "滨海港",
    "spell": "binhaigang",
    "spellShort": "bhg",
    "code": "BGU"
  },
  {
    "name": "宝华山",
    "spell": "baohuashan",
    "spellShort": "bhs",
    "code": "BWH"
  },
  {
    "name": "白河县",
    "spell": "baihexian",
    "spellShort": "bhx",
    "code": "BEY"
  },
  {
    "name": "白芨沟",
    "spell": "baijigou",
    "spellShort": "bjg",
    "code": "BJJ"
  },
  {
    "name": "北滘",
    "spell": "beijiao",
    "spellShort": "bji",
    "code": "IBQ"
  },
  {
    "name": "碧江",
    "spell": "bijiang",
    "spellShort": "bji",
    "code": "BLQ"
  },
  {
    "name": "白鸡坡",
    "spell": "baijipo",
    "spellShort": "bjp",
    "code": "BBM"
  },
  {
    "name": "笔架山",
    "spell": "bijiashan",
    "spellShort": "bjs",
    "code": "BSB"
  },
  {
    "name": "八角台",
    "spell": "bajiaotai",
    "spellShort": "bjt",
    "code": "BTD"
  },
  {
    "name": "北井子",
    "spell": "beijingzi",
    "spellShort": "bjz",
    "code": "BRT"
  },
  {
    "name": "保康",
    "spell": "baokang",
    "spellShort": "bka",
    "code": "BKD"
  },
  {
    "name": "保康县",
    "spell": "baokangxian",
    "spellShort": "bkx",
    "code": "BKN"
  },
  {
    "name": "白狼",
    "spell": "bailang",
    "spellShort": "bla",
    "code": "BAT"
  },
  {
    "name": "博罗北",
    "spell": "boluobei",
    "spellShort": "blb",
    "code": "BLA"
  },
  {
    "name": "博乐东",
    "spell": "boledong",
    "spellShort": "bld",
    "code": "BOR"
  },
  {
    "name": "北流",
    "spell": "beiliu",
    "spellShort": "bli",
    "code": "BOZ"
  },
  {
    "name": "宝林",
    "spell": "baolin",
    "spellShort": "bli",
    "code": "BNB"
  },
  {
    "name": "布列开",
    "spell": "buliekai",
    "spellShort": "blk",
    "code": "BLR"
  },
  {
    "name": "宝龙山",
    "spell": "baolongshan",
    "spellShort": "bls",
    "code": "BND"
  },
  {
    "name": "百里峡",
    "spell": "bailixia",
    "spellShort": "blx",
    "code": "AAP"
  },
  {
    "name": "八里甸子",
    "spell": "balidianzi",
    "spellShort": "blz",
    "code": "BLT"
  },
  {
    "name": "白马北",
    "spell": "baimabei",
    "spellShort": "bmb",
    "code": "BME"
  },
  {
    "name": "八面城",
    "spell": "bamiancheng",
    "spellShort": "bmc",
    "code": "BMD"
  },
  {
    "name": "北马圈子",
    "spell": "beimajuanzi",
    "spellShort": "bmz",
    "code": "BRP"
  },
  {
    "name": "北票南",
    "spell": "beipiaonan",
    "spellShort": "bpn",
    "code": "RPD"
  },
  {
    "name": "白旗",
    "spell": "baiqi",
    "spellShort": "bqi",
    "code": "BQP"
  },
  {
    "name": "白泉",
    "spell": "baiquan",
    "spellShort": "bqu",
    "code": "BQL"
  },
  {
    "name": "璧山",
    "spell": "bishan",
    "spellShort": "bsh",
    "code": "FZW"
  },
  {
    "name": "巴山",
    "spell": "bashan",
    "spellShort": "bsh",
    "code": "BAY"
  },
  {
    "name": "白水江",
    "spell": "baishuijiang",
    "spellShort": "bsj",
    "code": "BSY"
  },
  {
    "name": "白沙铺",
    "spell": "baishapu",
    "spellShort": "bsp",
    "code": "BSN"
  },
  {
    "name": "白沙坡",
    "spell": "baishapo",
    "spellShort": "bsp",
    "code": "BPM"
  },
  {
    "name": "白石山",
    "spell": "baishishan",
    "spellShort": "bss",
    "code": "BAL"
  },
  {
    "name": "白水县",
    "spell": "baishuixian",
    "spellShort": "bsx",
    "code": "BGY"
  },
  {
    "name": "白水镇",
    "spell": "baishuizhen",
    "spellShort": "bsz",
    "code": "BUM"
  },
  {
    "name": "板塘",
    "spell": "bantang",
    "spellShort": "bta",
    "code": "NGQ"
  },
  {
    "name": "坂田",
    "spell": "bantian",
    "spellShort": "bti",
    "code": "BTQ"
  },
  {
    "name": "泊头",
    "spell": "botou",
    "spellShort": "bto",
    "code": "BZP"
  },
  {
    "name": "北屯",
    "spell": "beitun",
    "spellShort": "btu",
    "code": "BYP"
  },
  {
    "name": "巴图营",
    "spell": "batuying",
    "spellShort": "bty",
    "code": "BWT"
  },
  {
    "name": "白文东",
    "spell": "baiwendong",
    "spellShort": "bwd",
    "code": "BCV"
  },
  {
    "name": "本溪新城",
    "spell": "benxixincheng",
    "spellShort": "bxc",
    "code": "BVT"
  },
  {
    "name": "博兴",
    "spell": "boxing",
    "spellShort": "bxi",
    "code": "BXK"
  },
  {
    "name": "八仙筒",
    "spell": "baxiantong",
    "spellShort": "bxt",
    "code": "VXD"
  },
  {
    "name": "白音察干",
    "spell": "baiyinchagan",
    "spellShort": "byg",
    "code": "BYC"
  },
  {
    "name": "宝应",
    "spell": "baoying",
    "spellShort": "byi",
    "code": "BAU"
  },
  {
    "name": "白音他拉",
    "spell": "baiyintala",
    "spellShort": "byl",
    "code": "BID"
  },
  {
    "name": "白音华南",
    "spell": "baiyinhuanan",
    "spellShort": "byn",
    "code": "BOD"
  },
  {
    "name": "白音胡硕",
    "spell": "baiyinhushuo",
    "spellShort": "bys",
    "code": "BCD"
  },
  {
    "name": "白银市",
    "spell": "baiyinshi",
    "spellShort": "bys",
    "code": "BNJ"
  },
  {
    "name": "霸州北",
    "spell": "bazhoubei",
    "spellShort": "bzb",
    "code": "VPP"
  },
  {
    "name": "彬州",
    "spell": "binzhou",
    "spellShort": "bzh",
    "code": "BXY"
  },
  {
    "name": "霸州",
    "spell": "bazhou",
    "spellShort": "bzh",
    "code": "RMP"
  },
  {
    "name": "北宅",
    "spell": "beizhai",
    "spellShort": "bzh",
    "code": "BVP"
  },
  {
    "name": "霸州西",
    "spell": "bazhouxi",
    "spellShort": "bzx",
    "code": "FOP"
  },
  {
    "name": "长安",
    "spell": "changan",
    "spellShort": "can",
    "code": "CAA"
  },
  {
    "name": "长安西",
    "spell": "changanxi",
    "spellShort": "cax",
    "code": "CXA"
  },
  {
    "name": "赤壁北",
    "spell": "chibibei",
    "spellShort": "cbb",
    "code": "CIN"
  },
  {
    "name": "澄城",
    "spell": "chengcheng",
    "spellShort": "cch",
    "code": "CUY"
  },
  {
    "name": "长城",
    "spell": "changcheng",
    "spellShort": "cch",
    "code": "CEJ"
  },
  {
    "name": "承德县北",
    "spell": "chengdexianbei",
    "spellShort": "cdb",
    "code": "IYP"
  },
  {
    "name": "承德东",
    "spell": "chengdedong",
    "spellShort": "cdd",
    "code": "CCP"
  },
  {
    "name": "城固北",
    "spell": "chenggubei",
    "spellShort": "cgb",
    "code": "CBY"
  },
  {
    "name": "长葛",
    "spell": "changge",
    "spellShort": "cge",
    "code": "CEF"
  },
  {
    "name": "查干湖",
    "spell": "chaganhu",
    "spellShort": "cgh",
    "code": "VAT"
  },
  {
    "name": "册亨",
    "spell": "ceheng",
    "spellShort": "che",
    "code": "CHZ"
  },
  {
    "name": "翠亨",
    "spell": "cuiheng",
    "spellShort": "che",
    "code": "IHQ"
  },
  {
    "name": "草河口",
    "spell": "caohekou",
    "spellShort": "chk",
    "code": "CKT"
  },
  {
    "name": "崔黄口",
    "spell": "cuihuangkou",
    "spellShort": "chk",
    "code": "CHP"
  },
  {
    "name": "蔡家沟",
    "spell": "caijiagou",
    "spellShort": "cjg",
    "code": "CJT"
  },
  {
    "name": "成吉思汗",
    "spell": "chengjisihan",
    "spellShort": "cjh",
    "code": "CJX"
  },
  {
    "name": "岔江",
    "spell": "chajiang",
    "spellShort": "cji",
    "code": "CAM"
  },
  {
    "name": "陈江南",
    "spell": "chenjiangnan",
    "spellShort": "cjn",
    "code": "KKQ"
  },
  {
    "name": "蔡家坡",
    "spell": "caijiapo",
    "spellShort": "cjp",
    "code": "CJY"
  },
  {
    "name": "策勒",
    "spell": "cele",
    "spellShort": "cle",
    "code": "CLR"
  },
  {
    "name": "昌乐",
    "spell": "changle",
    "spellShort": "cle",
    "code": "CLK"
  },
  {
    "name": "超梁沟",
    "spell": "chaolianggou",
    "spellShort": "clg",
    "code": "CYP"
  },
  {
    "name": "茶陵南",
    "spell": "chalingnan",
    "spellShort": "cln",
    "code": "CNG"
  },
  {
    "name": "长岭子",
    "spell": "changlingzi",
    "spellShort": "clz",
    "code": "CLT"
  },
  {
    "name": "潮南",
    "spell": "chaonan",
    "spellShort": "cna",
    "code": "CHA"
  },
  {
    "name": "长宁",
    "spell": "changning",
    "spellShort": "cni",
    "code": "CNE"
  },
  {
    "name": "长农",
    "spell": "changnong",
    "spellShort": "cno",
    "code": "CNJ"
  },
  {
    "name": "常平",
    "spell": "changping",
    "spellShort": "cpi",
    "code": "DAQ"
  },
  {
    "name": "长坡岭",
    "spell": "changpoling",
    "spellShort": "cpl",
    "code": "CPM"
  },
  {
    "name": "常平南",
    "spell": "changpingnan",
    "spellShort": "cpn",
    "code": "FPQ"
  },
  {
    "name": "茌平南",
    "spell": "chipingnan",
    "spellShort": "cpn",
    "code": "CPK"
  },
  {
    "name": "长箐",
    "spell": "changqing",
    "spellShort": "cqi",
    "code": "CQE"
  },
  {
    "name": "辰清",
    "spell": "chenqing",
    "spellShort": "cqi",
    "code": "CQB"
  },
  {
    "name": "长寿",
    "spell": "changshou",
    "spellShort": "csh",
    "code": "EFW"
  },
  {
    "name": "长寿湖",
    "spell": "changshouhu",
    "spellShort": "csh",
    "code": "CSE"
  },
  {
    "name": "蔡山",
    "spell": "caishan",
    "spellShort": "csh",
    "code": "CON"
  },
  {
    "name": "苍石",
    "spell": "cangshi",
    "spellShort": "csh",
    "code": "CST"
  },
  {
    "name": "草市",
    "spell": "caoshi",
    "spellShort": "csh",
    "code": "CSL"
  },
  {
    "name": "磁山",
    "spell": "cishan",
    "spellShort": "csh",
    "code": "CSP"
  },
  {
    "name": "常山",
    "spell": "changshan",
    "spellShort": "csh",
    "code": "CSU"
  },
  {
    "name": "常熟",
    "spell": "changshu",
    "spellShort": "csh",
    "code": "CAU"
  },
  {
    "name": "楚山",
    "spell": "chushan",
    "spellShort": "csh",
    "code": "CSB"
  },
  {
    "name": "长山屯",
    "spell": "changshantun",
    "spellShort": "cst",
    "code": "CVT"
  },
  {
    "name": "长汀",
    "spell": "changting",
    "spellShort": "cti",
    "code": "CES"
  },
  {
    "name": "春湾",
    "spell": "chunwan",
    "spellShort": "cwa",
    "code": "CQQ"
  },
  {
    "name": "岑溪",
    "spell": "cenxi",
    "spellShort": "cxi",
    "code": "CNZ"
  },
  {
    "name": "长兴",
    "spell": "changxing",
    "spellShort": "cxi",
    "code": "CBH"
  },
  {
    "name": "磁西",
    "spell": "cixi",
    "spellShort": "cxi",
    "code": "CRP"
  },
  {
    "name": "磁窑",
    "spell": "ciyao",
    "spellShort": "cya",
    "code": "CYK"
  },
  {
    "name": "长阳",
    "spell": "changyang",
    "spellShort": "cya",
    "code": "CYN"
  },
  {
    "name": "城阳",
    "spell": "chengyang",
    "spellShort": "cya",
    "code": "CEK"
  },
  {
    "name": "创业村",
    "spell": "chuangyecun",
    "spellShort": "cyc",
    "code": "CEX"
  },
  {
    "name": "朝阳地",
    "spell": "chaoyangdi",
    "spellShort": "cyd",
    "code": "CDD"
  },
  {
    "name": "昌邑",
    "spell": "changyi",
    "spellShort": "cyi",
    "code": "CRK"
  },
  {
    "name": "朝阳南",
    "spell": "chaoyangnan",
    "spellShort": "cyn",
    "code": "CYD"
  },
  {
    "name": "长垣",
    "spell": "changyuan",
    "spellShort": "cyu",
    "code": "CYF"
  },
  {
    "name": "朝阳镇",
    "spell": "chaoyangzhen",
    "spellShort": "cyz",
    "code": "CZL"
  },
  {
    "name": "陈庄",
    "spell": "chenzhuang",
    "spellShort": "czh",
    "code": "CZY"
  },
  {
    "name": "潮州",
    "spell": "chaozhou",
    "spellShort": "czh",
    "code": "CKQ"
  },
  {
    "name": "曹子里",
    "spell": "caozili",
    "spellShort": "czl",
    "code": "CFP"
  },
  {
    "name": "长治南",
    "spell": "changzhinan",
    "spellShort": "czn",
    "code": "CAF"
  },
  {
    "name": "城子坦",
    "spell": "chengzitan",
    "spellShort": "czt",
    "code": "CWT"
  },
  {
    "name": "车转湾",
    "spell": "chezhuanwan",
    "spellShort": "czw",
    "code": "CWM"
  },
  {
    "name": "都安",
    "spell": "duan",
    "spellShort": "dan",
    "code": "RUZ"
  },
  {
    "name": "大安",
    "spell": "daan",
    "spellShort": "dan",
    "code": "RAT"
  },
  {
    "name": "德安",
    "spell": "dean",
    "spellShort": "dan",
    "code": "DAG"
  },
  {
    "name": "大坝",
    "spell": "daba",
    "spellShort": "dba",
    "code": "DBJ"
  },
  {
    "name": "德保",
    "spell": "debao",
    "spellShort": "dba",
    "code": "RBZ"
  },
  {
    "name": "到保",
    "spell": "daobao",
    "spellShort": "dba",
    "code": "RBT"
  },
  {
    "name": "大巴",
    "spell": "daba",
    "spellShort": "dba",
    "code": "DBD"
  },
  {
    "name": "电白",
    "spell": "dianbai",
    "spellShort": "dba",
    "code": "NWQ"
  },
  {
    "name": "大板",
    "spell": "daban",
    "spellShort": "dba",
    "code": "DBC"
  },
  {
    "name": "东边井",
    "spell": "dongbianjing",
    "spellShort": "dbj",
    "code": "DBB"
  },
  {
    "name": "德伯斯",
    "spell": "debosi",
    "spellShort": "dbs",
    "code": "RDT"
  },
  {
    "name": "打柴沟",
    "spell": "dachaigou",
    "spellShort": "dcg",
    "code": "DGJ"
  },
  {
    "name": "德昌",
    "spell": "dechang",
    "spellShort": "dch",
    "code": "DVW"
  },
  {
    "name": "大厂",
    "spell": "dachang",
    "spellShort": "dch",
    "code": "DCI"
  },
  {
    "name": "都昌",
    "spell": "duchang",
    "spellShort": "dch",
    "code": "DCG"
  },
  {
    "name": "东城南",
    "spell": "dongchengnan",
    "spellShort": "dcn",
    "code": "IYQ"
  },
  {
    "name": "德昌西",
    "spell": "dechangxi",
    "spellShort": "dcx",
    "code": "DXE"
  },
  {
    "name": "滴道",
    "spell": "didao",
    "spellShort": "dda",
    "code": "DDB"
  },
  {
    "name": "大磴沟",
    "spell": "dadenggou",
    "spellShort": "ddg",
    "code": "DKJ"
  },
  {
    "name": "东戴河",
    "spell": "dongdaihe",
    "spellShort": "ddh",
    "code": "RDD"
  },
  {
    "name": "丹东西",
    "spell": "dandongxi",
    "spellShort": "ddx",
    "code": "RWT"
  },
  {
    "name": "刀尔登",
    "spell": "daoerdeng",
    "spellShort": "ded",
    "code": "DRD"
  },
  {
    "name": "得耳布尔",
    "spell": "deerbuer",
    "spellShort": "dee",
    "code": "DRX"
  },
  {
    "name": "东二道河",
    "spell": "dongerdaohe",
    "spellShort": "deh",
    "code": "DRB"
  },
  {
    "name": "杜尔伯特",
    "spell": "duerbote",
    "spellShort": "det",
    "code": "TKX"
  },
  {
    "name": "大方",
    "spell": "dafang",
    "spellShort": "dfa",
    "code": "DFE"
  },
  {
    "name": "东丰",
    "spell": "dongfeng",
    "spellShort": "dfe",
    "code": "DIL"
  },
  {
    "name": "都格",
    "spell": "duge",
    "spellShort": "dge",
    "code": "DMM"
  },
  {
    "name": "东莞港",
    "spell": "dongguangang",
    "spellShort": "dgg",
    "code": "DGA"
  },
  {
    "name": "大港南",
    "spell": "dagangnan",
    "spellShort": "dgn",
    "code": "DNU"
  },
  {
    "name": "大官屯",
    "spell": "daguantun",
    "spellShort": "dgt",
    "code": "DTT"
  },
  {
    "name": "东光",
    "spell": "dongguang",
    "spellShort": "dgu",
    "code": "DGP"
  },
  {
    "name": "东海",
    "spell": "donghai",
    "spellShort": "dha",
    "code": "DHB"
  },
  {
    "name": "东花园北",
    "spell": "donghuayuanbei",
    "spellShort": "dhb",
    "code": "QBP"
  },
  {
    "name": "大灰厂",
    "spell": "dahuichang",
    "spellShort": "dhc",
    "code": "DHP"
  },
  {
    "name": "鼎湖东",
    "spell": "dinghudong",
    "spellShort": "dhd",
    "code": "UWQ"
  },
  {
    "name": "鼎湖山",
    "spell": "dinghushan",
    "spellShort": "dhs",
    "code": "NVQ"
  },
  {
    "name": "大禾塘",
    "spell": "shaodong",
    "spellShort": "dht",
    "code": "SOQ"
  },
  {
    "name": "东海县",
    "spell": "donghaixian",
    "spellShort": "dhx",
    "code": "DQH"
  },
  {
    "name": "东津",
    "spell": "dongjin",
    "spellShort": "dji",
    "code": "DKB"
  },
  {
    "name": "丹江口",
    "spell": "danjiangkou",
    "spellShort": "djk",
    "code": "DON"
  },
  {
    "name": "董家口",
    "spell": "dongjiakou",
    "spellShort": "djk",
    "code": "DTK"
  },
  {
    "name": "大口屯",
    "spell": "dakoutun",
    "spellShort": "dkt",
    "code": "DKP"
  },
  {
    "name": "东来",
    "spell": "donglai",
    "spellShort": "dla",
    "code": "RVD"
  },
  {
    "name": "大林",
    "spell": "dalin",
    "spellShort": "dli",
    "code": "DLD"
  },
  {
    "name": "带岭",
    "spell": "dailing",
    "spellShort": "dli",
    "code": "DLB"
  },
  {
    "name": "达拉特旗",
    "spell": "dalateqi",
    "spellShort": "dlq",
    "code": "DIC"
  },
  {
    "name": "独立屯",
    "spell": "dulitun",
    "spellShort": "dlt",
    "code": "DTX"
  },
  {
    "name": "豆罗",
    "spell": "douluo",
    "spellShort": "dlu",
    "code": "DLV"
  },
  {
    "name": "达拉特西",
    "spell": "dalatexi",
    "spellShort": "dlx",
    "code": "DNC"
  },
  {
    "name": "大连西",
    "spell": "dalianxi",
    "spellShort": "dlx",
    "code": "GZT"
  },
  {
    "name": "大朗镇",
    "spell": "dalangzhen",
    "spellShort": "dlz",
    "code": "KOQ"
  },
  {
    "name": "东明村",
    "spell": "dongmingcun",
    "spellShort": "dmc",
    "code": "DMD"
  },
  {
    "name": "洞庙河",
    "spell": "dongmiaohe",
    "spellShort": "dmh",
    "code": "DEP"
  },
  {
    "name": "大平房",
    "spell": "dapingfang",
    "spellShort": "dpf",
    "code": "DPD"
  },
  {
    "name": "大盘石",
    "spell": "dapanshi",
    "spellShort": "dps",
    "code": "RPP"
  },
  {
    "name": "大堡",
    "spell": "dapu",
    "spellShort": "dpu",
    "code": "DVT"
  },
  {
    "name": "大青沟",
    "spell": "daqinggou",
    "spellShort": "dqg",
    "code": "DSD"
  },
  {
    "name": "大其拉哈",
    "spell": "daqilaha",
    "spellShort": "dqh",
    "code": "DQX"
  },
  {
    "name": "德清",
    "spell": "deqing",
    "spellShort": "dqi",
    "code": "DRH"
  },
  {
    "name": "杜桥",
    "spell": "duqiao",
    "spellShort": "dqi",
    "code": "DQU"
  },
  {
    "name": "德清西",
    "spell": "deqingxi",
    "spellShort": "dqx",
    "code": "MOH"
  },
  {
    "name": "东胜东",
    "spell": "dongshengdong",
    "spellShort": "dsd",
    "code": "RSC"
  },
  {
    "name": "东升",
    "spell": "dongsheng",
    "spellShort": "dsh",
    "code": "DRQ"
  },
  {
    "name": "登沙河",
    "spell": "dengshahe",
    "spellShort": "dsh",
    "code": "DWT"
  },
  {
    "name": "砀山",
    "spell": "dangshan",
    "spellShort": "dsh",
    "code": "DKH"
  },
  {
    "name": "大石头南",
    "spell": "dashitounan",
    "spellShort": "dsn",
    "code": "DAL"
  },
  {
    "name": "大石头",
    "spell": "dashitou",
    "spellShort": "dst",
    "code": "DSL"
  },
  {
    "name": "大石寨",
    "spell": "dashizhai",
    "spellShort": "dsz",
    "code": "RZT"
  },
  {
    "name": "灯塔",
    "spell": "dengta",
    "spellShort": "dta",
    "code": "DGT"
  },
  {
    "name": "定陶",
    "spell": "dingtao",
    "spellShort": "dta",
    "code": "DQK"
  },
  {
    "name": "东台",
    "spell": "dongtai",
    "spellShort": "dta",
    "code": "DBH"
  },
  {
    "name": "大田边",
    "spell": "datianbian",
    "spellShort": "dtb",
    "code": "DBM"
  },
  {
    "name": "当涂东",
    "spell": "dangtudong",
    "spellShort": "dtd",
    "code": "OWH"
  },
  {
    "name": "东通化",
    "spell": "dongtonghua",
    "spellShort": "dth",
    "code": "DTL"
  },
  {
    "name": "丹徒",
    "spell": "dantu",
    "spellShort": "dtu",
    "code": "RUH"
  },
  {
    "name": "东湾",
    "spell": "dongwan",
    "spellShort": "dwa",
    "code": "DRJ"
  },
  {
    "name": "大旺",
    "spell": "dawang",
    "spellShort": "dwa",
    "code": "WWQ"
  },
  {
    "name": "低窝铺",
    "spell": "diwopu",
    "spellShort": "dwp",
    "code": "DWJ"
  },
  {
    "name": "德兴东",
    "spell": "dexingdong",
    "spellShort": "dxd",
    "code": "DDG"
  },
  {
    "name": "大兴沟",
    "spell": "daxinggou",
    "spellShort": "dxg",
    "code": "DXL"
  },
  {
    "name": "德兴",
    "spell": "dexing",
    "spellShort": "dxi",
    "code": "DWG"
  },
  {
    "name": "定襄",
    "spell": "dingxiang",
    "spellShort": "dxi",
    "code": "DXV"
  },
  {
    "name": "代县",
    "spell": "daixian",
    "spellShort": "dxi",
    "code": "DKV"
  },
  {
    "name": "甸心",
    "spell": "dianxin",
    "spellShort": "dxi",
    "code": "DXM"
  },
  {
    "name": "丹霞山",
    "spell": "danxiashan",
    "spellShort": "dxs",
    "code": "IRQ"
  },
  {
    "name": "东戌",
    "spell": "dongxu",
    "spellShort": "dxu",
    "code": "RXP"
  },
  {
    "name": "东辛庄",
    "spell": "dongxinzhuang",
    "spellShort": "dxz",
    "code": "DXD"
  },
  {
    "name": "大雁",
    "spell": "dayan",
    "spellShort": "dya",
    "code": "DYX"
  },
  {
    "name": "大阳",
    "spell": "dayang",
    "spellShort": "dya",
    "code": "RET"
  },
  {
    "name": "丹阳北",
    "spell": "danyangbei",
    "spellShort": "dyb",
    "code": "EXH"
  },
  {
    "name": "东阳北",
    "spell": "dongyangbei",
    "spellShort": "dyb",
    "code": "DIU"
  },
  {
    "name": "东淤地",
    "spell": "dongyudi",
    "spellShort": "dyd",
    "code": "DBV"
  },
  {
    "name": "大营",
    "spell": "daying",
    "spellShort": "dyi",
    "code": "DYV"
  },
  {
    "name": "定远",
    "spell": "dingyuan",
    "spellShort": "dyu",
    "code": "EWH"
  },
  {
    "name": "岱岳",
    "spell": "daiyue",
    "spellShort": "dyu",
    "code": "RYV"
  },
  {
    "name": "大余",
    "spell": "dayu",
    "spellShort": "dyu",
    "code": "DYG"
  },
  {
    "name": "大营子",
    "spell": "dayingzi",
    "spellShort": "dyz",
    "code": "DZD"
  },
  {
    "name": "大营镇",
    "spell": "dayingzhen",
    "spellShort": "dyz",
    "code": "DJP"
  },
  {
    "name": "大战场",
    "spell": "dazhanchang",
    "spellShort": "dzc",
    "code": "DTJ"
  },
  {
    "name": "兑镇",
    "spell": "duizhen",
    "spellShort": "dzh",
    "code": "DWV"
  },
  {
    "name": "道州",
    "spell": "daozhou",
    "spellShort": "dzh",
    "code": "DFZ"
  },
  {
    "name": "东镇",
    "spell": "dongzhen",
    "spellShort": "dzh",
    "code": "DNV"
  },
  {
    "name": "东庄",
    "spell": "dongzhuang",
    "spellShort": "dzh",
    "code": "DZV"
  },
  {
    "name": "端州",
    "spell": "duanzhou",
    "spellShort": "dzh",
    "code": "WZQ"
  },
  {
    "name": "低庄",
    "spell": "dizhuang",
    "spellShort": "dzh",
    "code": "DVQ"
  },
  {
    "name": "豆庄",
    "spell": "douzhuang",
    "spellShort": "dzh",
    "code": "ROP"
  },
  {
    "name": "大足南",
    "spell": "dazunan",
    "spellShort": "dzn",
    "code": "FQW"
  },
  {
    "name": "大竹园",
    "spell": "dazhuyuan",
    "spellShort": "dzy",
    "code": "DZY"
  },
  {
    "name": "大杖子",
    "spell": "dazhangzi",
    "spellShort": "dzz",
    "code": "DAP"
  },
  {
    "name": "豆张庄",
    "spell": "douzhangzhuang",
    "spellShort": "dzz",
    "code": "RZP"
  },
  {
    "name": "峨边南",
    "spell": "ebiannan",
    "spellShort": "ebn",
    "code": "ENE"
  },
  {
    "name": "二道沟门",
    "spell": "erdaogoumen",
    "spellShort": "edm",
    "code": "RDP"
  },
  {
    "name": "二道湾",
    "spell": "erdaowan",
    "spellShort": "edw",
    "code": "RDX"
  },
  {
    "name": "二龙",
    "spell": "erlong",
    "spellShort": "elo",
    "code": "RLD"
  },
  {
    "name": "二龙山屯",
    "spell": "erlongshantun",
    "spellShort": "elt",
    "code": "ELA"
  },
  {
    "name": "二密河",
    "spell": "ermihe",
    "spellShort": "emh",
    "code": "RML"
  },
  {
    "name": "额敏",
    "spell": "emin",
    "spellShort": "emi",
    "code": "EMR"
  },
  {
    "name": "恩平",
    "spell": "enping",
    "spellShort": "epi",
    "code": "PXQ"
  },
  {
    "name": "峨山",
    "spell": "eshan",
    "spellShort": "esh",
    "code": "EVM"
  },
  {
    "name": "二营",
    "spell": "erying",
    "spellShort": "eyi",
    "code": "RYJ"
  },
  {
    "name": "鄂州东",
    "spell": "ezhoudong",
    "spellShort": "ezd",
    "code": "EFN"
  },
  {
    "name": "福安",
    "spell": "fuan",
    "spellShort": "fan",
    "code": "FAS"
  },
  {
    "name": "丰城东",
    "spell": "fengchengdong",
    "spellShort": "fcd",
    "code": "FIG"
  },
  {
    "name": "凤城东",
    "spell": "fengchengdong",
    "spellShort": "fcd",
    "code": "FDT"
  },
  {
    "name": "富川",
    "spell": "fuchuan",
    "spellShort": "fch",
    "code": "FDZ"
  },
  {
    "name": "丰城",
    "spell": "fengcheng",
    "spellShort": "fch",
    "code": "FCG"
  },
  {
    "name": "方城",
    "spell": "fangcheng",
    "spellShort": "fch",
    "code": "FNF"
  },
  {
    "name": "丰城南",
    "spell": "fengchengnan",
    "spellShort": "fcn",
    "code": "FNG"
  },
  {
    "name": "繁昌西",
    "spell": "fanchangxi",
    "spellShort": "fcx",
    "code": "PUH"
  },
  {
    "name": "扶沟南",
    "spell": "fugounan",
    "spellShort": "fgn",
    "code": "FGF"
  },
  {
    "name": "富海",
    "spell": "fuhai",
    "spellShort": "fha",
    "code": "FHX"
  },
  {
    "name": "凤凰古城",
    "spell": "fenghuanggucheng",
    "spellShort": "fhc",
    "code": "FCA"
  },
  {
    "name": "福海西",
    "spell": "fuhaixi",
    "spellShort": "fhx",
    "code": "FHA"
  },
  {
    "name": "奉节",
    "spell": "fengjie",
    "spellShort": "fji",
    "code": "FJE"
  },
  {
    "name": "枫林",
    "spell": "fenglin",
    "spellShort": "fli",
    "code": "FLN"
  },
  {
    "name": "福利屯",
    "spell": "fulitun",
    "spellShort": "flt",
    "code": "FTB"
  },
  {
    "name": "丰乐镇",
    "spell": "fenglezhen",
    "spellShort": "flz",
    "code": "FZB"
  },
  {
    "name": "阜南",
    "spell": "funan",
    "spellShort": "fna",
    "code": "FNH"
  },
  {
    "name": "抚宁",
    "spell": "funing",
    "spellShort": "fni",
    "code": "FNP"
  },
  {
    "name": "阜宁",
    "spell": "funing",
    "spellShort": "fni",
    "code": "AKH"
  },
  {
    "name": "阜宁南",
    "spell": "funingnan",
    "spellShort": "fnn",
    "code": "FNU"
  },
  {
    "name": "富平",
    "spell": "fuping",
    "spellShort": "fpi",
    "code": "FPY"
  },
  {
    "name": "佛坪",
    "spell": "foping",
    "spellShort": "fpi",
    "code": "FUY"
  },
  {
    "name": "法启",
    "spell": "faqi",
    "spellShort": "fqi",
    "code": "FQE"
  },
  {
    "name": "福清西",
    "spell": "fuqingxi",
    "spellShort": "fqx",
    "code": "FVS"
  },
  {
    "name": "芙蓉镇",
    "spell": "furongzhen",
    "spellShort": "frz",
    "code": "FRA"
  },
  {
    "name": "丰顺东",
    "spell": "fengshundong",
    "spellShort": "fsd",
    "code": "FDA"
  },
  {
    "name": "复盛",
    "spell": "fusheng",
    "spellShort": "fsh",
    "code": "FAW"
  },
  {
    "name": "丰顺",
    "spell": "fengshun",
    "spellShort": "fsh",
    "code": "FUQ"
  },
  {
    "name": "繁峙",
    "spell": "fanshi",
    "spellShort": "fsh",
    "code": "FSV"
  },
  {
    "name": "抚顺",
    "spell": "fushun",
    "spellShort": "fsh",
    "code": "FST"
  },
  {
    "name": "福山口",
    "spell": "fushankou",
    "spellShort": "fsk",
    "code": "FKP"
  },
  {
    "name": "扶绥南",
    "spell": "fusuinan",
    "spellShort": "fsn",
    "code": "FNZ"
  },
  {
    "name": "抚松",
    "spell": "fusong",
    "spellShort": "fso",
    "code": "FSL"
  },
  {
    "name": "福山镇",
    "spell": "fushanzhen",
    "spellShort": "fsz",
    "code": "FZQ"
  },
  {
    "name": "凤台南",
    "spell": "fengtainan",
    "spellShort": "ftn",
    "code": "FTU"
  },
  {
    "name": "冯屯",
    "spell": "fengtun",
    "spellShort": "ftu",
    "code": "FTX"
  },
  {
    "name": "浮图峪",
    "spell": "futuyu",
    "spellShort": "fty",
    "code": "FYP"
  },
  {
    "name": "费县北",
    "spell": "feixianbei",
    "spellShort": "fxb",
    "code": "FBK"
  },
  {
    "name": "富县东",
    "spell": "fuxiandong",
    "spellShort": "fxd",
    "code": "FDY"
  },
  {
    "name": "富县",
    "spell": "fuxian",
    "spellShort": "fxi",
    "code": "FEY"
  },
  {
    "name": "费县",
    "spell": "feixian",
    "spellShort": "fxi",
    "code": "FXK"
  },
  {
    "name": "汾阳",
    "spell": "fenyang",
    "spellShort": "fya",
    "code": "FAV"
  },
  {
    "name": "凤阳",
    "spell": "fengyang",
    "spellShort": "fya",
    "code": "FUH"
  },
  {
    "name": "富源北",
    "spell": "fuyuanbei",
    "spellShort": "fyb",
    "code": "FBM"
  },
  {
    "name": "扶余",
    "spell": "fuyu",
    "spellShort": "fyu",
    "code": "FYT"
  },
  {
    "name": "抚州北",
    "spell": "fuzhoubei",
    "spellShort": "fzb",
    "code": "FBG"
  },
  {
    "name": "抚州东",
    "spell": "fuzhoudong",
    "spellShort": "fzd",
    "code": "FDG"
  },
  {
    "name": "范镇",
    "spell": "fanzhen",
    "spellShort": "fzh",
    "code": "VZK"
  },
  {
    "name": "固安东",
    "spell": "guandong",
    "spellShort": "gad",
    "code": "GQP"
  },
  {
    "name": "固安",
    "spell": "guan",
    "spellShort": "gan",
    "code": "GFP"
  },
  {
    "name": "高碑店东",
    "spell": "gaobeidiandong",
    "spellShort": "gbd",
    "code": "GMP"
  },
  {
    "name": "高碑店",
    "spell": "gaobeidian",
    "spellShort": "gbd",
    "code": "GBP"
  },
  {
    "name": "沟帮子",
    "spell": "goubangzi",
    "spellShort": "gbz",
    "code": "GBD"
  },
  {
    "name": "谷城北",
    "spell": "guchengbei",
    "spellShort": "gcb",
    "code": "GBN"
  },
  {
    "name": "古城东",
    "spell": "guchengdong",
    "spellShort": "gcd",
    "code": "GUU"
  },
  {
    "name": "恭城",
    "spell": "gongcheng",
    "spellShort": "gch",
    "code": "GCZ"
  },
  {
    "name": "谷城",
    "spell": "gucheng",
    "spellShort": "gch",
    "code": "GCN"
  },
  {
    "name": "古城镇",
    "spell": "guchengzhen",
    "spellShort": "gcz",
    "code": "GZB"
  },
  {
    "name": "贵定北",
    "spell": "guidingbei",
    "spellShort": "gdb",
    "code": "FMW"
  },
  {
    "name": "广德",
    "spell": "guangde",
    "spellShort": "gde",
    "code": "GRH"
  },
  {
    "name": "贵定",
    "spell": "guiding",
    "spellShort": "gdi",
    "code": "GTW"
  },
  {
    "name": "广德南",
    "spell": "guangdenan",
    "spellShort": "gdn",
    "code": "GNU"
  },
  {
    "name": "葛店南",
    "spell": "gediannan",
    "spellShort": "gdn",
    "code": "GNN"
  },
  {
    "name": "贵定县",
    "spell": "guidingxian",
    "spellShort": "gdx",
    "code": "KIW"
  },
  {
    "name": "岗嘎",
    "spell": "gangga",
    "spellShort": "gga",
    "code": "GAO"
  },
  {
    "name": "贡嘎",
    "spell": "gongga",
    "spellShort": "gga",
    "code": "GGO"
  },
  {
    "name": "官高",
    "spell": "guangao",
    "spellShort": "gga",
    "code": "GVP"
  },
  {
    "name": "葛根庙",
    "spell": "gegenmiao",
    "spellShort": "ggm",
    "code": "GGT"
  },
  {
    "name": "高各庄",
    "spell": "gaogezhuang",
    "spellShort": "ggz",
    "code": "GGP"
  },
  {
    "name": "广汉北",
    "spell": "guanghanbei",
    "spellShort": "ghb",
    "code": "GVW"
  },
  {
    "name": "甘河",
    "spell": "ganhe",
    "spellShort": "ghe",
    "code": "GAX"
  },
  {
    "name": "郭家店",
    "spell": "guojiadian",
    "spellShort": "gjd",
    "code": "GDT"
  },
  {
    "name": "个旧",
    "spell": "gejiu",
    "spellShort": "gji",
    "code": "JJM"
  },
  {
    "name": "古浪",
    "spell": "gulang",
    "spellShort": "gla",
    "code": "GLJ"
  },
  {
    "name": "橄榄坝",
    "spell": "ganlanba",
    "spellShort": "glb",
    "code": "GVM"
  },
  {
    "name": "归流河",
    "spell": "guiliuhe",
    "spellShort": "glh",
    "code": "GHT"
  },
  {
    "name": "关岭",
    "spell": "guanling",
    "spellShort": "gli",
    "code": "GLE"
  },
  {
    "name": "关林",
    "spell": "guanlin",
    "spellShort": "gli",
    "code": "GLF"
  },
  {
    "name": "甘洛南",
    "spell": "ganluonan",
    "spellShort": "gln",
    "code": "GNE"
  },
  {
    "name": "桂林西",
    "spell": "guilinxi",
    "spellShort": "glx",
    "code": "GEZ"
  },
  {
    "name": "郭磊庄",
    "spell": "guoleizhuang",
    "spellShort": "glz",
    "code": "GLP"
  },
  {
    "name": "高密北",
    "spell": "gaomibei",
    "spellShort": "gmb",
    "code": "GVK"
  },
  {
    "name": "光明城",
    "spell": "guangmingcheng",
    "spellShort": "gmc",
    "code": "IMQ"
  },
  {
    "name": "高密",
    "spell": "gaomi",
    "spellShort": "gmi",
    "code": "GMK"
  },
  {
    "name": "灌南",
    "spell": "guannan",
    "spellShort": "gna",
    "code": "GIU"
  },
  {
    "name": "广宁",
    "spell": "guangning",
    "spellShort": "gni",
    "code": "FBQ"
  },
  {
    "name": "广宁寺南",
    "spell": "guangningsinan",
    "spellShort": "gnn",
    "code": "GNT"
  },
  {
    "name": "广宁寺",
    "spell": "guangningsi",
    "spellShort": "gns",
    "code": "GQT"
  },
  {
    "name": "高平东",
    "spell": "gaopingdong",
    "spellShort": "gpd",
    "code": "GVF"
  },
  {
    "name": "高坪",
    "spell": "gaoping",
    "spellShort": "gpi",
    "code": "GGN"
  },
  {
    "name": "广平",
    "spell": "guangping",
    "spellShort": "gpi",
    "code": "GPP"
  },
  {
    "name": "高平",
    "spell": "gaoping",
    "spellShort": "gpi",
    "code": "GPF"
  },
  {
    "name": "弓棚子",
    "spell": "gongpengzi",
    "spellShort": "gpz",
    "code": "GPT"
  },
  {
    "name": "甘泉北",
    "spell": "ganquanbei",
    "spellShort": "gqb",
    "code": "GEY"
  },
  {
    "name": "甘旗卡",
    "spell": "ganqika",
    "spellShort": "gqk",
    "code": "GQD"
  },
  {
    "name": "甘泉",
    "spell": "ganquan",
    "spellShort": "gqu",
    "code": "GQY"
  },
  {
    "name": "高桥镇",
    "spell": "gaoqiaozhen",
    "spellShort": "gqz",
    "code": "GZD"
  },
  {
    "name": "赶水东",
    "spell": "ganshuidong",
    "spellShort": "gsd",
    "code": "GDE"
  },
  {
    "name": "光山",
    "spell": "guangshan",
    "spellShort": "gsh",
    "code": "GUN"
  },
  {
    "name": "灌水",
    "spell": "guanshui",
    "spellShort": "gsh",
    "code": "GST"
  },
  {
    "name": "孤山口",
    "spell": "gushankou",
    "spellShort": "gsk",
    "code": "GSP"
  },
  {
    "name": "果松",
    "spell": "guosong",
    "spellShort": "gso",
    "code": "GSL"
  },
  {
    "name": "嘎什甸子",
    "spell": "gashidianzi",
    "spellShort": "gsz",
    "code": "GXD"
  },
  {
    "name": "高山子",
    "spell": "gaoshanzi",
    "spellShort": "gsz",
    "code": "GSD"
  },
  {
    "name": "高滩",
    "spell": "gaotan",
    "spellShort": "gta",
    "code": "GAY"
  },
  {
    "name": "高台",
    "spell": "gaotai",
    "spellShort": "gta",
    "code": "GTJ"
  },
  {
    "name": "古田北",
    "spell": "gutianbei",
    "spellShort": "gtb",
    "code": "GBS"
  },
  {
    "name": "古田",
    "spell": "gutian",
    "spellShort": "gti",
    "code": "GTS"
  },
  {
    "name": "官厅",
    "spell": "guanting",
    "spellShort": "gti",
    "code": "GTP"
  },
  {
    "name": "高台南",
    "spell": "gaotainan",
    "spellShort": "gtn",
    "code": "GAJ"
  },
  {
    "name": "官厅西",
    "spell": "guantingxi",
    "spellShort": "gtx",
    "code": "KEP"
  },
  {
    "name": "赣县北",
    "spell": "ganxianbei",
    "spellShort": "gxb",
    "code": "GIG"
  },
  {
    "name": "贵溪",
    "spell": "guixi",
    "spellShort": "gxi",
    "code": "GXG"
  },
  {
    "name": "涡阳",
    "spell": "guoyang",
    "spellShort": "gya",
    "code": "GYH"
  },
  {
    "name": "高邮北",
    "spell": "gaoyoubei",
    "spellShort": "gyb",
    "code": "GEU"
  },
  {
    "name": "观音机场",
    "spell": "guanyinjichang",
    "spellShort": "gyc",
    "code": "GCU"
  },
  {
    "name": "高邮",
    "spell": "gaoyou",
    "spellShort": "gyo",
    "code": "GAU"
  },
  {
    "name": "灌云",
    "spell": "guanyun",
    "spellShort": "gyu",
    "code": "GOU"
  },
  {
    "name": "公营子",
    "spell": "gongyingzi",
    "spellShort": "gyz",
    "code": "GYD"
  },
  {
    "name": "光泽",
    "spell": "guangze",
    "spellShort": "gze",
    "code": "GZS"
  },
  {
    "name": "果珠",
    "spell": "guozhu",
    "spellShort": "gzh",
    "code": "GZE"
  },
  {
    "name": "古镇",
    "spell": "guzhen",
    "spellShort": "gzh",
    "code": "GNQ"
  },
  {
    "name": "虢镇",
    "spell": "guozhen",
    "spellShort": "gzh",
    "code": "GZY"
  },
  {
    "name": "盖州",
    "spell": "gaizhou",
    "spellShort": "gzh",
    "code": "GXT"
  },
  {
    "name": "瓜州",
    "spell": "guazhou",
    "spellShort": "gzh",
    "code": "GZJ"
  },
  {
    "name": "固镇",
    "spell": "guzhen",
    "spellShort": "gzh",
    "code": "GEH"
  },
  {
    "name": "官字井",
    "spell": "guanzijing",
    "spellShort": "gzj",
    "code": "GOT"
  },
  {
    "name": "冠豸山南",
    "spell": "guanzhaishannan",
    "spellShort": "gzn",
    "code": "GSS"
  },
  {
    "name": "古丈西",
    "spell": "guzhangxi",
    "spellShort": "gzx",
    "code": "GXA"
  },
  {
    "name": "红安",
    "spell": "hongan",
    "spellShort": "han",
    "code": "HWN"
  },
  {
    "name": "海安",
    "spell": "haian",
    "spellShort": "han",
    "code": "HIH"
  },
  {
    "name": "淮安南",
    "spell": "huaiannan",
    "spellShort": "han",
    "code": "AMH"
  },
  {
    "name": "怀安",
    "spell": "huaian",
    "spellShort": "han",
    "code": "QAP"
  },
  {
    "name": "惠安",
    "spell": "huian",
    "spellShort": "han",
    "code": "HNS"
  },
  {
    "name": "惠安堡",
    "spell": "huianpu",
    "spellShort": "hap",
    "code": "KBJ"
  },
  {
    "name": "黄柏",
    "spell": "huangbai",
    "spellShort": "hba",
    "code": "HBL"
  },
  {
    "name": "淮北北",
    "spell": "huaibeibei",
    "spellShort": "hbb",
    "code": "PLH"
  },
  {
    "name": "鹤壁东",
    "spell": "hebidong",
    "spellShort": "hbd",
    "code": "HFF"
  },
  {
    "name": "海北",
    "spell": "haibei",
    "spellShort": "hbe",
    "code": "HEB"
  },
  {
    "name": "鹤壁",
    "spell": "hebi",
    "spellShort": "hbi",
    "code": "HAF"
  },
  {
    "name": "会昌北",
    "spell": "huichangbei",
    "spellShort": "hcb",
    "code": "XEG"
  },
  {
    "name": "寒葱沟",
    "spell": "hanconggou",
    "spellShort": "hcg",
    "code": "HKB"
  },
  {
    "name": "河唇",
    "spell": "hechun",
    "spellShort": "hch",
    "code": "HCZ"
  },
  {
    "name": "华城",
    "spell": "huacheng",
    "spellShort": "hch",
    "code": "VCQ"
  },
  {
    "name": "霍城",
    "spell": "huocheng",
    "spellShort": "hch",
    "code": "SER"
  },
  {
    "name": "汉川",
    "spell": "hanchuan",
    "spellShort": "hch",
    "code": "HCN"
  },
  {
    "name": "黑冲滩",
    "spell": "heichongtan",
    "spellShort": "hct",
    "code": "HCJ"
  },
  {
    "name": "红岛",
    "spell": "hongdao",
    "spellShort": "hda",
    "code": "HQK"
  },
  {
    "name": "横道河子东",
    "spell": "hengdaohezidong",
    "spellShort": "hdd",
    "code": "KUX"
  },
  {
    "name": "化德",
    "spell": "huade",
    "spellShort": "hde",
    "code": "HGC"
  },
  {
    "name": "河东里",
    "spell": "hedongli",
    "spellShort": "hdl",
    "code": "KLJ"
  },
  {
    "name": "海东",
    "spell": "haidong",
    "spellShort": "hdo",
    "code": "LVO"
  },
  {
    "name": "洪洞",
    "spell": "hongtong",
    "spellShort": "hdo",
    "code": "HDV"
  },
  {
    "name": "海东西",
    "spell": "haidongxi",
    "spellShort": "hdx",
    "code": "HDO"
  },
  {
    "name": "横峰",
    "spell": "hengfeng",
    "spellShort": "hfe",
    "code": "HFG"
  },
  {
    "name": "韩府湾",
    "spell": "hanfuwan",
    "spellShort": "hfw",
    "code": "HXJ"
  },
  {
    "name": "黄冈",
    "spell": "huanggang",
    "spellShort": "hga",
    "code": "KGN"
  },
  {
    "name": "横沟桥东",
    "spell": "henggouqiaodong",
    "spellShort": "hgd",
    "code": "HNN"
  },
  {
    "name": "黄冈西",
    "spell": "huanggangxi",
    "spellShort": "hgx",
    "code": "KXN"
  },
  {
    "name": "洪河",
    "spell": "honghe",
    "spellShort": "hhe",
    "code": "HPB"
  },
  {
    "name": "红花沟",
    "spell": "honghuagou",
    "spellShort": "hhg",
    "code": "VHD"
  },
  {
    "name": "黄花筒",
    "spell": "huanghuatong",
    "spellShort": "hht",
    "code": "HUD"
  },
  {
    "name": "惠环",
    "spell": "huihuan",
    "spellShort": "hhu",
    "code": "KHQ"
  },
  {
    "name": "花湖",
    "spell": "huahu",
    "spellShort": "hhu",
    "code": "KHN"
  },
  {
    "name": "贺家店",
    "spell": "hejiadian",
    "spellShort": "hjd",
    "code": "HJJ"
  },
  {
    "name": "厚街",
    "spell": "houjie",
    "spellShort": "hji",
    "code": "HJA"
  },
  {
    "name": "黑井",
    "spell": "heijing",
    "spellShort": "hji",
    "code": "HIM"
  },
  {
    "name": "涵江",
    "spell": "hanjiang",
    "spellShort": "hji",
    "code": "HJS"
  },
  {
    "name": "获嘉",
    "spell": "huojia",
    "spellShort": "hji",
    "code": "HJF"
  },
  {
    "name": "杭锦后旗",
    "spell": "hangjinhouqi",
    "spellShort": "hjq",
    "code": "HDC"
  },
  {
    "name": "河间西",
    "spell": "hejianxi",
    "spellShort": "hjx",
    "code": "HXP"
  },
  {
    "name": "花家庄",
    "spell": "huajiazhuang",
    "spellShort": "hjz",
    "code": "HJM"
  },
  {
    "name": "黄口",
    "spell": "huangkou",
    "spellShort": "hko",
    "code": "KOH"
  },
  {
    "name": "湖口",
    "spell": "hukou",
    "spellShort": "hko",
    "code": "HKG"
  },
  {
    "name": "惠来",
    "spell": "huilai",
    "spellShort": "hla",
    "code": "HGA"
  },
  {
    "name": "怀来",
    "spell": "huailai",
    "spellShort": "hla",
    "code": "VQP"
  },
  {
    "name": "海林北",
    "spell": "hailinbei",
    "spellShort": "hlb",
    "code": "KBX"
  },
  {
    "name": "浩良河",
    "spell": "haolianghe",
    "spellShort": "hlh",
    "code": "HHB"
  },
  {
    "name": "黄流",
    "spell": "huangliu",
    "spellShort": "hli",
    "code": "KLQ"
  },
  {
    "name": "黄陵",
    "spell": "huangling",
    "spellShort": "hli",
    "code": "ULY"
  },
  {
    "name": "鹤立",
    "spell": "heli",
    "spellShort": "hli",
    "code": "HOB"
  },
  {
    "name": "桦林",
    "spell": "hualin",
    "spellShort": "hli",
    "code": "HIB"
  },
  {
    "name": "和龙",
    "spell": "helong",
    "spellShort": "hlo",
    "code": "HLL"
  },
  {
    "name": "海龙",
    "spell": "hailong",
    "spellShort": "hlo",
    "code": "HIL"
  },
  {
    "name": "哈拉苏",
    "spell": "halasu",
    "spellShort": "hls",
    "code": "HAX"
  },
  {
    "name": "呼鲁斯太",
    "spell": "hulusitai",
    "spellShort": "hlt",
    "code": "VTJ"
  },
  {
    "name": "虎门北",
    "spell": "humenbei",
    "spellShort": "hmb",
    "code": "HBA"
  },
  {
    "name": "虎门东",
    "spell": "humendong",
    "spellShort": "hmd",
    "code": "HDA"
  },
  {
    "name": "黄梅",
    "spell": "huangmei",
    "spellShort": "hme",
    "code": "VEH"
  },
  {
    "name": "虎门",
    "spell": "humen",
    "spellShort": "hme",
    "code": "IUQ"
  },
  {
    "name": "洪梅",
    "spell": "hongmei",
    "spellShort": "hme",
    "code": "HMA"
  },
  {
    "name": "韩麻营",
    "spell": "hanmaying",
    "spellShort": "hmy",
    "code": "HYP"
  },
  {
    "name": "衡南",
    "spell": "hengnan",
    "spellShort": "hna",
    "code": "HNG"
  },
  {
    "name": "桦南东",
    "spell": "huanandong",
    "spellShort": "hnd",
    "code": "KNB"
  },
  {
    "name": "黄泥河",
    "spell": "huangnihe",
    "spellShort": "hnh",
    "code": "HHL"
  },
  {
    "name": "化念",
    "spell": "huanian",
    "spellShort": "hni",
    "code": "HDM"
  },
  {
    "name": "海宁",
    "spell": "haining",
    "spellShort": "hni",
    "code": "HNH"
  },
  {
    "name": "怀宁",
    "spell": "huaining",
    "spellShort": "hni",
    "code": "APH"
  },
  {
    "name": "惠农",
    "spell": "huinong",
    "spellShort": "hno",
    "code": "HMJ"
  },
  {
    "name": "和平北",
    "spell": "hepingbei",
    "spellShort": "hpb",
    "code": "HPA"
  },
  {
    "name": "和平",
    "spell": "heping",
    "spellShort": "hpi",
    "code": "VAQ"
  },
  {
    "name": "合浦",
    "spell": "hepu",
    "spellShort": "hpu",
    "code": "HVZ"
  },
  {
    "name": "花棚子",
    "spell": "huapengzi",
    "spellShort": "hpz",
    "code": "HZM"
  },
  {
    "name": "横琴北",
    "spell": "hengqinbei",
    "spellShort": "hqb",
    "code": "HOA"
  },
  {
    "name": "霍邱",
    "spell": "huoqiu",
    "spellShort": "hqi",
    "code": "FBH"
  },
  {
    "name": "宏庆",
    "spell": "hongqing",
    "spellShort": "hqi",
    "code": "HEY"
  },
  {
    "name": "横琴",
    "spell": "hengqin",
    "spellShort": "hqi",
    "code": "HQA"
  },
  {
    "name": "花桥",
    "spell": "huaqiao",
    "spellShort": "hqi",
    "code": "VQH"
  },
  {
    "name": "红旗渠",
    "spell": "hongqiqu",
    "spellShort": "hqq",
    "code": "HQF"
  },
  {
    "name": "华容东",
    "spell": "huarongdong",
    "spellShort": "hrd",
    "code": "HPN"
  },
  {
    "name": "怀仁",
    "spell": "huairen",
    "spellShort": "hre",
    "code": "HRV"
  },
  {
    "name": "华容南",
    "spell": "huarongnan",
    "spellShort": "hrn",
    "code": "KRN"
  },
  {
    "name": "华容",
    "spell": "huarong",
    "spellShort": "hro",
    "code": "HRN"
  },
  {
    "name": "红寺堡",
    "spell": "hongsibu",
    "spellShort": "hsb",
    "code": "HSJ"
  },
  {
    "name": "红寺堡北",
    "spell": "hongsibubei",
    "spellShort": "hsb",
    "code": "HEJ"
  },
  {
    "name": "黑山北",
    "spell": "heishanbei",
    "spellShort": "hsb",
    "code": "HQT"
  },
  {
    "name": "黄石北",
    "spell": "huangshibei",
    "spellShort": "hsb",
    "code": "KSN"
  },
  {
    "name": "贺胜桥东",
    "spell": "heshengqiaodong",
    "spellShort": "hsd",
    "code": "HLN"
  },
  {
    "name": "黄松甸",
    "spell": "huangsongdian",
    "spellShort": "hsd",
    "code": "HDL"
  },
  {
    "name": "汉寿",
    "spell": "hanshou",
    "spellShort": "hsh",
    "code": "HHA"
  },
  {
    "name": "衡山",
    "spell": "hengshan",
    "spellShort": "hsh",
    "code": "HSQ"
  },
  {
    "name": "虎什哈",
    "spell": "hushiha",
    "spellShort": "hsh",
    "code": "HHP"
  },
  {
    "name": "惠山",
    "spell": "huishan",
    "spellShort": "hsh",
    "code": "VCH"
  },
  {
    "name": "红山",
    "spell": "hongshan",
    "spellShort": "hsh",
    "code": "VSB"
  },
  {
    "name": "汉寿南",
    "spell": "hanshounan",
    "spellShort": "hsn",
    "code": "VSQ"
  },
  {
    "name": "含山南",
    "spell": "hanshannan",
    "spellShort": "hsn",
    "code": "HSU"
  },
  {
    "name": "红砂岘",
    "spell": "hongshaxian",
    "spellShort": "hsx",
    "code": "VSJ"
  },
  {
    "name": "衡山西",
    "spell": "hengshanxi",
    "spellShort": "hsx",
    "code": "HEQ"
  },
  {
    "name": "荷塘",
    "spell": "hetang",
    "spellShort": "hta",
    "code": "KXQ"
  },
  {
    "name": "桓台",
    "spell": "huantai",
    "spellShort": "hta",
    "code": "VTK"
  },
  {
    "name": "黑台",
    "spell": "heitai",
    "spellShort": "hta",
    "code": "HQB"
  },
  {
    "name": "黄桶北",
    "spell": "huangtongbei",
    "spellShort": "htb",
    "code": "HBE"
  },
  {
    "name": "黑旺",
    "spell": "heiwang",
    "spellShort": "hwa",
    "code": "HWK"
  },
  {
    "name": "徽县",
    "spell": "huixian",
    "spellShort": "hxi",
    "code": "HYY"
  },
  {
    "name": "红星",
    "spell": "hongxing",
    "spellShort": "hxi",
    "code": "VXB"
  },
  {
    "name": "红兴隆",
    "spell": "hongxinglong",
    "spellShort": "hxl",
    "code": "VHB"
  },
  {
    "name": "红岘台",
    "spell": "hongxiantai",
    "spellShort": "hxt",
    "code": "HTJ"
  },
  {
    "name": "换新天",
    "spell": "huanxintian",
    "spellShort": "hxt",
    "code": "VTB"
  },
  {
    "name": "滑浚",
    "spell": "huaxun",
    "spellShort": "hxu",
    "code": "HWF"
  },
  {
    "name": "合阳",
    "spell": "heyang",
    "spellShort": "hya",
    "code": "HAY"
  },
  {
    "name": "海晏",
    "spell": "haiyan",
    "spellShort": "hya",
    "code": "HFO"
  },
  {
    "name": "红彦",
    "spell": "hongyan",
    "spellShort": "hya",
    "code": "VIX"
  },
  {
    "name": "合阳北",
    "spell": "heyangbei",
    "spellShort": "hyb",
    "code": "HTY"
  },
  {
    "name": "河源北",
    "spell": "heyuanbei",
    "spellShort": "hyb",
    "code": "HYA"
  },
  {
    "name": "海阳北",
    "spell": "haiyangbei",
    "spellShort": "hyb",
    "code": "HEK"
  },
  {
    "name": "汉阴",
    "spell": "hanyin",
    "spellShort": "hyi",
    "code": "HQY"
  },
  {
    "name": "槐荫",
    "spell": "huaiyin",
    "spellShort": "hyi",
    "code": "IYN"
  },
  {
    "name": "花园口",
    "spell": "huayuankou",
    "spellShort": "hyk",
    "code": "HYT"
  },
  {
    "name": "淮阳南",
    "spell": "huaiyangnan",
    "spellShort": "hyn",
    "code": "HVF"
  },
  {
    "name": "黄羊滩",
    "spell": "huangyangtan",
    "spellShort": "hyt",
    "code": "HGJ"
  },
  {
    "name": "花园",
    "spell": "huayuan",
    "spellShort": "hyu",
    "code": "HUN"
  },
  {
    "name": "黄羊镇",
    "spell": "huangyangzhen",
    "spellShort": "hyz",
    "code": "HYJ"
  },
  {
    "name": "霍州东",
    "spell": "huozhoudong",
    "spellShort": "hzd",
    "code": "HWV"
  },
  {
    "name": "黄州",
    "spell": "huangzhou",
    "spellShort": "hzh",
    "code": "VON"
  },
  {
    "name": "壶镇",
    "spell": "huzhen",
    "spellShort": "hzh",
    "code": "HUU"
  },
  {
    "name": "化州",
    "spell": "huazhou",
    "spellShort": "hzh",
    "code": "HZZ"
  },
  {
    "name": "霍州",
    "spell": "huozhou",
    "spellShort": "hzh",
    "code": "HZV"
  },
  {
    "name": "惠州西",
    "spell": "huizhouxi",
    "spellShort": "hzx",
    "code": "VXQ"
  },
  {
    "name": "靖边",
    "spell": "jingbian",
    "spellShort": "jbi",
    "code": "JIY"
  },
  {
    "name": "金宝屯",
    "spell": "jinbaotun",
    "spellShort": "jbt",
    "code": "JBD"
  },
  {
    "name": "晋城北",
    "spell": "jinchengbei",
    "spellShort": "jcb",
    "code": "JEF"
  },
  {
    "name": "交城",
    "spell": "jiaocheng",
    "spellShort": "jch",
    "code": "JNV"
  },
  {
    "name": "建昌",
    "spell": "jianchang",
    "spellShort": "jch",
    "code": "JFD"
  },
  {
    "name": "加查",
    "spell": "jiacha",
    "spellShort": "jch",
    "code": "JIO"
  },
  {
    "name": "泾川",
    "spell": "jingchuan",
    "spellShort": "jch",
    "code": "JAJ"
  },
  {
    "name": "碱厂",
    "spell": "jianchang",
    "spellShort": "jch",
    "code": "JUT"
  },
  {
    "name": "鄄城",
    "spell": "juancheng",
    "spellShort": "jch",
    "code": "JCK"
  },
  {
    "name": "旌德",
    "spell": "jingde",
    "spellShort": "jde",
    "code": "NSH"
  },
  {
    "name": "峻德",
    "spell": "junde",
    "spellShort": "jde",
    "code": "JDB"
  },
  {
    "name": "井店",
    "spell": "jingdian",
    "spellShort": "jdi",
    "code": "JFP"
  },
  {
    "name": "江都",
    "spell": "jiangdu",
    "spellShort": "jdu",
    "code": "UDH"
  },
  {
    "name": "尖峰",
    "spell": "jianfeng",
    "spellShort": "jfe",
    "code": "PFQ"
  },
  {
    "name": "金沟屯",
    "spell": "jingoutun",
    "spellShort": "jgt",
    "code": "VGP"
  },
  {
    "name": "江海",
    "spell": "jianghai",
    "spellShort": "jha",
    "code": "JNQ"
  },
  {
    "name": "精河",
    "spell": "jinghe",
    "spellShort": "jhe",
    "code": "JHR"
  },
  {
    "name": "金河",
    "spell": "jinhe",
    "spellShort": "jhe",
    "code": "JHX"
  },
  {
    "name": "锦河",
    "spell": "jinhe",
    "spellShort": "jhe",
    "code": "JHB"
  },
  {
    "name": "九华山",
    "spell": "jiuhuashan",
    "spellShort": "jhs",
    "code": "JSU"
  },
  {
    "name": "江华",
    "spell": "jianghua",
    "spellShort": "jhu",
    "code": "JHZ"
  },
  {
    "name": "建湖",
    "spell": "jianhu",
    "spellShort": "jhu",
    "code": "AJH"
  },
  {
    "name": "纪家沟",
    "spell": "jijiagou",
    "spellShort": "jjg",
    "code": "VJD"
  },
  {
    "name": "锦界",
    "spell": "jinjie",
    "spellShort": "jji",
    "code": "JEY"
  },
  {
    "name": "姜家",
    "spell": "jiangjia",
    "spellShort": "jji",
    "code": "JJB"
  },
  {
    "name": "金口河南",
    "spell": "jinkouhenan",
    "spellShort": "jkn",
    "code": "JHE"
  },
  {
    "name": "将乐",
    "spell": "jiangle",
    "spellShort": "jle",
    "code": "JLS"
  },
  {
    "name": "芨岭",
    "spell": "jiling",
    "spellShort": "jli",
    "code": "JLJ"
  },
  {
    "name": "九郎山",
    "spell": "jiulangshan",
    "spellShort": "jls",
    "code": "KJQ"
  },
  {
    "name": "江门东",
    "spell": "jiangmendong",
    "spellShort": "jmd",
    "code": "JWQ"
  },
  {
    "name": "角美",
    "spell": "jiaomei",
    "spellShort": "jme",
    "code": "JES"
  },
  {
    "name": "佳木斯西",
    "spell": "jiamusixi",
    "spellShort": "jmx",
    "code": "JUB"
  },
  {
    "name": "莒南",
    "spell": "junan",
    "spellShort": "jna",
    "code": "JOK"
  },
  {
    "name": "莒南北",
    "spell": "junanbei",
    "spellShort": "jnb",
    "code": "VNK"
  },
  {
    "name": "济宁北",
    "spell": "jiningbei",
    "spellShort": "jnb",
    "code": "MIK"
  },
  {
    "name": "济宁东",
    "spell": "jiningdong",
    "spellShort": "jnd",
    "code": "MNK"
  },
  {
    "name": "建宁南",
    "spell": "jianningnan",
    "spellShort": "jnn",
    "code": "JQS"
  },
  {
    "name": "建瓯东",
    "spell": "jianoudong",
    "spellShort": "jod",
    "code": "JZS"
  },
  {
    "name": "建瓯",
    "spell": "jianou",
    "spellShort": "jou",
    "code": "JVS"
  },
  {
    "name": "建瓯西",
    "spell": "jianouxi",
    "spellShort": "jox",
    "code": "JUS"
  },
  {
    "name": "金普",
    "spell": "jinpu",
    "spellShort": "jpu",
    "code": "PWT"
  },
  {
    "name": "建桥",
    "spell": "jianqiao",
    "spellShort": "jqi",
    "code": "JQA"
  },
  {
    "name": "江桥",
    "spell": "jiangqiao",
    "spellShort": "jqi",
    "code": "JQX"
  },
  {
    "name": "句容西",
    "spell": "jurongxi",
    "spellShort": "jrx",
    "code": "JWH"
  },
  {
    "name": "九三",
    "spell": "jiusan",
    "spellShort": "jsa",
    "code": "SSX"
  },
  {
    "name": "金山",
    "spell": "jinshan",
    "spellShort": "jsh",
    "code": "JSR"
  },
  {
    "name": "建始",
    "spell": "jianshi",
    "spellShort": "jsh",
    "code": "JRN"
  },
  {
    "name": "建水",
    "spell": "jianshui",
    "spellShort": "jsh",
    "code": "JSM"
  },
  {
    "name": "稷山",
    "spell": "jishan",
    "spellShort": "jsh",
    "code": "JVV"
  },
  {
    "name": "吉舒",
    "spell": "jishu",
    "spellShort": "jsh",
    "code": "JSL"
  },
  {
    "name": "建设",
    "spell": "jianshe",
    "spellShort": "jsh",
    "code": "JET"
  },
  {
    "name": "甲山",
    "spell": "jiashan",
    "spellShort": "jsh",
    "code": "JOP"
  },
  {
    "name": "京山",
    "spell": "jingshan",
    "spellShort": "jsh",
    "code": "JCN"
  },
  {
    "name": "嘉善",
    "spell": "jiashan",
    "spellShort": "jsh",
    "code": "JSH"
  },
  {
    "name": "嘉善南",
    "spell": "jiashannan",
    "spellShort": "jsn",
    "code": "EAH"
  },
  {
    "name": "界首市",
    "spell": "jieshoushi",
    "spellShort": "jss",
    "code": "JUN"
  },
  {
    "name": "江所田",
    "spell": "jiangsuotian",
    "spellShort": "jst",
    "code": "JOM"
  },
  {
    "name": "金山屯",
    "spell": "jinshantun",
    "spellShort": "jst",
    "code": "JTB"
  },
  {
    "name": "吉水西",
    "spell": "jishuixi",
    "spellShort": "jsx",
    "code": "JSG"
  },
  {
    "name": "景泰",
    "spell": "jingtai",
    "spellShort": "jta",
    "code": "JTJ"
  },
  {
    "name": "金塔",
    "spell": "jinta",
    "spellShort": "jta",
    "code": "JIJ"
  },
  {
    "name": "井湾",
    "spell": "jingwan",
    "spellShort": "jwa",
    "code": "JWA"
  },
  {
    "name": "吉文",
    "spell": "jiwen",
    "spellShort": "jwe",
    "code": "JWX"
  },
  {
    "name": "嘉祥北",
    "spell": "jiaxiangbei",
    "spellShort": "jxb",
    "code": "MXK"
  },
  {
    "name": "进贤北",
    "spell": "jinxianbei",
    "spellShort": "jxb",
    "code": "JHG"
  },
  {
    "name": "泾县",
    "spell": "jingxian",
    "spellShort": "jxi",
    "code": "LOH"
  },
  {
    "name": "莒县",
    "spell": "juxian",
    "spellShort": "jxi",
    "code": "JKK"
  },
  {
    "name": "嘉祥",
    "spell": "jiaxiang",
    "spellShort": "jxi",
    "code": "JUK"
  },
  {
    "name": "郏县",
    "spell": "jiaxian",
    "spellShort": "jxi",
    "code": "JXF"
  },
  {
    "name": "夹心子",
    "spell": "jiaxinzi",
    "spellShort": "jxz",
    "code": "JXT"
  },
  {
    "name": "揭阳",
    "spell": "jieyang",
    "spellShort": "jya",
    "code": "JYA"
  },
  {
    "name": "建阳",
    "spell": "jianyang",
    "spellShort": "jya",
    "code": "JYS"
  },
  {
    "name": "蛟洋",
    "spell": "jiaoyang",
    "spellShort": "jya",
    "code": "JBS"
  },
  {
    "name": "姜堰",
    "spell": "jiangyan",
    "spellShort": "jya",
    "code": "UEH"
  },
  {
    "name": "江油北",
    "spell": "jiangyoubei",
    "spellShort": "jyb",
    "code": "JBE"
  },
  {
    "name": "巨野北",
    "spell": "juyebei",
    "spellShort": "jyb",
    "code": "MYK"
  },
  {
    "name": "揭阳机场",
    "spell": "jieyangjichang",
    "spellShort": "jyc",
    "code": "JUA"
  },
  {
    "name": "揭阳南",
    "spell": "jieyangnan",
    "spellShort": "jyn",
    "code": "JRQ"
  },
  {
    "name": "江永",
    "spell": "jiangyong",
    "spellShort": "jyo",
    "code": "JYZ"
  },
  {
    "name": "江源",
    "spell": "jiangyuan",
    "spellShort": "jyu",
    "code": "SZL"
  },
  {
    "name": "靖远",
    "spell": "jingyuan",
    "spellShort": "jyu",
    "code": "JYJ"
  },
  {
    "name": "缙云",
    "spell": "jinyun",
    "spellShort": "jyu",
    "code": "JYH"
  },
  {
    "name": "济源",
    "spell": "jiyuan",
    "spellShort": "jyu",
    "code": "JYF"
  },
  {
    "name": "金月湾",
    "spell": "jinyuewan",
    "spellShort": "jyw",
    "code": "PYQ"
  },
  {
    "name": "靖远西",
    "spell": "jingyuanxi",
    "spellShort": "jyx",
    "code": "JXJ"
  },
  {
    "name": "缙云西",
    "spell": "jinyunxi",
    "spellShort": "jyx",
    "code": "PYH"
  },
  {
    "name": "胶州北",
    "spell": "jiaozhoubei",
    "spellShort": "jzb",
    "code": "JZK"
  },
  {
    "name": "焦作东",
    "spell": "jiaozuodong",
    "spellShort": "jzd",
    "code": "WEF"
  },
  {
    "name": "晋中",
    "spell": "jinzhong",
    "spellShort": "jzh",
    "code": "JZV"
  },
  {
    "name": "靖州",
    "spell": "jingzhou",
    "spellShort": "jzh",
    "code": "JEQ"
  },
  {
    "name": "景州",
    "spell": "jingzhou",
    "spellShort": "jzh",
    "code": "JEP"
  },
  {
    "name": "胶州",
    "spell": "jiaozhou",
    "spellShort": "jzh",
    "code": "JXK"
  },
  {
    "name": "旧庄窝",
    "spell": "jiuzhuangwo",
    "spellShort": "jzw",
    "code": "JVP"
  },
  {
    "name": "金杖子",
    "spell": "jinzhangzi",
    "spellShort": "jzz",
    "code": "JYD"
  },
  {
    "name": "康城",
    "spell": "kangcheng",
    "spellShort": "kch",
    "code": "KCP"
  },
  {
    "name": "宽甸",
    "spell": "kuandian",
    "spellShort": "kdi",
    "code": "KDT"
  },
  {
    "name": "克东",
    "spell": "kedong",
    "spellShort": "kdo",
    "code": "KOB"
  },
  {
    "name": "昆都仑召",
    "spell": "kundulunzhao",
    "spellShort": "kdz",
    "code": "KDC"
  },
  {
    "name": "库尔木依",
    "spell": "kuermuyi",
    "spellShort": "key",
    "code": "VPR"
  },
  {
    "name": "开江",
    "spell": "kaijiang",
    "spellShort": "kji",
    "code": "KAW"
  },
  {
    "name": "喀喇其",
    "spell": "kalaqi",
    "spellShort": "klq",
    "code": "KQX"
  },
  {
    "name": "开平南",
    "spell": "kaipingnan",
    "spellShort": "kpn",
    "code": "PVQ"
  },
  {
    "name": "口前",
    "spell": "kouqian",
    "spellShort": "kqi",
    "code": "KQL"
  },
  {
    "name": "奎山",
    "spell": "kuishan",
    "spellShort": "ksh",
    "code": "KAB"
  },
  {
    "name": "葵潭",
    "spell": "kuitan",
    "spellShort": "kta",
    "code": "KTQ"
  },
  {
    "name": "康熙岭",
    "spell": "kangxiling",
    "spellShort": "kxl",
    "code": "KXZ"
  },
  {
    "name": "克一河",
    "spell": "keyihe",
    "spellShort": "kyh",
    "code": "KHX"
  },
  {
    "name": "开远南",
    "spell": "kaiyuannan",
    "spellShort": "kyn",
    "code": "KUM"
  },
  {
    "name": "昆玉",
    "spell": "kunyu",
    "spellShort": "kyu",
    "code": "ESR"
  },
  {
    "name": "冷坝",
    "spell": "lengba",
    "spellShort": "lba",
    "code": "LBE"
  },
  {
    "name": "琅勃拉邦",
    "spell": "langbolabang",
    "spellShort": "lbb",
    "code": "VJM"
  },
  {
    "name": "来宾",
    "spell": "laibin",
    "spellShort": "lbi",
    "code": "UBZ"
  },
  {
    "name": "老边",
    "spell": "laobian",
    "spellShort": "lbi",
    "code": "LLT"
  },
  {
    "name": "灵璧",
    "spell": "lingbi",
    "spellShort": "lbi",
    "code": "GMH"
  },
  {
    "name": "寮步",
    "spell": "liaobu",
    "spellShort": "lbu",
    "code": "LTQ"
  },
  {
    "name": "洛川东",
    "spell": "luochuandong",
    "spellShort": "lcd",
    "code": "LRY"
  },
  {
    "name": "罗城",
    "spell": "luocheng",
    "spellShort": "lch",
    "code": "VCZ"
  },
  {
    "name": "乐昌",
    "spell": "lechang",
    "spellShort": "lch",
    "code": "LCQ"
  },
  {
    "name": "黎城",
    "spell": "licheng",
    "spellShort": "lch",
    "code": "UCP"
  },
  {
    "name": "临城",
    "spell": "lincheng",
    "spellShort": "lch",
    "code": "UUP"
  },
  {
    "name": "蓝村",
    "spell": "lancun",
    "spellShort": "lcu",
    "code": "LCK"
  },
  {
    "name": "乐东",
    "spell": "ledong",
    "spellShort": "ldo",
    "code": "UQQ"
  },
  {
    "name": "林东",
    "spell": "lindong",
    "spellShort": "ldo",
    "code": "LRC"
  },
  {
    "name": "乐都",
    "spell": "ledu",
    "spellShort": "ldu",
    "code": "LDO"
  },
  {
    "name": "梁底下",
    "spell": "liangdixia",
    "spellShort": "ldx",
    "code": "LDP"
  },
  {
    "name": "六道河子",
    "spell": "liudaohezi",
    "spellShort": "ldz",
    "code": "LVP"
  },
  {
    "name": "鲁番",
    "spell": "lufan",
    "spellShort": "lfa",
    "code": "LVM"
  },
  {
    "name": "落垡",
    "spell": "luofa",
    "spellShort": "lfa",
    "code": "LOP"
  },
  {
    "name": "陆丰东",
    "spell": "lufengdong",
    "spellShort": "lfd",
    "code": "LDA"
  },
  {
    "name": "来凤",
    "spell": "laifeng",
    "spellShort": "lfe",
    "code": "LFA"
  },
  {
    "name": "龙丰",
    "spell": "longfeng",
    "spellShort": "lfe",
    "code": "KFQ"
  },
  {
    "name": "陆丰南",
    "spell": "lufengnan",
    "spellShort": "lfn",
    "code": "LAA"
  },
  {
    "name": "禄丰南",
    "spell": "lufengnan",
    "spellShort": "lfn",
    "code": "LQM"
  },
  {
    "name": "老府",
    "spell": "laofu",
    "spellShort": "lfu",
    "code": "UFD"
  },
  {
    "name": "兰岗",
    "spell": "langang",
    "spellShort": "lga",
    "code": "LNB"
  },
  {
    "name": "龙骨甸",
    "spell": "longgudian",
    "spellShort": "lgd",
    "code": "LGM"
  },
  {
    "name": "临高南",
    "spell": "lingaonan",
    "spellShort": "lgn",
    "code": "KGQ"
  },
  {
    "name": "芦沟",
    "spell": "lugou",
    "spellShort": "lgo",
    "code": "LOM"
  },
  {
    "name": "龙沟",
    "spell": "longgou",
    "spellShort": "lgo",
    "code": "LGJ"
  },
  {
    "name": "临海",
    "spell": "linhai",
    "spellShort": "lha",
    "code": "UFH"
  },
  {
    "name": "凌海",
    "spell": "linghai",
    "spellShort": "lha",
    "code": "JID"
  },
  {
    "name": "拉哈",
    "spell": "laha",
    "spellShort": "lha",
    "code": "LHX"
  },
  {
    "name": "林海",
    "spell": "linhai",
    "spellShort": "lha",
    "code": "LXX"
  },
  {
    "name": "滦河",
    "spell": "luanhe",
    "spellShort": "lhe",
    "code": "UDP"
  },
  {
    "name": "临海南",
    "spell": "linhainan",
    "spellShort": "lhn",
    "code": "LHU"
  },
  {
    "name": "凌海南",
    "spell": "linghainan",
    "spellShort": "lhn",
    "code": "UNT"
  },
  {
    "name": "龙华",
    "spell": "longhua",
    "spellShort": "lhu",
    "code": "LHP"
  },
  {
    "name": "滦河沿",
    "spell": "luanheyan",
    "spellShort": "lhy",
    "code": "UNP"
  },
  {
    "name": "六合镇",
    "spell": "liuhezhen",
    "spellShort": "lhz",
    "code": "LEX"
  },
  {
    "name": "罗江东",
    "spell": "luojiangdong",
    "spellShort": "ljd",
    "code": "IKW"
  },
  {
    "name": "亮甲店",
    "spell": "liangjiadian",
    "spellShort": "ljd",
    "code": "LRT"
  },
  {
    "name": "刘家河",
    "spell": "liujiahe",
    "spellShort": "ljh",
    "code": "LVT"
  },
  {
    "name": "廉江",
    "spell": "lianjiang",
    "spellShort": "lji",
    "code": "LJZ"
  },
  {
    "name": "罗江",
    "spell": "luojiang",
    "spellShort": "lji",
    "code": "LJW"
  },
  {
    "name": "柳江",
    "spell": "liujiang",
    "spellShort": "lji",
    "code": "UQZ"
  },
  {
    "name": "两家",
    "spell": "liangjia",
    "spellShort": "lji",
    "code": "UJT"
  },
  {
    "name": "李家",
    "spell": "lijia",
    "spellShort": "lji",
    "code": "LJB"
  },
  {
    "name": "龙江",
    "spell": "longjiang",
    "spellShort": "lji",
    "code": "LJX"
  },
  {
    "name": "莲江口",
    "spell": "lianjiangkou",
    "spellShort": "ljk",
    "code": "LHB"
  },
  {
    "name": "利津南",
    "spell": "lijinnan",
    "spellShort": "ljn",
    "code": "LNK"
  },
  {
    "name": "李家坪",
    "spell": "lijiaping",
    "spellShort": "ljp",
    "code": "LIJ"
  },
  {
    "name": "厉家寨",
    "spell": "lijiazhai",
    "spellShort": "ljz",
    "code": "UPK"
  },
  {
    "name": "林口南",
    "spell": "linkounan",
    "spellShort": "lkn",
    "code": "LRB"
  },
  {
    "name": "路口铺",
    "spell": "lukoupu",
    "spellShort": "lkp",
    "code": "LKQ"
  },
  {
    "name": "老莱",
    "spell": "laolai",
    "spellShort": "lla",
    "code": "LAX"
  },
  {
    "name": "龙里北",
    "spell": "longlibei",
    "spellShort": "llb",
    "code": "KFW"
  },
  {
    "name": "沥林北",
    "spell": "lilinbei",
    "spellShort": "llb",
    "code": "KBQ"
  },
  {
    "name": "兰陵北",
    "spell": "lanlingbei",
    "spellShort": "llb",
    "code": "COK"
  },
  {
    "name": "醴陵东",
    "spell": "lilingdong",
    "spellShort": "lld",
    "code": "UKQ"
  },
  {
    "name": "临澧",
    "spell": "linli",
    "spellShort": "lli",
    "code": "LWQ"
  },
  {
    "name": "零陵",
    "spell": "lingling",
    "spellShort": "lli",
    "code": "UWZ"
  },
  {
    "name": "陆良",
    "spell": "luliang",
    "spellShort": "lli",
    "code": "LRM"
  },
  {
    "name": "卢龙",
    "spell": "lulong",
    "spellShort": "llo",
    "code": "UAP"
  },
  {
    "name": "喇嘛甸",
    "spell": "lamadian",
    "spellShort": "lmd",
    "code": "LMX"
  },
  {
    "name": "里木店",
    "spell": "limudian",
    "spellShort": "lmd",
    "code": "LMB"
  },
  {
    "name": "洛门",
    "spell": "luomen",
    "spellShort": "lme",
    "code": "LMJ"
  },
  {
    "name": "芦庙",
    "spell": "lumiao",
    "spellShort": "lmi",
    "code": "LMU"
  },
  {
    "name": "龙南",
    "spell": "longnan",
    "spellShort": "lna",
    "code": "UNG"
  },
  {
    "name": "龙南东",
    "spell": "longnandong",
    "spellShort": "lnd",
    "code": "LBG"
  },
  {
    "name": "乐平北",
    "spell": "lepingbei",
    "spellShort": "lpb",
    "code": "LKG"
  },
  {
    "name": "六盘水东",
    "spell": "liupanshuidong",
    "spellShort": "lpd",
    "code": "LDE"
  },
  {
    "name": "落坡岭",
    "spell": "luopoling",
    "spellShort": "lpl",
    "code": "LPP"
  },
  {
    "name": "六盘山",
    "spell": "liupanshan",
    "spellShort": "lps",
    "code": "UPJ"
  },
  {
    "name": "乐平市",
    "spell": "lepingshi",
    "spellShort": "lps",
    "code": "LPG"
  },
  {
    "name": "洛浦",
    "spell": "luopu",
    "spellShort": "lpu",
    "code": "LVR"
  },
  {
    "name": "临清",
    "spell": "linqing",
    "spellShort": "lqi",
    "code": "UQK"
  },
  {
    "name": "礼泉南",
    "spell": "liquannan",
    "spellShort": "lqn",
    "code": "UNY"
  },
  {
    "name": "龙泉市",
    "spell": "longquanshi",
    "spellShort": "lqs",
    "code": "LVU"
  },
  {
    "name": "礼泉",
    "spell": "liquan",
    "spellShort": "lqu",
    "code": "LGY"
  },
  {
    "name": "临泉",
    "spell": "linquan",
    "spellShort": "lqu",
    "code": "LOU"
  },
  {
    "name": "乐山北",
    "spell": "leshanbei",
    "spellShort": "lsb",
    "code": "UTW"
  },
  {
    "name": "冷水江东",
    "spell": "lengshuijiangdong",
    "spellShort": "lsd",
    "code": "UDQ"
  },
  {
    "name": "连山关",
    "spell": "lianshanguan",
    "spellShort": "lsg",
    "code": "LGT"
  },
  {
    "name": "流水沟",
    "spell": "liushuigou",
    "spellShort": "lsg",
    "code": "USP"
  },
  {
    "name": "灵石",
    "spell": "lingshi",
    "spellShort": "lsh",
    "code": "LSV"
  },
  {
    "name": "露水河",
    "spell": "lushuihe",
    "spellShort": "lsh",
    "code": "LUL"
  },
  {
    "name": "罗山",
    "spell": "luoshan",
    "spellShort": "lsh",
    "code": "LRN"
  },
  {
    "name": "涟水",
    "spell": "lianshui",
    "spellShort": "lsh",
    "code": "LIU"
  },
  {
    "name": "龙市",
    "spell": "longshi",
    "spellShort": "lsh",
    "code": "LAG"
  },
  {
    "name": "梁山",
    "spell": "liangshan",
    "spellShort": "lsh",
    "code": "LMK"
  },
  {
    "name": "鲁山",
    "spell": "lushan",
    "spellShort": "lsh",
    "code": "LAF"
  },
  {
    "name": "娄山关南",
    "spell": "loushanguannan",
    "spellShort": "lsn",
    "code": "LSE"
  },
  {
    "name": "柳树屯",
    "spell": "liushutun",
    "spellShort": "lst",
    "code": "LSD"
  },
  {
    "name": "龙山镇",
    "spell": "longshanzhen",
    "spellShort": "lsz",
    "code": "LAS"
  },
  {
    "name": "李石寨",
    "spell": "lishizhai",
    "spellShort": "lsz",
    "code": "LET"
  },
  {
    "name": "梨树镇",
    "spell": "lishuzhen",
    "spellShort": "lsz",
    "code": "LSB"
  },
  {
    "name": "轮台",
    "spell": "luntai",
    "spellShort": "lta",
    "code": "LAR"
  },
  {
    "name": "龙塘坝",
    "spell": "longtangba",
    "spellShort": "ltb",
    "code": "LBM"
  },
  {
    "name": "濑湍",
    "spell": "laituan",
    "spellShort": "ltu",
    "code": "LVZ"
  },
  {
    "name": "龙塘镇",
    "spell": "longtangzhen",
    "spellShort": "ltz",
    "code": "LVB"
  },
  {
    "name": "李旺",
    "spell": "liwang",
    "spellShort": "lwa",
    "code": "VLJ"
  },
  {
    "name": "狼尾山",
    "spell": "langweishan",
    "spellShort": "lws",
    "code": "LRJ"
  },
  {
    "name": "灵武",
    "spell": "lingwu",
    "spellShort": "lwu",
    "code": "LNJ"
  },
  {
    "name": "莱芜西",
    "spell": "laiwuxi",
    "spellShort": "lwx",
    "code": "UXK"
  },
  {
    "name": "岚县",
    "spell": "lanxian",
    "spellShort": "lxi",
    "code": "UXV"
  },
  {
    "name": "朗县",
    "spell": "langxian",
    "spellShort": "lxi",
    "code": "LIO"
  },
  {
    "name": "芦溪",
    "spell": "luxi",
    "spellShort": "lxi",
    "code": "LUG"
  },
  {
    "name": "临湘",
    "spell": "linxiang",
    "spellShort": "lxi",
    "code": "LXQ"
  },
  {
    "name": "滦县",
    "spell": "luanxian",
    "spellShort": "lxi",
    "code": "UXP"
  },
  {
    "name": "林西",
    "spell": "linxi",
    "spellShort": "lxi",
    "code": "LXC"
  },
  {
    "name": "朗乡",
    "spell": "langxiang",
    "spellShort": "lxi",
    "code": "LXB"
  },
  {
    "name": "郎溪南",
    "spell": "langxinan",
    "spellShort": "lxn",
    "code": "LXU"
  },
  {
    "name": "莱西南",
    "spell": "laixinan",
    "spellShort": "lxn",
    "code": "LXK"
  },
  {
    "name": "莱阳",
    "spell": "laiyang",
    "spellShort": "lya",
    "code": "LYK"
  },
  {
    "name": "凌源东",
    "spell": "lingyuandong",
    "spellShort": "lyd",
    "code": "LDD"
  },
  {
    "name": "临沂东",
    "spell": "linyidong",
    "spellShort": "lyd",
    "code": "UYK"
  },
  {
    "name": "临邑",
    "spell": "linyi",
    "spellShort": "lyi",
    "code": "LUK"
  },
  {
    "name": "临颍",
    "spell": "linying",
    "spellShort": "lyi",
    "code": "LNF"
  },
  {
    "name": "莱阳南",
    "spell": "laiyangnan",
    "spellShort": "lyn",
    "code": "VEK"
  },
  {
    "name": "龙游南",
    "spell": "longyounan",
    "spellShort": "lyn",
    "code": "LYU"
  },
  {
    "name": "龙游",
    "spell": "longyou",
    "spellShort": "lyo",
    "code": "LMH"
  },
  {
    "name": "礼乐",
    "spell": "liyue",
    "spellShort": "lyu",
    "code": "UEQ"
  },
  {
    "name": "林源",
    "spell": "linyuan",
    "spellShort": "lyu",
    "code": "LYX"
  },
  {
    "name": "鹿寨北",
    "spell": "luzhaibei",
    "spellShort": "lzb",
    "code": "LSZ"
  },
  {
    "name": "临淄北",
    "spell": "linzibei",
    "spellShort": "lzb",
    "code": "UEK"
  },
  {
    "name": "临泽",
    "spell": "linze",
    "spellShort": "lze",
    "code": "LEJ"
  },
  {
    "name": "雷州",
    "spell": "leizhou",
    "spellShort": "lzh",
    "code": "UAQ"
  },
  {
    "name": "来舟",
    "spell": "laizhou",
    "spellShort": "lzh",
    "code": "LZS"
  },
  {
    "name": "鹿寨",
    "spell": "luzhai",
    "spellShort": "lzh",
    "code": "LIZ"
  },
  {
    "name": "拉鲊",
    "spell": "lazha",
    "spellShort": "lzh",
    "code": "LEM"
  },
  {
    "name": "六枝南",
    "spell": "liuzhinan",
    "spellShort": "lzn",
    "code": "LOE"
  },
  {
    "name": "临泽南",
    "spell": "linzenan",
    "spellShort": "lzn",
    "code": "LDJ"
  },
  {
    "name": "马鞍山",
    "spell": "maanshan",
    "spellShort": "mas",
    "code": "MAH"
  },
  {
    "name": "毛坝",
    "spell": "maoba",
    "spellShort": "mba",
    "code": "MBY"
  },
  {
    "name": "毛坝关",
    "spell": "maobaguan",
    "spellShort": "mbg",
    "code": "MGY"
  },
  {
    "name": "明城",
    "spell": "mingcheng",
    "spellShort": "mch",
    "code": "MCL"
  },
  {
    "name": "毛陈",
    "spell": "maochen",
    "spellShort": "mch",
    "code": "MHN"
  },
  {
    "name": "渑池",
    "spell": "mianchi",
    "spellShort": "mch",
    "code": "MCF"
  },
  {
    "name": "庙城",
    "spell": "miaocheng",
    "spellShort": "mch",
    "code": "MAP"
  },
  {
    "name": "茅草坪",
    "spell": "maocaoping",
    "spellShort": "mcp",
    "code": "KPM"
  },
  {
    "name": "猛洞河",
    "spell": "mengdonghe",
    "spellShort": "mdh",
    "code": "MUQ"
  },
  {
    "name": "磨刀石",
    "spell": "modaoshi",
    "spellShort": "mds",
    "code": "MOB"
  },
  {
    "name": "民丰",
    "spell": "minfeng",
    "spellShort": "mfe",
    "code": "MFR"
  },
  {
    "name": "明港",
    "spell": "minggang",
    "spellShort": "mga",
    "code": "MGN"
  },
  {
    "name": "明港东",
    "spell": "minggangdong",
    "spellShort": "mgd",
    "code": "MDN"
  },
  {
    "name": "马皇",
    "spell": "mahuang",
    "spellShort": "mhu",
    "code": "MHZ"
  },
  {
    "name": "墨江",
    "spell": "mojiang",
    "spellShort": "mji",
    "code": "MJM"
  },
  {
    "name": "闵集",
    "spell": "minji",
    "spellShort": "mji",
    "code": "MJN"
  },
  {
    "name": "马兰",
    "spell": "malan",
    "spellShort": "mla",
    "code": "MLR"
  },
  {
    "name": "汨罗东",
    "spell": "miluodong",
    "spellShort": "mld",
    "code": "MQQ"
  },
  {
    "name": "民乐",
    "spell": "minle",
    "spellShort": "mle",
    "code": "MBJ"
  },
  {
    "name": "马莲河",
    "spell": "malianhe",
    "spellShort": "mlh",
    "code": "MHB"
  },
  {
    "name": "茅岭",
    "spell": "maoling",
    "spellShort": "mli",
    "code": "MLZ"
  },
  {
    "name": "庙岭",
    "spell": "miaoling",
    "spellShort": "mli",
    "code": "MLL"
  },
  {
    "name": "米林",
    "spell": "milin",
    "spellShort": "mli",
    "code": "MIO"
  },
  {
    "name": "麻柳",
    "spell": "maliu",
    "spellShort": "mli",
    "code": "MLY"
  },
  {
    "name": "茂林",
    "spell": "maolin",
    "spellShort": "mli",
    "code": "MLD"
  },
  {
    "name": "马龙",
    "spell": "malong",
    "spellShort": "mlo",
    "code": "MGM"
  },
  {
    "name": "木里图",
    "spell": "mulitu",
    "spellShort": "mlt",
    "code": "MUD"
  },
  {
    "name": "汨罗",
    "spell": "miluo",
    "spellShort": "mlu",
    "code": "MLQ"
  },
  {
    "name": "玛纳斯湖",
    "spell": "manasihu",
    "spellShort": "mnh",
    "code": "MNR"
  },
  {
    "name": "牟平",
    "spell": "muping",
    "spellShort": "mpi",
    "code": "MBK"
  },
  {
    "name": "民权北",
    "spell": "minquanbei",
    "spellShort": "mqb",
    "code": "MIF"
  },
  {
    "name": "马桥河",
    "spell": "maqiaohe",
    "spellShort": "mqh",
    "code": "MQB"
  },
  {
    "name": "闽清",
    "spell": "minqing",
    "spellShort": "mqi",
    "code": "MQS"
  },
  {
    "name": "孟赛",
    "spell": "mengsai",
    "spellShort": "msa",
    "code": "VFM"
  },
  {
    "name": "眉山",
    "spell": "meishan",
    "spellShort": "msh",
    "code": "MSW"
  },
  {
    "name": "明水河",
    "spell": "mingshuihe",
    "spellShort": "msh",
    "code": "MUT"
  },
  {
    "name": "蒙山",
    "spell": "mengshan",
    "spellShort": "msh",
    "code": "MOK"
  },
  {
    "name": "麻山",
    "spell": "mashan",
    "spellShort": "msh",
    "code": "MAB"
  },
  {
    "name": "马山县",
    "spell": "mashanxian",
    "spellShort": "msx",
    "code": "MAZ"
  },
  {
    "name": "马踏",
    "spell": "mata",
    "spellShort": "mta",
    "code": "PWQ"
  },
  {
    "name": "眉县东",
    "spell": "meixiandong",
    "spellShort": "mxd",
    "code": "CXY"
  },
  {
    "name": "美溪",
    "spell": "meixi",
    "spellShort": "mxi",
    "code": "MEB"
  },
  {
    "name": "麻阳",
    "spell": "mayang",
    "spellShort": "mya",
    "code": "MVQ"
  },
  {
    "name": "米易东",
    "spell": "miyidong",
    "spellShort": "myd",
    "code": "MDE"
  },
  {
    "name": "麦园",
    "spell": "maiyuan",
    "spellShort": "myu",
    "code": "MYS"
  },
  {
    "name": "麻阳西",
    "spell": "mayangxi",
    "spellShort": "myx",
    "code": "MYA"
  },
  {
    "name": "庙庄",
    "spell": "miaozhuang",
    "spellShort": "mzh",
    "code": "MZJ"
  },
  {
    "name": "米脂",
    "spell": "mizhi",
    "spellShort": "mzh",
    "code": "MEY"
  },
  {
    "name": "明珠",
    "spell": "mingzhu",
    "spellShort": "mzh",
    "code": "MFQ"
  },
  {
    "name": "南博山",
    "spell": "nanboshan",
    "spellShort": "nbs",
    "code": "NBK"
  },
  {
    "name": "牛车河",
    "spell": "niuchehe",
    "spellShort": "nch",
    "code": "NHA"
  },
  {
    "name": "宁城",
    "spell": "ningcheng",
    "spellShort": "nch",
    "code": "NCD"
  },
  {
    "name": "南仇",
    "spell": "nanqiu",
    "spellShort": "nch",
    "code": "NCK"
  },
  {
    "name": "南城司",
    "spell": "nanchengsi",
    "spellShort": "ncs",
    "code": "NSP"
  },
  {
    "name": "宁都",
    "spell": "ningdu",
    "spellShort": "ndu",
    "code": "NIG"
  },
  {
    "name": "宁洱",
    "spell": "ninger",
    "spellShort": "ner",
    "code": "NEM"
  },
  {
    "name": "南芬北",
    "spell": "nanfenbei",
    "spellShort": "nfb",
    "code": "NUT"
  },
  {
    "name": "南观村",
    "spell": "nanguancun",
    "spellShort": "ngc",
    "code": "NGP"
  },
  {
    "name": "南宫东",
    "spell": "nangongdong",
    "spellShort": "ngd",
    "code": "NFP"
  },
  {
    "name": "宁国",
    "spell": "ningguo",
    "spellShort": "ngu",
    "code": "NNH"
  },
  {
    "name": "南河川",
    "spell": "nanhechuan",
    "spellShort": "nhc",
    "code": "NHJ"
  },
  {
    "name": "南华",
    "spell": "nanhua",
    "spellShort": "nhu",
    "code": "NAM"
  },
  {
    "name": "宁化",
    "spell": "ninghua",
    "spellShort": "nhu",
    "code": "NHS"
  },
  {
    "name": "内黄",
    "spell": "neihuang",
    "spellShort": "nhu",
    "code": "NUF"
  },
  {
    "name": "泥河子",
    "spell": "nihezi",
    "spellShort": "nhz",
    "code": "NHD"
  },
  {
    "name": "内江东",
    "spell": "neijiangdong",
    "spellShort": "njd",
    "code": "NDE"
  },
  {
    "name": "宁家",
    "spell": "ningjia",
    "spellShort": "nji",
    "code": "NVT"
  },
  {
    "name": "能家",
    "spell": "nengjia",
    "spellShort": "nji",
    "code": "NJD"
  },
  {
    "name": "南靖",
    "spell": "nanjing",
    "spellShort": "nji",
    "code": "NJS"
  },
  {
    "name": "南江口",
    "spell": "nanjiangkou",
    "spellShort": "njk",
    "code": "NDQ"
  },
  {
    "name": "南口前",
    "spell": "nankouqian",
    "spellShort": "nkq",
    "code": "NKT"
  },
  {
    "name": "南朗",
    "spell": "nanlang",
    "spellShort": "nla",
    "code": "NNQ"
  },
  {
    "name": "南乐",
    "spell": "nanle",
    "spellShort": "nle",
    "code": "NWF"
  },
  {
    "name": "奈林皋",
    "spell": "nailingao",
    "spellShort": "nlg",
    "code": "NGT"
  },
  {
    "name": "乃林",
    "spell": "nailin",
    "spellShort": "nli",
    "code": "NLD"
  },
  {
    "name": "南陵",
    "spell": "nanling",
    "spellShort": "nli",
    "code": "LLH"
  },
  {
    "name": "尼勒克",
    "spell": "nileke",
    "spellShort": "nlk",
    "code": "NIR"
  },
  {
    "name": "宁明",
    "spell": "ningming",
    "spellShort": "nmi",
    "code": "NMZ"
  },
  {
    "name": "南木",
    "spell": "nanmu",
    "spellShort": "nmu",
    "code": "NMX"
  },
  {
    "name": "南堡北",
    "spell": "nanpubei",
    "spellShort": "npb",
    "code": "TLP"
  },
  {
    "name": "南桥",
    "spell": "nanqiao",
    "spellShort": "nqi",
    "code": "NQD"
  },
  {
    "name": "南头",
    "spell": "nantou",
    "spellShort": "nto",
    "code": "NOQ"
  },
  {
    "name": "南屯",
    "spell": "nantun",
    "spellShort": "ntu",
    "code": "NTR"
  },
  {
    "name": "乃托",
    "spell": "naituo",
    "spellShort": "ntu",
    "code": "YHW"
  },
  {
    "name": "南湾子",
    "spell": "nanwanzi",
    "spellShort": "nwz",
    "code": "NWP"
  },
  {
    "name": "泥溪",
    "spell": "nixi",
    "spellShort": "nxi",
    "code": "NIE"
  },
  {
    "name": "宁县",
    "spell": "ningxian",
    "spellShort": "nxi",
    "code": "AXJ"
  },
  {
    "name": "内乡",
    "spell": "neixiang",
    "spellShort": "nxi",
    "code": "NXF"
  },
  {
    "name": "宁乡西",
    "spell": "ningxiangxi",
    "spellShort": "nxx",
    "code": "NXA"
  },
  {
    "name": "娘子关",
    "spell": "niangziguan",
    "spellShort": "nzg",
    "code": "NIP"
  },
  {
    "name": "南漳",
    "spell": "nanzhang",
    "spellShort": "nzh",
    "code": "NZN"
  },
  {
    "name": "南召",
    "spell": "nanzhao",
    "spellShort": "nzh",
    "code": "NAF"
  },
  {
    "name": "南杂木",
    "spell": "nanzamu",
    "spellShort": "nzm",
    "code": "NZT"
  },
  {
    "name": "蓬安",
    "spell": "pengan",
    "spellShort": "pan",
    "code": "PAW"
  },
  {
    "name": "平安",
    "spell": "pingan",
    "spellShort": "pan",
    "code": "PAL"
  },
  {
    "name": "磐安南",
    "spell": "panannan",
    "spellShort": "pan",
    "code": "PNU"
  },
  {
    "name": "普安县",
    "spell": "puanxian",
    "spellShort": "pax",
    "code": "PUE"
  },
  {
    "name": "平安驿",
    "spell": "pinganyi",
    "spellShort": "pay",
    "code": "PNO"
  },
  {
    "name": "平安镇",
    "spell": "pinganzhen",
    "spellShort": "paz",
    "code": "PZT"
  },
  {
    "name": "磐安镇",
    "spell": "pananzhen",
    "spellShort": "paz",
    "code": "PAJ"
  },
  {
    "name": "屏边",
    "spell": "pingbian",
    "spellShort": "pbi",
    "code": "PBM"
  },
  {
    "name": "平坝南",
    "spell": "pingbanan",
    "spellShort": "pbn",
    "code": "PBE"
  },
  {
    "name": "蒲城",
    "spell": "pucheng",
    "spellShort": "pch",
    "code": "PCY"
  },
  {
    "name": "裴德",
    "spell": "peide",
    "spellShort": "pde",
    "code": "PDB"
  },
  {
    "name": "普定",
    "spell": "puding",
    "spellShort": "pdi",
    "code": "PGW"
  },
  {
    "name": "偏店",
    "spell": "piandian",
    "spellShort": "pdi",
    "code": "PRP"
  },
  {
    "name": "平岗",
    "spell": "pinggang",
    "spellShort": "pga",
    "code": "PGL"
  },
  {
    "name": "平果",
    "spell": "pingguo",
    "spellShort": "pgu",
    "code": "PGZ"
  },
  {
    "name": "平关",
    "spell": "pingguan",
    "spellShort": "pgu",
    "code": "PGM"
  },
  {
    "name": "盘关",
    "spell": "panguan",
    "spellShort": "pgu",
    "code": "PAM"
  },
  {
    "name": "徘徊北",
    "spell": "paihuaibei",
    "spellShort": "phb",
    "code": "PHP"
  },
  {
    "name": "平河口",
    "spell": "pinghekou",
    "spellShort": "phk",
    "code": "PHM"
  },
  {
    "name": "平湖",
    "spell": "pinghu",
    "spellShort": "phu",
    "code": "PHQ"
  },
  {
    "name": "潘家店",
    "spell": "panjiadian",
    "spellShort": "pjd",
    "code": "PDP"
  },
  {
    "name": "皮口南",
    "spell": "pikounan",
    "spellShort": "pkn",
    "code": "PKT"
  },
  {
    "name": "皮口",
    "spell": "pikou",
    "spellShort": "pko",
    "code": "PUT"
  },
  {
    "name": "屏南",
    "spell": "pingnan",
    "spellShort": "pna",
    "code": "PNS"
  },
  {
    "name": "平南南",
    "spell": "pingnannan",
    "spellShort": "pnn",
    "code": "PAZ"
  },
  {
    "name": "朋普",
    "spell": "pengpu",
    "spellShort": "ppu",
    "code": "PRM"
  },
  {
    "name": "彭山北",
    "spell": "pengshanbei",
    "spellShort": "psb",
    "code": "PPW"
  },
  {
    "name": "蒲石",
    "spell": "pushi",
    "spellShort": "psh",
    "code": "PSY"
  },
  {
    "name": "彭山",
    "spell": "pengshan",
    "spellShort": "psh",
    "code": "PSW"
  },
  {
    "name": "彭水",
    "spell": "pengshui",
    "spellShort": "psh",
    "code": "PHW"
  },
  {
    "name": "屏山",
    "spell": "pingshan",
    "spellShort": "psh",
    "code": "PSE"
  },
  {
    "name": "平社",
    "spell": "pingshe",
    "spellShort": "psh",
    "code": "PSV"
  },
  {
    "name": "盘山",
    "spell": "panshan",
    "spellShort": "psh",
    "code": "PUD"
  },
  {
    "name": "坪上",
    "spell": "pingshang",
    "spellShort": "psh",
    "code": "PSK"
  },
  {
    "name": "平台",
    "spell": "pingtai",
    "spellShort": "pta",
    "code": "PVT"
  },
  {
    "name": "平田",
    "spell": "pingtian",
    "spellShort": "pti",
    "code": "PTM"
  },
  {
    "name": "葡萄菁",
    "spell": "putaojing",
    "spellShort": "ptq",
    "code": "PTW"
  },
  {
    "name": "平旺",
    "spell": "pingwang",
    "spellShort": "pwa",
    "code": "PWV"
  },
  {
    "name": "平型关",
    "spell": "pingxingguan",
    "spellShort": "pxg",
    "code": "PGV"
  },
  {
    "name": "蓬溪",
    "spell": "pengxi",
    "spellShort": "pxi",
    "code": "KZW"
  },
  {
    "name": "平遥",
    "spell": "pingyao",
    "spellShort": "pya",
    "code": "PYV"
  },
  {
    "name": "彭阳",
    "spell": "pengyang",
    "spellShort": "pya",
    "code": "PYJ"
  },
  {
    "name": "鄱阳",
    "spell": "poyang",
    "spellShort": "pya",
    "code": "POG"
  },
  {
    "name": "平洋",
    "spell": "pingyang",
    "spellShort": "pya",
    "code": "PYX"
  },
  {
    "name": "鄱阳北",
    "spell": "poyangbei",
    "spellShort": "pyb",
    "code": "PYG"
  },
  {
    "name": "平邑",
    "spell": "pingyi",
    "spellShort": "pyi",
    "code": "PIK"
  },
  {
    "name": "平原堡",
    "spell": "pingyuanpu",
    "spellShort": "pyp",
    "code": "PPJ"
  },
  {
    "name": "平原",
    "spell": "pingyuan",
    "spellShort": "pyu",
    "code": "PYK"
  },
  {
    "name": "平峪",
    "spell": "pingyu",
    "spellShort": "pyu",
    "code": "PYP"
  },
  {
    "name": "平庄北",
    "spell": "pingzhuangbei",
    "spellShort": "pzb",
    "code": "PZD"
  },
  {
    "name": "邳州东",
    "spell": "pizhoudong",
    "spellShort": "pzd",
    "code": "PIU"
  },
  {
    "name": "平庄",
    "spell": "pingzhuang",
    "spellShort": "pzh",
    "code": "PAD"
  },
  {
    "name": "邳州",
    "spell": "pizhou",
    "spellShort": "pzh",
    "code": "PJH"
  },
  {
    "name": "泡子",
    "spell": "paozi",
    "spellShort": "pzi",
    "code": "POD"
  },
  {
    "name": "平庄南",
    "spell": "pingzhuangnan",
    "spellShort": "pzn",
    "code": "PND"
  },
  {
    "name": "乾安",
    "spell": "qianan",
    "spellShort": "qan",
    "code": "QOT"
  },
  {
    "name": "迁安",
    "spell": "qianan",
    "spellShort": "qan",
    "code": "QQP"
  },
  {
    "name": "秦安",
    "spell": "qinan",
    "spellShort": "qan",
    "code": "QGJ"
  },
  {
    "name": "庆城",
    "spell": "qingcheng",
    "spellShort": "qch",
    "code": "QHJ"
  },
  {
    "name": "蕲春南",
    "spell": "qichunnan",
    "spellShort": "qcn",
    "code": "QCN"
  },
  {
    "name": "祁东北",
    "spell": "qidongbei",
    "spellShort": "qdb",
    "code": "QRQ"
  },
  {
    "name": "青岛机场",
    "spell": "qingdaojichang",
    "spellShort": "qdc",
    "code": "QJK"
  },
  {
    "name": "祁东",
    "spell": "qidong",
    "spellShort": "qdo",
    "code": "QMQ"
  },
  {
    "name": "青堆",
    "spell": "qingdui",
    "spellShort": "qdu",
    "code": "QET"
  },
  {
    "name": "曲阜南",
    "spell": "qufunan",
    "spellShort": "qfn",
    "code": "QQK"
  },
  {
    "name": "奇峰塔",
    "spell": "qifengta",
    "spellShort": "qft",
    "code": "QVP"
  },
  {
    "name": "泉港",
    "spell": "quangang",
    "spellShort": "qga",
    "code": "QGS"
  },
  {
    "name": "清河门北",
    "spell": "qinghemenbei",
    "spellShort": "qhb",
    "code": "QBD"
  },
  {
    "name": "千河",
    "spell": "qianhe",
    "spellShort": "qhe",
    "code": "QUY"
  },
  {
    "name": "齐河",
    "spell": "qihe",
    "spellShort": "qhe",
    "code": "QIK"
  },
  {
    "name": "清河门",
    "spell": "qinghemen",
    "spellShort": "qhm",
    "code": "QHD"
  },
  {
    "name": "渠旧",
    "spell": "qujiu",
    "spellShort": "qji",
    "code": "QJZ"
  },
  {
    "name": "潜江",
    "spell": "qianjiang",
    "spellShort": "qji",
    "code": "QJN"
  },
  {
    "name": "曲江",
    "spell": "qujiang",
    "spellShort": "qji",
    "code": "QIM"
  },
  {
    "name": "全椒",
    "spell": "quanjiao",
    "spellShort": "qji",
    "code": "INH"
  },
  {
    "name": "秦家",
    "spell": "qinjia",
    "spellShort": "qji",
    "code": "QJB"
  },
  {
    "name": "祁家堡",
    "spell": "qijiapu",
    "spellShort": "qjp",
    "code": "QBT"
  },
  {
    "name": "清涧县",
    "spell": "qingjianxian",
    "spellShort": "qjx",
    "code": "QNY"
  },
  {
    "name": "秦家庄",
    "spell": "qinjiazhuang",
    "spellShort": "qjz",
    "code": "QZV"
  },
  {
    "name": "七里河",
    "spell": "qilihe",
    "spellShort": "qlh",
    "code": "QLD"
  },
  {
    "name": "渠黎",
    "spell": "quli",
    "spellShort": "qli",
    "code": "QLZ"
  },
  {
    "name": "秦岭",
    "spell": "qinling",
    "spellShort": "qli",
    "code": "QLY"
  },
  {
    "name": "青莲",
    "spell": "qinglian",
    "spellShort": "qli",
    "code": "QEW"
  },
  {
    "name": "青龙",
    "spell": "qinglong",
    "spellShort": "qlo",
    "code": "QIB"
  },
  {
    "name": "青龙山",
    "spell": "qinglongshan",
    "spellShort": "qls",
    "code": "QGH"
  },
  {
    "name": "祁门",
    "spell": "qimen",
    "spellShort": "qme",
    "code": "QIH"
  },
  {
    "name": "祁门南",
    "spell": "qimennan",
    "spellShort": "qmn",
    "code": "QNU"
  },
  {
    "name": "且末",
    "spell": "qiemo",
    "spellShort": "qmo",
    "code": "QMR"
  },
  {
    "name": "前磨头",
    "spell": "qianmotou",
    "spellShort": "qmt",
    "code": "QMP"
  },
  {
    "name": "清水北",
    "spell": "qingshuibei",
    "spellShort": "qsb",
    "code": "QEJ"
  },
  {
    "name": "青神",
    "spell": "qingshen",
    "spellShort": "qsh",
    "code": "QVW"
  },
  {
    "name": "岐山",
    "spell": "qishan",
    "spellShort": "qsh",
    "code": "QAY"
  },
  {
    "name": "前山",
    "spell": "qianshan",
    "spellShort": "qsh",
    "code": "QXQ"
  },
  {
    "name": "确山",
    "spell": "queshan",
    "spellShort": "qsh",
    "code": "QSN"
  },
  {
    "name": "清水",
    "spell": "qingshui",
    "spellShort": "qsh",
    "code": "QUJ"
  },
  {
    "name": "青山",
    "spell": "qingshan",
    "spellShort": "qsh",
    "code": "QSB"
  },
  {
    "name": "清水县",
    "spell": "qingshuixian",
    "spellShort": "qsx",
    "code": "QIJ"
  },
  {
    "name": "戚墅堰",
    "spell": "qishuyan",
    "spellShort": "qsy",
    "code": "QYH"
  },
  {
    "name": "青田",
    "spell": "qingtian",
    "spellShort": "qti",
    "code": "QVH"
  },
  {
    "name": "桥头",
    "spell": "qiaotou",
    "spellShort": "qto",
    "code": "QAT"
  },
  {
    "name": "犍为",
    "spell": "qianwei",
    "spellShort": "qwe",
    "code": "JWE"
  },
  {
    "name": "前卫",
    "spell": "qianwei",
    "spellShort": "qwe",
    "code": "QWD"
  },
  {
    "name": "前苇塘",
    "spell": "qianweitang",
    "spellShort": "qwt",
    "code": "QWP"
  },
  {
    "name": "祁县东",
    "spell": "qixiandong",
    "spellShort": "qxd",
    "code": "QGV"
  },
  {
    "name": "黔西",
    "spell": "qianxi",
    "spellShort": "qxi",
    "code": "QXE"
  },
  {
    "name": "祁县",
    "spell": "qixian",
    "spellShort": "qxi",
    "code": "QXV"
  },
  {
    "name": "乾县",
    "spell": "qianxian",
    "spellShort": "qxi",
    "code": "QBY"
  },
  {
    "name": "青县",
    "spell": "qingxian",
    "spellShort": "qxi",
    "code": "QXP"
  },
  {
    "name": "桥西",
    "spell": "qiaoxi",
    "spellShort": "qxi",
    "code": "QXJ"
  },
  {
    "name": "旗下营南",
    "spell": "qixiayingnan",
    "spellShort": "qxn",
    "code": "QNC"
  },
  {
    "name": "旗下营",
    "spell": "qixiaying",
    "spellShort": "qxy",
    "code": "QXC"
  },
  {
    "name": "泉阳",
    "spell": "quanyang",
    "spellShort": "qya",
    "code": "QYL"
  },
  {
    "name": "千阳",
    "spell": "qianyang",
    "spellShort": "qya",
    "code": "QOY"
  },
  {
    "name": "祁阳",
    "spell": "qiyang",
    "spellShort": "qya",
    "code": "QWQ"
  },
  {
    "name": "沁阳",
    "spell": "qinyang",
    "spellShort": "qya",
    "code": "QYF"
  },
  {
    "name": "祁阳北",
    "spell": "qiyangbei",
    "spellShort": "qyb",
    "code": "QVQ"
  },
  {
    "name": "七营",
    "spell": "qiying",
    "spellShort": "qyi",
    "code": "QYJ"
  },
  {
    "name": "庆阳山",
    "spell": "qingyangshan",
    "spellShort": "qys",
    "code": "QSJ"
  },
  {
    "name": "清原",
    "spell": "qingyuan",
    "spellShort": "qyu",
    "code": "QYT"
  },
  {
    "name": "青州市北",
    "spell": "qingzhoushibei",
    "spellShort": "qzb",
    "code": "QOK"
  },
  {
    "name": "泉州东",
    "spell": "quanzhoudong",
    "spellShort": "qzd",
    "code": "QRS"
  },
  {
    "name": "钦州",
    "spell": "qinzhou",
    "spellShort": "qzh",
    "code": "QRZ"
  },
  {
    "name": "曲子",
    "spell": "quzi",
    "spellShort": "qzi",
    "code": "QJJ"
  },
  {
    "name": "泉州南",
    "spell": "quanzhounan",
    "spellShort": "qzn",
    "code": "QNS"
  },
  {
    "name": "青州市",
    "spell": "qingzhoushi",
    "spellShort": "qzs",
    "code": "QZK"
  },
  {
    "name": "棋子湾",
    "spell": "qiziwan",
    "spellShort": "qzw",
    "code": "QZQ"
  },
  {
    "name": "仁布",
    "spell": "renbu",
    "spellShort": "rbu",
    "code": "RUO"
  },
  {
    "name": "瑞昌",
    "spell": "ruichang",
    "spellShort": "rch",
    "code": "RCG"
  },
  {
    "name": "瑞昌西",
    "spell": "ruichangxi",
    "spellShort": "rcx",
    "code": "RXG"
  },
  {
    "name": "如皋",
    "spell": "rugao",
    "spellShort": "rga",
    "code": "RBH"
  },
  {
    "name": "如皋南",
    "spell": "rugaonan",
    "spellShort": "rgn",
    "code": "RNU"
  },
  {
    "name": "容桂",
    "spell": "ronggui",
    "spellShort": "rgu",
    "code": "RUQ"
  },
  {
    "name": "榕江",
    "spell": "rongjiang",
    "spellShort": "rji",
    "code": "RVW"
  },
  {
    "name": "任丘",
    "spell": "renqiu",
    "spellShort": "rqi",
    "code": "RQP"
  },
  {
    "name": "融水",
    "spell": "rongshui",
    "spellShort": "rsh",
    "code": "RSZ"
  },
  {
    "name": "乳山",
    "spell": "rushan",
    "spellShort": "rsh",
    "code": "ROK"
  },
  {
    "name": "容县",
    "spell": "rongxian",
    "spellShort": "rxi",
    "code": "RXZ"
  },
  {
    "name": "饶阳",
    "spell": "raoyang",
    "spellShort": "rya",
    "code": "RVP"
  },
  {
    "name": "汝阳",
    "spell": "ruyang",
    "spellShort": "rya",
    "code": "RYF"
  },
  {
    "name": "绕阳河",
    "spell": "raoyanghe",
    "spellShort": "ryh",
    "code": "RHD"
  },
  {
    "name": "汝州",
    "spell": "ruzhou",
    "spellShort": "rzh",
    "code": "ROF"
  },
  {
    "name": "石坝",
    "spell": "shiba",
    "spellShort": "sba",
    "code": "OBJ"
  },
  {
    "name": "上板城",
    "spell": "shangbancheng",
    "spellShort": "sbc",
    "code": "SBP"
  },
  {
    "name": "施秉",
    "spell": "shibing",
    "spellShort": "sbi",
    "code": "AQW"
  },
  {
    "name": "上板城南",
    "spell": "shangbanchengnan",
    "spellShort": "sbn",
    "code": "OBP"
  },
  {
    "name": "石城东",
    "spell": "shichengdong",
    "spellShort": "scd",
    "code": "SDG"
  },
  {
    "name": "商城",
    "spell": "shangcheng",
    "spellShort": "sch",
    "code": "SWN"
  },
  {
    "name": "舒城",
    "spell": "shucheng",
    "spellShort": "sch",
    "code": "OCH"
  },
  {
    "name": "遂昌",
    "spell": "suichang",
    "spellShort": "sch",
    "code": "SCU"
  },
  {
    "name": "顺昌",
    "spell": "shunchang",
    "spellShort": "sch",
    "code": "SCS"
  },
  {
    "name": "神池",
    "spell": "shenchi",
    "spellShort": "sch",
    "code": "SMV"
  },
  {
    "name": "石城",
    "spell": "shicheng",
    "spellShort": "sch",
    "code": "SCT"
  },
  {
    "name": "山城镇",
    "spell": "shanchengzhen",
    "spellShort": "scz",
    "code": "SCL"
  },
  {
    "name": "山丹",
    "spell": "shandan",
    "spellShort": "sda",
    "code": "SDJ"
  },
  {
    "name": "山丹马场",
    "spell": "shandanmachang",
    "spellShort": "sdc",
    "code": "JEJ"
  },
  {
    "name": "绥德",
    "spell": "suide",
    "spellShort": "sde",
    "code": "ODY"
  },
  {
    "name": "顺德",
    "spell": "shunde",
    "spellShort": "sde",
    "code": "ORQ"
  },
  {
    "name": "商都",
    "spell": "shangdu",
    "spellShort": "sdu",
    "code": "SXC"
  },
  {
    "name": "四道湾",
    "spell": "sidaowan",
    "spellShort": "sdw",
    "code": "OUD"
  },
  {
    "name": "三都县",
    "spell": "sanduxian",
    "spellShort": "sdx",
    "code": "KKW"
  },
  {
    "name": "顺德学院",
    "spell": "shundexueyuan",
    "spellShort": "sdy",
    "code": "OJQ"
  },
  {
    "name": "胜芳",
    "spell": "shengfang",
    "spellShort": "sfa",
    "code": "SUP"
  },
  {
    "name": "四方台",
    "spell": "sifangtai",
    "spellShort": "sft",
    "code": "STB"
  },
  {
    "name": "水富",
    "spell": "shuifu",
    "spellShort": "sfu",
    "code": "OTW"
  },
  {
    "name": "三关口",
    "spell": "sanguankou",
    "spellShort": "sgk",
    "code": "OKJ"
  },
  {
    "name": "桑根达来",
    "spell": "sanggendalai",
    "spellShort": "sgl",
    "code": "OGC"
  },
  {
    "name": "上高镇",
    "spell": "shanggaozhen",
    "spellShort": "sgz",
    "code": "SVK"
  },
  {
    "name": "上杭",
    "spell": "shanghang",
    "spellShort": "sha",
    "code": "SNS"
  },
  {
    "name": "蜀河",
    "spell": "shuhe",
    "spellShort": "she",
    "code": "SHY"
  },
  {
    "name": "松河",
    "spell": "songhe",
    "spellShort": "she",
    "code": "SBM"
  },
  {
    "name": "沙河口",
    "spell": "shahekou",
    "spellShort": "shk",
    "code": "SKT"
  },
  {
    "name": "赛汗塔拉",
    "spell": "saihantala",
    "spellShort": "shl",
    "code": "SHC"
  },
  {
    "name": "泗洪",
    "spell": "sihong",
    "spellShort": "sho",
    "code": "GQH"
  },
  {
    "name": "双河市",
    "spell": "shuangheshi",
    "spellShort": "shs",
    "code": "OHR"
  },
  {
    "name": "四会",
    "spell": "sihui",
    "spellShort": "shu",
    "code": "AHQ"
  },
  {
    "name": "三河县",
    "spell": "sanhexian",
    "spellShort": "shx",
    "code": "OXP"
  },
  {
    "name": "四合永",
    "spell": "siheyong",
    "spellShort": "shy",
    "code": "OHD"
  },
  {
    "name": "双河镇",
    "spell": "shuanghezhen",
    "spellShort": "shz",
    "code": "SEL"
  },
  {
    "name": "三合庄",
    "spell": "sanhezhuang",
    "spellShort": "shz",
    "code": "SVP"
  },
  {
    "name": "畲江北",
    "spell": "shejiangbei",
    "spellShort": "sjb",
    "code": "SOA"
  },
  {
    "name": "沈家河",
    "spell": "shenjiahe",
    "spellShort": "sjh",
    "code": "OJJ"
  },
  {
    "name": "双吉",
    "spell": "shuangji",
    "spellShort": "sji",
    "code": "SML"
  },
  {
    "name": "尚家",
    "spell": "shangjia",
    "spellShort": "sji",
    "code": "SJB"
  },
  {
    "name": "三江口",
    "spell": "sanjiangkou",
    "spellShort": "sjk",
    "code": "SKD"
  },
  {
    "name": "司家岭",
    "spell": "sijialing",
    "spellShort": "sjl",
    "code": "OLK"
  },
  {
    "name": "沙井西",
    "spell": "shajingxi",
    "spellShort": "sjx",
    "code": "SJA"
  },
  {
    "name": "松江镇",
    "spell": "songjiangzhen",
    "spellShort": "sjz",
    "code": "OZL"
  },
  {
    "name": "三井子",
    "spell": "sanjingzi",
    "spellShort": "sjz",
    "code": "OJT"
  },
  {
    "name": "十家子",
    "spell": "shijiazi",
    "spellShort": "sjz",
    "code": "SJD"
  },
  {
    "name": "三家寨",
    "spell": "sanjiazhai",
    "spellShort": "sjz",
    "code": "SMM"
  },
  {
    "name": "什里店",
    "spell": "shilidian",
    "spellShort": "sld",
    "code": "OMP"
  },
  {
    "name": "疏勒",
    "spell": "shule",
    "spellShort": "sle",
    "code": "SUR"
  },
  {
    "name": "舍力虎",
    "spell": "shelihu",
    "spellShort": "slh",
    "code": "VLD"
  },
  {
    "name": "疏勒河",
    "spell": "shulehe",
    "spellShort": "slh",
    "code": "SHJ"
  },
  {
    "name": "双辽",
    "spell": "shuangliao",
    "spellShort": "sli",
    "code": "ZJD"
  },
  {
    "name": "石岭",
    "spell": "shiling",
    "spellShort": "sli",
    "code": "SOL"
  },
  {
    "name": "石磷",
    "spell": "shilin",
    "spellShort": "sli",
    "code": "SPB"
  },
  {
    "name": "石龙",
    "spell": "shilong",
    "spellShort": "slo",
    "code": "SLQ"
  },
  {
    "name": "萨拉齐",
    "spell": "salaqi",
    "spellShort": "slq",
    "code": "SLC"
  },
  {
    "name": "索伦",
    "spell": "suolun",
    "spellShort": "slu",
    "code": "SNT"
  },
  {
    "name": "沙岭子",
    "spell": "shalingzi",
    "spellShort": "slz",
    "code": "SLP"
  },
  {
    "name": "石门县",
    "spell": "shimenxian",
    "spellShort": "smx",
    "code": "OMQ"
  },
  {
    "name": "神木西",
    "spell": "shenmuxi",
    "spellShort": "smx",
    "code": "OUY"
  },
  {
    "name": "山南",
    "spell": "shannan",
    "spellShort": "sna",
    "code": "SAO"
  },
  {
    "name": "肃宁",
    "spell": "suning",
    "spellShort": "sni",
    "code": "SYP"
  },
  {
    "name": "神农架",
    "spell": "shennongjia",
    "spellShort": "snj",
    "code": "SMN"
  },
  {
    "name": "苏尼特左旗",
    "spell": "sunitezuoqi",
    "spellShort": "snq",
    "code": "ONC"
  },
  {
    "name": "双牌",
    "spell": "shuangpai",
    "spellShort": "spa",
    "code": "SBZ"
  },
  {
    "name": "遂平",
    "spell": "suiping",
    "spellShort": "spi",
    "code": "SON"
  },
  {
    "name": "沙坡头",
    "spell": "shapotou",
    "spellShort": "spt",
    "code": "SFJ"
  },
  {
    "name": "商丘东",
    "spell": "shangqiudong",
    "spellShort": "sqd",
    "code": "SIF"
  },
  {
    "name": "石桥",
    "spell": "shiqiao",
    "spellShort": "sqi",
    "code": "SQE"
  },
  {
    "name": "沈丘",
    "spell": "shenqiu",
    "spellShort": "sqi",
    "code": "SQN"
  },
  {
    "name": "商丘南",
    "spell": "shangqiunan",
    "spellShort": "sqn",
    "code": "SPF"
  },
  {
    "name": "水泉",
    "spell": "shuiquan",
    "spellShort": "squ",
    "code": "SID"
  },
  {
    "name": "桑日",
    "spell": "sangri",
    "spellShort": "sri",
    "code": "SRO"
  },
  {
    "name": "狮山北",
    "spell": "shishanbei",
    "spellShort": "ssb",
    "code": "NSQ"
  },
  {
    "name": "三水北",
    "spell": "sanshuibei",
    "spellShort": "ssb",
    "code": "ARQ"
  },
  {
    "name": "松山湖北",
    "spell": "songshanhubei",
    "spellShort": "ssb",
    "code": "KUQ"
  },
  {
    "name": "鄯善",
    "spell": "shanshan",
    "spellShort": "ssh",
    "code": "SSR"
  },
  {
    "name": "狮山",
    "spell": "shishan",
    "spellShort": "ssh",
    "code": "KSQ"
  },
  {
    "name": "松树",
    "spell": "songshu",
    "spellShort": "ssh",
    "code": "SFT"
  },
  {
    "name": "三水",
    "spell": "sanshui",
    "spellShort": "ssh",
    "code": "SJQ"
  },
  {
    "name": "泗水",
    "spell": "sishui",
    "spellShort": "ssh",
    "code": "OSK"
  },
  {
    "name": "山市",
    "spell": "shanshi",
    "spellShort": "ssh",
    "code": "SQB"
  },
  {
    "name": "三十家",
    "spell": "sanshijia",
    "spellShort": "ssj",
    "code": "SRD"
  },
  {
    "name": "三水南",
    "spell": "sanshuinan",
    "spellShort": "ssn",
    "code": "RNQ"
  },
  {
    "name": "泗水南",
    "spell": "sishuinan",
    "spellShort": "ssn",
    "code": "ONK"
  },
  {
    "name": "松树镇",
    "spell": "songshuzhen",
    "spellShort": "ssz",
    "code": "SSL"
  },
  {
    "name": "双水镇",
    "spell": "shuangshuizhen",
    "spellShort": "ssz",
    "code": "PQQ"
  },
  {
    "name": "索图罕",
    "spell": "suotuhan",
    "spellShort": "sth",
    "code": "SHX"
  },
  {
    "name": "石梯",
    "spell": "shiti",
    "spellShort": "sti",
    "code": "STE"
  },
  {
    "name": "三堂集",
    "spell": "santangji",
    "spellShort": "stj",
    "code": "SDH"
  },
  {
    "name": "神头",
    "spell": "shentou",
    "spellShort": "sto",
    "code": "SEV"
  },
  {
    "name": "石头",
    "spell": "shitou",
    "spellShort": "sto",
    "code": "OTB"
  },
  {
    "name": "沙沱",
    "spell": "shatuo",
    "spellShort": "stu",
    "code": "SFM"
  },
  {
    "name": "上万",
    "spell": "shangwan",
    "spellShort": "swa",
    "code": "SWP"
  },
  {
    "name": "沙湾南",
    "spell": "shawannan",
    "spellShort": "swn",
    "code": "SWE"
  },
  {
    "name": "沙湾市",
    "spell": "shawanshi",
    "spellShort": "sws",
    "code": "SXR"
  },
  {
    "name": "孙吴",
    "spell": "sunwu",
    "spellShort": "swu",
    "code": "SKB"
  },
  {
    "name": "歙县北",
    "spell": "shexianbei",
    "spellShort": "sxb",
    "code": "NPH"
  },
  {
    "name": "遂溪",
    "spell": "suixi",
    "spellShort": "sxi",
    "code": "SXZ"
  },
  {
    "name": "石岘",
    "spell": "shixian",
    "spellShort": "sxi",
    "code": "SXL"
  },
  {
    "name": "寿县",
    "spell": "shouxian",
    "spellShort": "sxi",
    "code": "SOU"
  },
  {
    "name": "沙县",
    "spell": "shaxian",
    "spellShort": "sxi",
    "code": "SAS"
  },
  {
    "name": "始兴",
    "spell": "shixing",
    "spellShort": "sxi",
    "code": "IPQ"
  },
  {
    "name": "随县",
    "spell": "suixian",
    "spellShort": "sxi",
    "code": "OVN"
  },
  {
    "name": "歙县",
    "spell": "shexian",
    "spellShort": "sxi",
    "code": "OVH"
  },
  {
    "name": "泗县",
    "spell": "sixian",
    "spellShort": "sxi",
    "code": "GPH"
  },
  {
    "name": "水茜",
    "spell": "shuixi",
    "spellShort": "sxi",
    "code": "SSS"
  },
  {
    "name": "上西铺",
    "spell": "shangxipu",
    "spellShort": "sxp",
    "code": "SXM"
  },
  {
    "name": "石峡子",
    "spell": "shixiazi",
    "spellShort": "sxz",
    "code": "SXJ"
  },
  {
    "name": "寿阳",
    "spell": "shouyang",
    "spellShort": "sya",
    "code": "SYV"
  },
  {
    "name": "泗阳",
    "spell": "siyang",
    "spellShort": "sya",
    "code": "MPH"
  },
  {
    "name": "沭阳",
    "spell": "shuyang",
    "spellShort": "sya",
    "code": "FMH"
  },
  {
    "name": "松阳",
    "spell": "songyang",
    "spellShort": "sya",
    "code": "SUU"
  },
  {
    "name": "水洋",
    "spell": "shuiyang",
    "spellShort": "sya",
    "code": "OYP"
  },
  {
    "name": "三阳",
    "spell": "sanyang",
    "spellShort": "sya",
    "code": "SYU"
  },
  {
    "name": "射阳",
    "spell": "sheyang",
    "spellShort": "sya",
    "code": "SAU"
  },
  {
    "name": "双洋",
    "spell": "shuangyang",
    "spellShort": "sya",
    "code": "SQS"
  },
  {
    "name": "绥阳",
    "spell": "suiyang",
    "spellShort": "sya",
    "code": "SYB"
  },
  {
    "name": "松原北",
    "spell": "songyuanbei",
    "spellShort": "syb",
    "code": "OCT"
  },
  {
    "name": "邵阳北",
    "spell": "shaoyangbei",
    "spellShort": "syb",
    "code": "OVQ"
  },
  {
    "name": "三阳川",
    "spell": "sanyangchuan",
    "spellShort": "syc",
    "code": "SYJ"
  },
  {
    "name": "上腰墩",
    "spell": "shangyaodun",
    "spellShort": "syd",
    "code": "SPJ"
  },
  {
    "name": "三营",
    "spell": "sanying",
    "spellShort": "syi",
    "code": "OEJ"
  },
  {
    "name": "山阴",
    "spell": "shanyin",
    "spellShort": "syi",
    "code": "SNV"
  },
  {
    "name": "上虞南",
    "spell": "shangyunan",
    "spellShort": "syn",
    "code": "SVU"
  },
  {
    "name": "三源浦",
    "spell": "sanyuanpu",
    "spellShort": "syp",
    "code": "SYL"
  },
  {
    "name": "上园",
    "spell": "shangyuan",
    "spellShort": "syu",
    "code": "SUD"
  },
  {
    "name": "三原",
    "spell": "sanyuan",
    "spellShort": "syu",
    "code": "SAY"
  },
  {
    "name": "上虞",
    "spell": "shangyu",
    "spellShort": "syu",
    "code": "BDH"
  },
  {
    "name": "邵阳西",
    "spell": "shaoyangxi",
    "spellShort": "syx",
    "code": "SXA"
  },
  {
    "name": "绥中北",
    "spell": "suizhongbei",
    "spellShort": "szb",
    "code": "SND"
  },
  {
    "name": "深圳机场北",
    "spell": "shenzhenjichangbei",
    "spellShort": "szb",
    "code": "SBA"
  },
  {
    "name": "嵊州北",
    "spell": "shengzhoubei",
    "spellShort": "szb",
    "code": "SEU"
  },
  {
    "name": "三灶东",
    "spell": "sanzaodong",
    "spellShort": "szd",
    "code": "SAA"
  },
  {
    "name": "孙镇",
    "spell": "sunzhen",
    "spellShort": "szh",
    "code": "OZY"
  },
  {
    "name": "神州",
    "spell": "shenzhou",
    "spellShort": "szh",
    "code": "SRQ"
  },
  {
    "name": "桑植",
    "spell": "sangzhi",
    "spellShort": "szh",
    "code": "SZA"
  },
  {
    "name": "深州",
    "spell": "shenzhou",
    "spellShort": "szh",
    "code": "OZP"
  },
  {
    "name": "肃州",
    "spell": "suzhou",
    "spellShort": "szh",
    "code": "SRJ"
  },
  {
    "name": "松滋",
    "spell": "songzi",
    "spellShort": "szi",
    "code": "SIN"
  },
  {
    "name": "十字门",
    "spell": "shizimen",
    "spellShort": "szm",
    "code": "SIA"
  },
  {
    "name": "师宗",
    "spell": "shizong",
    "spellShort": "szo",
    "code": "SEM"
  },
  {
    "name": "苏州园区",
    "spell": "suzhouyuanqu",
    "spellShort": "szq",
    "code": "KAH"
  },
  {
    "name": "苏州新区",
    "spell": "suzhouxinqu",
    "spellShort": "szq",
    "code": "ITH"
  },
  {
    "name": "台安",
    "spell": "taian",
    "spellShort": "tan",
    "code": "TID"
  },
  {
    "name": "台安南",
    "spell": "taiannan",
    "spellShort": "tan",
    "code": "TAD"
  },
  {
    "name": "通安驿",
    "spell": "tonganyi",
    "spellShort": "tay",
    "code": "TAJ"
  },
  {
    "name": "桐柏",
    "spell": "tongbai",
    "spellShort": "tba",
    "code": "TBF"
  },
  {
    "name": "太仓",
    "spell": "taicang",
    "spellShort": "tca",
    "code": "TCU"
  },
  {
    "name": "桃村北",
    "spell": "taocunbei",
    "spellShort": "tcb",
    "code": "TOK"
  },
  {
    "name": "桐城东",
    "spell": "tongchengdong",
    "spellShort": "tcd",
    "code": "TOU"
  },
  {
    "name": "铁厂沟",
    "spell": "tiechanggou",
    "spellShort": "tcg",
    "code": "TJR"
  },
  {
    "name": "铁厂",
    "spell": "tiechang",
    "spellShort": "tch",
    "code": "TCL"
  },
  {
    "name": "郯城",
    "spell": "tancheng",
    "spellShort": "tch",
    "code": "TZK"
  },
  {
    "name": "桐城",
    "spell": "tongcheng",
    "spellShort": "tch",
    "code": "TTH"
  },
  {
    "name": "桐城南",
    "spell": "tongchengnan",
    "spellShort": "tcn",
    "code": "TUU"
  },
  {
    "name": "太仓南",
    "spell": "taicangnan",
    "spellShort": "tcn",
    "code": "TNU"
  },
  {
    "name": "铁刹山",
    "spell": "tiechashan",
    "spellShort": "tcs",
    "code": "PST"
  },
  {
    "name": "桃村",
    "spell": "taocun",
    "spellShort": "tcu",
    "code": "TCK"
  },
  {
    "name": "田东北",
    "spell": "tiandongbei",
    "spellShort": "tdb",
    "code": "TBZ"
  },
  {
    "name": "田东",
    "spell": "tiandong",
    "spellShort": "tdo",
    "code": "TDZ"
  },
  {
    "name": "天岗",
    "spell": "tiangang",
    "spellShort": "tga",
    "code": "TGL"
  },
  {
    "name": "太谷东",
    "spell": "taigudong",
    "spellShort": "tgd",
    "code": "TEV"
  },
  {
    "name": "铁干里克",
    "spell": "tieganlike",
    "spellShort": "tgk",
    "code": "VAR"
  },
  {
    "name": "土贵乌拉",
    "spell": "tuguiwula",
    "spellShort": "tgl",
    "code": "TGC"
  },
  {
    "name": "太谷西",
    "spell": "taiguxi",
    "spellShort": "tgx",
    "code": "TIV"
  },
  {
    "name": "太和北",
    "spell": "taihebei",
    "spellShort": "thb",
    "code": "JYN"
  },
  {
    "name": "太和东",
    "spell": "taihedong",
    "spellShort": "thd",
    "code": "TDU"
  },
  {
    "name": "唐河",
    "spell": "tanghe",
    "spellShort": "the",
    "code": "THF"
  },
  {
    "name": "唐海南",
    "spell": "tanghainan",
    "spellShort": "thn",
    "code": "IEP"
  },
  {
    "name": "通化县",
    "spell": "tonghuaxian",
    "spellShort": "thx",
    "code": "TXL"
  },
  {
    "name": "团结",
    "spell": "tuanjie",
    "spellShort": "tji",
    "code": "TIX"
  },
  {
    "name": "谭家井",
    "spell": "tanjiajing",
    "spellShort": "tjj",
    "code": "TNJ"
  },
  {
    "name": "唐家湾",
    "spell": "tangjiawan",
    "spellShort": "tjw",
    "code": "PDQ"
  },
  {
    "name": "统军庄",
    "spell": "tongjunzhuang",
    "spellShort": "tjz",
    "code": "TZP"
  },
  {
    "name": "铜陵北",
    "spell": "tonglingbei",
    "spellShort": "tlb",
    "code": "KXH"
  },
  {
    "name": "吐列毛杜",
    "spell": "tuliemaodu",
    "spellShort": "tld",
    "code": "TMD"
  },
  {
    "name": "图里河",
    "spell": "tulihe",
    "spellShort": "tlh",
    "code": "TEX"
  },
  {
    "name": "亭亮",
    "spell": "tingliang",
    "spellShort": "tli",
    "code": "TIZ"
  },
  {
    "name": "田林",
    "spell": "tianlin",
    "spellShort": "tli",
    "code": "TFZ"
  },
  {
    "name": "天门",
    "spell": "tianmen",
    "spellShort": "tme",
    "code": "TMN"
  },
  {
    "name": "太姥山",
    "spell": "taimushan",
    "spellShort": "tms",
    "code": "TLS"
  },
  {
    "name": "土牧尔台",
    "spell": "tumuertai",
    "spellShort": "tmt",
    "code": "TRC"
  },
  {
    "name": "土门子",
    "spell": "tumenzi",
    "spellShort": "tmz",
    "code": "TCJ"
  },
  {
    "name": "洮南",
    "spell": "taonan",
    "spellShort": "tna",
    "code": "TVT"
  },
  {
    "name": "太平川",
    "spell": "taipingchuan",
    "spellShort": "tpc",
    "code": "TIT"
  },
  {
    "name": "太平镇",
    "spell": "taipingzhen",
    "spellShort": "tpz",
    "code": "TEB"
  },
  {
    "name": "台前",
    "spell": "taiqian",
    "spellShort": "tqi",
    "code": "TTK"
  },
  {
    "name": "图强",
    "spell": "tuqiang",
    "spellShort": "tqi",
    "code": "TQX"
  },
  {
    "name": "天桥岭",
    "spell": "tianqiaoling",
    "spellShort": "tql",
    "code": "TQL"
  },
  {
    "name": "土桥子",
    "spell": "tuqiaozi",
    "spellShort": "tqz",
    "code": "TQJ"
  },
  {
    "name": "甜水堡",
    "spell": "tianshuibu",
    "spellShort": "tsb",
    "code": "TUJ"
  },
  {
    "name": "汤山城",
    "spell": "tangshancheng",
    "spellShort": "tsc",
    "code": "TCT"
  },
  {
    "name": "台山",
    "spell": "taishan",
    "spellShort": "tsh",
    "code": "PUQ"
  },
  {
    "name": "桃山",
    "spell": "taoshan",
    "spellShort": "tsh",
    "code": "TAB"
  },
  {
    "name": "唐山西",
    "spell": "tangshanxi",
    "spellShort": "tsx",
    "code": "TSI"
  },
  {
    "name": "天台山",
    "spell": "tiantaishan",
    "spellShort": "tts",
    "code": "TIU"
  },
  {
    "name": "通途",
    "spell": "tongtu",
    "spellShort": "ttu",
    "code": "TUT"
  },
  {
    "name": "通渭",
    "spell": "tongwei",
    "spellShort": "twe",
    "code": "TWJ"
  },
  {
    "name": "田心东",
    "spell": "tianxindong",
    "spellShort": "txd",
    "code": "KQQ"
  },
  {
    "name": "藤县",
    "spell": "tengxian",
    "spellShort": "txi",
    "code": "TAZ"
  },
  {
    "name": "同心",
    "spell": "tongxin",
    "spellShort": "txi",
    "code": "TXJ"
  },
  {
    "name": "桐乡",
    "spell": "tongxiang",
    "spellShort": "txi",
    "code": "TCH"
  },
  {
    "name": "田阳",
    "spell": "tianyang",
    "spellShort": "tya",
    "code": "TRZ"
  },
  {
    "name": "天义",
    "spell": "tianyi",
    "spellShort": "tyi",
    "code": "TND"
  },
  {
    "name": "汤阴",
    "spell": "tangyin",
    "spellShort": "tyi",
    "code": "TYF"
  },
  {
    "name": "驼腰岭",
    "spell": "tuoyaoling",
    "spellShort": "tyl",
    "code": "TIL"
  },
  {
    "name": "太阳山",
    "spell": "taiyangshan",
    "spellShort": "tys",
    "code": "TYJ"
  },
  {
    "name": "桃源",
    "spell": "taoyuan",
    "spellShort": "tyu",
    "code": "TYA"
  },
  {
    "name": "汤原",
    "spell": "tangyuan",
    "spellShort": "tyu",
    "code": "TYB"
  },
  {
    "name": "通远堡西",
    "spell": "tongyuanpuxi",
    "spellShort": "tyx",
    "code": "TST"
  },
  {
    "name": "塔崖驿",
    "spell": "tayayi",
    "spellShort": "tyy",
    "code": "TYP"
  },
  {
    "name": "滕州",
    "spell": "tengzhou",
    "spellShort": "tzh",
    "code": "TXK"
  },
  {
    "name": "天镇",
    "spell": "tianzhen",
    "spellShort": "tzh",
    "code": "TZV"
  },
  {
    "name": "天祝",
    "spell": "tianzhu",
    "spellShort": "tzh",
    "code": "TZJ"
  },
  {
    "name": "天柱山",
    "spell": "tianzhushan",
    "spellShort": "tzs",
    "code": "QWH"
  },
  {
    "name": "武安",
    "spell": "wuan",
    "spellShort": "wan",
    "code": "WAP"
  },
  {
    "name": "文安",
    "spell": "wenan",
    "spellShort": "wan",
    "code": "WBP"
  },
  {
    "name": "万安县",
    "spell": "wananxian",
    "spellShort": "wax",
    "code": "WAG"
  },
  {
    "name": "王安镇",
    "spell": "wanganzhen",
    "spellShort": "waz",
    "code": "WVP"
  },
  {
    "name": "吴堡",
    "spell": "wubu",
    "spellShort": "wbu",
    "code": "WUY"
  },
  {
    "name": "五叉沟",
    "spell": "wuchagou",
    "spellShort": "wcg",
    "code": "WCT"
  },
  {
    "name": "吴川",
    "spell": "wuchuan",
    "spellShort": "wch",
    "code": "WAQ"
  },
  {
    "name": "温春",
    "spell": "wenchun",
    "spellShort": "wch",
    "code": "WDB"
  },
  {
    "name": "五大连池",
    "spell": "wudalianchi",
    "spellShort": "wdc",
    "code": "WRB"
  },
  {
    "name": "文登东",
    "spell": "wendengdong",
    "spellShort": "wdd",
    "code": "WGK"
  },
  {
    "name": "文登",
    "spell": "wendeng",
    "spellShort": "wde",
    "code": "WBK"
  },
  {
    "name": "五道沟",
    "spell": "wudaogou",
    "spellShort": "wdg",
    "code": "WDL"
  },
  {
    "name": "五道河",
    "spell": "wudaohe",
    "spellShort": "wdh",
    "code": "WHP"
  },
  {
    "name": "文地",
    "spell": "wendi",
    "spellShort": "wdi",
    "code": "WNZ"
  },
  {
    "name": "文登南",
    "spell": "wendengnan",
    "spellShort": "wdn",
    "code": "WWK"
  },
  {
    "name": "卫东",
    "spell": "weidong",
    "spellShort": "wdo",
    "code": "WVT"
  },
  {
    "name": "望都",
    "spell": "wangdu",
    "spellShort": "wdu",
    "code": "WDP"
  },
  {
    "name": "武当山西",
    "spell": "wudangshanxi",
    "spellShort": "wdx",
    "code": "WWN"
  },
  {
    "name": "乌尔旗汗",
    "spell": "wuerqihan",
    "spellShort": "weh",
    "code": "WHX"
  },
  {
    "name": "潍坊北",
    "spell": "weifangbei",
    "spellShort": "wfb",
    "code": "WJK"
  },
  {
    "name": "五府山",
    "spell": "wufushan",
    "spellShort": "wfs",
    "code": "WFG"
  },
  {
    "name": "王府",
    "spell": "wangfu",
    "spellShort": "wfu",
    "code": "WUT"
  },
  {
    "name": "湾沟",
    "spell": "wangou",
    "spellShort": "wgo",
    "code": "WGL"
  },
  {
    "name": "吴官田",
    "spell": "wuguantian",
    "spellShort": "wgt",
    "code": "WGM"
  },
  {
    "name": "威虎岭北",
    "spell": "weihulingbei",
    "spellShort": "whb",
    "code": "WBL"
  },
  {
    "name": "威海北",
    "spell": "weihaibei",
    "spellShort": "whb",
    "code": "WHK"
  },
  {
    "name": "芜湖北",
    "spell": "wuhubei",
    "spellShort": "whb",
    "code": "WBU"
  },
  {
    "name": "威海南海",
    "spell": "weihainanhai",
    "spellShort": "whh",
    "code": "WRK"
  },
  {
    "name": "芜湖南",
    "spell": "wuhunan",
    "spellShort": "whn",
    "code": "RVH"
  },
  {
    "name": "卫辉南",
    "spell": "weihuinan",
    "spellShort": "whn",
    "code": "WVF"
  },
  {
    "name": "卫辉",
    "spell": "weihui",
    "spellShort": "whu",
    "code": "WHF"
  },
  {
    "name": "吴家川",
    "spell": "wujiachuan",
    "spellShort": "wjc",
    "code": "WCJ"
  },
  {
    "name": "渭津",
    "spell": "weijin",
    "spellShort": "wji",
    "code": "WJL"
  },
  {
    "name": "午汲",
    "spell": "wuji",
    "spellShort": "wji",
    "code": "WJP"
  },
  {
    "name": "威箐",
    "spell": "weiqing",
    "spellShort": "wji",
    "code": "WAM"
  },
  {
    "name": "魏家泉",
    "spell": "weijiaquan",
    "spellShort": "wjq",
    "code": "WJR"
  },
  {
    "name": "倭肯",
    "spell": "woken",
    "spellShort": "wke",
    "code": "WQB"
  },
  {
    "name": "乌兰",
    "spell": "wulan",
    "spellShort": "wla",
    "code": "WIO"
  },
  {
    "name": "五龙背",
    "spell": "wulongbei",
    "spellShort": "wlb",
    "code": "WBT"
  },
  {
    "name": "五龙背东",
    "spell": "wulongbeidong",
    "spellShort": "wld",
    "code": "WMT"
  },
  {
    "name": "瓦拉干",
    "spell": "walagan",
    "spellShort": "wlg",
    "code": "WVX"
  },
  {
    "name": "五莲",
    "spell": "wulian",
    "spellShort": "wli",
    "code": "WLK"
  },
  {
    "name": "卧龙寺",
    "spell": "wolongsi",
    "spellShort": "wls",
    "code": "WLY"
  },
  {
    "name": "乌兰木图",
    "spell": "wulanmutu",
    "spellShort": "wlt",
    "code": "VLT"
  },
  {
    "name": "卧里屯",
    "spell": "wolitun",
    "spellShort": "wlt",
    "code": "WLX"
  },
  {
    "name": "望牛墩",
    "spell": "wangniudun",
    "spellShort": "wnd",
    "code": "WNA"
  },
  {
    "name": "乌奴耳",
    "spell": "wunuer",
    "spellShort": "wne",
    "code": "WRX"
  },
  {
    "name": "万宁",
    "spell": "wanning",
    "spellShort": "wni",
    "code": "WNQ"
  },
  {
    "name": "万年",
    "spell": "wannian",
    "spellShort": "wni",
    "code": "WWG"
  },
  {
    "name": "渭南南",
    "spell": "weinannan",
    "spellShort": "wnn",
    "code": "WVY"
  },
  {
    "name": "渭南镇",
    "spell": "weinanzhen",
    "spellShort": "wnz",
    "code": "WNJ"
  },
  {
    "name": "武平",
    "spell": "wuping",
    "spellShort": "wpi",
    "code": "WPS"
  },
  {
    "name": "吴桥",
    "spell": "wuqiao",
    "spellShort": "wqi",
    "code": "WUP"
  },
  {
    "name": "万荣",
    "spell": "wanrong",
    "spellShort": "wro",
    "code": "VOM"
  },
  {
    "name": "巫山",
    "spell": "wushan",
    "spellShort": "wsh",
    "code": "WOE"
  },
  {
    "name": "文水",
    "spell": "wenshui",
    "spellShort": "wsh",
    "code": "WEV"
  },
  {
    "name": "巍山",
    "spell": "weishan",
    "spellShort": "wsh",
    "code": "WOM"
  },
  {
    "name": "武山",
    "spell": "wushan",
    "spellShort": "wsh",
    "code": "WSJ"
  },
  {
    "name": "瓦石峡",
    "spell": "washixia",
    "spellShort": "wsx",
    "code": "WHR"
  },
  {
    "name": "魏善庄",
    "spell": "weishanzhuang",
    "spellShort": "wsz",
    "code": "WSP"
  },
  {
    "name": "五通",
    "spell": "wutong",
    "spellShort": "wto",
    "code": "WTZ"
  },
  {
    "name": "王瞳",
    "spell": "wangtong",
    "spellShort": "wto",
    "code": "WTP"
  },
  {
    "name": "五台山",
    "spell": "wutaishan",
    "spellShort": "wts",
    "code": "WSV"
  },
  {
    "name": "王团庄",
    "spell": "wangtuanzhuang",
    "spellShort": "wtz",
    "code": "WZJ"
  },
  {
    "name": "无为",
    "spell": "wuwei",
    "spellShort": "wwe",
    "code": "IIH"
  },
  {
    "name": "瓦屋山",
    "spell": "wawushan",
    "spellShort": "wws",
    "code": "WAH"
  },
  {
    "name": "五五",
    "spell": "wuwu",
    "spellShort": "wwu",
    "code": "WVR"
  },
  {
    "name": "武乡东",
    "spell": "wuxiangdong",
    "spellShort": "wxd",
    "code": "WVV"
  },
  {
    "name": "威信",
    "spell": "weixin",
    "spellShort": "wxi",
    "code": "WXE"
  },
  {
    "name": "武乡",
    "spell": "wuxiang",
    "spellShort": "wxi",
    "code": "WUV"
  },
  {
    "name": "闻喜",
    "spell": "wenxi",
    "spellShort": "wxi",
    "code": "WXV"
  },
  {
    "name": "卫星",
    "spell": "weixing",
    "spellShort": "wxi",
    "code": "WVB"
  },
  {
    "name": "无锡新区",
    "spell": "wuxixinqu",
    "spellShort": "wxq",
    "code": "IFH"
  },
  {
    "name": "王杨",
    "spell": "wangyang",
    "spellShort": "wya",
    "code": "WYB"
  },
  {
    "name": "武义北",
    "spell": "wuyibei",
    "spellShort": "wyb",
    "code": "WDH"
  },
  {
    "name": "武义",
    "spell": "wuyi",
    "spellShort": "wyi",
    "code": "RYH"
  },
  {
    "name": "瓦窑田",
    "spell": "wayaotian",
    "spellShort": "wyt",
    "code": "WIM"
  },
  {
    "name": "五原",
    "spell": "wuyuan",
    "spellShort": "wyu",
    "code": "WYC"
  },
  {
    "name": "湾仔",
    "spell": "wanzai",
    "spellShort": "wza",
    "code": "WZA"
  },
  {
    "name": "湾仔北",
    "spell": "wanzaibei",
    "spellShort": "wzb",
    "code": "WBA"
  },
  {
    "name": "温州北",
    "spell": "wenzhoubei",
    "spellShort": "wzb",
    "code": "URH"
  },
  {
    "name": "苇子沟",
    "spell": "weizigou",
    "spellShort": "wzg",
    "code": "WZL"
  },
  {
    "name": "韦庄",
    "spell": "weizhuang",
    "spellShort": "wzh",
    "code": "WZY"
  },
  {
    "name": "五寨",
    "spell": "wuzhai",
    "spellShort": "wzh",
    "code": "WZV"
  },
  {
    "name": "武陟",
    "spell": "wuzhi",
    "spellShort": "wzh",
    "code": "WIF"
  },
  {
    "name": "湾沚南",
    "spell": "wanzhinan",
    "spellShort": "wzn",
    "code": "WNU"
  },
  {
    "name": "魏杖子",
    "spell": "weizhangzi",
    "spellShort": "wzz",
    "code": "WKD"
  },
  {
    "name": "微子镇",
    "spell": "weizizhen",
    "spellShort": "wzz",
    "code": "WQP"
  },
  {
    "name": "兴安",
    "spell": "xingan",
    "spellShort": "xan",
    "code": "XAZ"
  },
  {
    "name": "新安",
    "spell": "xinan",
    "spellShort": "xan",
    "code": "EAM"
  },
  {
    "name": "新安县",
    "spell": "xinanxian",
    "spellShort": "xax",
    "code": "XAF"
  },
  {
    "name": "新保安",
    "spell": "xinbaoan",
    "spellShort": "xba",
    "code": "XAP"
  },
  {
    "name": "下板城",
    "spell": "xiabancheng",
    "spellShort": "xbc",
    "code": "EBP"
  },
  {
    "name": "西八里",
    "spell": "xibali",
    "spellShort": "xbl",
    "code": "XLP"
  },
  {
    "name": "新昌北",
    "spell": "xinchangbei",
    "spellShort": "xcb",
    "code": "XBU"
  },
  {
    "name": "许昌北",
    "spell": "xuchangbei",
    "spellShort": "xcb",
    "code": "EBF"
  },
  {
    "name": "项城",
    "spell": "xiangcheng",
    "spellShort": "xch",
    "code": "ERN"
  },
  {
    "name": "小村",
    "spell": "xiaocun",
    "spellShort": "xcu",
    "code": "XEM"
  },
  {
    "name": "兴城西",
    "spell": "xingchengxi",
    "spellShort": "xcx",
    "code": "XXD"
  },
  {
    "name": "新绰源",
    "spell": "xinchuoyuan",
    "spellShort": "xcy",
    "code": "XRX"
  },
  {
    "name": "下城子",
    "spell": "xiachengzi",
    "spellShort": "xcz",
    "code": "XCB"
  },
  {
    "name": "喜德",
    "spell": "xide",
    "spellShort": "xde",
    "code": "EDW"
  },
  {
    "name": "小得江",
    "spell": "xiaodejiang",
    "spellShort": "xdj",
    "code": "EJM"
  },
  {
    "name": "西大庙",
    "spell": "xidamiao",
    "spellShort": "xdm",
    "code": "XMP"
  },
  {
    "name": "小董",
    "spell": "xiaodong",
    "spellShort": "xdo",
    "code": "XEZ"
  },
  {
    "name": "小东",
    "spell": "xiaodong",
    "spellShort": "xdo",
    "code": "XOD"
  },
  {
    "name": "西渡",
    "spell": "xidu",
    "spellShort": "xdu",
    "code": "XDA"
  },
  {
    "name": "喜德西",
    "spell": "xidexi",
    "spellShort": "xdx",
    "code": "XXE"
  },
  {
    "name": "襄汾",
    "spell": "xiangfen",
    "spellShort": "xfe",
    "code": "XFV"
  },
  {
    "name": "信丰",
    "spell": "xinfeng",
    "spellShort": "xfe",
    "code": "EFG"
  },
  {
    "name": "襄汾西",
    "spell": "xiangfenxi",
    "spellShort": "xfx",
    "code": "XTV"
  },
  {
    "name": "信丰西",
    "spell": "xinfengxi",
    "spellShort": "xfx",
    "code": "XFG"
  },
  {
    "name": "新干",
    "spell": "xingan",
    "spellShort": "xga",
    "code": "EGG"
  },
  {
    "name": "孝感",
    "spell": "xiaogan",
    "spellShort": "xga",
    "code": "XGN"
  },
  {
    "name": "新干东",
    "spell": "xingandong",
    "spellShort": "xgd",
    "code": "XGG"
  },
  {
    "name": "兴国西",
    "spell": "xingguoxi",
    "spellShort": "xgx",
    "code": "XIG"
  },
  {
    "name": "夏格庄",
    "spell": "xiagezhuang",
    "spellShort": "xgz",
    "code": "XZK"
  },
  {
    "name": "西岗子",
    "spell": "xigangzi",
    "spellShort": "xgz",
    "code": "NBB"
  },
  {
    "name": "宣化北",
    "spell": "xuanhuabei",
    "spellShort": "xhb",
    "code": "VJP"
  },
  {
    "name": "西湖东",
    "spell": "xihudong",
    "spellShort": "xhd",
    "code": "WDQ"
  },
  {
    "name": "新和",
    "spell": "xinhe",
    "spellShort": "xhe",
    "code": "XIR"
  },
  {
    "name": "宣和",
    "spell": "xuanhe",
    "spellShort": "xhe",
    "code": "XWJ"
  },
  {
    "name": "香河",
    "spell": "xianghe",
    "spellShort": "xhe",
    "code": "XHI"
  },
  {
    "name": "襄河",
    "spell": "xianghe",
    "spellShort": "xhe",
    "code": "XXB"
  },
  {
    "name": "斜河涧",
    "spell": "xiehejian",
    "spellShort": "xhj",
    "code": "EEP"
  },
  {
    "name": "新华屯",
    "spell": "xinhuatun",
    "spellShort": "xht",
    "code": "XAX"
  },
  {
    "name": "新华",
    "spell": "xinhua",
    "spellShort": "xhu",
    "code": "XHB"
  },
  {
    "name": "新化",
    "spell": "xinhua",
    "spellShort": "xhu",
    "code": "EHQ"
  },
  {
    "name": "宣化",
    "spell": "xuanhua",
    "spellShort": "xhu",
    "code": "XHP"
  },
  {
    "name": "西华",
    "spell": "xihua",
    "spellShort": "xhu",
    "code": "EHF"
  },
  {
    "name": "下花园",
    "spell": "xiahuayuan",
    "spellShort": "xhy",
    "code": "XYP"
  },
  {
    "name": "小河镇",
    "spell": "xiaohezhen",
    "spellShort": "xhz",
    "code": "EKY"
  },
  {
    "name": "徐家店",
    "spell": "xujiadian",
    "spellShort": "xjd",
    "code": "HYK"
  },
  {
    "name": "峡江",
    "spell": "xiajiang",
    "spellShort": "xji",
    "code": "EJG"
  },
  {
    "name": "新绛",
    "spell": "xinjiang",
    "spellShort": "xji",
    "code": "XJV"
  },
  {
    "name": "仙居南",
    "spell": "xianjunan",
    "spellShort": "xjn",
    "code": "XNU"
  },
  {
    "name": "许家屯",
    "spell": "xujiatun",
    "spellShort": "xjt",
    "code": "XJT"
  },
  {
    "name": "兴凯",
    "spell": "xingkai",
    "spellShort": "xka",
    "code": "EKB"
  },
  {
    "name": "溪口",
    "spell": "xikou",
    "spellShort": "xko",
    "code": "XKU"
  },
  {
    "name": "小榄",
    "spell": "xiaolan",
    "spellShort": "xla",
    "code": "EAQ"
  },
  {
    "name": "香兰",
    "spell": "xianglan",
    "spellShort": "xla",
    "code": "XNB"
  },
  {
    "name": "新李",
    "spell": "xinli",
    "spellShort": "xli",
    "code": "XLJ"
  },
  {
    "name": "西柳",
    "spell": "xiliu",
    "spellShort": "xli",
    "code": "GCT"
  },
  {
    "name": "西林",
    "spell": "xilin",
    "spellShort": "xli",
    "code": "XYB"
  },
  {
    "name": "新林",
    "spell": "xinlin",
    "spellShort": "xli",
    "code": "XPX"
  },
  {
    "name": "新立屯",
    "spell": "xinlitun",
    "spellShort": "xlt",
    "code": "XLD"
  },
  {
    "name": "兴隆县西",
    "spell": "xilongxianxi",
    "spellShort": "xlx",
    "code": "IRP"
  },
  {
    "name": "西麻山",
    "spell": "ximashan",
    "spellShort": "xms",
    "code": "XMB"
  },
  {
    "name": "下马塘",
    "spell": "xiamatang",
    "spellShort": "xmt",
    "code": "XAT"
  },
  {
    "name": "孝南",
    "spell": "xiaonan",
    "spellShort": "xna",
    "code": "XNV"
  },
  {
    "name": "咸宁北",
    "spell": "xianningbei",
    "spellShort": "xnb",
    "code": "XRN"
  },
  {
    "name": "咸宁东",
    "spell": "xianningdong",
    "spellShort": "xnd",
    "code": "XKN"
  },
  {
    "name": "兴宁",
    "spell": "xingning",
    "spellShort": "xni",
    "code": "ENQ"
  },
  {
    "name": "咸宁",
    "spell": "xianning",
    "spellShort": "xni",
    "code": "XNN"
  },
  {
    "name": "兴平",
    "spell": "xingping",
    "spellShort": "xpi",
    "code": "XPY"
  },
  {
    "name": "西平",
    "spell": "xiping",
    "spellShort": "xpi",
    "code": "XPN"
  },
  {
    "name": "新坪田",
    "spell": "xinpingtian",
    "spellShort": "xpt",
    "code": "XPM"
  },
  {
    "name": "西平西",
    "spell": "xipingxi",
    "spellShort": "xpx",
    "code": "EGQ"
  },
  {
    "name": "新邱",
    "spell": "xinqiu",
    "spellShort": "xqi",
    "code": "XQD"
  },
  {
    "name": "新青",
    "spell": "xinqing",
    "spellShort": "xqi",
    "code": "XQB"
  },
  {
    "name": "兴泉堡",
    "spell": "xingquanbu",
    "spellShort": "xqp",
    "code": "XQJ"
  },
  {
    "name": "仙人桥",
    "spell": "xianrenqiao",
    "spellShort": "xrq",
    "code": "XRL"
  },
  {
    "name": "小寺沟",
    "spell": "xiaosigou",
    "spellShort": "xsg",
    "code": "ESP"
  },
  {
    "name": "夏石",
    "spell": "xiashi",
    "spellShort": "xsh",
    "code": "XIZ"
  },
  {
    "name": "浠水",
    "spell": "xishui",
    "spellShort": "xsh",
    "code": "XZN"
  },
  {
    "name": "杏树",
    "spell": "xingshu",
    "spellShort": "xsh",
    "code": "XSB"
  },
  {
    "name": "下社",
    "spell": "xiashe",
    "spellShort": "xsh",
    "code": "XSV"
  },
  {
    "name": "徐水",
    "spell": "xushui",
    "spellShort": "xsh",
    "code": "XSP"
  },
  {
    "name": "浠水南",
    "spell": "xishuinan",
    "spellShort": "xsn",
    "code": "VNN"
  },
  {
    "name": "杏树屯",
    "spell": "xingshutun",
    "spellShort": "xst",
    "code": "XDT"
  },
  {
    "name": "许三湾",
    "spell": "xusanwan",
    "spellShort": "xsw",
    "code": "XSJ"
  },
  {
    "name": "响水县",
    "spell": "xiangshuixian",
    "spellShort": "xsx",
    "code": "XSU"
  },
  {
    "name": "邢台",
    "spell": "xingtai",
    "spellShort": "xta",
    "code": "XTP"
  },
  {
    "name": "湘潭北",
    "spell": "xiangtanbei",
    "spellShort": "xtb",
    "code": "EDQ"
  },
  {
    "name": "仙桃西",
    "spell": "xiantaoxi",
    "spellShort": "xtx",
    "code": "XAN"
  },
  {
    "name": "下台子",
    "spell": "xiataizi",
    "spellShort": "xtz",
    "code": "EIP"
  },
  {
    "name": "小湾东",
    "spell": "xiaowandong",
    "spellShort": "xwd",
    "code": "XNM"
  },
  {
    "name": "徐闻",
    "spell": "xuwen",
    "spellShort": "xwe",
    "code": "XJQ"
  },
  {
    "name": "兴文南",
    "spell": "xingwennan",
    "spellShort": "xwn",
    "code": "XAE"
  },
  {
    "name": "新窝铺",
    "spell": "xinwopu",
    "spellShort": "xwp",
    "code": "EPD"
  },
  {
    "name": "西乌旗",
    "spell": "xiwuqi",
    "spellShort": "xwq",
    "code": "XWD"
  },
  {
    "name": "修武",
    "spell": "xiuwu",
    "spellShort": "xwu",
    "code": "XWF"
  },
  {
    "name": "修武西",
    "spell": "xiuwuxi",
    "spellShort": "xwx",
    "code": "EXF"
  },
  {
    "name": "新县",
    "spell": "xinxian",
    "spellShort": "xxi",
    "code": "XSN"
  },
  {
    "name": "息县",
    "spell": "xixian",
    "spellShort": "xxi",
    "code": "ENN"
  },
  {
    "name": "湘乡",
    "spell": "xiangxiang",
    "spellShort": "xxi",
    "code": "XXQ"
  },
  {
    "name": "萧县",
    "spell": "xiaoxian",
    "spellShort": "xxi",
    "code": "EOH"
  },
  {
    "name": "新乡南",
    "spell": "xinxiangnan",
    "spellShort": "xxn",
    "code": "ENF"
  },
  {
    "name": "新兴县",
    "spell": "xinxingxian",
    "spellShort": "xxx",
    "code": "XGQ"
  },
  {
    "name": "西小召",
    "spell": "xixiaozhao",
    "spellShort": "xxz",
    "code": "XZC"
  },
  {
    "name": "小西庄",
    "spell": "xiaoxizhuang",
    "spellShort": "xxz",
    "code": "XXP"
  },
  {
    "name": "向阳",
    "spell": "xiangyang",
    "spellShort": "xya",
    "code": "XDB"
  },
  {
    "name": "旬阳北",
    "spell": "xunyangbei",
    "spellShort": "xyb",
    "code": "XBY"
  },
  {
    "name": "咸阳北",
    "spell": "xianyangbei",
    "spellShort": "xyb",
    "code": "EBY"
  },
  {
    "name": "襄垣东",
    "spell": "xiangyuandong",
    "spellShort": "xyd",
    "code": "EAF"
  },
  {
    "name": "兴业",
    "spell": "xingye",
    "spellShort": "xye",
    "code": "SNZ"
  },
  {
    "name": "小雨谷",
    "spell": "xiaoyugu",
    "spellShort": "xyg",
    "code": "XHM"
  },
  {
    "name": "新沂",
    "spell": "xinyi",
    "spellShort": "xyi",
    "code": "VIH"
  },
  {
    "name": "小月旧",
    "spell": "xiaoyuejiu",
    "spellShort": "xyj",
    "code": "XFM"
  },
  {
    "name": "新沂南",
    "spell": "xinyinan",
    "spellShort": "xyn",
    "code": "XYU"
  },
  {
    "name": "仙游",
    "spell": "xianyou",
    "spellShort": "xyo",
    "code": "XWS"
  },
  {
    "name": "小扬气",
    "spell": "xiaoyangqi",
    "spellShort": "xyq",
    "code": "XYX"
  },
  {
    "name": "襄垣",
    "spell": "xiangyuan",
    "spellShort": "xyu",
    "code": "EIF"
  },
  {
    "name": "夏邑县",
    "spell": "xiayixian",
    "spellShort": "xyx",
    "code": "EJH"
  },
  {
    "name": "新友谊",
    "spell": "xinyouyi",
    "spellShort": "xyy",
    "code": "EYB"
  },
  {
    "name": "新阳镇",
    "spell": "xinyangzhen",
    "spellShort": "xyz",
    "code": "XZJ"
  },
  {
    "name": "新帐房",
    "spell": "xinzhangfang",
    "spellShort": "xzf",
    "code": "XZX"
  },
  {
    "name": "悬钟",
    "spell": "xuanzhong",
    "spellShort": "xzh",
    "code": "XRP"
  },
  {
    "name": "汐子",
    "spell": "xizi",
    "spellShort": "xzi",
    "code": "XZD"
  },
  {
    "name": "西哲里木",
    "spell": "xizhelimu",
    "spellShort": "xzm",
    "code": "XRD"
  },
  {
    "name": "新杖子",
    "spell": "xinzhangzi",
    "spellShort": "xzz",
    "code": "ERP"
  },
  {
    "name": "永安",
    "spell": "yongan",
    "spellShort": "yan",
    "code": "YAS"
  },
  {
    "name": "永安乡",
    "spell": "yonganxiang",
    "spellShort": "yax",
    "code": "YNB"
  },
  {
    "name": "永安镇",
    "spell": "yonganzhen",
    "spellShort": "yaz",
    "code": "YQZ"
  },
  {
    "name": "盐边",
    "spell": "yanbian",
    "spellShort": "ybi",
    "code": "YBE"
  },
  {
    "name": "羊草",
    "spell": "yangcao",
    "spellShort": "yca",
    "code": "YAB"
  },
  {
    "name": "永城北",
    "spell": "yongchengbei",
    "spellShort": "ycb",
    "code": "RGH"
  },
  {
    "name": "秧草地",
    "spell": "yangcaodi",
    "spellShort": "ycd",
    "code": "YKM"
  },
  {
    "name": "禹城东",
    "spell": "yuchengdong",
    "spellShort": "ycd",
    "code": "YSK"
  },
  {
    "name": "盐城大丰",
    "spell": "yanchengdafeng",
    "spellShort": "ycf",
    "code": "YFU"
  },
  {
    "name": "砚川",
    "spell": "yanchuan",
    "spellShort": "ych",
    "code": "YYY"
  },
  {
    "name": "盐池",
    "spell": "yanchi",
    "spellShort": "ych",
    "code": "YKJ"
  },
  {
    "name": "阳岔",
    "spell": "yangcha",
    "spellShort": "ych",
    "code": "YAL"
  },
  {
    "name": "应城",
    "spell": "yingcheng",
    "spellShort": "ych",
    "code": "YHN"
  },
  {
    "name": "宜城",
    "spell": "yicheng",
    "spellShort": "ych",
    "code": "YIN"
  },
  {
    "name": "郓城",
    "spell": "yuncheng",
    "spellShort": "ych",
    "code": "YPK"
  },
  {
    "name": "晏城",
    "spell": "yancheng",
    "spellShort": "ych",
    "code": "YEK"
  },
  {
    "name": "禹城",
    "spell": "yucheng",
    "spellShort": "ych",
    "code": "YCK"
  },
  {
    "name": "阳澄湖",
    "spell": "yangchenghu",
    "spellShort": "ych",
    "code": "AIH"
  },
  {
    "name": "阳城",
    "spell": "yangcheng",
    "spellShort": "ych",
    "code": "YNF"
  },
  {
    "name": "迎春",
    "spell": "yingchun",
    "spellShort": "ych",
    "code": "YYB"
  },
  {
    "name": "雁翅",
    "spell": "yanchi",
    "spellShort": "ych",
    "code": "YAP"
  },
  {
    "name": "云彩岭",
    "spell": "yuncailing",
    "spellShort": "ycl",
    "code": "ACP"
  },
  {
    "name": "虞城县",
    "spell": "yuchengxian",
    "spellShort": "ycx",
    "code": "IXH"
  },
  {
    "name": "营城子",
    "spell": "yingchengzi",
    "spellShort": "ycz",
    "code": "YCT"
  },
  {
    "name": "于都北",
    "spell": "yudubei",
    "spellShort": "ydb",
    "code": "YYG"
  },
  {
    "name": "英德",
    "spell": "yingde",
    "spellShort": "yde",
    "code": "YDQ"
  },
  {
    "name": "云东海",
    "spell": "yundonghai",
    "spellShort": "ydh",
    "code": "NAQ"
  },
  {
    "name": "尹地",
    "spell": "yindi",
    "spellShort": "ydi",
    "code": "YDM"
  },
  {
    "name": "永定",
    "spell": "yongding",
    "spellShort": "ydi",
    "code": "YGS"
  },
  {
    "name": "阳东",
    "spell": "yangdong",
    "spellShort": "ydo",
    "code": "WLQ"
  },
  {
    "name": "园墩",
    "spell": "yuandun",
    "spellShort": "ydu",
    "code": "YAJ"
  },
  {
    "name": "永福南",
    "spell": "yongfunan",
    "spellShort": "yfn",
    "code": "YBZ"
  },
  {
    "name": "余干",
    "spell": "yugan",
    "spellShort": "yga",
    "code": "YFG"
  },
  {
    "name": "阳高",
    "spell": "yanggao",
    "spellShort": "yga",
    "code": "YOV"
  },
  {
    "name": "杨岗",
    "spell": "yanggang",
    "spellShort": "yga",
    "code": "YRB"
  },
  {
    "name": "雨格",
    "spell": "yuge",
    "spellShort": "yge",
    "code": "VTM"
  },
  {
    "name": "阳高南",
    "spell": "yanggaonan",
    "spellShort": "ygn",
    "code": "AGV"
  },
  {
    "name": "阳谷",
    "spell": "yanggu",
    "spellShort": "ygu",
    "code": "YIK"
  },
  {
    "name": "友好",
    "spell": "youhao",
    "spellShort": "yha",
    "code": "YOB"
  },
  {
    "name": "沿河城",
    "spell": "yanhecheng",
    "spellShort": "yhc",
    "code": "YHP"
  },
  {
    "name": "洋河",
    "spell": "yanghe",
    "spellShort": "yhe",
    "code": "GTH"
  },
  {
    "name": "岩会",
    "spell": "yanhui",
    "spellShort": "yhu",
    "code": "AEP"
  },
  {
    "name": "羊臼河",
    "spell": "yangjiuhe",
    "spellShort": "yjh",
    "code": "YHM"
  },
  {
    "name": "元江",
    "spell": "yuanjiang",
    "spellShort": "yji",
    "code": "AJM"
  },
  {
    "name": "叶集",
    "spell": "yeji",
    "spellShort": "yji",
    "code": "YCH"
  },
  {
    "name": "营街",
    "spell": "yingjie",
    "spellShort": "yji",
    "code": "YAM"
  },
  {
    "name": "余江",
    "spell": "yujiang",
    "spellShort": "yji",
    "code": "YHG"
  },
  {
    "name": "岳家井",
    "spell": "yuejiajing",
    "spellShort": "yjj",
    "code": "YGJ"
  },
  {
    "name": "云居寺",
    "spell": "yunjusi",
    "spellShort": "yjs",
    "code": "AFP"
  },
  {
    "name": "燕家庄",
    "spell": "yanjiazhuang",
    "spellShort": "yjz",
    "code": "AZK"
  },
  {
    "name": "永康",
    "spell": "yongkang",
    "spellShort": "yka",
    "code": "RFH"
  },
  {
    "name": "英库勒",
    "spell": "yinfkule",
    "spellShort": "ykl",
    "code": "YLR"
  },
  {
    "name": "银浪",
    "spell": "yinlang",
    "spellShort": "yla",
    "code": "YJX"
  },
  {
    "name": "以勒",
    "spell": "yile",
    "spellShort": "yle",
    "code": "YPE"
  },
  {
    "name": "运粮河",
    "spell": "yunlianghe",
    "spellShort": "ylh",
    "code": "YEF"
  },
  {
    "name": "伊拉哈",
    "spell": "yilaha",
    "spellShort": "ylh",
    "code": "YLX"
  },
  {
    "name": "尉犁",
    "spell": "yuli",
    "spellShort": "yli",
    "code": "WRR"
  },
  {
    "name": "鄢陵",
    "spell": "yanling",
    "spellShort": "yli",
    "code": "YIF"
  },
  {
    "name": "伊林",
    "spell": "yilin",
    "spellShort": "yli",
    "code": "YLB"
  },
  {
    "name": "月亮田",
    "spell": "yueliangtian",
    "spellShort": "ylt",
    "code": "YUM"
  },
  {
    "name": "义马",
    "spell": "yima",
    "spellShort": "yma",
    "code": "YMF"
  },
  {
    "name": "阳明堡",
    "spell": "yangmingbu",
    "spellShort": "ymb",
    "code": "YVV"
  },
  {
    "name": "云梦",
    "spell": "yunmeng",
    "spellShort": "yme",
    "code": "YMN"
  },
  {
    "name": "伊敏",
    "spell": "yimin",
    "spellShort": "ymi",
    "code": "YMX"
  },
  {
    "name": "一面山",
    "spell": "yimianshan",
    "spellShort": "yms",
    "code": "YST"
  },
  {
    "name": "沂南",
    "spell": "yinan",
    "spellShort": "yna",
    "code": "YNK"
  },
  {
    "name": "云南驿",
    "spell": "yunnanyi",
    "spellShort": "yny",
    "code": "ANM"
  },
  {
    "name": "银瓶",
    "spell": "yinping",
    "spellShort": "ypi",
    "code": "KPQ"
  },
  {
    "name": "营盘水",
    "spell": "yingpanshui",
    "spellShort": "yps",
    "code": "YZJ"
  },
  {
    "name": "乐清东",
    "spell": "yueqingdong",
    "spellShort": "yqd",
    "code": "OLH"
  },
  {
    "name": "永庆",
    "spell": "yongqing",
    "spellShort": "yqi",
    "code": "YQL"
  },
  {
    "name": "杨桥",
    "spell": "yangqiao",
    "spellShort": "yqi",
    "code": "YQA"
  },
  {
    "name": "源迁",
    "spell": "yuanqian",
    "spellShort": "yqi",
    "code": "AQK"
  },
  {
    "name": "玉泉镇",
    "spell": "yuquanzhen",
    "spellShort": "yqz",
    "code": "YFR"
  },
  {
    "name": "永仁",
    "spell": "yongren",
    "spellShort": "yre",
    "code": "ARM"
  },
  {
    "name": "颍上北",
    "spell": "yingshangbei",
    "spellShort": "ysb",
    "code": "YBU"
  },
  {
    "name": "野三关",
    "spell": "yesanguan",
    "spellShort": "ysg",
    "code": "BNN"
  },
  {
    "name": "榆树沟",
    "spell": "yushugou",
    "spellShort": "ysg",
    "code": "YGP"
  },
  {
    "name": "玉石",
    "spell": "yushi",
    "spellShort": "ysh",
    "code": "YSJ"
  },
  {
    "name": "阳朔",
    "spell": "yangshuo",
    "spellShort": "ysh",
    "code": "YCZ"
  },
  {
    "name": "永寿",
    "spell": "yongshou",
    "spellShort": "ysh",
    "code": "ASY"
  },
  {
    "name": "云山",
    "spell": "yunshan",
    "spellShort": "ysh",
    "code": "KZQ"
  },
  {
    "name": "窑上",
    "spell": "yaoshang",
    "spellShort": "ysh",
    "code": "ASP"
  },
  {
    "name": "玉舍",
    "spell": "yushe",
    "spellShort": "ysh",
    "code": "AUM"
  },
  {
    "name": "沂水",
    "spell": "yishui",
    "spellShort": "ysh",
    "code": "YUK"
  },
  {
    "name": "颍上",
    "spell": "yingshang",
    "spellShort": "ysh",
    "code": "YVH"
  },
  {
    "name": "偃师",
    "spell": "yanshi",
    "spellShort": "ysh",
    "code": "YSF"
  },
  {
    "name": "月山",
    "spell": "yueshan",
    "spellShort": "ysh",
    "code": "YBF"
  },
  {
    "name": "杨树岭",
    "spell": "yangshuling",
    "spellShort": "ysl",
    "code": "YAD"
  },
  {
    "name": "雁石南",
    "spell": "yanshinan",
    "spellShort": "ysn",
    "code": "YMS"
  },
  {
    "name": "野三坡",
    "spell": "yesanpo",
    "spellShort": "ysp",
    "code": "AIP"
  },
  {
    "name": "榆社西",
    "spell": "yushexi",
    "spellShort": "ysx",
    "code": "AXV"
  },
  {
    "name": "永寿西",
    "spell": "yongshouxi",
    "spellShort": "ysx",
    "code": "AUY"
  },
  {
    "name": "鹰手营子",
    "spell": "yingshouyingzi",
    "spellShort": "ysz",
    "code": "YIP"
  },
  {
    "name": "源潭",
    "spell": "yuantan",
    "spellShort": "yta",
    "code": "YTQ"
  },
  {
    "name": "于田",
    "spell": "yutian",
    "spellShort": "yti",
    "code": "YWR"
  },
  {
    "name": "玉田南",
    "spell": "yutiannan",
    "spellShort": "ytn",
    "code": "YTI"
  },
  {
    "name": "伊通",
    "spell": "yitong",
    "spellShort": "yto",
    "code": "YTL"
  },
  {
    "name": "牙屯堡",
    "spell": "yatunpu",
    "spellShort": "ytp",
    "code": "YTZ"
  },
  {
    "name": "烟筒屯",
    "spell": "yantongtun",
    "spellShort": "ytt",
    "code": "YUX"
  },
  {
    "name": "烟台西",
    "spell": "yantaixi",
    "spellShort": "ytx",
    "code": "YTK"
  },
  {
    "name": "羊尾哨",
    "spell": "yangweishao",
    "spellShort": "yws",
    "code": "YWM"
  },
  {
    "name": "黟县东",
    "spell": "yixiandong",
    "spellShort": "yxd",
    "code": "YIU"
  },
  {
    "name": "野象谷",
    "spell": "yexianggu",
    "spellShort": "yxg",
    "code": "AGM"
  },
  {
    "name": "阳西",
    "spell": "yangxi",
    "spellShort": "yxi",
    "code": "WMQ"
  },
  {
    "name": "云县",
    "spell": "yunxian",
    "spellShort": "yxi",
    "code": "AIM"
  },
  {
    "name": "阳信",
    "spell": "yangxin",
    "spellShort": "yxi",
    "code": "YVK"
  },
  {
    "name": "应县",
    "spell": "yingxian",
    "spellShort": "yxi",
    "code": "YZV"
  },
  {
    "name": "攸县",
    "spell": "youxian",
    "spellShort": "yxi",
    "code": "YOG"
  },
  {
    "name": "永修",
    "spell": "yongxiu",
    "spellShort": "yxi",
    "code": "ACG"
  },
  {
    "name": "攸县南",
    "spell": "youxiannan",
    "spellShort": "yxn",
    "code": "YXG"
  },
  {
    "name": "洋县西",
    "spell": "yangxianxi",
    "spellShort": "yxx",
    "code": "YXY"
  },
  {
    "name": "义县西",
    "spell": "yixianxi",
    "spellShort": "yxx",
    "code": "YSD"
  },
  {
    "name": "云阳",
    "spell": "yunyang",
    "spellShort": "yya",
    "code": "YUE"
  },
  {
    "name": "酉阳",
    "spell": "youyang",
    "spellShort": "yya",
    "code": "AFW"
  },
  {
    "name": "弋阳",
    "spell": "yiyang",
    "spellShort": "yya",
    "code": "YIG"
  },
  {
    "name": "余姚",
    "spell": "yuyao",
    "spellShort": "yya",
    "code": "YYH"
  },
  {
    "name": "余姚北",
    "spell": "yuyaobei",
    "spellShort": "yyb",
    "code": "CTH"
  },
  {
    "name": "阳邑",
    "spell": "yangyi",
    "spellShort": "yyi",
    "code": "ARP"
  },
  {
    "name": "杨源",
    "spell": "yangyuan",
    "spellShort": "yyu",
    "code": "AYS"
  },
  {
    "name": "鸳鸯镇",
    "spell": "yuanyangzhen",
    "spellShort": "yyz",
    "code": "YYJ"
  },
  {
    "name": "燕子砭",
    "spell": "yanzibian",
    "spellShort": "yzb",
    "code": "YZY"
  },
  {
    "name": "宜州",
    "spell": "yizhou",
    "spellShort": "yzh",
    "code": "YSZ"
  },
  {
    "name": "银盏",
    "spell": "yinzhan",
    "spellShort": "yzh",
    "code": "YZA"
  },
  {
    "name": "仪征",
    "spell": "yizheng",
    "spellShort": "yzh",
    "code": "UZH"
  },
  {
    "name": "耀州",
    "spell": "yaozhou",
    "spellShort": "yzh",
    "code": "YOY"
  },
  {
    "name": "禹州",
    "spell": "yuzhou",
    "spellShort": "yzh",
    "code": "YZF"
  },
  {
    "name": "迤资",
    "spell": "yizi",
    "spellShort": "yzi",
    "code": "YQM"
  },
  {
    "name": "羊者窝",
    "spell": "yangzhewo",
    "spellShort": "yzw",
    "code": "AEM"
  },
  {
    "name": "杨杖子",
    "spell": "yangzhangzi",
    "spellShort": "yzz",
    "code": "YZD"
  },
  {
    "name": "镇安",
    "spell": "zhenan",
    "spellShort": "zan",
    "code": "ZEY"
  },
  {
    "name": "治安",
    "spell": "zhian",
    "spellShort": "zan",
    "code": "ZAD"
  },
  {
    "name": "招柏",
    "spell": "zhaobai",
    "spellShort": "zba",
    "code": "ZBP"
  },
  {
    "name": "张百湾",
    "spell": "zhangbaiwan",
    "spellShort": "zbw",
    "code": "ZUP"
  },
  {
    "name": "子长",
    "spell": "zichang",
    "spellShort": "zch",
    "code": "ZHY"
  },
  {
    "name": "赵城",
    "spell": "zhaocheng",
    "spellShort": "zch",
    "code": "ZCV"
  },
  {
    "name": "枝城",
    "spell": "zhicheng",
    "spellShort": "zch",
    "code": "ZCN"
  },
  {
    "name": "邹城",
    "spell": "zoucheng",
    "spellShort": "zch",
    "code": "ZIK"
  },
  {
    "name": "诸城",
    "spell": "zhucheng",
    "spellShort": "zch",
    "code": "ZQK"
  },
  {
    "name": "章党",
    "spell": "zhangdang",
    "spellShort": "zda",
    "code": "ZHT"
  },
  {
    "name": "肇东",
    "spell": "zhaodong",
    "spellShort": "zdo",
    "code": "ZDB"
  },
  {
    "name": "照福铺",
    "spell": "zhaofupu",
    "spellShort": "zfp",
    "code": "ZFM"
  },
  {
    "name": "准格尔",
    "spell": "zhungeer",
    "spellShort": "zge",
    "code": "ZEC"
  },
  {
    "name": "章古台",
    "spell": "zhanggutai",
    "spellShort": "zgt",
    "code": "ZGD"
  },
  {
    "name": "赵光",
    "spell": "zhaoguang",
    "spellShort": "zgu",
    "code": "ZGB"
  },
  {
    "name": "政和",
    "spell": "zhenghe",
    "spellShort": "zhe",
    "code": "ZES"
  },
  {
    "name": "中和",
    "spell": "zhonghe",
    "spellShort": "zhe",
    "code": "ZHX"
  },
  {
    "name": "织金北",
    "spell": "zhijinbei",
    "spellShort": "zjb",
    "code": "ZJE"
  },
  {
    "name": "枝江北",
    "spell": "zhijiangbei",
    "spellShort": "zjb",
    "code": "ZIN"
  },
  {
    "name": "钟家村",
    "spell": "zhongjiacun",
    "spellShort": "zjc",
    "code": "ZJY"
  },
  {
    "name": "紫荆关",
    "spell": "zijingguan",
    "spellShort": "zjg",
    "code": "ZYP"
  },
  {
    "name": "朱家沟",
    "spell": "zhujiagou",
    "spellShort": "zjg",
    "code": "ZUB"
  },
  {
    "name": "周家屯",
    "spell": "zhoujiatun",
    "spellShort": "zjt",
    "code": "ZOD"
  },
  {
    "name": "褚家湾",
    "spell": "zhujiawan",
    "spellShort": "zjw",
    "code": "CWJ"
  },
  {
    "name": "仲恺",
    "spell": "zhongkai",
    "spellShort": "zka",
    "code": "ZKA"
  },
  {
    "name": "曾口",
    "spell": "zengkou",
    "spellShort": "zko",
    "code": "ZKE"
  },
  {
    "name": "张兰",
    "spell": "zhanglan",
    "spellShort": "zla",
    "code": "ZLV"
  },
  {
    "name": "珠琳",
    "spell": "zhulin",
    "spellShort": "zli",
    "code": "ZOM"
  },
  {
    "name": "枣林",
    "spell": "zaolin",
    "spellShort": "zli",
    "code": "ZIV"
  },
  {
    "name": "扎鲁特",
    "spell": "zhalute",
    "spellShort": "zlt",
    "code": "ZLD"
  },
  {
    "name": "樟木头东",
    "spell": "zhangmutoudong",
    "spellShort": "zmd",
    "code": "ZRQ"
  },
  {
    "name": "樟木头",
    "spell": "zhangmutou",
    "spellShort": "zmt",
    "code": "ZOQ"
  },
  {
    "name": "扎囊",
    "spell": "zhanang",
    "spellShort": "zna",
    "code": "ZNO"
  },
  {
    "name": "中宁东",
    "spell": "zhongningdong",
    "spellShort": "znd",
    "code": "ZDJ"
  },
  {
    "name": "中宁",
    "spell": "zhongning",
    "spellShort": "zni",
    "code": "VNJ"
  },
  {
    "name": "周宁",
    "spell": "zhouning",
    "spellShort": "zni",
    "code": "ZNS"
  },
  {
    "name": "中宁南",
    "spell": "zhongningnan",
    "spellShort": "znn",
    "code": "ZNJ"
  },
  {
    "name": "邹平",
    "spell": "zouping",
    "spellShort": "zpi",
    "code": "ZLK"
  },
  {
    "name": "镇平",
    "spell": "zhenping",
    "spellShort": "zpi",
    "code": "ZPF"
  },
  {
    "name": "漳浦",
    "spell": "zhangpu",
    "spellShort": "zpu",
    "code": "ZCS"
  },
  {
    "name": "张桥",
    "spell": "zhangqiao",
    "spellShort": "zqi",
    "code": "ZQY"
  },
  {
    "name": "枣强",
    "spell": "zaoqiang",
    "spellShort": "zqi",
    "code": "ZVP"
  },
  {
    "name": "庄桥",
    "spell": "zhuangqiao",
    "spellShort": "zqi",
    "code": "ZQH"
  },
  {
    "name": "朱日和",
    "spell": "zhurihe",
    "spellShort": "zrh",
    "code": "ZRC"
  },
  {
    "name": "中山北",
    "spell": "zhongshanbei",
    "spellShort": "zsb",
    "code": "ZGQ"
  },
  {
    "name": "樟树东",
    "spell": "zhangshudong",
    "spellShort": "zsd",
    "code": "ZOG"
  },
  {
    "name": "钟山",
    "spell": "zhongshan",
    "spellShort": "zsh",
    "code": "ZSZ"
  },
  {
    "name": "昭山",
    "spell": "zhaoshan",
    "spellShort": "zsh",
    "code": "KWQ"
  },
  {
    "name": "钟山西",
    "spell": "zhongshanxi",
    "spellShort": "zsx",
    "code": "ZAZ"
  },
  {
    "name": "支提山",
    "spell": "zhitishan",
    "spellShort": "zts",
    "code": "ZIS"
  },
  {
    "name": "珠窝",
    "spell": "zhuwo",
    "spellShort": "zwo",
    "code": "ZOP"
  },
  {
    "name": "张维屯",
    "spell": "zhangweitun",
    "spellShort": "zwt",
    "code": "ZWB"
  },
  {
    "name": "彰武",
    "spell": "zhangwu",
    "spellShort": "zwu",
    "code": "ZWD"
  },
  {
    "name": "漳县",
    "spell": "zhangxian",
    "spellShort": "zxi",
    "code": "ZXJ"
  },
  {
    "name": "资溪",
    "spell": "zixi",
    "spellShort": "zxi",
    "code": "ZXS"
  },
  {
    "name": "棕溪",
    "spell": "zongxi",
    "spellShort": "zxi",
    "code": "ZOY"
  },
  {
    "name": "镇西",
    "spell": "zhenxi",
    "spellShort": "zxi",
    "code": "ZVT"
  },
  {
    "name": "钟祥",
    "spell": "zhongxiang",
    "spellShort": "zxi",
    "code": "ZTN"
  },
  {
    "name": "张辛",
    "spell": "zhangxin",
    "spellShort": "zxi",
    "code": "ZIP"
  },
  {
    "name": "正镶白旗",
    "spell": "zhengxiangbaiqi",
    "spellShort": "zxq",
    "code": "ZXC"
  },
  {
    "name": "遵义南",
    "spell": "zunyinan",
    "spellShort": "zyn",
    "code": "ZNE"
  },
  {
    "name": "竹园",
    "spell": "zhuyuan",
    "spellShort": "zyu",
    "code": "ZUM"
  },
  {
    "name": "枣庄东",
    "spell": "zaozhuangdong",
    "spellShort": "zzd",
    "code": "ZNK"
  },
  {
    "name": "卓资东",
    "spell": "zhuozidong",
    "spellShort": "zzd",
    "code": "ZDC"
  },
  {
    "name": "子洲",
    "spell": "zizhou",
    "spellShort": "zzh",
    "code": "ZZY"
  },
  {
    "name": "涿州",
    "spell": "zhuozhou",
    "spellShort": "zzh",
    "code": "ZXP"
  },
  {
    "name": "中寨",
    "spell": "zhongzhai",
    "spellShort": "zzh",
    "code": "ZZM"
  },
  {
    "name": "壮志",
    "spell": "zhuangzhi",
    "spellShort": "zzh",
    "code": "ZUX"
  },
  {
    "name": "咋子",
    "spell": "zhazi",
    "spellShort": "zzi",
    "code": "ZAL"
  },
  {
    "name": "卓资山",
    "spell": "zhuozishan",
    "spellShort": "zzs",
    "code": "ZZC"
  },
  {
    "name": "安溪东",
    "spell": "anxidong",
    "spellShort": "axd",
    "code": "ANS"
  },
  {
    "name": "安州",
    "spell": "anzhou",
    "spellShort": "azh",
    "code": "AZE"
  },
  {
    "name": "博罗",
    "spell": "boluo",
    "spellShort": "blu",
    "code": "BOA"
  },
  {
    "name": "保山",
    "spell": "baoshan",
    "spellShort": "bsh",
    "code": "BAM"
  },
  {
    "name": "北滩",
    "spell": "beitan",
    "spellShort": "bta",
    "code": "BEJ"
  },
  {
    "name": "白银南",
    "spell": "baiyinnan",
    "spellShort": "byn",
    "code": "BVJ"
  },
  {
    "name": "茶卡",
    "spell": "chaka",
    "spellShort": "cka",
    "code": "CVO"
  },
  {
    "name": "茌平",
    "spell": "chiping",
    "spellShort": "cpi",
    "code": "CHK"
  },
  {
    "name": "德化",
    "spell": "dehua",
    "spellShort": "dhu",
    "code": "DKS"
  },
  {
    "name": "独山东",
    "spell": "dushandong",
    "spellShort": "dsd",
    "code": "DDE"
  },
  {
    "name": "大田北",
    "spell": "datianbei",
    "spellShort": "dtb",
    "code": "DTS"
  },
  {
    "name": "富阳西",
    "spell": "fuyangxi",
    "spellShort": "fyx",
    "code": "FUU"
  },
  {
    "name": "高川",
    "spell": "gaochuan",
    "spellShort": "gch",
    "code": "GCE"
  },
  {
    "name": "革居",
    "spell": "geju",
    "spellShort": "gju",
    "code": "GEM"
  },
  {
    "name": "古路",
    "spell": "gulu",
    "spellShort": "glu",
    "code": "GOE"
  },
  {
    "name": "花博山",
    "spell": "huaboshan",
    "spellShort": "hbs",
    "code": "KBT"
  },
  {
    "name": "惠东",
    "spell": "huidong",
    "spellShort": "hdo",
    "code": "KDA"
  },
  {
    "name": "黄水",
    "spell": "huangshui",
    "spellShort": "hsh",
    "code": "SZE"
  },
  {
    "name": "海头",
    "spell": "haitou",
    "spellShort": "hto",
    "code": "FTQ"
  },
  {
    "name": "惠州南",
    "spell": "huizhounan",
    "spellShort": "hzn",
    "code": "KNA"
  },
  {
    "name": "杭州西",
    "spell": "hangzhouxi",
    "spellShort": "hzx",
    "code": "HVU"
  },
  {
    "name": "江北机场",
    "spell": "jiangbeijichang",
    "spellShort": "jbc",
    "code": "JCE"
  },
  {
    "name": "句容",
    "spell": "jurong",
    "spellShort": "jro",
    "code": "JRU"
  },
  {
    "name": "金坛",
    "spell": "jintan",
    "spellShort": "jta",
    "code": "JTU"
  },
  {
    "name": "靖远北",
    "spell": "jingyuanbei",
    "spellShort": "jyb",
    "code": "JOJ"
  },
  {
    "name": "江阴",
    "spell": "jiangyin",
    "spellShort": "jyi",
    "code": "KYH"
  },
  {
    "name": "绛帐",
    "spell": "jiangzhang",
    "spellShort": "jzh",
    "code": "JZY"
  },
  {
    "name": "荔波",
    "spell": "libo",
    "spellShort": "lbo",
    "code": "UBE"
  },
  {
    "name": "罗浮山",
    "spell": "luofushan",
    "spellShort": "lfs",
    "code": "LVA"
  },
  {
    "name": "珞璜东",
    "spell": "luohuangdong",
    "spellShort": "lhd",
    "code": "LHE"
  },
  {
    "name": "龙兴",
    "spell": "longxing",
    "spellShort": "lxi",
    "code": "LIE"
  },
  {
    "name": "茂县",
    "spell": "maoxian",
    "spellShort": "mxi",
    "code": "MXE"
  },
  {
    "name": "明溪",
    "spell": "mingxi",
    "spellShort": "mxi",
    "code": "MOS"
  },
  {
    "name": "绵竹南",
    "spell": "mianzhunan",
    "spellShort": "mzn",
    "code": "MNE"
  },
  {
    "name": "南安北",
    "spell": "nananbei",
    "spellShort": "nab",
    "code": "NUS"
  },
  {
    "name": "南彭",
    "spell": "nanpeng",
    "spellShort": "npe",
    "code": "NAE"
  },
  {
    "name": "宁强",
    "spell": "ningqiang",
    "spellShort": "nqi",
    "code": "NQY"
  },
  {
    "name": "南溪北",
    "spell": "nanxibei",
    "spellShort": "nxb",
    "code": "NOE"
  },
  {
    "name": "平川西",
    "spell": "pingchuanxi",
    "spellShort": "pcx",
    "code": "PCJ"
  },
  {
    "name": "秦王川",
    "spell": "qinwangchuan",
    "spellShort": "qwc",
    "code": "QWJ"
  },
  {
    "name": "三岔湖",
    "spell": "sanchahu",
    "spellShort": "sch",
    "code": "SCE"
  },
  {
    "name": "什邡西",
    "spell": "shifangxi",
    "spellShort": "sfx",
    "code": "SFE"
  },
  {
    "name": "商洛北",
    "spell": "shangluobei",
    "spellShort": "slb",
    "code": "SBY"
  },
  {
    "name": "水土",
    "spell": "shuitu",
    "spellShort": "stu",
    "code": "SUE"
  },
  {
    "name": "三星堆",
    "spell": "sanxingdui",
    "spellShort": "sxd",
    "code": "SDE"
  },
  {
    "name": "三元西",
    "spell": "sanyuanxi",
    "spellShort": "syx",
    "code": "SRS"
  },
  {
    "name": "天府机场",
    "spell": "tianfujichang",
    "spellShort": "tfc",
    "code": "TIE"
  },
  {
    "name": "统景",
    "spell": "tongjing",
    "spellShort": "tji",
    "code": "TOE"
  },
  {
    "name": "桐庐东",
    "spell": "tongludong",
    "spellShort": "tld",
    "code": "TBU"
  },
  {
    "name": "铁门关",
    "spell": "tiemenguan",
    "spellShort": "tmg",
    "code": "XAR"
  },
  {
    "name": "武进",
    "spell": "wujin",
    "spellShort": "wji",
    "code": "WJU"
  },
  {
    "name": "威远",
    "spell": "weiyuan",
    "spellShort": "wyu",
    "code": "WYE"
  },
  {
    "name": "香格里拉",
    "spell": "xianggelila",
    "spellShort": "xgl",
    "code": "EUM"
  },
  {
    "name": "西阳村",
    "spell": "xiyangcun",
    "spellShort": "xyc",
    "code": "XQF"
  },
  {
    "name": "小中甸",
    "spell": "xiaozhongdian",
    "spellShort": "xzd",
    "code": "EDM"
  },
  {
    "name": "宜宾东",
    "spell": "yibindong",
    "spellShort": "ybd",
    "code": "EDE"
  },
  {
    "name": "宜宾",
    "spell": "yibin",
    "spellShort": "ybi",
    "code": "YKE"
  },
  {
    "name": "漾濞",
    "spell": "yangbi",
    "spellShort": "ybi",
    "code": "AVM"
  },
  {
    "name": "永春",
    "spell": "yongchun",
    "spellShort": "ych",
    "code": "ACS"
  },
  {
    "name": "银花",
    "spell": "yinhua",
    "spellShort": "yhu",
    "code": "YWE"
  },
  {
    "name": "迎龙",
    "spell": "yinglong",
    "spellShort": "ylo",
    "code": "YVE"
  },
  {
    "name": "永平县",
    "spell": "yongpingxian",
    "spellShort": "ypx",
    "code": "APM"
  },
  {
    "name": "沿滩",
    "spell": "yantan",
    "spellShort": "yta",
    "code": "YTE"
  },
  {
    "name": "越西",
    "spell": "yuexi",
    "spellShort": "yxi",
    "code": "YIE"
  },
  {
    "name": "增城",
    "spell": "zengcheng",
    "spellShort": "zch",
    "code": "ZCA"
  },
  {
    "name": "镇江关",
    "spell": "zhenjiangguan",
    "spellShort": "zjg",
    "code": "ZEE"
  },
  {
    "name": "资阳西",
    "spell": "ziyangxi",
    "spellShort": "zyx",
    "code": "ZIE"
  },
  {
    "name": "资中西",
    "spell": "zizhongxi",
    "spellShort": "zzx",
    "code": "ZZE"
  }
]



// WEBPACK FOOTER //
// ./src/components/trainCityData.js